export const homeData = {
    "tabs": [
        {
            "id": "womens_bag",
            "title": "女包",
            "categoryIds": [
                "e0"
            ],
            "brands": [
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/ca48d30a-1dd3-354c-8001-ddb0468ed4ff.jpg",
                    "id": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                    "name": "迈克高仕",
                    "categoryIds": [
                        "13",
                        "e0"
                    ],
                    "pathname": "mai4-ke4-gao1-shi4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/fd4b2ed8-a1f7-31e1-8492-94070793f5f9.jpg",
                    "id": "f931b13a-ead0-32d7-bcdb-02f84e0f794f",
                    "name": "蔻驰",
                    "categoryIds": [
                        "13",
                        "e0"
                    ],
                    "pathname": "kou4-chi2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/f38f6a5c-fdcf-3710-b685-94c7763d978e.jpg",
                    "id": "dc9a30b7-8e06-3630-ae61-e198fb793425",
                    "name": "汤丽·柏琦",
                    "categoryIds": [
                        "13",
                        "e0"
                    ],
                    "pathname": "tang1-li4-bai3-qi2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/e843e580-9b82-4348-baad-eefcab93b85a.jpg",
                    "id": "c990953c-4114-3a78-ac7c-b89120e7bd24",
                    "name": "珑骧",
                    "categoryIds": [
                        "13",
                        "e0"
                    ],
                    "pathname": "long2-xiang1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/7db9b053-a010-3ee4-aca8-42b678f33c18.jpg",
                    "id": "0e42f86f-7098-3292-99dc-2cd5171579c2",
                    "name": "Free People",
                    "categoryIds": [
                        "13",
                        "e0"
                    ],
                    "pathname": "free-people"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/3ef735b5-0d0e-3b71-9796-97f1bff86430.jpg",
                    "id": "fb35adb5-fa93-3307-ab74-a644b26facee",
                    "name": "拉夫·劳伦",
                    "categoryIds": [
                        "13",
                        "e0"
                    ],
                    "pathname": "la1-fu1-lao2-lun2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/29397d81-7136-3e4e-b430-e93505b499f4.jpg",
                    "id": "e8d19ca7-81aa-39f0-ac20-6dcdfb632cb9",
                    "name": "芬迪",
                    "categoryIds": [
                        "13",
                        "e0"
                    ],
                    "pathname": "fen1-di2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/c6a8ce0e-9579-3ba1-a61e-c00173867db9.jpg",
                    "id": "74d2568b-67aa-3414-98b7-b4ce0ff49f6a",
                    "name": "True Religion",
                    "categoryIds": [
                        "13",
                        "e0"
                    ],
                    "pathname": "true-religion"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/98f8e7b3-965d-3898-89b5-86ac16bf9bc5.jpg",
                    "id": "25cce1e7-2381-3267-bf74-9aad879d70c1",
                    "name": "凯特·丝蓓",
                    "categoryIds": [
                        "13",
                        "e0"
                    ],
                    "pathname": "kai3-te4-si1-bei4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/5ea2f7e0-965d-338a-9269-ccf521d714b4.jpg",
                    "id": "a03ef079-efb3-3f8e-bbae-1b2c75bd020f",
                    "name": "凯浦林",
                    "categoryIds": [
                        "13",
                        "e0"
                    ],
                    "pathname": "kai3-pu3-lin2"
                }
            ],
            "productList": [
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "ca48d30a-1dd3-354c-8001-ddb0468ed4ff",
                                    "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35T9GTVT0B-0001_1?dpr=on%2C2",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ca48d30a-1dd3-354c-8001-ddb0468ed4ff.jpg",
                                        "width": 595,
                                        "height": 800,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ca48d30a-1dd3-354c-8001-ddb0468ed4ff.jpg",
                                        "width": 260,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "PWD BLSH MLT",
                                    "image": {
                                        "id": "242ccbe0-6b72-3b2f-83a2-0a27fafa60d7",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/242ccbe0-6b72-3b2f-83a2-0a27fafa60d7.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "BROWN",
                                    "image": {
                                        "id": "8705b855-9e4d-3963-aa2e-4fd0fd57f062",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8705b855-9e4d-3963-aa2e-4fd0fd57f062.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "BLACK",
                                    "image": {
                                        "id": "6755fe5f-d74b-3e89-a13b-cbd98d57465c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6755fe5f-d74b-3e89-a13b-cbd98d57465c.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "michaelkors_35T9GTVT0B",
                            "name": "Jet Set Travel Extra-Small Logo Top-Zip Tote Bag",
                            "nameCN": "Jet Set超小号托特旅行袋 菜篮子（多种配色）",
                            "description": [
                                "Compact yet practical, our Jet Set tote bag is the ideal daily companion. Logo-print canvas and a polished charm make a luxe statement, while a top-zip fastening ensures your belongings will stay in place. Carry it crossbody for days that require on-the-go ease.",
                                "• Tote bag",
                                "• Logo-print canvas",
                                "• 89.4% coated canvas/9.6% polyester/1% polyurethane",
                                "• Gold-tone hardware",
                                "• 10.75”W X 7.5”H X 4”D",
                                "• Handle drop: 21.5-25.5”",
                                "• Interior details: front slip pocket, back zip pocket",
                                "• Lining: 100% polyester",
                                "• Zip fastening",
                                "• Dust bag not included",
                                "• Imported",
                                "• Tote bag",
                                "• Logo-print canvas",
                                "• 89.4% coated canvas/9.6% polyester/1% polyurethane",
                                "• Gold-tone hardware",
                                "• 10.75”W X 7.5”H X 4”D",
                                "• Handle drop: 21.5-25.5”",
                                "• Interior details: front slip pocket, back zip pocket",
                                "• Lining: 100% polyester",
                                "• Zip fastening",
                                "• Dust bag not included",
                                "• Imported"
                            ],
                            "merchantId": "89896b29-9191-a09f-8ffd-e872a296da04",
                            "brand": "Michael Kors",
                            "displayBrand": "Michael Kors",
                            "brandId": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                            "category": "women|bag|sale",
                            "categoryIds": [
                                "e07"
                            ],
                            "priceTag": "$66.83",
                            "priceTagCN": "¥490",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "2.4折",
                        "activityOffs": [
                            "额外八五折",
                            "新人补贴价"
                        ],
                        "merchantName": "Michael Kors",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "额外八五折",
                                    "color": "D27D3F"
                                },
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "2.4折×额外8.5折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 17291,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "5ea2f7e0-965d-338a-9269-ccf521d714b4",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/31190513_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5ea2f7e0-965d-338a-9269-ccf521d714b4.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5ea2f7e0-965d-338a-9269-ccf521d714b4.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Bridal Lavender",
                                    "image": {
                                        "id": "681092da-6c65-3689-b8f9-9e15834f49be",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/681092da-6c65-3689-b8f9-9e15834f49be.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Bridal Blue",
                                    "image": {
                                        "id": "2968c781-fcfa-30de-9cec-f88a4abe6c1b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2968c781-fcfa-30de-9cec-f88a4abe6c1b.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "True Pink",
                                    "image": {
                                        "id": "00e1da8f-6022-31d3-a4a5-1e4c6a98ab9e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/00e1da8f-6022-31d3-a4a5-1e4c6a98ab9e.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Coral Sea",
                                    "image": {
                                        "id": "3fe86f8c-0e01-3360-9e45-2c03c238c4ca",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3fe86f8c-0e01-3360-9e45-2c03c238c4ca.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_13091416",
                            "name": "Seoul Medium Backpack",
                            "nameCN": "kipling中号首尔双肩包  早八通勤神包",
                            "description": [
                                "Get wherever you're going in casual-cool style with the Kipling Seoul Go Backpack featuring ultimate organization inside and out.",
                                "Medium sized bag; 12-3/4\"W x 17-1/4\"H x 5-1/2\"D width is measured across the bottom of backpack ; 2.84 lbs. approx. weight",
                                "3\"L handles; 15\"L-18\"L adjustable removable strap",
                                "Zip closure",
                                "Silver-tone exterior hardware, monkey key fob, 2 side water bottle pockets, 1 top zip pocket, 1 front zip pocket & 1 front zip pocket featuring a cell phone pocket, slip pocket pen loop & key clasp",
                                "Interior protective 15\" laptop sleeve",
                                "Laptop compatible (std. size 13\"-15\")",
                                "Silhouette is based on 5'9\" model",
                                "Polyamide",
                                "Spot clean",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Kipling",
                            "displayBrand": "Kipling",
                            "brandId": "a03ef079-efb3-3f8e-bbae-1b2c75bd020f",
                            "category": "handbag|women's fashion|handbags, wallets & accessories",
                            "categoryIds": [
                                "e06"
                            ],
                            "priceTag": "$50.05",
                            "priceTagCN": "¥367",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "3.9折起",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "3.9折起",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 335,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "25571467-3ae8-3e30-9cf9-c3b3175ec9f3",
                                    "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35T1GM9C0I-7183_1?dpr=on%2C2",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/25571467-3ae8-3e30-9cf9-c3b3175ec9f3.jpg",
                                        "width": 595,
                                        "height": 800,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/25571467-3ae8-3e30-9cf9-c3b3175ec9f3.jpg",
                                        "width": 260,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "BROWN",
                                    "image": {
                                        "id": "9c9ef556-5ef0-39c9-8a06-c95b8a0fcce9",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9c9ef556-5ef0-39c9-8a06-c95b8a0fcce9.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "BLACK",
                                    "image": {
                                        "id": "795cc51d-ae8a-3786-baad-7e3df2ec02b0",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/795cc51d-ae8a-3786-baad-7e3df2ec02b0.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "PWD BLSH MLT",
                                    "image": {
                                        "id": "4eef4eb4-f0e1-3c21-bc06-7a8f8bccb458",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4eef4eb4-f0e1-3c21-bc06-7a8f8bccb458.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "michaelkors_35T1GM9C0I",
                            "name": "Mercer Extra-Small Logo and Leather Crossbody Bag",
                            "nameCN": "女式 Mercer系列 超小号琴谱包 手提斜挎包MK风琴包",
                            "description": [
                                "Our scaled-down Mercer crossbody allows you to travel light without compromising on style. Crafted from pebbled leather with smooth accents, this bag features structured top handles and an adjustable shoulder strap for added versatility. Wear it crossbody on casual days, or carry it by the top handles for added polish.",
                                "• Crossbody bag",
                                "• Logo-print canvas/leather",
                                "• 84.9% coated canvas/9.6% polyester/1% polyurethane",
                                "• Trim: 100% leather",
                                "• Gold-tone hardware",
                                "• 6”W X 6.75”H X 2.5”D",
                                "• Handle drop: 3”",
                                "• Adjustable strap: 20.5”-24”",
                                "• Exterior details:removable strap",
                                "• Interior details: 3 card slots",
                                "• Lining: 100% polyester",
                                "• Dust bag not included",
                                "• Imported",
                                "• Crossbody bag\n• Logo-print canvas/leather\n• 84.9% coated canvas/9.6% polyester/1% polyurethane\n• Trim: 100% leather\n• Gold-tone hardware\n• 6”W X 6.75”H X 2.5”D\n• Handle drop: 3”\n• Adjustable strap: 20.5”-24”\n• Exterior details:removable strap\n• Interior details: 3 card slots\n• Lining: 100% polyester• Dust bag not included\n• Imported"
                            ],
                            "merchantId": "89896b29-9191-a09f-8ffd-e872a296da04",
                            "brand": "Michael Kors",
                            "displayBrand": "Michael Kors",
                            "brandId": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                            "category": "?sz=72&start=294|women",
                            "categoryIds": [
                                "e08"
                            ],
                            "priceTag": "$49.66",
                            "priceTagCN": "¥364",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "2.5折",
                        "activityOffs": [
                            "额外八五折",
                            "新人补贴价"
                        ],
                        "merchantName": "Michael Kors",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "额外八五折",
                                    "color": "D27D3F"
                                },
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "2.5折×额外8.5折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 32181,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "e843e580-9b82-4348-baad-eefcab93b85a",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e843e580-9b82-4348-baad-eefcab93b85a.jpg",
                                        "width": 756,
                                        "height": 721,
                                        "format": "jpg"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e843e580-9b82-4348-baad-eefcab93b85a.jpg",
                                        "width": 756,
                                        "height": 721,
                                        "format": "jpg"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "橙 色",
                                    "image": {
                                        "id": "b5d0fc8f-08ed-33a1-bb43-423422816e22",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b5d0fc8f-08ed-33a1-bb43-423422816e22.jpg",
                                            "width": 740,
                                            "height": 673,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "沙色",
                                    "image": {
                                        "id": "7816f78e-0919-3b48-b61f-a086339ff64c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7816f78e-0919-3b48-b61f-a086339ff64c.jpg",
                                            "width": 720,
                                            "height": 711,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "terriwonder_10155",
                            "name": "珑骧新款女士短柄小号手提包环保系列女士手提饺子包L1621（香港仓发货）",
                            "description": [],
                            "merchantId": "845ebfac-d06a-35fd-a5f9-84e686740dd3",
                            "brand": "Longchamp",
                            "displayBrand": "Longchamp",
                            "brandId": "c990953c-4114-3a78-ac7c-b89120e7bd24",
                            "categoryIds": [
                                "e04"
                            ],
                            "priceTag": "$94.80",
                            "priceTagCN": "¥695",
                            "labels": [
                                "final_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "9.2折起",
                        "activityOffs": [
                            "额外七九折"
                        ],
                        "merchantName": "Terri Wonder",
                        "origin": "[中国香港]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "额外七九折",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "9.2折起×额外7.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 598,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "中国香港",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "2da63829-2387-336e-9adf-d498fbb3004b",
                                    "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S1GM9M2B-0200_1?dpr=on%2C2",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2da63829-2387-336e-9adf-d498fbb3004b.jpg",
                                        "width": 595,
                                        "height": 800,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2da63829-2387-336e-9adf-d498fbb3004b.jpg",
                                        "width": 260,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "BROWN",
                                    "image": {
                                        "id": "0a5c5bde-8243-3d3b-a842-552d704ee549",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0a5c5bde-8243-3d3b-a842-552d704ee549.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "PWD BLSH MLT",
                                    "image": {
                                        "id": "8bb8c398-5838-324b-8825-b0b0e23a3436",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8bb8c398-5838-324b-8825-b0b0e23a3436.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "michaelkors_35S1GM9M2B",
                            "name": "Mercer Medium Logo and Leather Accordion Crossbody Bag",
                            "nameCN": "Mercer 中号徽标和皮革手风琴斜挎包 MK风琴包",
                            "description": [
                                "Crafted from signature-print canvas and leather, our two-tone Mercer crossbody bag is updated with accordion side gussets. Its streamlined design features structured top handles and a removable shoulder strap for added versatility, while a median zippered compartment promises safekeeping for smaller items.",
                                "• Crossbody bag",
                                "• Logo-print canvas",
                                "• 90% coated canvas/9% polyester/1% polyurethane",
                                "• Trim: 100% leather",
                                "• Gold-tone hardware",
                                "• 8.75\"W X 7.5\"H X 4\"D",
                                "• Handle drop: 4.25\"",
                                "• Adjustable strap: 22.25\"-24.5\"",
                                "• Exterior details: detachable crossbody strap",
                                "• Interior details: center zip compartment, 3 card slots",
                                "• Pocket lining: 100% polyester",
                                "• Dust bag not included",
                                "• Imported",
                                "• Crossbody bag",
                                "• Logo-print canvas",
                                "• 90% coated canvas/9% polyester/1% polyurethane",
                                "• Trim: 100% leather",
                                "• Gold-tone hardware",
                                "• 8.75\"W X 7.5\"H X 4\"D",
                                "• Handle drop: 4.25\"",
                                "• Adjustable strap: 22.25\"-24.5\"",
                                "• Exterior details: detachable crossbody strap",
                                "• Interior details: center zip compartment, 3 card slots",
                                "• Pocket lining: 100% polyester",
                                "• Dust bag not included",
                                "• Imported"
                            ],
                            "merchantId": "89896b29-9191-a09f-8ffd-e872a296da04",
                            "brand": "Michael Kors",
                            "displayBrand": "Michael Kors",
                            "brandId": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                            "category": "?sz=72&start=294|women",
                            "categoryIds": [
                                "e08"
                            ],
                            "priceTag": "$65.83",
                            "priceTagCN": "¥482",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "2.4折",
                        "activityOffs": [
                            "额外八五折",
                            "新人补贴价"
                        ],
                        "merchantName": "Michael Kors",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "额外八五折",
                                    "color": "D27D3F"
                                },
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "2.4折×额外8.5折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$2",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 10406,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "e050a0e8-cc3a-3014-b232-af226e8bfa42",
                                    "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S1GTTC9B-0200_1?dpr=on%2C2",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e050a0e8-cc3a-3014-b232-af226e8bfa42.jpg",
                                        "width": 595,
                                        "height": 800,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e050a0e8-cc3a-3014-b232-af226e8bfa42.jpg",
                                        "width": 260,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "BROWN",
                                    "image": {
                                        "id": "0cc15dcb-7766-3658-809b-40180d468862",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0cc15dcb-7766-3658-809b-40180d468862.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "PWD BLSH MLT",
                                    "image": {
                                        "id": "32f193b3-1dff-3a03-afbd-65d8c82e6846",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/32f193b3-1dff-3a03-afbd-65d8c82e6846.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "VANILLA",
                                    "image": {
                                        "id": "e9672619-cfa3-38f4-bd96-32172fcf1625",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e9672619-cfa3-38f4-bd96-32172fcf1625.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "michaelkors_35S1GTTC9B",
                            "name": "Jet Set Large Logo Crossbody Bag",
                            "nameCN": "女式 Jet Set 大号徽标斜挎包",
                            "description": [
                                "Crafted from our Signature-print canvas for novelty appeal, the Jet Set crossbody bag is designed in a sleek, compact silhouette. A polished chain-link zipper pull delivers standout style, while the pocketed interior is perfectly sized for a day’s worth of essentials. Wear it while commuting, running errands or taking a weekend getaway.",
                                "• Crossbody bag",
                                "• Logo-print canvas",
                                "• 89.4% coated canvas/9.6% polyester/1% polyurethane",
                                "• Gold-tone hardware",
                                "• 9.5”W X 6.5”H X 2”D",
                                "• Exterior details: detachable crossbody strap, back slip pocket, front slip and zip pockets",
                                "• Interior details: back and front slip pockets",
                                "• Lining: 100% polyester",
                                "• Zip fastening",
                                "• Dust bag not included",
                                "• Imported",
                                "• Crossbody bag",
                                "• Logo-print canvas",
                                "• 89.4% coated canvas/9.6% polyester/1% polyurethane",
                                "• Gold-tone hardware",
                                "• 9.5”W X 6.5”H X 2”D",
                                "• Exterior details: detachable crossbody strap, back slip pocket, front slip and zip pockets",
                                "• Interior details: back and front slip pockets",
                                "• Lining: 100% polyester",
                                "• Zip fastening",
                                "• Dust bag not included",
                                "• Imported"
                            ],
                            "merchantId": "89896b29-9191-a09f-8ffd-e872a296da04",
                            "brand": "Michael Kors",
                            "displayBrand": "Michael Kors",
                            "brandId": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                            "category": "?sz=72&start=294|women",
                            "categoryIds": [
                                "e08"
                            ],
                            "priceTag": "$49.66",
                            "priceTagCN": "¥364",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "2.2折",
                        "activityOffs": [
                            "额外八五折",
                            "新人补贴价"
                        ],
                        "merchantName": "Michael Kors",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "额外八五折",
                                    "color": "D27D3F"
                                },
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "2.2折×额外8.5折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 1567,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "0dc763b7-7d84-4e91-b2fa-c0727dc8dd4b",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0dc763b7-7d84-4e91-b2fa-c0727dc8dd4b.jpg",
                                        "width": 607,
                                        "height": 589,
                                        "format": "jpg"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0dc763b7-7d84-4e91-b2fa-c0727dc8dd4b.jpg",
                                        "width": 607,
                                        "height": 589,
                                        "format": "jpg"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "米粉色",
                                    "image": {
                                        "id": "7b5877ab-3140-3ca8-8bff-7905c0aa2522",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7b5877ab-3140-3ca8-8bff-7905c0aa2522.jpg",
                                            "width": 782,
                                            "height": 779,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "沙色",
                                    "image": {
                                        "id": "1d5826dd-4562-379f-9e4d-2873ef30bb8a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1d5826dd-4562-379f-9e4d-2873ef30bb8a.jpg",
                                            "width": 741,
                                            "height": 760,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "青瓷色",
                                    "image": {
                                        "id": "b127a304-aba5-33d6-a8ca-5a88c4fe23fa",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b127a304-aba5-33d6-a8ca-5a88c4fe23fa.jpg",
                                            "width": 785,
                                            "height": 750,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "terriwonder_10729",
                            "name": "珑骧女士新色大号长柄经典饺子包手提包1899 089（香港仓发货）",
                            "description": [],
                            "merchantId": "845ebfac-d06a-35fd-a5f9-84e686740dd3",
                            "brand": "Longchamp",
                            "displayBrand": "Longchamp",
                            "brandId": "c990953c-4114-3a78-ac7c-b89120e7bd24",
                            "categoryIds": [
                                "e05"
                            ],
                            "priceTag": "$112.55",
                            "priceTagCN": "¥824",
                            "labels": [
                                "final_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "9.5折起",
                        "activityOffs": [
                            "额外七九折",
                            "新人补贴价"
                        ],
                        "merchantName": "Terri Wonder",
                        "origin": "[中国香港]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "额外七九折",
                                    "color": "D27D3F"
                                },
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "9.5折起×额外7.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$2",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 582,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "中国香港",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "9297c2b1-d5f2-3896-97fb-51a3df2cd6f2",
                                    "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/30F5GY5M2L-0323_1?dpr=on%2C2",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9297c2b1-d5f2-3896-97fb-51a3df2cd6f2.jpg",
                                        "width": 595,
                                        "height": 800,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9297c2b1-d5f2-3896-97fb-51a3df2cd6f2.jpg",
                                        "width": 260,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "PISTACHIO",
                                    "image": {
                                        "id": "c8899404-726e-341e-a2eb-dbff1926cbe8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c8899404-726e-341e-a2eb-dbff1926cbe8.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "HUSK",
                                    "image": {
                                        "id": "5dee4fbb-fe7e-397b-81dc-58156173860c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/5dee4fbb-fe7e-397b-81dc-58156173860c.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "CHOCOLATE",
                                    "image": {
                                        "id": "d09a8ad6-4e32-3a67-82a8-cf40c0a2aa08",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d09a8ad6-4e32-3a67-82a8-cf40c0a2aa08.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "michaelkors_30F5GY5M2L",
                            "name": "Nolita Medium Nubuck Shoulder Bag",
                            "nameCN": "【檀健次同款】中号磨砂皮革 Nolita 单肩包",
                            "description": [
                                "We reimagined our beloved Nolita in a compact silhouette with a longer, adjustable shoulder strap that converts the design into a crossbody. Complete with gold-tone hardware and a polished MK Pop Charm for added character, this top-zip bag opens to an array of pockets sized to safely hold a day’s worth of essentials and more.",
                                "• Shoulder bag",
                                "• Nubuck",
                                "• 100% nubuck",
                                "• Trim: 100% leather",
                                "• Gold-tone hardware",
                                "• 15.75”W X 9.75”H X 5”D",
                                "• Adjustable strap: 11\"-28.5\"",
                                "• Interior details: back slip pocket, 2 front slip pockets",
                                "• Lining: 37% rayon/24% polyester/24% cotton/15% linen",
                                "• Zip fastening",
                                "• Dust bag not included",
                                "• Imported",
                                "• Shoulder bag\n• Nubuck\n• 100% nubuck\n• Trim: 100% leather\n• Gold-tone hardware\n• 15.75”W X 9.75”H X 5”D\n• Adjustable strap: 11\"-28.5\"\n• Interior details: back slip pocket, 2 front slip pockets\n• Lining: 37% rayon/24% polyester/24% cotton/15% linen\n• Zip fastening\n• Dust bag not included\n• Imported"
                            ],
                            "merchantId": "89896b29-9191-a09f-8ffd-e872a296da04",
                            "brand": "Michael Kors",
                            "displayBrand": "Michael Kors",
                            "brandId": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                            "category": "medium|bag|convertible|nubuck|nolita|shoulder|women",
                            "categoryIds": [
                                "e05"
                            ],
                            "priceTag": "$294.25",
                            "priceTagCN": "¥2155",
                            "labels": [],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Michael Kors",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$6",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 103,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "7db9b053-a010-3ee4-aca8-42b678f33c18",
                                    "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/1/optimized/15240131_fpx.tif?op_sharpen=1&wid=700",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7db9b053-a010-3ee4-aca8-42b678f33c18.jpg",
                                        "width": 700,
                                        "height": 875,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7db9b053-a010-3ee4-aca8-42b678f33c18.jpg",
                                        "width": 280,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Salt",
                                    "image": {
                                        "id": "04e3c8e5-ea1f-38cd-81a0-ce49a935900d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/04e3c8e5-ea1f-38cd-81a0-ce49a935900d.jpg",
                                            "width": 40,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Secret Sage",
                                    "image": {
                                        "id": "7ef0240d-b919-3cd4-8754-4ddbc140006f",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7ef0240d-b919-3cd4-8754-4ddbc140006f.jpg",
                                            "width": 40,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "bloomingdales_5602414",
                            "name": "We The Free Emerson Tote",
                            "nameCN": "FreePeople爆款流浪包 ",
                            "description": [
                                "Top handles, 11.6\" drop",
                                "Removable, adjustable crossbody strap, 21.3\" drop",
                                "Dimensions: 16.5\"W x 7\"D x 14\"H",
                                "Zip closure",
                                "Three exterior zip pockets & one slip pocket; one interior zip pocket & one slip pocket",
                                "Worn leather design",
                                "Branded metal hangtag",
                                "Lined",
                                "Main: leather; lining: cotton",
                                "Made in India",
                                "Web ID: 5602414"
                            ],
                            "merchantId": "34b7c946-2aec-d75b-66f0-81fcea0ce875",
                            "brand": "Free People",
                            "displayBrand": "Free People",
                            "brandId": "0e42f86f-7098-3292-99dc-2cd5171579c2",
                            "category": "women|handbags|handbag",
                            "categoryIds": [
                                "e07"
                            ],
                            "priceTag": "$244.25",
                            "priceTagCN": "¥1789",
                            "labels": [],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Bloomingdale's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$5",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 96,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                }
            ]
        },
        {
            "id": "womens_shoes",
            "title": "女鞋",
            "categoryIds": [
                "k1",
                "7e"
            ],
            "brands": [
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/b438b974-2fdd-3159-a9ca-f0767f69085a.jpg",
                    "id": "d9f32436-125b-37e0-bd11-fbf1fa62424a",
                    "name": "彪马",
                    "categoryIds": [
                        "12",
                        "k1",
                        "7e"
                    ],
                    "pathname": "biao1-ma3"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/fb253eab-ec87-3b9d-9d57-3723311a92eb.jpg",
                    "id": "0748f099-3da0-30ae-9370-d8ef28fb8766",
                    "name": "UGG",
                    "categoryIds": [
                        "12",
                        "k1",
                        "7e"
                    ],
                    "pathname": "ugg"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/37485c44-d18f-3991-83a8-856a5b9652c4.jpg",
                    "id": "57f417b4-38b1-3da6-b3e6-61e998e5bb92",
                    "name": "Keen",
                    "categoryIds": [
                        "12",
                        "k1",
                        "7e"
                    ],
                    "pathname": "keen"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/59591880-1b61-3f6b-b5a9-ac70e925e8aa.jpg",
                    "id": "41aabf5c-212b-3aa2-9014-0086c2409af8",
                    "name": "斯图尔特·韦茨曼",
                    "categoryIds": [
                        "12",
                        "k1",
                        "7e"
                    ],
                    "pathname": "si1-tu2-er3-te4-wei2-ci2-man4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/bd20ea55-2393-3fef-bfd5-3a214496a650.jpg",
                    "id": "5cb502e0-ff52-341b-a304-54307164573c",
                    "name": "橘滋",
                    "categoryIds": [
                        "12",
                        "k1",
                        "7e"
                    ],
                    "pathname": "ju2-zi1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/4a24eb73-1a08-3133-b4fe-cd910de772bf.jpg",
                    "id": "6a97ca61-7ed8-3bd8-8a75-ff9ca539a4e4",
                    "name": "匡威",
                    "categoryIds": [
                        "12",
                        "k1",
                        "7e"
                    ],
                    "pathname": "kuang1-wei1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/d9fa2c6a-a3a2-34a0-ae66-42c422137849.jpg",
                    "id": "f71b8edc-b242-3bd8-b6a0-474e90ab0010",
                    "name": "斐乐",
                    "categoryIds": [
                        "12",
                        "k1",
                        "7e"
                    ],
                    "pathname": "fei3-le4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/3f0beab9-2056-3fbf-8d89-5b78676919c3.jpg",
                    "id": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                    "name": "迈克高仕",
                    "categoryIds": [
                        "12",
                        "k1",
                        "7e"
                    ],
                    "pathname": "mai4-ke4-gao1-shi4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/61e9e625-bc11-37fb-b32b-eb6e8a16173e.jpg",
                    "id": "329e755c-e2a9-3d39-8777-e24933abef28",
                    "name": "山姆·爱德曼",
                    "categoryIds": [
                        "12",
                        "k1",
                        "7e"
                    ],
                    "pathname": "shan1-mu3-ai4-de2-man4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/2d0cdc8a-e6d4-3642-b008-f236b8e0b5d2.jpg",
                    "id": "25cce1e7-2381-3267-bf74-9aad879d70c1",
                    "name": "凯特·丝蓓",
                    "categoryIds": [
                        "12",
                        "k1",
                        "7e"
                    ],
                    "pathname": "kai3-te4-si1-bei4"
                }
            ],
            "productList": [
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "70308757-0abc-370e-9032-dbb0d92df797",
                                    "originalURL": "https://images.lululemon.com/is/image/lululemon/LW9FFIS_049729_1",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/70308757-0abc-370e-9032-dbb0d92df797.jpg",
                                        "width": 853,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/70308757-0abc-370e-9032-dbb0d92df797.jpg",
                                        "width": 292,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Chambray/Chambray/Chambray",
                                    "image": {
                                        "id": "90fbdbe2-65bb-39fd-b37c-1d32fca8d175",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/90fbdbe2-65bb-39fd-b37c-1d32fca8d175.jpg",
                                            "width": 42,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "lululemon_11740044",
                            "name": "Women's Cityverse Sneaker",
                            "nameCN": "女款休闲运动鞋 多款配色",
                            "description": [
                                "Designed for Casual, Travel, Work",
                                "None:",
                                "Fit and Feel:",
                                "Cityverse fits true to size for most",
                                "Those with a wider foot should consider going up a half size",
                                "Tailored to the unique morphology of the female foot for a better fit and feel",
                                "Product Features:",
                                "Mixed material upper with two different lace options that let you customize the look",
                                "Two different lace options let you customize your look",
                                "Layers of contoured cushioning create the perfect balance of comfort and support",
                                "Cupped rubber outsole enhances traction",
                                "Material and care:",
                                "Material and care:",
                                "Do Not Wash",
                                "Do Not Bleach",
                                "Do Not Tumble Dry",
                                "Do Not Iron",
                                "Do Not Dry Clean",
                                "Spot Clean"
                            ],
                            "merchantId": "28b9c32c-4182-3023-9f14-e4ffb3728eaf",
                            "brand": "lululemon",
                            "displayBrand": "Lululemon",
                            "brandId": "273c0224-d38f-3ad8-96cc-56abdf6c5e8d",
                            "category": "shoes|Women",
                            "categoryIds": [
                                "k1b",
                                "783"
                            ],
                            "priceTag": "$85.70",
                            "priceTagCN": "¥628",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "us_8"
                                    ],
                                    "name": "8",
                                    "displayName": "美码8",
                                    "type": "us"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "5.7折",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Lululemon",
                        "origin": "[加拿大]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "5.7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$2",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 1227,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "加拿大",
                        "buoy": {
                            "remainingSizes": "剩8码",
                            "buoyId": "REMAINING_SIZES"
                        }
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "4e9ced69-0ac5-32d8-98eb-142c115b317b",
                                    "originalURL": "https://m.media-amazon.com/images/I/71KDJThrHML.jpg",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4e9ced69-0ac5-32d8-98eb-142c115b317b.jpg",
                                        "width": 878,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4e9ced69-0ac5-32d8-98eb-142c115b317b.jpg",
                                        "width": 300,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Black Extra Tough 50/50/Ajax",
                                    "image": {
                                        "id": "b8858ad4-ad87-3891-a192-c044ee2f01e5",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b8858ad4-ad87-3891-a192-c044ee2f01e5.jpg",
                                            "width": 43,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Black Wyoming",
                                    "image": {
                                        "id": "e7c5b0b4-57dd-3189-b524-b98045e03485",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e7c5b0b4-57dd-3189-b524-b98045e03485.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Dark Brown Crazy Horse",
                                    "image": {
                                        "id": "0582cbc9-a768-3bc2-874f-c1b126997d0a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0582cbc9-a768-3bc2-874f-c1b126997d0a.jpg",
                                            "width": 43,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "zappos_9520939",
                            "name": "Reeder",
                            "nameCN": "马丁博士Reeder鞋  Coyseio主理人同款",
                            "description": [
                                "Versatile and elegant, the Dr. Martens® Reeder are designed to elevate your everyday style while offering you the desired comfort.",
                                "Textile and synthetic upper.",
                                "Breathable textile lining and insole.",
                                "Cushioned comfort footbed.",
                                "Traditional lace-up closure for a secure fit.",
                                "Pull-tabs for easy wear.",
                                "Round toe silhouette.",
                                "Durable and flexible synthetic outsole.",
                                "Imported.",
                                "Product measurements were taken using size UK 8 (US Men's 9, US Women's 10), width Medium. Please note that measurements may vary by size.",
                                "Measurements:\n\n     Weight: 1 lb 3 oz"
                            ],
                            "merchantId": "725755ff-5f38-95fd-eec5-b3535bce2fd5",
                            "brand": "Dr. Martens",
                            "displayBrand": "Dr. Martens",
                            "brandId": "239cbe9a-021a-3368-b8f1-9e059d0b77fc",
                            "category": "free shipping|Women|men|zappos.com|reeder|shoes|Men|women|oxfords",
                            "categoryIds": [
                                "k1d"
                            ],
                            "priceTag": "$72.60",
                            "priceTagCN": "¥532",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "cm_22",
                                        "eu_36",
                                        "uk_3",
                                        "us_m_4",
                                        "us_w_5"
                                    ],
                                    "name": "UK 3 (US Men's 4, Women's 5)",
                                    "displayName": "欧码36(适合脚长22cm)",
                                    "type": "eu",
                                    "label": "36"
                                },
                                {
                                    "ids": [
                                        "cm_23",
                                        "eu_37",
                                        "uk_4",
                                        "us_m_5",
                                        "us_w_6"
                                    ],
                                    "name": "UK 4 (US Men's 5, Women's 6)",
                                    "displayName": "欧码37(适合脚长23cm)",
                                    "type": "eu",
                                    "label": "37"
                                },
                                {
                                    "ids": [
                                        "cm_23.5",
                                        "eu_38",
                                        "uk_5",
                                        "us_m_6",
                                        "us_w_7"
                                    ],
                                    "name": "UK 5 (US Men's 6, Women's 7)",
                                    "displayName": "欧码38(适合脚长23.5cm)",
                                    "type": "eu",
                                    "label": "38"
                                },
                                {
                                    "ids": [
                                        "cm_24.5",
                                        "eu_39",
                                        "uk_6",
                                        "us_m_7",
                                        "us_w_8"
                                    ],
                                    "name": "UK 6 (US Men's 7, US Women's 8)",
                                    "displayName": "欧码39(适合脚长24.5cm)",
                                    "type": "eu",
                                    "label": "39"
                                },
                                {
                                    "ids": [
                                        "cm_25.5",
                                        "eu_41",
                                        "uk_7",
                                        "us_m_8",
                                        "us_w_9"
                                    ],
                                    "name": "UK 7 (US Men's 8, US Women's 9)",
                                    "displayName": "欧码41(适合脚长25.5cm)",
                                    "type": "eu",
                                    "label": "41"
                                },
                                {
                                    "ids": [
                                        "cm_26",
                                        "eu_42",
                                        "uk_8",
                                        "us_m_9",
                                        "us_w_10"
                                    ],
                                    "name": "UK 8 (US Men's 9, US Women's 10)",
                                    "displayName": "欧码42(适合脚长26cm)",
                                    "type": "eu",
                                    "label": "42"
                                },
                                {
                                    "ids": [
                                        "cm_27",
                                        "eu_43",
                                        "uk_9",
                                        "us_m_10",
                                        "us_w_11"
                                    ],
                                    "name": "UK 9 (US Men's 10, US Women's 11)",
                                    "displayName": "欧码43(适合脚长27cm)",
                                    "type": "eu",
                                    "label": "43"
                                },
                                {
                                    "ids": [
                                        "cm_28",
                                        "eu_45",
                                        "uk_10",
                                        "us_m_11",
                                        "us_w_12"
                                    ],
                                    "name": "UK 10 (US Men's 11, Women's 12)",
                                    "displayName": "欧码45(适合脚长28cm)",
                                    "type": "eu",
                                    "label": "45"
                                },
                                {
                                    "ids": [
                                        "cm_29",
                                        "eu_46",
                                        "uk_11",
                                        "us_m_12",
                                        "us_w_13"
                                    ],
                                    "name": "UK 11 (US Men's 12, Women's 13)",
                                    "displayName": "欧码46(适合脚长29cm)",
                                    "type": "eu",
                                    "label": "46"
                                },
                                {
                                    "ids": [
                                        "cm_29.5",
                                        "eu_47",
                                        "uk_12",
                                        "us_m_13",
                                        "us_w_14"
                                    ],
                                    "name": "UK 12 (US Men's 13, Women's 14)",
                                    "displayName": "欧码47(适合脚长29.5cm)",
                                    "type": "eu",
                                    "label": "47"
                                },
                                {
                                    "ids": [
                                        "eu_48",
                                        "uk_13",
                                        "us_m_14",
                                        "us_w_15"
                                    ],
                                    "name": "UK 13 (US Men's 14, Women's 15)",
                                    "displayName": "欧码48",
                                    "type": "eu",
                                    "label": "48"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "7.2折起",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Zappos",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "tideShoes": true,
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "7.2折起",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 337,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "fb253eab-ec87-3b9d-9d57-3723311a92eb",
                                    "originalURL": "https://n.nordstrommedia.com/it/c3aace0e-ff10-47d9-b4b4-18e4880a48b2.jpeg",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fb253eab-ec87-3b9d-9d57-3723311a92eb.jpg",
                                        "width": 668,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fb253eab-ec87-3b9d-9d57-3723311a92eb.jpg",
                                        "width": 228,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Cbg",
                                    "image": {
                                        "id": "65da2d88-eadf-34d8-ae0f-8ab3aa05aca4",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/65da2d88-eadf-34d8-ae0f-8ab3aa05aca4.jpg",
                                            "width": 31,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Black / Birch",
                                    "image": {
                                        "id": "97711845-f528-3ae8-ba11-067baaf6b228",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/97711845-f528-3ae8-ba11-067baaf6b228.jpg",
                                            "width": 31,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Mustard Seed / Cream",
                                    "image": {
                                        "id": "53bd96f1-be81-32fa-b16d-9c7a3f290a0c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/53bd96f1-be81-32fa-b16d-9c7a3f290a0c.jpg",
                                            "width": 31,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "nordstromrack_8582203",
                            "name": "Tasman Waterproof Hybrid Slip-On",
                            "nameCN": "秋季男女同款 厚底塔斯曼时尚雪地靴（可能无鞋盒）",
                            "description": [
                                "This updated version of the Tasman slip-on lets you brave any type of conditions, featuring waterproof suede and seam-sealed construction along with a lining of UGGplush and genuine shearling to keep you warm and cozy.",
                                "Waterproof: protects against rain, puddles and slush to keep feet dry in wet conditions",
                                "Adjustable toggle closure",
                                "Dua-density EVA midsole",
                                "Treadlite by UGG outsole for comfort",
                                "Leather upper/UGGplush wool-blend and genuine-shearling (Australia) lining/synthetic sole",
                                "Imported",
                                "Item #11048391"
                            ],
                            "merchantId": "f8828b5b-30d5-d492-d151-7b87aec09f96",
                            "brand": "UGG®",
                            "displayBrand": "UGG",
                            "brandId": "0748f099-3da0-30ae-9370-d8ef28fb8766",
                            "category": "mens|men|slippers|shoes|male",
                            "categoryIds": [
                                "k18",
                                "k04"
                            ],
                            "priceTag": "$86.55",
                            "priceTagCN": "¥634",
                            "labels": [
                                "ADULT",
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "cm_23",
                                        "eu_38",
                                        "uk_4",
                                        "us_5"
                                    ],
                                    "name": "5",
                                    "displayName": "欧码38(适合脚长23cm)",
                                    "type": "eu",
                                    "label": "38"
                                },
                                {
                                    "ids": [
                                        "cm_24",
                                        "eu_39",
                                        "uk_5",
                                        "us_6"
                                    ],
                                    "name": "6",
                                    "displayName": "欧码39(适合脚长24cm)",
                                    "type": "eu",
                                    "label": "39"
                                },
                                {
                                    "ids": [
                                        "cm_25",
                                        "eu_40",
                                        "uk_6",
                                        "us_7"
                                    ],
                                    "name": "7",
                                    "displayName": "欧码40(适合脚长25cm)",
                                    "type": "eu",
                                    "label": "40"
                                },
                                {
                                    "ids": [
                                        "cm_26",
                                        "eu_41",
                                        "uk_7",
                                        "us_8"
                                    ],
                                    "name": "8",
                                    "displayName": "欧码41(适合脚长26cm)",
                                    "type": "eu",
                                    "label": "41"
                                },
                                {
                                    "ids": [
                                        "cm_33",
                                        "eu_49.5",
                                        "uk_14",
                                        "us_15"
                                    ],
                                    "name": "15",
                                    "displayName": "欧码49.5(适合脚长33cm)",
                                    "type": "eu",
                                    "label": "49.5"
                                },
                                {
                                    "ids": [
                                        "cm_34",
                                        "eu_50.5",
                                        "uk_15",
                                        "us_16"
                                    ],
                                    "name": "16",
                                    "displayName": "欧码50.5(适合脚长34cm)",
                                    "type": "eu",
                                    "label": "50.5"
                                },
                                {
                                    "ids": [
                                        "cm_35",
                                        "eu_51",
                                        "uk_16",
                                        "us_17"
                                    ],
                                    "name": "17",
                                    "displayName": "欧码51(适合脚长35cm)",
                                    "type": "eu",
                                    "label": "51"
                                },
                                {
                                    "ids": [
                                        "cm_36",
                                        "eu_52",
                                        "uk_17",
                                        "us_18"
                                    ],
                                    "name": "18",
                                    "displayName": "欧码52(适合脚长36cm)",
                                    "type": "eu",
                                    "label": "52"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4.9折起",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Nordstrom Rack",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4.9折起",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$2",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 291,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "6fb4fdea-37cb-369a-9bcc-1b0d610f48bb",
                                    "originalURL": "https://n.nordstrommedia.com/it/417f6c96-152f-4bbe-887f-8a5eadddbf4c.jpeg",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6fb4fdea-37cb-369a-9bcc-1b0d610f48bb.jpg",
                                        "width": 668,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6fb4fdea-37cb-369a-9bcc-1b0d610f48bb.jpg",
                                        "width": 228,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Che",
                                    "image": {
                                        "id": "d54d8ec8-809c-303a-91f3-b74845027dfc",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d54d8ec8-809c-303a-91f3-b74845027dfc.jpg",
                                            "width": 31,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "nordstromrack_7518609",
                            "name": "Tazzlita Genuine Shearling Trim Platform Slipper",
                            "nameCN": "女款厚底保暖鞋",
                            "description": [
                                "Pillowy quilting and a genuine-shearling collar lend indelible coziness to this boosted platform slipper. The comfort continues inside with lining made from UGGplush™, a moisture-wicking textile made from a wool-rich blend but crafted to feel and wear like genuine shearling.",
                                "1 3/4\" platform (size 11)",
                                "Leather and genuine-shearling upper/UGGplush wool-blend lining/synthetic sole",
                                "Shearling may be sourced from Australia, Ireland, Spain, the UK or the USA. See packaging for confirmed country of origin",
                                "Imported",
                                "Item #10024531"
                            ],
                            "merchantId": "f8828b5b-30d5-d492-d151-7b87aec09f96",
                            "brand": "UGG®",
                            "displayBrand": "UGG",
                            "brandId": "0748f099-3da0-30ae-9370-d8ef28fb8766",
                            "category": "slippers|shoes|female|women",
                            "categoryIds": [
                                "k18"
                            ],
                            "priceTag": "$99.65",
                            "priceTagCN": "¥730",
                            "labels": [
                                "ADULT",
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "cm_24",
                                        "eu_38",
                                        "uk_5",
                                        "us_7"
                                    ],
                                    "name": "7",
                                    "displayName": "欧码38(适合脚长24cm)",
                                    "type": "eu",
                                    "label": "38"
                                },
                                {
                                    "ids": [
                                        "cm_25",
                                        "eu_39",
                                        "uk_6",
                                        "us_8"
                                    ],
                                    "name": "8",
                                    "displayName": "欧码39(适合脚长25cm)",
                                    "type": "eu",
                                    "label": "39"
                                },
                                {
                                    "ids": [
                                        "cm_26",
                                        "eu_40",
                                        "uk_7",
                                        "us_9"
                                    ],
                                    "name": "9",
                                    "displayName": "欧码40(适合脚长26cm)",
                                    "type": "eu",
                                    "label": "40"
                                },
                                {
                                    "ids": [
                                        "cm_27",
                                        "eu_41",
                                        "uk_8",
                                        "us_10"
                                    ],
                                    "name": "10",
                                    "displayName": "欧码41(适合脚长27cm)",
                                    "type": "eu",
                                    "label": "41"
                                },
                                {
                                    "ids": [
                                        "cm_28",
                                        "eu_42",
                                        "uk_9",
                                        "us_11"
                                    ],
                                    "name": "11",
                                    "displayName": "欧码42(适合脚长28cm)",
                                    "type": "eu",
                                    "label": "42"
                                },
                                {
                                    "ids": [
                                        "cm_29",
                                        "eu_43",
                                        "uk_10",
                                        "us_12"
                                    ],
                                    "name": "12",
                                    "displayName": "欧码43(适合脚长29cm)",
                                    "type": "eu",
                                    "label": "43"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "5.9折",
                        "activityOffs": [],
                        "merchantName": "Nordstrom Rack",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "5.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 164,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "4e94ad29-f28e-3dc8-9355-c848616423fb",
                                    "originalURL": "https://www.steepandcheap.com/images/items/900/LOW/LOWZ16O/STEBLU.jpg",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4e94ad29-f28e-3dc8-9355-c848616423fb.jpg",
                                        "width": 900,
                                        "height": 900,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4e94ad29-f28e-3dc8-9355-c848616423fb.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Steel Blue",
                                    "image": {
                                        "id": "247ae53e-c75a-3c2c-8a88-02562b9ef645",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/247ae53e-c75a-3c2c-8a88-02562b9ef645.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "backcountry_LOWZ16O",
                            "name": "Zephyr GTX Mid TF Hiking Boot - Women's",
                            "nameCN": "女款Zephyr GTX Mid TF 户外登山靴",
                            "description": [
                                "Lowa made the Zephyr GTX Mid TF Hiking Boot so working professionals and day hikers have something rugged and reliable to step into each time they set off. If the breathable and waterproof GORE-TEX Extended Comfort membrane wasn't enough already, the Zephyr has a DuraPU midsole and ATC footbed for that additional cushion we'll come to cherish during long days.",
                                "Upper Material: split leather, fabric;",
                                "Waterproofing: GORE-TEX Extended Comfort;",
                                "Closure: lace;",
                                "Footbed: ATC;",
                                "Midsole: double injection DuraPU;",
                                "Sole: Lowa Cross II;",
                                "Claimed Weight: [single] 1lb 1oz;",
                                "Activity: casual, hiking;",
                                "Manufacturer Warranty: 1 year;",
                                "storecredits: 0.0;"
                            ],
                            "merchantId": "f9ffaba4-3dda-3155-8340-25ca2a7643d2",
                            "brand": "Lowa",
                            "displayBrand": "Lowa",
                            "brandId": "1a2ffe36-502b-3610-a6c5-71867b7f458c",
                            "category": "womens hiking &amp; backpacking boots &amp; shoes|womens|womens footwear|womens hiking &amp; backpacking boots",
                            "categoryIds": [
                                "789",
                                "k10"
                            ],
                            "priceTag": "$104.30",
                            "priceTagCN": "¥764",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "us_8.5"
                                    ],
                                    "name": "8.5",
                                    "displayName": "美码8.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_9"
                                    ],
                                    "name": "9.0",
                                    "displayName": "美码9",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_9.5"
                                    ],
                                    "name": "9.5",
                                    "displayName": "美码9.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_10.5"
                                    ],
                                    "name": "10.5",
                                    "displayName": "美码10.5",
                                    "type": "us"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "3.9折起",
                        "activityOffs": [],
                        "merchantName": "Backcountry",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "3.9折起",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 147,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "0ecf52f5-a36d-328d-a085-f435f84b9abd",
                                    "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/GZ8872_1l.jpg?v=1731059761",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0ecf52f5-a36d-328d-a085-f435f84b9abd.jpg",
                                        "width": 1000,
                                        "height": 1000,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0ecf52f5-a36d-328d-a085-f435f84b9abd.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "shoebacca_9646297252122",
                            "name": "adidas Yeezy Quantum Basketball Shoes",
                            "nameCN": "男士Adidas Yeezy QNTM 中帮 篮球鞋  GZ8872",
                            "description": [
                                "The Adidas Yeezy Basketball Quantum features an upper composed of a mesh underlay combined with an RPU cage that wraps the upper for structure and durability, while the suede toe overlay offers toe protection and durability. The knitted elastic collar provides a premium lock down feel and multi-directional support. Reflective material throughout the inner webbing and heel counter emits light in darkness. The Adidas Yeezy Basketball Quantum elevates the cushioning experience with a re-engineered full-length drop-in Boost midsole with a high-performance shank that provides optimal comfort where athletes need it most, while the herringbone rubber outsole provides superior traction for dynamic cuts and pivots.",
                                "Upper composed of a mesh underlay combined with an RPU cage",
                                "Lace up closure",
                                "BOOST midsole",
                                "Knitted elastic collar provides a premium lock down feel",
                                "Herringbone rubber outsole",
                                "For a better fit we recommend purchasing 1/2 size up",
                                "SKU: \nGZ8872",
                                "Color: \nBlue",
                                "Material: \nMesh",
                                "Sport: \nBasketball",
                                "Style: \nLace Up"
                            ],
                            "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                            "brand": "adidas",
                            "displayBrand": "Adidas",
                            "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                            "category": "sapg::adi07925 ~ color::blue|shoes|casual|athletic|men|adult|basketball|mens|clearance",
                            "categoryIds": [
                                "7e1"
                            ],
                            "priceTag": "$70.35",
                            "priceTagCN": "¥516",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "cm_22",
                                        "eu_36",
                                        "uk_3.5",
                                        "us_4"
                                    ],
                                    "name": "4",
                                    "displayName": "欧码36(适合脚长22cm)",
                                    "type": "eu",
                                    "label": "36"
                                },
                                {
                                    "ids": [
                                        "cm_22.5",
                                        "eu_36 2/3",
                                        "uk_4",
                                        "us_4.5"
                                    ],
                                    "name": "4.5",
                                    "displayName": "欧码36 2/3(适合脚长22.5cm)",
                                    "type": "eu",
                                    "label": "36 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_23",
                                        "eu_37 1/3",
                                        "uk_4.5",
                                        "us_5"
                                    ],
                                    "name": "5",
                                    "displayName": "欧码37 1/3(适合脚长23cm)",
                                    "type": "eu",
                                    "label": "37 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_23.5",
                                        "eu_38",
                                        "uk_5",
                                        "us_5.5"
                                    ],
                                    "name": "5.5",
                                    "displayName": "欧码38(适合脚长23.5cm)",
                                    "type": "eu",
                                    "label": "38"
                                },
                                {
                                    "ids": [
                                        "cm_24",
                                        "eu_38 2/3",
                                        "uk_5.5",
                                        "us_6"
                                    ],
                                    "name": "6",
                                    "displayName": "欧码38 2/3(适合脚长24cm)",
                                    "type": "eu",
                                    "label": "38 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_24.5",
                                        "eu_39 1/3",
                                        "uk_6",
                                        "us_6.5"
                                    ],
                                    "name": "6.5",
                                    "displayName": "欧码39 1/3(适合脚长24.5cm)",
                                    "type": "eu",
                                    "label": "39 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_25",
                                        "eu_40",
                                        "uk_6.5",
                                        "us_7"
                                    ],
                                    "name": "7",
                                    "displayName": "欧码40(适合脚长25cm)",
                                    "type": "eu",
                                    "label": "40"
                                },
                                {
                                    "ids": [
                                        "cm_25.5",
                                        "eu_40 2/3",
                                        "uk_7",
                                        "us_7.5"
                                    ],
                                    "name": "7.5",
                                    "displayName": "欧码40 2/3(适合脚长25.5cm)",
                                    "type": "eu",
                                    "label": "40 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_26",
                                        "eu_41 1/3",
                                        "uk_7.5",
                                        "us_8"
                                    ],
                                    "name": "8",
                                    "displayName": "欧码41 1/3(适合脚长26cm)",
                                    "type": "eu",
                                    "label": "41 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_26.5",
                                        "eu_42",
                                        "uk_8",
                                        "us_8.5"
                                    ],
                                    "name": "8.5",
                                    "displayName": "欧码42(适合脚长26.5cm)",
                                    "type": "eu",
                                    "label": "42"
                                },
                                {
                                    "ids": [
                                        "cm_27",
                                        "eu_42 2/3",
                                        "uk_8.5",
                                        "us_9"
                                    ],
                                    "name": "9",
                                    "displayName": "欧码42 2/3(适合脚长27cm)",
                                    "type": "eu",
                                    "label": "42 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_27.5",
                                        "eu_43 1/3",
                                        "uk_9",
                                        "us_9.5"
                                    ],
                                    "name": "9.5",
                                    "displayName": "欧码43 1/3(适合脚长27.5cm)",
                                    "type": "eu",
                                    "label": "43 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_28",
                                        "eu_44",
                                        "uk_9.5",
                                        "us_10"
                                    ],
                                    "name": "10",
                                    "displayName": "欧码44(适合脚长28cm)",
                                    "type": "eu",
                                    "label": "44"
                                },
                                {
                                    "ids": [
                                        "cm_28.5",
                                        "eu_44 2/3",
                                        "uk_10",
                                        "us_10.5"
                                    ],
                                    "name": "10.5",
                                    "displayName": "欧码44 2/3(适合脚长28.5cm)",
                                    "type": "eu",
                                    "label": "44 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_29",
                                        "eu_45 1/3",
                                        "uk_10.5",
                                        "us_11"
                                    ],
                                    "name": "11",
                                    "displayName": "欧码45 1/3(适合脚长29cm)",
                                    "type": "eu",
                                    "label": "45 1/3"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "2.7折",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "SHOEBACCA",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "tideShoes": true,
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "2.7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 187,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "e24b276d-8485-31f7-905c-103b9d8758da",
                                    "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/A0891U_01_b2_s1_a1_m51_80870d6f-5ce1-4229-a0fd-518d15f331ce_750x.jpg?v=1753741023",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e24b276d-8485-31f7-905c-103b9d8758da.jpg",
                                        "width": 683,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e24b276d-8485-31f7-905c-103b9d8758da.jpg",
                                        "width": 233,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Black",
                                    "image": {
                                        "id": "01022903-f83e-3c99-b890-10c464cf632a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/01022903-f83e-3c99-b890-10c464cf632a.jpg",
                                            "width": 33,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Sandstone",
                                    "image": {
                                        "id": "2fb7d5b8-38e7-3e50-9b6e-d3d1cc34372e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2fb7d5b8-38e7-3e50-9b6e-d3d1cc34372e.jpg",
                                            "width": 33,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "aloyoga_A0891U",
                            "name": "ALO Sunset Sneaker - Sandstone",
                            "nameCN": "女士 Sunset系列 休闲运动鞋",
                            "description": [
                                "With a sleek silhouette and a name that nods to the energy of Sunset Boulevard, the Sunset Sneaker is the epitome of effortless and elevated. Designed with a recovery foam insole, it blends performance-driven comfort with polished street sensibility. Consider this the shoe that goes wherever the day takes you."
                            ],
                            "merchantId": "ad4a17c1-7ed8-e5d2-acee-a6d9711d1ef0",
                            "brand": "Alo Yoga",
                            "displayBrand": "Alo",
                            "brandId": "1b2ccf52-b54e-32c9-868c-a24fbe164919",
                            "category": "yoga|alo",
                            "categoryIds": [
                                "k1b"
                            ],
                            "priceTag": "$234",
                            "priceTagCN": "¥1714",
                            "labels": [],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "us_4.5"
                                    ],
                                    "name": "4.5W",
                                    "displayName": "美码4.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_5"
                                    ],
                                    "name": "5W",
                                    "displayName": "美码5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_5.5"
                                    ],
                                    "name": "5.5W",
                                    "displayName": "美码5.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_6"
                                    ],
                                    "name": "6W",
                                    "displayName": "美码6",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_6.5"
                                    ],
                                    "name": "6.5W",
                                    "displayName": "美码6.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_7"
                                    ],
                                    "name": "7W",
                                    "displayName": "美码7",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_7.5"
                                    ],
                                    "name": "7.5W",
                                    "displayName": "美码7.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_8"
                                    ],
                                    "name": "8W",
                                    "displayName": "美码8",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_8.5"
                                    ],
                                    "name": "8.5W",
                                    "displayName": "美码8.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_9"
                                    ],
                                    "name": "9W",
                                    "displayName": "美码9",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_9.5"
                                    ],
                                    "name": "9.5W",
                                    "displayName": "美码9.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_10"
                                    ],
                                    "name": "10W",
                                    "displayName": "美码10",
                                    "type": "us"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "activityOffs": [],
                        "merchantName": "Alo yoga",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 103,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "4a24eb73-1a08-3133-b4fe-cd910de772bf",
                                    "originalURL": "https://res.cloudinary.com/ssenseweb/image/upload/241799F127021_1.jpg",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4a24eb73-1a08-3133-b4fe-cd910de772bf.jpg",
                                        "width": 856,
                                        "height": 512,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4a24eb73-1a08-3133-b4fe-cd910de772bf.jpg",
                                        "width": 350,
                                        "height": 209,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "ssenseus_14363761",
                            "name": "Black Chuck Taylor All Star Pro Sneakers",
                            "nameCN": "匡威Black Chuck Taylor All Star Pro运动鞋",
                            "description": [
                                "Converse",
                                "Black Chuck Taylor All Star Pro Sneakers",
                                "High-top grained leather sneakers in black.",
                                "· Rubber cap toe",
                                "· Lace-up closure",
                                "· Concealed elasticized gussets at tongue",
                                "· Logo patch at inner side",
                                "· Eyelets at inner side",
                                "· Rubberized logo patch at heel",
                                "· CX-cushioned footbed",
                                "· Fleece lining",
                                "· Treaded rubber sole",
                                "· Contrast stitching in white",
                                "Supplier color: Black/White/Black",
                                "Upper: leather. Sole: rubber.",
                                "Made in Viet Nam.",
                                "241799F127021"
                            ],
                            "merchantId": "ddaac9a3-3bca-3cfb-9503-421dd9b59f3a",
                            "brand": "Converse",
                            "displayBrand": "Converse",
                            "brandId": "6a97ca61-7ed8-3bd8-8a75-ff9ca539a4e4",
                            "category": "women|high top sneakers",
                            "categoryIds": [
                                "7e3"
                            ],
                            "priceTag": "$22.60",
                            "priceTagCN": "¥166",
                            "labels": [
                                "final_sale",
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "cm_22",
                                        "eu_35",
                                        "uk_3",
                                        "us_5"
                                    ],
                                    "name": "US 5 = IT 35",
                                    "displayName": "欧码35(适合脚长22cm)",
                                    "type": "eu",
                                    "label": "35"
                                },
                                {
                                    "ids": [
                                        "cm_22.5",
                                        "eu_36",
                                        "uk_3.5",
                                        "us_5.5"
                                    ],
                                    "name": "US 5.5 = IT 35.5",
                                    "displayName": "欧码36(适合脚长22.5cm)",
                                    "type": "eu",
                                    "label": "36"
                                },
                                {
                                    "ids": [
                                        "cm_23",
                                        "eu_36.5",
                                        "uk_4",
                                        "us_6"
                                    ],
                                    "name": "US 6 = IT 36",
                                    "displayName": "欧码36.5(适合脚长23cm)",
                                    "type": "eu",
                                    "label": "36.5"
                                },
                                {
                                    "ids": [
                                        "cm_23.5",
                                        "eu_37",
                                        "uk_4.5",
                                        "us_6.5"
                                    ],
                                    "name": "US 6.5 = IT 36.5",
                                    "displayName": "欧码37(适合脚长23.5cm)",
                                    "type": "eu",
                                    "label": "37"
                                },
                                {
                                    "ids": [
                                        "cm_24",
                                        "eu_37.5",
                                        "uk_5",
                                        "us_7"
                                    ],
                                    "name": "US 7 = IT 37",
                                    "displayName": "欧码37.5(适合脚长24cm)",
                                    "type": "eu",
                                    "label": "37.5"
                                },
                                {
                                    "ids": [
                                        "cm_24.5",
                                        "eu_38",
                                        "uk_5.5",
                                        "us_7.5"
                                    ],
                                    "name": "US 7.5 = IT 37.5",
                                    "displayName": "欧码38(适合脚长24.5cm)",
                                    "type": "eu",
                                    "label": "38"
                                },
                                {
                                    "ids": [
                                        "cm_24.5",
                                        "eu_39",
                                        "uk_6",
                                        "us_8"
                                    ],
                                    "name": "US 8 = IT 38",
                                    "displayName": "欧码39(适合脚长24.5cm)",
                                    "type": "eu",
                                    "label": "39"
                                },
                                {
                                    "ids": [
                                        "cm_25",
                                        "eu_39.5",
                                        "uk_6.5",
                                        "us_8.5"
                                    ],
                                    "name": "US 8.5 = IT 38.5",
                                    "displayName": "欧码39.5(适合脚长25cm)",
                                    "type": "eu",
                                    "label": "39.5"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "2.5折",
                        "activityOffs": [],
                        "merchantName": "Ssense US",
                        "origin": "[加拿大]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "tideShoes": true,
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "2.5折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 177,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "加拿大",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "f82b9de2-2b40-34a8-b004-3e0d31352e61",
                                    "originalURL": "https://m.media-amazon.com/images/I/71K8p3cYs6L.jpg",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f82b9de2-2b40-34a8-b004-3e0d31352e61.jpg",
                                        "width": 1024,
                                        "height": 768,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f82b9de2-2b40-34a8-b004-3e0d31352e61.jpg",
                                        "width": 350,
                                        "height": 263,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Amber",
                                    "image": {
                                        "id": "7c8ec038-a98c-3139-a169-8ca9619535d4",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7c8ec038-a98c-3139-a169-8ca9619535d4.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Black",
                                    "image": {
                                        "id": "9d751a12-8093-3544-94fe-0d27d1cad093",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9d751a12-8093-3544-94fe-0d27d1cad093.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Black Larse",
                                    "image": {
                                        "id": "ff3a2682-5c5b-3186-99a9-694ea8243c8a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ff3a2682-5c5b-3186-99a9-694ea8243c8a.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Black Snake",
                                    "image": {
                                        "id": "a032d010-2ace-357d-acd8-f5a135432245",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a032d010-2ace-357d-acd8-f5a135432245.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Denim",
                                    "image": {
                                        "id": "ad385190-bba5-377c-9909-8ad5ee6d1da0",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ad385190-bba5-377c-9909-8ad5ee6d1da0.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Moonbeam",
                                    "image": {
                                        "id": "d3b62837-93ae-3c1f-a52f-e303d47e4829",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d3b62837-93ae-3c1f-a52f-e303d47e4829.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Natural",
                                    "image": {
                                        "id": "40348b7c-e13e-33e6-a59e-86b60cd5c147",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/40348b7c-e13e-33e6-a59e-86b60cd5c147.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Rust",
                                    "image": {
                                        "id": "6bf12302-01c4-35e7-baf6-81fd0be132bc",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6bf12302-01c4-35e7-baf6-81fd0be132bc.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Shining Sea",
                                    "image": {
                                        "id": "bdf4b040-641c-39c9-89af-5238a9da6715",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bdf4b040-641c-39c9-89af-5238a9da6715.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Silver/Blue",
                                    "image": {
                                        "id": "fdac7cfe-f8cf-34b0-a666-bf9999795a56",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fdac7cfe-f8cf-34b0-a666-bf9999795a56.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Sky Harbor",
                                    "image": {
                                        "id": "6761db0c-95a3-368a-ae97-1bffe216fa14",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6761db0c-95a3-368a-ae97-1bffe216fa14.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Sunbeam",
                                    "image": {
                                        "id": "fca8296e-a2e7-3f65-909a-3efed9242bc2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fca8296e-a2e7-3f65-909a-3efed9242bc2.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Sunstone",
                                    "image": {
                                        "id": "e230a649-e2e7-3c29-9a64-ed49dd08d956",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e230a649-e2e7-3c29-9a64-ed49dd08d956.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Teddy",
                                    "image": {
                                        "id": "deeb206b-128b-3adf-ab12-81650560d0d0",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/deeb206b-128b-3adf-ab12-81650560d0d0.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Vanilla",
                                    "image": {
                                        "id": "9a340326-56cf-3798-8201-450cce2f14c9",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9a340326-56cf-3798-8201-450cce2f14c9.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Web Linen",
                                    "image": {
                                        "id": "33e11b10-cb40-3f78-9395-3967bd6b0027",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/33e11b10-cb40-3f78-9395-3967bd6b0027.jpg",
                                            "width": 50,
                                            "height": 38,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "zappos_8867544",
                            "name": "Relaxed Comfort Sandal",
                            "nameCN": "女式 休闲舒适凉鞋",
                            "description": [
                                "Unwind, leave your worries behind, and simply relax and enjoy the comfort of the versatile SAS® Relaxed Walking Comfort Sandal.",
                                "Ultra-Puff™ cushioned linings that protect the foot with Super Soft topline construction eliminating harsh edges against the foot.",
                                "A broad, contoured footbed features soft Super Suede™ linings that molds to the natural arches and curves of your foot for maximum comfort and shock absorption.",
                                "It offers multi-layered Tripad® cushions designed to comfort all three pressure points: the inside ball, outside ball and heel for all-day support.",
                                "Three-point adjustability with durable buckles at each strap while a shock-absorbing wide outsole contours and rebounds with every step.",
                                "Made in the U.S.A.",
                                "WARNING",
                                "California's Proposition 65",
                                "Product measurements were taken using size 8, width M - Medium (B). Please note that measurements may vary by size.",
                                "Measurements:\n\n     Heel Height: 1 1/2 in\n     Weight: 10 oz"
                            ],
                            "merchantId": "725755ff-5f38-95fd-eec5-b3535bce2fd5",
                            "brand": "SAS",
                            "displayBrand": "SAS",
                            "brandId": "a8a64cef-262a-34de-8872-b68b63ab7cd8",
                            "category": "shoes|Women|zappos.com|sandals|free shipping|women|relaxed comfort sandal",
                            "categoryIds": [
                                "k1a"
                            ],
                            "priceTag": "$216.85",
                            "priceTagCN": "¥1588",
                            "labels": [],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "us_4"
                                    ],
                                    "name": "4",
                                    "displayName": "美码4",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_4.5"
                                    ],
                                    "name": "4.5",
                                    "displayName": "美码4.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_5"
                                    ],
                                    "name": "5",
                                    "displayName": "美码5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_5.5"
                                    ],
                                    "name": "5.5",
                                    "displayName": "美码5.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_6"
                                    ],
                                    "name": "6",
                                    "displayName": "美码6",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_6.5"
                                    ],
                                    "name": "6.5",
                                    "displayName": "美码6.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_7"
                                    ],
                                    "name": "7",
                                    "displayName": "美码7",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_7.5"
                                    ],
                                    "name": "7.5",
                                    "displayName": "美码7.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_8"
                                    ],
                                    "name": "8",
                                    "displayName": "美码8",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_8.5"
                                    ],
                                    "name": "8.5",
                                    "displayName": "美码8.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_9"
                                    ],
                                    "name": "9",
                                    "displayName": "美码9",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_9.5"
                                    ],
                                    "name": "9.5",
                                    "displayName": "美码9.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_10"
                                    ],
                                    "name": "10",
                                    "displayName": "美码10",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_10.5"
                                    ],
                                    "name": "10.5",
                                    "displayName": "美码10.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_11"
                                    ],
                                    "name": "11",
                                    "displayName": "美码11",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_11.5"
                                    ],
                                    "name": "11.5",
                                    "displayName": "美码11.5",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "us_12"
                                    ],
                                    "name": "12",
                                    "displayName": "美码12",
                                    "type": "us"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "activityOffs": [],
                        "merchantName": "Zappos",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 1321,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                }
            ]
        },
        {
            "id": "mens_shoes",
            "title": "男鞋",
            "categoryIds": [
                "k0",
                "75"
            ],
            "brands": [
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/c067c13d-5b04-3b3c-86a1-e10cdf594a5e.jpg",
                    "id": "28a34010-e84b-381f-b087-359c7e280a08",
                    "name": "阿迪达斯",
                    "categoryIds": [
                        "22",
                        "k0",
                        "71",
                        "75"
                    ],
                    "pathname": "a1-di2-da2-si1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/99542fcf-b8b7-37d0-8b3d-57f9d09f6cc1.jpg",
                    "id": "fb35adb5-fa93-3307-ab74-a644b26facee",
                    "name": "拉夫·劳伦",
                    "categoryIds": [
                        "22",
                        "k0",
                        "71",
                        "75"
                    ],
                    "pathname": "la1-fu1-lao2-lun2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/25d87e92-68ea-3d6e-b624-9559cee194dd.jpg",
                    "id": "d9f32436-125b-37e0-bd11-fbf1fa62424a",
                    "name": "彪马",
                    "categoryIds": [
                        "22",
                        "k0",
                        "71",
                        "75"
                    ],
                    "pathname": "biao1-ma3"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/218df886-ee2c-3a4c-b91a-98633c3b3b7a.jpg",
                    "id": "41fd220f-05ed-3d8c-96e3-b83af87d45d7",
                    "name": "耐克",
                    "categoryIds": [
                        "22",
                        "k0",
                        "71",
                        "75"
                    ],
                    "pathname": "nai4-ke4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/fb253eab-ec87-3b9d-9d57-3723311a92eb.jpg",
                    "id": "0748f099-3da0-30ae-9370-d8ef28fb8766",
                    "name": "UGG",
                    "categoryIds": [
                        "22",
                        "k0",
                        "71",
                        "75"
                    ],
                    "pathname": "ugg"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/500528e5-6ca6-3acc-9e7e-b7933a4254cc.jpg",
                    "id": "e0535e0b-8502-3951-b944-e2a9b523fc14",
                    "name": "新百伦",
                    "categoryIds": [
                        "22",
                        "k0",
                        "71",
                        "75"
                    ],
                    "pathname": "xin1-bai3-lun2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/5d273f15-82f9-36d7-a426-4516cdda7b12.jpg",
                    "id": "5bf37d50-5ab3-30fa-9fe9-5f8e95ed1a5b",
                    "name": "克拉克斯",
                    "categoryIds": [
                        "22",
                        "k0",
                        "71",
                        "75"
                    ],
                    "pathname": "ke4-la1-ke4-si1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/ce4358a8-772b-3d03-aa2a-b3c35ba4269c.jpg",
                    "id": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                    "name": "博柏利",
                    "categoryIds": [
                        "22",
                        "k0",
                        "71",
                        "75"
                    ],
                    "pathname": "bo2-bai3-li4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/39762288-d769-3b9e-857f-320fcaad5ee9.jpg",
                    "id": "793a9a91-1ab2-3c0e-8750-776de574f2f4",
                    "name": "迪亚多纳",
                    "categoryIds": [
                        "22",
                        "k0",
                        "71",
                        "75"
                    ],
                    "pathname": "di2-ya4-duo1-na4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/80adc900-a364-3226-8cfc-29a2146daa80.jpg",
                    "id": "7967aace-a6cf-3bb6-b619-1926e1796d5c",
                    "name": "ASOS",
                    "categoryIds": [
                        "22",
                        "k0",
                        "71",
                        "75"
                    ],
                    "pathname": "asos"
                }
            ],
            "productList": [
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "fb253eab-ec87-3b9d-9d57-3723311a92eb",
                                    "originalURL": "https://n.nordstrommedia.com/it/c3aace0e-ff10-47d9-b4b4-18e4880a48b2.jpeg",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fb253eab-ec87-3b9d-9d57-3723311a92eb.jpg",
                                        "width": 668,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fb253eab-ec87-3b9d-9d57-3723311a92eb.jpg",
                                        "width": 228,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Cbg",
                                    "image": {
                                        "id": "65da2d88-eadf-34d8-ae0f-8ab3aa05aca4",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/65da2d88-eadf-34d8-ae0f-8ab3aa05aca4.jpg",
                                            "width": 31,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Black / Birch",
                                    "image": {
                                        "id": "97711845-f528-3ae8-ba11-067baaf6b228",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/97711845-f528-3ae8-ba11-067baaf6b228.jpg",
                                            "width": 31,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Mustard Seed / Cream",
                                    "image": {
                                        "id": "53bd96f1-be81-32fa-b16d-9c7a3f290a0c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/53bd96f1-be81-32fa-b16d-9c7a3f290a0c.jpg",
                                            "width": 31,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "nordstromrack_8582203",
                            "name": "Tasman Waterproof Hybrid Slip-On",
                            "nameCN": "秋季男女同款 厚底塔斯曼时尚雪地靴（可能无鞋盒）",
                            "description": [
                                "This updated version of the Tasman slip-on lets you brave any type of conditions, featuring waterproof suede and seam-sealed construction along with a lining of UGGplush and genuine shearling to keep you warm and cozy.",
                                "Waterproof: protects against rain, puddles and slush to keep feet dry in wet conditions",
                                "Adjustable toggle closure",
                                "Dua-density EVA midsole",
                                "Treadlite by UGG outsole for comfort",
                                "Leather upper/UGGplush wool-blend and genuine-shearling (Australia) lining/synthetic sole",
                                "Imported",
                                "Item #11048391"
                            ],
                            "merchantId": "f8828b5b-30d5-d492-d151-7b87aec09f96",
                            "brand": "UGG®",
                            "displayBrand": "UGG",
                            "brandId": "0748f099-3da0-30ae-9370-d8ef28fb8766",
                            "category": "mens|men|slippers|shoes|male",
                            "categoryIds": [
                                "k18",
                                "k04"
                            ],
                            "priceTag": "$86.55",
                            "priceTagCN": "¥634",
                            "labels": [
                                "ADULT",
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "cm_23",
                                        "eu_38",
                                        "uk_4",
                                        "us_5"
                                    ],
                                    "name": "5",
                                    "displayName": "欧码38(适合脚长23cm)",
                                    "type": "eu",
                                    "label": "38"
                                },
                                {
                                    "ids": [
                                        "cm_24",
                                        "eu_39",
                                        "uk_5",
                                        "us_6"
                                    ],
                                    "name": "6",
                                    "displayName": "欧码39(适合脚长24cm)",
                                    "type": "eu",
                                    "label": "39"
                                },
                                {
                                    "ids": [
                                        "cm_25",
                                        "eu_40",
                                        "uk_6",
                                        "us_7"
                                    ],
                                    "name": "7",
                                    "displayName": "欧码40(适合脚长25cm)",
                                    "type": "eu",
                                    "label": "40"
                                },
                                {
                                    "ids": [
                                        "cm_26",
                                        "eu_41",
                                        "uk_7",
                                        "us_8"
                                    ],
                                    "name": "8",
                                    "displayName": "欧码41(适合脚长26cm)",
                                    "type": "eu",
                                    "label": "41"
                                },
                                {
                                    "ids": [
                                        "cm_33",
                                        "eu_49.5",
                                        "uk_14",
                                        "us_15"
                                    ],
                                    "name": "15",
                                    "displayName": "欧码49.5(适合脚长33cm)",
                                    "type": "eu",
                                    "label": "49.5"
                                },
                                {
                                    "ids": [
                                        "cm_34",
                                        "eu_50.5",
                                        "uk_15",
                                        "us_16"
                                    ],
                                    "name": "16",
                                    "displayName": "欧码50.5(适合脚长34cm)",
                                    "type": "eu",
                                    "label": "50.5"
                                },
                                {
                                    "ids": [
                                        "cm_35",
                                        "eu_51",
                                        "uk_16",
                                        "us_17"
                                    ],
                                    "name": "17",
                                    "displayName": "欧码51(适合脚长35cm)",
                                    "type": "eu",
                                    "label": "51"
                                },
                                {
                                    "ids": [
                                        "cm_36",
                                        "eu_52",
                                        "uk_17",
                                        "us_18"
                                    ],
                                    "name": "18",
                                    "displayName": "欧码52(适合脚长36cm)",
                                    "type": "eu",
                                    "label": "52"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4.9折起",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Nordstrom Rack",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4.9折起",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$2",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 291,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "c067c13d-5b04-3b3c-86a1-e10cdf594a5e",
                                    "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IG8188_1l.jpg?v=1729219603",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c067c13d-5b04-3b3c-86a1-e10cdf594a5e.jpg",
                                        "width": 1000,
                                        "height": 1000,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c067c13d-5b04-3b3c-86a1-e10cdf594a5e.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "shoebacca_9635520184602",
                            "name": "adidas Yeezy 950 Round Toe Lace Up Boots",
                            "nameCN": "Yeezy 950 Boots 男款 短筒 户外靴 舒适百搭  IG8188",
                            "description": [
                                "The adidas Yeezy 950 Boot ‘Pirate’ brings back a monochrome colorway of the hybrid silhouette that blends design notes from a duck boot and military boot. Crafted from black rubber and ballistic nylon mesh, the high-cut upper is lined in leather and canvas for improved durability and support. Branding is limited to mismatched tongue tags marked with debossed adidas and Yeezy logos. Anchoring the boot is a bulky midsole, fitted with an interior foam wedge and supported by a lugged rubber outsole.",
                                "Hybrid Design: Combines military and duck boot aesthetics for a rugged, fashion-forward silhouette.",
                                "Durable Upper: Made from ballistic nylon mesh and leather for a tough, textured appearance.",
                                "Chunky Rubber Sole: Thick, ridged sole provides excellent traction and a stable platform.",
                                "Functional Closure: Rope laces and a heel pull-tab allow for secure fit and easy wear.",
                                "Subtle and unique branding, with the Yeezy logo on one tongue and the Adidas logo on the other.",
                                "Season 1 Release: Debuted in Yeezy Season 1, known for earth-toned colorways and utilitarian style.",
                                "SKU: \nIG8188",
                                "Color: \nBlack",
                                "Material: \nMesh, Rubber",
                                "Style: \nLace Up",
                                "Heel Height: \nLow Heel 1in-2in",
                                "Shaft Height: \nAnkle"
                            ],
                            "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                            "brand": "adidas",
                            "displayBrand": "Adidas",
                            "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                            "category": "casual|sapg::adi08277 ~ color::black|adult|shoes|men|boots|mens|adidas|clearance",
                            "categoryIds": [
                                "k05"
                            ],
                            "priceTag": "$249.95",
                            "priceTagCN": "¥1830",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "cm_23",
                                        "eu_37 1/3",
                                        "uk_4.5",
                                        "us_5"
                                    ],
                                    "name": "5",
                                    "displayName": "欧码37 1/3(适合脚长23cm)",
                                    "type": "eu",
                                    "label": "37 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_23.5",
                                        "eu_38",
                                        "uk_5",
                                        "us_5.5"
                                    ],
                                    "name": "5.5",
                                    "displayName": "欧码38(适合脚长23.5cm)",
                                    "type": "eu",
                                    "label": "38"
                                },
                                {
                                    "ids": [
                                        "cm_24",
                                        "eu_38 2/3",
                                        "uk_5.5",
                                        "us_6"
                                    ],
                                    "name": "6",
                                    "displayName": "欧码38 2/3(适合脚长24cm)",
                                    "type": "eu",
                                    "label": "38 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_24.5",
                                        "eu_39 1/3",
                                        "uk_6",
                                        "us_6.5"
                                    ],
                                    "name": "6.5",
                                    "displayName": "欧码39 1/3(适合脚长24.5cm)",
                                    "type": "eu",
                                    "label": "39 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_25",
                                        "eu_40",
                                        "uk_6.5",
                                        "us_7"
                                    ],
                                    "name": "7",
                                    "displayName": "欧码40(适合脚长25cm)",
                                    "type": "eu",
                                    "label": "40"
                                },
                                {
                                    "ids": [
                                        "cm_25.5",
                                        "eu_40 2/3",
                                        "uk_7",
                                        "us_7.5"
                                    ],
                                    "name": "7.5",
                                    "displayName": "欧码40 2/3(适合脚长25.5cm)",
                                    "type": "eu",
                                    "label": "40 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_26",
                                        "eu_41 1/3",
                                        "uk_7.5",
                                        "us_8"
                                    ],
                                    "name": "8",
                                    "displayName": "欧码41 1/3(适合脚长26cm)",
                                    "type": "eu",
                                    "label": "41 1/3"
                                },
                                {
                                    "ids": [
                                        "us_17.0",
                                        "eu_53  1/3",
                                        "cm_35.0"
                                    ],
                                    "name": "17",
                                    "displayName": "欧码53  1/3(适合脚长35.0cm)",
                                    "type": "eu",
                                    "label": "53  1/3"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4.1折",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "SHOEBACCA",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4.1折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$5",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 913,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "74b5abf2-6c3b-3f0b-a792-fc6892960ccc",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/30309014_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/74b5abf2-6c3b-3f0b-a792-fc6892960ccc.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/74b5abf2-6c3b-3f0b-a792-fc6892960ccc.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "GRAPHITE/B",
                                    "image": {
                                        "id": "cc58befe-8b5b-3397-9dc5-75d0a2b37f82",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/cc58befe-8b5b-3397-9dc5-75d0a2b37f82.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_19528590",
                            "name": "Men's High Line Signature Canvas Sneaker",
                            "nameCN": "男士 High Line Signature 帆布运动鞋",
                            "description": [
                                "Named for the bustling trail on New York City's West Side, our High Line sneaker combines sophisticated good looks with maximum comfort. Crafted of our Signature canvas with smooth leather details, the low-top silhouette features a comfortable cushioned insole and a lightweight EVA outsole.",
                                "Round Toe",
                                "Lace-up closure",
                                "Ethylene-vinyl acetate outsole",
                                "Fabric lining and footbed",
                                "This item purchased online must be returned to the vendor by mail only. This item cannot be returned to Macy's stores.",
                                "Signature coated canvas and leather upper",
                                "Spot clean",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "COACH",
                            "displayBrand": "Coach",
                            "brandId": "f931b13a-ead0-32d7-bcdb-02f84e0f794f",
                            "category": "shoe|men's shoes",
                            "categoryIds": [
                                "k09"
                            ],
                            "priceTag": "$123.25",
                            "priceTagCN": "¥903",
                            "labels": [
                                "final_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "7D",
                                    "displayName": "7D"
                                },
                                {
                                    "ids": [],
                                    "name": "8D",
                                    "displayName": "8D"
                                },
                                {
                                    "ids": [],
                                    "name": "8.5D",
                                    "displayName": "8.5D"
                                },
                                {
                                    "ids": [],
                                    "name": "9D",
                                    "displayName": "9D"
                                },
                                {
                                    "ids": [],
                                    "name": "9.5D",
                                    "displayName": "9.5D"
                                },
                                {
                                    "ids": [],
                                    "name": "10D",
                                    "displayName": "10D"
                                },
                                {
                                    "ids": [],
                                    "name": "10.5D",
                                    "displayName": "10.5D"
                                },
                                {
                                    "ids": [],
                                    "name": "11D",
                                    "displayName": "11D"
                                },
                                {
                                    "ids": [],
                                    "name": "11.5D",
                                    "displayName": "11.5D"
                                },
                                {
                                    "ids": [],
                                    "name": "12D",
                                    "displayName": "12D"
                                },
                                {
                                    "ids": [],
                                    "name": "13D",
                                    "displayName": "13D"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$3",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 260,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "218df886-ee2c-3a4c-b91a-98633c3b3b7a",
                                    "originalURL": "https://media.finishline.com/i/finishline/921826_001_P1?w=800&h=800&fmt=auto&bg=rgb(237,237,237)",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/218df886-ee2c-3a4c-b91a-98633c3b3b7a.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/218df886-ee2c-3a4c-b91a-98633c3b3b7a.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "921826-001/Black/White",
                                    "image": {
                                        "id": "93941163-a74e-3dc2-b057-470a00ca2278",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/93941163-a74e-3dc2-b057-470a00ca2278.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "921826-015/Black/Anthracite/White",
                                    "image": {
                                        "id": "d34d8353-b312-3de1-8b55-0ddc604d2a42",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d34d8353-b312-3de1-8b55-0ddc604d2a42.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "921826-101/White/Black/Wolf Grey",
                                    "image": {
                                        "id": "fd9094a4-e3ca-3b06-9d5f-80aacbca9d50",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fd9094a4-e3ca-3b06-9d5f-80aacbca9d50.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "finishline_prod2770629",
                            "name": "Mens Nike Air Max 97 Casual Shoes",
                            "nameCN": "男士 Air Max 97 运动鞋",
                            "description": [
                                "Synthetic upper is lightweight yet durable \n\tWelded overlays for durable style \n\t3M detailing for low light visibility \n\tPull tabs at the heel and tongue \n\tFull-length Max Air unit for lightweight, responsive cushioning\n\tRubber outsole for durable traction\n\tThe Nike Air Max 97 is imported.\n\n\nSlip into the iconic Men's Nike Air Max 97 Casual Shoes for a street-ready look spanning decades of pop culture. Featuring water-ripple lines, reflective piping and full-length Max Air cushioning, this sneaker is a must-have to add to your collection."
                            ],
                            "merchantId": "26415a45-e02c-6a77-1ed7-f40023f03163",
                            "brand": "Nike",
                            "displayBrand": "NIKE",
                            "brandId": "41fd220f-05ed-3d8c-96e3-b83af87d45d7",
                            "category": "mens|Men|shoes|running",
                            "categoryIds": [
                                "753"
                            ],
                            "priceTag": "$177.65",
                            "priceTagCN": "¥1301",
                            "labels": [],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "cm_23.5",
                                        "eu_37.5",
                                        "uk_4",
                                        "us_5"
                                    ],
                                    "name": "5.0",
                                    "displayName": "欧码37.5(适合脚长23.5cm)",
                                    "type": "eu",
                                    "label": "37.5"
                                },
                                {
                                    "ids": [
                                        "cm_26",
                                        "eu_40.5",
                                        "uk_6.5",
                                        "us_7.5"
                                    ],
                                    "name": "7.5",
                                    "displayName": "欧码40.5(适合脚长26cm)",
                                    "type": "eu",
                                    "label": "40.5"
                                },
                                {
                                    "ids": [
                                        "cm_26.5",
                                        "eu_41",
                                        "uk_7",
                                        "us_8"
                                    ],
                                    "name": "8.0",
                                    "displayName": "欧码41(适合脚长26.5cm)",
                                    "type": "eu",
                                    "label": "41"
                                },
                                {
                                    "ids": [
                                        "cm_27",
                                        "eu_42",
                                        "uk_7.5",
                                        "us_8.5"
                                    ],
                                    "name": "8.5",
                                    "displayName": "欧码42(适合脚长27cm)",
                                    "type": "eu",
                                    "label": "42"
                                },
                                {
                                    "ids": [
                                        "cm_27.5",
                                        "eu_42.5",
                                        "uk_8",
                                        "us_9"
                                    ],
                                    "name": "9.0",
                                    "displayName": "欧码42.5(适合脚长27.5cm)",
                                    "type": "eu",
                                    "label": "42.5"
                                },
                                {
                                    "ids": [
                                        "cm_28",
                                        "eu_43",
                                        "uk_8.5",
                                        "us_9.5"
                                    ],
                                    "name": "9.5",
                                    "displayName": "欧码43(适合脚长28cm)",
                                    "type": "eu",
                                    "label": "43"
                                },
                                {
                                    "ids": [
                                        "cm_28.5",
                                        "eu_44",
                                        "uk_9",
                                        "us_10"
                                    ],
                                    "name": "10.0",
                                    "displayName": "欧码44(适合脚长28.5cm)",
                                    "type": "eu",
                                    "label": "44"
                                },
                                {
                                    "ids": [
                                        "cm_29",
                                        "eu_44.5",
                                        "uk_9.5",
                                        "us_10.5"
                                    ],
                                    "name": "10.5",
                                    "displayName": "欧码44.5(适合脚长29cm)",
                                    "type": "eu",
                                    "label": "44.5"
                                },
                                {
                                    "ids": [
                                        "cm_29.5",
                                        "eu_45",
                                        "uk_10",
                                        "us_11"
                                    ],
                                    "name": "11.0",
                                    "displayName": "欧码45(适合脚长29.5cm)",
                                    "type": "eu",
                                    "label": "45"
                                },
                                {
                                    "ids": [
                                        "cm_30",
                                        "eu_45.5",
                                        "uk_10.5",
                                        "us_11.5"
                                    ],
                                    "name": "11.5",
                                    "displayName": "欧码45.5(适合脚长30cm)",
                                    "type": "eu",
                                    "label": "45.5"
                                },
                                {
                                    "ids": [
                                        "cm_30.5",
                                        "eu_46",
                                        "uk_11",
                                        "us_12"
                                    ],
                                    "name": "12.0",
                                    "displayName": "欧码46(适合脚长30.5cm)",
                                    "type": "eu",
                                    "label": "46"
                                },
                                {
                                    "ids": [
                                        "cm_31.5",
                                        "eu_47.5",
                                        "uk_12",
                                        "us_13"
                                    ],
                                    "name": "13.0",
                                    "displayName": "欧码47.5(适合脚长31.5cm)",
                                    "type": "eu",
                                    "label": "47.5"
                                },
                                {
                                    "ids": [
                                        "cm_32.5",
                                        "eu_48.5",
                                        "uk_13",
                                        "us_14"
                                    ],
                                    "name": "14.0",
                                    "displayName": "欧码48.5(适合脚长32.5cm)",
                                    "type": "eu",
                                    "label": "48.5"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "activityOffs": [],
                        "merchantName": "Finish Line",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "tideShoes": true,
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 523,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "d50f6d70-9bdf-3985-b291-dd81f20aba50",
                                    "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IE4783_1l.jpg?v=1739861671",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d50f6d70-9bdf-3985-b291-dd81f20aba50.jpg",
                                        "width": 1000,
                                        "height": 1000,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d50f6d70-9bdf-3985-b291-dd81f20aba50.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "shoebacca_9641358721306",
                            "name": "adidas Yeezy 500 Lace Up Sneakers",
                            "nameCN": "男款 Yeezy 500系列 休闲鞋",
                            "description": [
                                "The adidas Yeezy 500 revives a subdued colorway of the retro-inspired model. An grey finish floods the upper, composed of airy mesh with durable overlays in suede and leather. A seamless rubber mudguard offers improved support and abrasion resistance, while reflective piping around the eyestay provides improved visibility in low-light conditions. Lightweight cushioning arrives via an adiPRENE+ midsole, featuring podular construction that takes its cues from the adidas KB8 3.",
                                "Mesh and suede upper",
                                "Lace up closure",
                                "adiPRENE midsole",
                                "Rubber outsole",
                                "SKU: \nIE4783",
                                "Color: \nGrey",
                                "Feature: \nAbrasion Resistant, Comfort Technology, Lightweight",
                                "Material: \nMesh, Suede",
                                "Style: \nLace Up"
                            ],
                            "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                            "brand": "adidas",
                            "displayBrand": "Adidas",
                            "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                            "category": "mens|adidas|men|sneakers|shoes|adult|casual|adidas-puma-diadora|clearance|sapg::adi07919 ~ color::grey",
                            "categoryIds": [
                                "751"
                            ],
                            "priceTag": "$99.95",
                            "priceTagCN": "¥732",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "cm_22",
                                        "eu_36",
                                        "uk_3.5",
                                        "us_4"
                                    ],
                                    "name": "4",
                                    "displayName": "欧码36(适合脚长22cm)",
                                    "type": "eu",
                                    "label": "36"
                                },
                                {
                                    "ids": [
                                        "cm_22.5",
                                        "eu_36 2/3",
                                        "uk_4",
                                        "us_4.5"
                                    ],
                                    "name": "4.5",
                                    "displayName": "欧码36 2/3(适合脚长22.5cm)",
                                    "type": "eu",
                                    "label": "36 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_23",
                                        "eu_37 1/3",
                                        "uk_4.5",
                                        "us_5"
                                    ],
                                    "name": "5",
                                    "displayName": "欧码37 1/3(适合脚长23cm)",
                                    "type": "eu",
                                    "label": "37 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_23.5",
                                        "eu_38",
                                        "uk_5",
                                        "us_5.5"
                                    ],
                                    "name": "5.5",
                                    "displayName": "欧码38(适合脚长23.5cm)",
                                    "type": "eu",
                                    "label": "38"
                                },
                                {
                                    "ids": [
                                        "cm_24",
                                        "eu_38 2/3",
                                        "uk_5.5",
                                        "us_6"
                                    ],
                                    "name": "6",
                                    "displayName": "欧码38 2/3(适合脚长24cm)",
                                    "type": "eu",
                                    "label": "38 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_24.5",
                                        "eu_39 1/3",
                                        "uk_6",
                                        "us_6.5"
                                    ],
                                    "name": "6.5",
                                    "displayName": "欧码39 1/3(适合脚长24.5cm)",
                                    "type": "eu",
                                    "label": "39 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_25",
                                        "eu_40",
                                        "uk_6.5",
                                        "us_7"
                                    ],
                                    "name": "7",
                                    "displayName": "欧码40(适合脚长25cm)",
                                    "type": "eu",
                                    "label": "40"
                                },
                                {
                                    "ids": [
                                        "cm_25.5",
                                        "eu_40 2/3",
                                        "uk_7",
                                        "us_7.5"
                                    ],
                                    "name": "7.5",
                                    "displayName": "欧码40 2/3(适合脚长25.5cm)",
                                    "type": "eu",
                                    "label": "40 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_26",
                                        "eu_41 1/3",
                                        "uk_7.5",
                                        "us_8"
                                    ],
                                    "name": "8",
                                    "displayName": "欧码41 1/3(适合脚长26cm)",
                                    "type": "eu",
                                    "label": "41 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_26.5",
                                        "eu_42",
                                        "uk_8",
                                        "us_8.5"
                                    ],
                                    "name": "8.5",
                                    "displayName": "欧码42(适合脚长26.5cm)",
                                    "type": "eu",
                                    "label": "42"
                                },
                                {
                                    "ids": [
                                        "cm_27",
                                        "eu_42 2/3",
                                        "uk_8.5",
                                        "us_9"
                                    ],
                                    "name": "9",
                                    "displayName": "欧码42 2/3(适合脚长27cm)",
                                    "type": "eu",
                                    "label": "42 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_27.5",
                                        "eu_43 1/3",
                                        "uk_9",
                                        "us_9.5"
                                    ],
                                    "name": "9.5",
                                    "displayName": "欧码43 1/3(适合脚长27.5cm)",
                                    "type": "eu",
                                    "label": "43 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_28",
                                        "eu_44",
                                        "uk_9.5",
                                        "us_10"
                                    ],
                                    "name": "10",
                                    "displayName": "欧码44(适合脚长28cm)",
                                    "type": "eu",
                                    "label": "44"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4.7折",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "SHOEBACCA",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "tideShoes": true,
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4.7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$2",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 1128,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "664aa490-4295-3740-af51-fe856f687639",
                                    "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IH5152_1l.jpg?v=1732414082",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/664aa490-4295-3740-af51-fe856f687639.jpg",
                                        "width": 1000,
                                        "height": 1000,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/664aa490-4295-3740-af51-fe856f687639.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "shoebacca_9695499878682",
                            "name": "Fear of God x Athletics Los Angeles Lace Up Sneakers",
                            "nameCN": "男款 FOG联名 休闲运动鞋",
                            "description": [
                                "Fear of God Athletics reimagines the iconic L.A. Trainer in full premium suede with durable ripstop fabric framed in a wavy rubber sole. The shoe features a padded tongue, a molded cupsole for comfort, and a lace toggle for adjustability. Branding details are realized in the signature Adidas 3-Stripes on the midfoot, Adidas logo embossed on the sole, and the Fear of God embossed logo on the black bar on the heel.",
                                "Full premium suede uppers with durable ripstop fabric",
                                "Molded cupsole",
                                "Wavy rubber outsole",
                                "Padded tongue",
                                "Lace toggle and additional off white laces",
                                "SKU: \nIH5152",
                                "Color: \nBeige",
                                "Material: \nSuede",
                                "Style: \nLace Up"
                            ],
                            "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                            "brand": "adidas",
                            "displayBrand": "Adidas",
                            "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                            "category": "mens|sneakers|men|clearance|adidas|adult|casual|shoes|sapg::adi08832 ~ color::beige",
                            "categoryIds": [
                                "751"
                            ],
                            "priceTag": "$55.05",
                            "priceTagCN": "¥404",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "cm_22",
                                        "eu_36",
                                        "uk_3.5",
                                        "us_4"
                                    ],
                                    "name": "4",
                                    "displayName": "欧码36(适合脚长22cm)",
                                    "type": "eu",
                                    "label": "36"
                                },
                                {
                                    "ids": [
                                        "cm_22.5",
                                        "eu_36 2/3",
                                        "uk_4",
                                        "us_4.5"
                                    ],
                                    "name": "4.5",
                                    "displayName": "欧码36 2/3(适合脚长22.5cm)",
                                    "type": "eu",
                                    "label": "36 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_23",
                                        "eu_37 1/3",
                                        "uk_4.5",
                                        "us_5"
                                    ],
                                    "name": "5",
                                    "displayName": "欧码37 1/3(适合脚长23cm)",
                                    "type": "eu",
                                    "label": "37 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_23.5",
                                        "eu_38",
                                        "uk_5",
                                        "us_5.5"
                                    ],
                                    "name": "5.5",
                                    "displayName": "欧码38(适合脚长23.5cm)",
                                    "type": "eu",
                                    "label": "38"
                                },
                                {
                                    "ids": [
                                        "cm_24",
                                        "eu_38 2/3",
                                        "uk_5.5",
                                        "us_6"
                                    ],
                                    "name": "6",
                                    "displayName": "欧码38 2/3(适合脚长24cm)",
                                    "type": "eu",
                                    "label": "38 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_24.5",
                                        "eu_39 1/3",
                                        "uk_6",
                                        "us_6.5"
                                    ],
                                    "name": "6.5",
                                    "displayName": "欧码39 1/3(适合脚长24.5cm)",
                                    "type": "eu",
                                    "label": "39 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_25",
                                        "eu_40",
                                        "uk_6.5",
                                        "us_7"
                                    ],
                                    "name": "7",
                                    "displayName": "欧码40(适合脚长25cm)",
                                    "type": "eu",
                                    "label": "40"
                                },
                                {
                                    "ids": [
                                        "cm_25.5",
                                        "eu_40 2/3",
                                        "uk_7",
                                        "us_7.5"
                                    ],
                                    "name": "7.5",
                                    "displayName": "欧码40 2/3(适合脚长25.5cm)",
                                    "type": "eu",
                                    "label": "40 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_26",
                                        "eu_41 1/3",
                                        "uk_7.5",
                                        "us_8"
                                    ],
                                    "name": "8",
                                    "displayName": "欧码41 1/3(适合脚长26cm)",
                                    "type": "eu",
                                    "label": "41 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_26.5",
                                        "eu_42",
                                        "uk_8",
                                        "us_8.5"
                                    ],
                                    "name": "8.5",
                                    "displayName": "欧码42(适合脚长26.5cm)",
                                    "type": "eu",
                                    "label": "42"
                                },
                                {
                                    "ids": [
                                        "cm_27",
                                        "eu_42 2/3",
                                        "uk_8.5",
                                        "us_9"
                                    ],
                                    "name": "9",
                                    "displayName": "欧码42 2/3(适合脚长27cm)",
                                    "type": "eu",
                                    "label": "42 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_27.5",
                                        "eu_43 1/3",
                                        "uk_9",
                                        "us_9.5"
                                    ],
                                    "name": "9.5",
                                    "displayName": "欧码43 1/3(适合脚长27.5cm)",
                                    "type": "eu",
                                    "label": "43 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_28",
                                        "eu_44",
                                        "uk_9.5",
                                        "us_10"
                                    ],
                                    "name": "10",
                                    "displayName": "欧码44(适合脚长28cm)",
                                    "type": "eu",
                                    "label": "44"
                                },
                                {
                                    "ids": [
                                        "cm_28.5",
                                        "eu_44 2/3",
                                        "uk_10",
                                        "us_10.5"
                                    ],
                                    "name": "10.5",
                                    "displayName": "欧码44 2/3(适合脚长28.5cm)",
                                    "type": "eu",
                                    "label": "44 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_29",
                                        "eu_45 1/3",
                                        "uk_10.5",
                                        "us_11"
                                    ],
                                    "name": "11",
                                    "displayName": "欧码45 1/3(适合脚长29cm)",
                                    "type": "eu",
                                    "label": "45 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_29.5",
                                        "eu_46",
                                        "uk_11",
                                        "us_11.5"
                                    ],
                                    "name": "11.5",
                                    "displayName": "欧码46(适合脚长29.5cm)",
                                    "type": "eu",
                                    "label": "46"
                                },
                                {
                                    "ids": [
                                        "cm_30",
                                        "eu_46 2/3",
                                        "uk_11.5",
                                        "us_12"
                                    ],
                                    "name": "12",
                                    "displayName": "欧码46 2/3(适合脚长30cm)",
                                    "type": "eu",
                                    "label": "46 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_30.5",
                                        "eu_47 1/3",
                                        "uk_12",
                                        "us_12.5"
                                    ],
                                    "name": "12.5",
                                    "displayName": "欧码47 1/3(适合脚长30.5cm)",
                                    "type": "eu",
                                    "label": "47 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_31",
                                        "eu_48",
                                        "uk_12.5",
                                        "us_13"
                                    ],
                                    "name": "13",
                                    "displayName": "欧码48(适合脚长31cm)",
                                    "type": "eu",
                                    "label": "48"
                                },
                                {
                                    "ids": [
                                        "cm_31.5",
                                        "eu_48 2/3",
                                        "uk_13",
                                        "us_13.5"
                                    ],
                                    "name": "13.5",
                                    "displayName": "欧码48 2/3(适合脚长31.5cm)",
                                    "type": "eu",
                                    "label": "48 2/3"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "3.2折",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "SHOEBACCA",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "tideShoes": true,
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "3.2折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 777,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "3d9e7de0-02de-3b41-bd3f-7b3f09891810",
                                    "originalURL": "https://www.yoox.com/images/items/17/17869027GT_14_f.jpg",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3d9e7de0-02de-3b41-bd3f-7b3f09891810.jpg",
                                        "width": 804,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3d9e7de0-02de-3b41-bd3f-7b3f09891810.jpg",
                                        "width": 275,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Beige",
                                    "image": {
                                        "id": "47988ec0-2cdf-3a40-929d-1540c4505a8c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/47988ec0-2cdf-3a40-929d-1540c4505a8c.jpg",
                                            "width": 39,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "yooxhk_17869027",
                            "name": "Sneakers",
                            "nameCN": "男款 XT-Quest 2系列 户外功能鞋",
                            "description": [
                                "Leather, Textile fibers",
                                "suede, rubber, brand logo, multicolor, fabric inner, lace-up, round toe, flat, rubber cleated sole, contains non-textile parts of animal origin, chunky sneakers",
                                "Appliqué: Logo detail",
                                "ColoreFoto_ID: 32",
                                "Composition: Leather, Textile fibers",
                                "CustomsInvoiceDescr: Suede,Rubber,Rubber cleated sole,Chunky sneakers,Woven,Flat",
                                "Design: Multicolor",
                                "FOOTWEAR: Low-tops & trainers",
                                "Footwear Fastening: Laces",
                                "Footwear Model: Chunky sneakers",
                                "Footwear Sole: Rubber cleated sole",
                                "Heel Shape: No heel",
                                "HSCode: 64039996",
                                "ItemDescription: suede, rubber, brand logo, multicolor, fabric inner, lace-up, round toe, flat, rubber cleated sole, contains non-textile parts of animal origin, chunky sneakers",
                                "KeywordDescription: Suede Rubber Brand logo Multicolor Fabric inner Lace-up Round toe Flat Rubber cleated sole Contains non-textile parts of animal origin Chunky sneakers not made of fur No zip Woven Not EAC Certified No Label No platform Flat",
                                "Kind of fabric: Woven",
                                "MainMaterial: Leather",
                                "Proposition65: Proposition65",
                                "Toe Shape: Round toeline",
                                "Zip closure: No zip",
                                "MacroCategory: FOOTWEAR",
                                "MicroCategory: Sneakers",
                                "MicroCategoryPlural: Sneakers",
                                "Made In Cambodia",
                                "MadeInIsoCode: KH",
                                "Product Code: 17869027GT"
                            ],
                            "merchantId": "1909da89-b21b-38c3-b449-378e79039eae",
                            "brand": "SALOMON",
                            "displayBrand": "Salomon",
                            "brandId": "09fb24f0-60ae-351d-8c7f-ceb2a5f3957d",
                            "category": "men|sneakers",
                            "categoryIds": [
                                "k09"
                            ],
                            "priceTag": "$107.52",
                            "priceTagCN": "¥788",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "eu_38"
                                    ],
                                    "name": "38 ⅔(EU)",
                                    "displayName": "欧码38",
                                    "type": "eu"
                                },
                                {
                                    "ids": [
                                        "eu_40"
                                    ],
                                    "name": "40(EU)",
                                    "displayName": "欧码40",
                                    "type": "eu"
                                },
                                {
                                    "ids": [
                                        "eu_40"
                                    ],
                                    "name": "40 ⅔(EU)",
                                    "displayName": "欧码40",
                                    "type": "eu"
                                },
                                {
                                    "ids": [
                                        "eu_41"
                                    ],
                                    "name": "41 ⅓(EU)",
                                    "displayName": "欧码41",
                                    "type": "eu"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "3.2折",
                        "activityOffs": [
                            "额外八折"
                        ],
                        "merchantName": "Yoox HK",
                        "origin": "[意大利]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "额外八折",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "tideShoes": true,
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "3.2折×额外8折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 121,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "意大利",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "17a9e2b6-8149-3d99-9466-524036a93d66",
                                    "originalURL": "https://n.nordstrommedia.com/it/d6c32521-e42b-4d1c-aad9-8cb2c48857e4.jpeg",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/17a9e2b6-8149-3d99-9466-524036a93d66.jpg",
                                        "width": 668,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/17a9e2b6-8149-3d99-9466-524036a93d66.jpg",
                                        "width": 228,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Black / Birch",
                                    "image": {
                                        "id": "c8bfa492-a8ed-37d8-8ab0-63f5c506a8b2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c8bfa492-a8ed-37d8-8ab0-63f5c506a8b2.jpg",
                                            "width": 31,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "nordstromrack_7956516",
                            "name": "Neumel High Weather Hybrid Waterproof Boot",
                            "nameCN": "男士高帮系带秋冬雪地靴 Neumel",
                            "description": [
                                "Part sneaker, part boot, this winter-ready footwear is rated to keep you warm to -20ºC. Keep wrapped up in the comfort of the padded collar, contoured EVA footbed and external guard that protects from light rain and snow. For added traction, this boot has Spider Rubber® pods on it's lugged rubber sole. It's lined with UGGplush, a moisture-wicking textile made from a wool-rich blend but crafted to feel and wear like genuine shearling, while the sole is sourced from renewable sugarcane.",
                                "Waterproof: protects against rain, puddles and slush to keep feet dry in wet conditions",
                                "Lace-up style",
                                "Contoured EVA footbed",
                                "Padded collar",
                                "Seam sealed",
                                "Removable insole",
                                "Leather upper/UGGplush recycled wool-and-Tencel® lyocell lining/sugarcane-based synthetic sole",
                                "Tencel lyocell is a more-sustainably produced fiber made with closed-loop processing",
                                "Imported",
                                "Item #10460767"
                            ],
                            "merchantId": "f8828b5b-30d5-d492-d151-7b87aec09f96",
                            "brand": "UGG®",
                            "displayBrand": "UGG",
                            "brandId": "0748f099-3da0-30ae-9370-d8ef28fb8766",
                            "category": "mens|men|boots|male|shoes",
                            "categoryIds": [
                                "k05"
                            ],
                            "priceTag": "$108.70",
                            "priceTagCN": "¥796",
                            "labels": [
                                "ADULT",
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "us_4.0"
                                    ],
                                    "name": "4",
                                    "displayName": "美码4",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "cm_23",
                                        "eu_38",
                                        "uk_4",
                                        "us_5"
                                    ],
                                    "name": "5",
                                    "displayName": "美码5(适合脚长23cm)",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "cm_24",
                                        "eu_39",
                                        "uk_5",
                                        "us_6"
                                    ],
                                    "name": "6",
                                    "displayName": "美码6(适合脚长24cm)",
                                    "type": "us"
                                },
                                {
                                    "ids": [
                                        "cm_25",
                                        "eu_40",
                                        "uk_6",
                                        "us_7"
                                    ],
                                    "name": "7",
                                    "displayName": "美码7(适合脚长25cm)",
                                    "type": "us"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4.7折",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Nordstrom Rack",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4.7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$2",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 69,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "269a2ce3-373d-369f-992b-f882f9fc3e62",
                                    "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IF6683_1l.jpg?v=1731448550",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/269a2ce3-373d-369f-992b-f882f9fc3e62.jpg",
                                        "width": 1000,
                                        "height": 1000,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/269a2ce3-373d-369f-992b-f882f9fc3e62.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "shoebacca_9677114245402",
                            "name": "Fear of God x Athletics 86 Hi High Top Sneakers",
                            "nameCN": "男款 FOG联名 Athletics 86系列 高帮休闲运动鞋",
                            "description": [
                                "Fear of God Athletics reinvents the iconic adidas Rivalry '86 Hi in a modern shape crafted in full premium washed suede with a contoured rubber outsole. These shoes feature a padded tongue, a moulded cupsole for comfort and a lace toggle for adjustability. Branding details are realized in the signature adidas 3-Stripes on the midfoot, an adidas Trefoil logo debossed on the heel pad, an adidas logo embossed on the sole and the Fear of God embossed logo on the black bar on the heel.",
                                "Regular fit",
                                "Full premium washed suede upper with stitch and turn edges",
                                "Molded cupsole",
                                "Padded tongue and lace toggle",
                                "Signature adidas 3-Stripes on quarter panel",
                                "Adidas Trefoil logo debossed on the heel pad and adidas logo embossed on sole",
                                "SKU: \nIF6683",
                                "Color: \nBeige",
                                "Material: \nSuede",
                                "Style: \nHigh Top, Lace Up"
                            ],
                            "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                            "brand": "adidas",
                            "displayBrand": "Adidas",
                            "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                            "category": "adult|adidas|clearance|shoes|men|casual|mens|sneakers|sapg::adi08794 ~ color::beige",
                            "categoryIds": [
                                "751"
                            ],
                            "priceTag": "$79.55",
                            "priceTagCN": "¥583",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [
                                        "cm_22",
                                        "eu_36",
                                        "uk_3.5",
                                        "us_4"
                                    ],
                                    "name": "4",
                                    "displayName": "欧码36(适合脚长22cm)",
                                    "type": "eu",
                                    "label": "36"
                                },
                                {
                                    "ids": [
                                        "cm_22.5",
                                        "eu_36 2/3",
                                        "uk_4",
                                        "us_4.5"
                                    ],
                                    "name": "4.5",
                                    "displayName": "欧码36 2/3(适合脚长22.5cm)",
                                    "type": "eu",
                                    "label": "36 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_23",
                                        "eu_37 1/3",
                                        "uk_4.5",
                                        "us_5"
                                    ],
                                    "name": "5",
                                    "displayName": "欧码37 1/3(适合脚长23cm)",
                                    "type": "eu",
                                    "label": "37 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_23.5",
                                        "eu_38",
                                        "uk_5",
                                        "us_5.5"
                                    ],
                                    "name": "5.5",
                                    "displayName": "欧码38(适合脚长23.5cm)",
                                    "type": "eu",
                                    "label": "38"
                                },
                                {
                                    "ids": [
                                        "cm_24",
                                        "eu_38 2/3",
                                        "uk_5.5",
                                        "us_6"
                                    ],
                                    "name": "6",
                                    "displayName": "欧码38 2/3(适合脚长24cm)",
                                    "type": "eu",
                                    "label": "38 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_24.5",
                                        "eu_39 1/3",
                                        "uk_6",
                                        "us_6.5"
                                    ],
                                    "name": "6.5",
                                    "displayName": "欧码39 1/3(适合脚长24.5cm)",
                                    "type": "eu",
                                    "label": "39 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_25",
                                        "eu_40",
                                        "uk_6.5",
                                        "us_7"
                                    ],
                                    "name": "7",
                                    "displayName": "欧码40(适合脚长25cm)",
                                    "type": "eu",
                                    "label": "40"
                                },
                                {
                                    "ids": [
                                        "cm_25.5",
                                        "eu_40 2/3",
                                        "uk_7",
                                        "us_7.5"
                                    ],
                                    "name": "7.5",
                                    "displayName": "欧码40 2/3(适合脚长25.5cm)",
                                    "type": "eu",
                                    "label": "40 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_26",
                                        "eu_41 1/3",
                                        "uk_7.5",
                                        "us_8"
                                    ],
                                    "name": "8",
                                    "displayName": "欧码41 1/3(适合脚长26cm)",
                                    "type": "eu",
                                    "label": "41 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_26.5",
                                        "eu_42",
                                        "uk_8",
                                        "us_8.5"
                                    ],
                                    "name": "8.5",
                                    "displayName": "欧码42(适合脚长26.5cm)",
                                    "type": "eu",
                                    "label": "42"
                                },
                                {
                                    "ids": [
                                        "cm_27",
                                        "eu_42 2/3",
                                        "uk_8.5",
                                        "us_9"
                                    ],
                                    "name": "9",
                                    "displayName": "欧码42 2/3(适合脚长27cm)",
                                    "type": "eu",
                                    "label": "42 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_27.5",
                                        "eu_43 1/3",
                                        "uk_9",
                                        "us_9.5"
                                    ],
                                    "name": "9.5",
                                    "displayName": "欧码43 1/3(适合脚长27.5cm)",
                                    "type": "eu",
                                    "label": "43 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_28",
                                        "eu_44",
                                        "uk_9.5",
                                        "us_10"
                                    ],
                                    "name": "10",
                                    "displayName": "欧码44(适合脚长28cm)",
                                    "type": "eu",
                                    "label": "44"
                                },
                                {
                                    "ids": [
                                        "cm_28.5",
                                        "eu_44 2/3",
                                        "uk_10",
                                        "us_10.5"
                                    ],
                                    "name": "10.5",
                                    "displayName": "欧码44 2/3(适合脚长28.5cm)",
                                    "type": "eu",
                                    "label": "44 2/3"
                                },
                                {
                                    "ids": [
                                        "cm_29",
                                        "eu_45 1/3",
                                        "uk_10.5",
                                        "us_11"
                                    ],
                                    "name": "11",
                                    "displayName": "欧码45 1/3(适合脚长29cm)",
                                    "type": "eu",
                                    "label": "45 1/3"
                                },
                                {
                                    "ids": [
                                        "cm_29.5",
                                        "eu_46",
                                        "uk_11",
                                        "us_11.5"
                                    ],
                                    "name": "11.5",
                                    "displayName": "欧码46(适合脚长29.5cm)",
                                    "type": "eu",
                                    "label": "46"
                                },
                                {
                                    "ids": [
                                        "cm_30.5",
                                        "eu_47 1/3",
                                        "uk_12",
                                        "us_12.5"
                                    ],
                                    "name": "12.5",
                                    "displayName": "欧码47 1/3(适合脚长30.5cm)",
                                    "type": "eu",
                                    "label": "47 1/3"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "3.6折",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "SHOEBACCA",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "tideShoes": true,
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "3.6折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$2",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 104,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                }
            ]
        },
        {
            "id": "beauty_skincare",
            "title": "美护",
            "categoryIds": [
                "b"
            ],
            "brands": [
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/1d2bd670-633e-4462-b606-f7757e38c678.jpg",
                    "id": "31324581-2dcc-3c7d-a1fc-70541e5e2ba4",
                    "name": "雅诗兰黛",
                    "categoryIds": [
                        "5",
                        "b"
                    ],
                    "pathname": "ya3-shi1-lan2-dai4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/ce2c96d9-6822-41e7-bb30-c04ce143eb45.jpg",
                    "id": "8c3ccaca-ed0e-37bb-8e39-9baeca9e3d26",
                    "name": "兰蔻",
                    "categoryIds": [
                        "5",
                        "b"
                    ],
                    "pathname": "lan2-kou4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/d9e7f73b-f8ab-428e-99a7-417d504ac9bb.jpg",
                    "id": "95ab3b7d-33fb-3a53-b475-8629c6f28478",
                    "name": "娇韵诗",
                    "categoryIds": [
                        "5",
                        "b"
                    ],
                    "pathname": "jiao1-yun4-shi1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/6f617276-c8f7-49d4-a310-7e658f32e6eb.jpg",
                    "id": "8cca16b7-687c-3924-a7a4-0df624cd1296",
                    "name": "科颜氏",
                    "categoryIds": [
                        "5",
                        "b"
                    ],
                    "pathname": "ke1-yan2-shi4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/8dc0849a-8f92-3cfb-8846-06af9ce0bcb7.jpg",
                    "id": "c260b086-eb36-3736-afbd-dfda6c669b08",
                    "name": "圣罗兰",
                    "categoryIds": [
                        "5",
                        "b"
                    ],
                    "pathname": "sheng4-luo2-lan2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/ba9460e7-b128-4f54-99b8-de9aaf730e01.jpg",
                    "id": "fb738cfb-e34b-325d-9bdb-623fca77af5e",
                    "name": "海蓝之谜",
                    "categoryIds": [
                        "5",
                        "b"
                    ],
                    "pathname": "hai3-lan2-zhi1-mi2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/6d761587-7385-4baf-8b89-8b7f34446895.jpg",
                    "id": "1726d017-a62c-3eab-afa6-25db794102a1",
                    "name": "娇兰",
                    "categoryIds": [
                        "5",
                        "b"
                    ],
                    "pathname": "jiao1-lan2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/a52f015a-fe26-42fd-b1a1-d622201e0946.jpg",
                    "id": "ee6d6a48-2195-3239-a9fe-63aab4f0f73d",
                    "name": "汤姆·福特",
                    "categoryIds": [
                        "5",
                        "b"
                    ],
                    "pathname": "tang1-mu3-fu2-te4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/0cd4e67d-8d35-4525-9d16-80ea4a19c004.jpg",
                    "id": "18a0671d-ef16-39ec-9be6-c3b23035c28c",
                    "name": "纳斯",
                    "categoryIds": [
                        "5",
                        "b"
                    ],
                    "pathname": "na4-si1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/25a364ce-fa10-4800-9668-d1328a15dc97.jpg",
                    "id": "8f8355bb-d29b-3699-9723-f0d1835f06a5",
                    "name": "迪奥",
                    "categoryIds": [
                        "5",
                        "b"
                    ],
                    "pathname": "di2-ao4"
                }
            ],
            "productList": [
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "0cd4e67d-8d35-4525-9d16-80ea4a19c004",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0cd4e67d-8d35-4525-9d16-80ea4a19c004.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0cd4e67d-8d35-4525-9d16-80ea4a19c004.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "blankspace_10279",
                            "name": "Nars纳斯裸光透明色蜜粉饼10g控油定妆焦柔美肌【香港直邮】",
                            "description": [],
                            "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                            "brand": "NARS",
                            "displayBrand": "NARS",
                            "brandId": "18a0671d-ef16-39ec-9be6-c3b23035c28c",
                            "categoryIds": [
                                "b05"
                            ],
                            "priceTag": "$20.50",
                            "priceTagCN": "¥151",
                            "labels": [
                                "final_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4.1折",
                        "activityOffs": [],
                        "merchantName": "BLANKSPACE",
                        "origin": "[中国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4.1折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "包邮包税",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ]
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 6749,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "中国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "e4307e52-3826-4a84-a4e0-c024ecf20a44",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e4307e52-3826-4a84-a4e0-c024ecf20a44.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e4307e52-3826-4a84-a4e0-c024ecf20a44.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "blankspace_10653",
                            "name": "肌肤之钥CPB隔离37ml钻石光感长管隔离妆前霜自然裸装多版本随机发 香港直邮",
                            "description": [],
                            "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                            "brand": "Cle de Peau",
                            "displayBrand": "Cle de Peau",
                            "brandId": "7707f2dd-9758-30f8-90e7-c38163fd755c",
                            "categoryIds": [
                                "b04"
                            ],
                            "priceTag": "$27.50",
                            "priceTagCN": "¥202",
                            "labels": [
                                "final_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "37ml",
                                    "displayName": "37ml"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "5.5折",
                        "activityOffs": [],
                        "merchantName": "BLANKSPACE",
                        "origin": "[中国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "5.5折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "包邮包税",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ]
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 2545,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "中国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "83130d6a-36d6-3c16-a9d7-a303c8b9a212",
                                    "originalURL": "https://www.peterthomasroth.com/cdn/shop/files/22-06-248_UW_Eye_Super_Size_capon_noref_2000x2000_gray.jpg?v=1724187329&width=1280",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/83130d6a-36d6-3c16-a9d7-a303c8b9a212.jpg",
                                        "width": 1024,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/83130d6a-36d6-3c16-a9d7-a303c8b9a212.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "peterthomasroth_2206248",
                            "name": "Super-Size Un-Wrinkle Eye Concentrate|30 ml / 1 oz",
                            "nameCN": "抗皱紧肤修护眼霜(抗皱眼霜) 30ml - 价值$200美金",
                            "description": [
                                "A highly concentrated 23% solution of six powerful anti-aging peptides and neuropeptides combined with three new cutting-edge ingredients created especially for the eye area to help reduce the appearance of deep and fine eye wrinkles. Includes neuropeptides SYN-AKE* at 4%, SNAP-8* at 10% and ARGIRELINE* (hexapeptide) at 3% along with peptides SYN-COLL* at 3% and MATRIXYL™ 3000* (a dual peptide) at 3%."
                            ],
                            "merchantId": "97f01347-3d82-cc95-a7c5-824b2841721f",
                            "brand": "Peter Thomas Roth",
                            "displayBrand": "Peter Thomas Roth",
                            "brandId": "1f8ee8c7-746c-3353-abcf-7c6000e6504b",
                            "category": "more|shop|collections",
                            "categoryIds": [
                                "b22",
                                "b24"
                            ],
                            "priceTag": "$204",
                            "priceTagCN": "¥1494",
                            "labels": [],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "30 ml / 1 oz",
                                    "displayName": "30 ml / 1 oz"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "activityOffs": [],
                        "merchantName": "Peter Thomas Roth",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 23715,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "d9e7f73b-f8ab-428e-99a7-417d504ac9bb",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d9e7f73b-f8ab-428e-99a7-417d504ac9bb.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d9e7f73b-f8ab-428e-99a7-417d504ac9bb.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "blankspace_10128",
                            "name": "clarins娇韵诗双萃精华30ml/50ml/75ml/100ml双双效抗初老多版本随机发 香港直邮",
                            "description": [],
                            "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                            "brand": "Clarins",
                            "displayBrand": "Clarins",
                            "brandId": "95ab3b7d-33fb-3a53-b475-8629c6f28478",
                            "categoryIds": [
                                "b25"
                            ],
                            "priceTag": "$41",
                            "priceTagCN": "¥301",
                            "labels": [
                                "final_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "30ml",
                                    "displayName": "30ml"
                                },
                                {
                                    "ids": [],
                                    "name": "50ml",
                                    "displayName": "50ml"
                                },
                                {
                                    "ids": [],
                                    "name": "75ml",
                                    "displayName": "75ml"
                                },
                                {
                                    "ids": [],
                                    "name": "100ml",
                                    "displayName": "100ml"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "3.6折起",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "BLANKSPACE",
                        "origin": "[中国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "3.6折起",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "包邮包税",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ]
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 598,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "中国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "1ee43a9d-b6bb-4681-84d0-b9d0cd99b28a",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1ee43a9d-b6bb-4681-84d0-b9d0cd99b28a.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1ee43a9d-b6bb-4681-84d0-b9d0cd99b28a.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": " 缎光005",
                                    "image": {
                                        "id": "7d03e4bd-636c-32da-83f6-c86d8b941847",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7d03e4bd-636c-32da-83f6-c86d8b941847.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "哑光001M",
                                    "image": {
                                        "id": "4318c2ff-a150-35af-a00c-341ab5dfe4b8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4318c2ff-a150-35af-a00c-341ab5dfe4b8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "哑光002M",
                                    "image": {
                                        "id": "78b95fd0-01e2-319c-828b-cbcdac73fa68",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/78b95fd0-01e2-319c-828b-cbcdac73fa68.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "哑光148M",
                                    "image": {
                                        "id": "b8c5f109-3a6f-3798-a529-620ff3c3b433",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b8c5f109-3a6f-3798-a529-620ff3c3b433.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "哑光342M",
                                    "image": {
                                        "id": "8e79c9e4-cc66-3bd5-be04-db63818c04a7",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8e79c9e4-cc66-3bd5-be04-db63818c04a7.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "哑光513M",
                                    "image": {
                                        "id": "0e73b703-1d44-3039-8e0b-5207191f7823",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0e73b703-1d44-3039-8e0b-5207191f7823.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "哑光888M",
                                    "image": {
                                        "id": "e7132e22-bd3e-3f04-8eb8-596d1261a082",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e7132e22-bd3e-3f04-8eb8-596d1261a082.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "锻光111",
                                    "image": {
                                        "id": "bf21d021-8eca-395d-ad0b-939f7b84e115",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bf21d021-8eca-395d-ad0b-939f7b84e115.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": " 缎光816",
                                    "image": {
                                        "id": "bba9b622-9b82-32a1-907e-e10a60bef46d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bba9b622-9b82-32a1-907e-e10a60bef46d.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": " 缎光354",
                                    "image": {
                                        "id": "b32b6101-1833-37be-a456-dbc81df80582",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b32b6101-1833-37be-a456-dbc81df80582.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "vpfrance_19990",
                            "name": "路铂廷 女王权杖唇膏3.8g cl萝卜丁口红 ",
                            "description": [],
                            "merchantId": "a7dbaa3e-55a8-3190-a04c-ee838af8c328",
                            "brand": "Christian Louboutin",
                            "displayBrand": "Christian Louboutin",
                            "brandId": "5e3360de-527f-3418-aa29-56d17cd44406",
                            "categoryIds": [
                                "b0g"
                            ],
                            "priceTagCN": "¥187",
                            "labels": [
                                "final_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "9.9折",
                        "activityOffs": [
                            "满折",
                            "限时价",
                            "额外九八折"
                        ],
                        "merchantName": "VP FRANCE",
                        "origin": "[法国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "满折",
                                    "color": "D27D3F"
                                },
                                {
                                    "text": "限时价",
                                    "color": "D27D3F"
                                },
                                {
                                    "text": "额外九八折",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "9.9折×额外9.8折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "限时价",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "1件9.9折",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "包邮包税",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ]
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 1606,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "法国",
                        "attraction": {
                            "badges": [
                                {
                                    "icon": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/img/app/img_limited_tag.png"
                                    },
                                    "type": "PROMO",
                                    "contents": []
                                }
                            ]
                        },
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "ba9460e7-b128-4f54-99b8-de9aaf730e01",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ba9460e7-b128-4f54-99b8-de9aaf730e01.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ba9460e7-b128-4f54-99b8-de9aaf730e01.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "blankspace_10639",
                            "name": "海蓝之谜修护精萃水100ml/150ml/200ml精粹水补水保湿修护紧致精华水新旧版本随机发 香港直邮",
                            "description": [],
                            "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                            "brand": "La Mer",
                            "displayBrand": "La Mer",
                            "brandId": "fb738cfb-e34b-325d-9bdb-623fca77af5e",
                            "categoryIds": [
                                "b2d"
                            ],
                            "priceTag": "$64",
                            "priceTagCN": "¥469",
                            "labels": [
                                "final_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "100ml",
                                    "displayName": "100ml"
                                },
                                {
                                    "ids": [],
                                    "name": "150ml",
                                    "displayName": "150ml"
                                },
                                {
                                    "ids": [],
                                    "name": "200ml",
                                    "displayName": "200ml"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "3.6折起",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "BLANKSPACE",
                        "origin": "[中国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "3.6折起",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "包邮包税",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ]
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 951,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "中国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "ce2c96d9-6822-41e7-bb30-c04ce143eb45",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ce2c96d9-6822-41e7-bb30-c04ce143eb45.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ce2c96d9-6822-41e7-bb30-c04ce143eb45.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "20ml",
                                    "image": {
                                        "id": "98bb615e-d567-3f9a-aee0-f792e5f248a2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/98bb615e-d567-3f9a-aee0-f792e5f248a2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "5ml*3 3瓶体验装",
                                    "image": {
                                        "id": "4a8f4825-7995-3d5e-afb1-7a1e46089753",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4a8f4825-7995-3d5e-afb1-7a1e46089753.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "5ml体验装",
                                    "image": {
                                        "id": "0836b63b-4b92-3558-b044-381439e7cffd",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0836b63b-4b92-3558-b044-381439e7cffd.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "luxurybeauty_10070",
                            "name": "兰蔻 菁纯眼霜 滋润焕亮淡化细纹紧致眼周抗老眼霜 20ml",
                            "description": [],
                            "merchantId": "eb66d114-c281-3762-ac98-b204b3352dd4",
                            "brand": "Lancôme",
                            "displayBrand": "Lancôme",
                            "brandId": "8c3ccaca-ed0e-37bb-8e39-9baeca9e3d26",
                            "categoryIds": [
                                "b24"
                            ],
                            "priceTagCN": "¥89",
                            "labels": [
                                "final_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "5.4折",
                        "activityOffs": [
                            "满折",
                            "限时价"
                        ],
                        "merchantName": "LuxuryBeauty",
                        "origin": "[中国香港]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "满折",
                                    "color": "D27D3F"
                                },
                                {
                                    "text": "限时价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "5.4折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "限时价",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "1件8.5折",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "包邮包税",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ]
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 2326,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "中国香港",
                        "attraction": {
                            "badges": [
                                {
                                    "icon": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/img/app/img_limited_tag.png"
                                    },
                                    "type": "PROMO",
                                    "contents": []
                                }
                            ]
                        },
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "d58adc7c-0c62-46c6-8036-f0ab2019eaba",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d58adc7c-0c62-46c6-8036-f0ab2019eaba.jpg",
                                        "width": 500,
                                        "height": 500,
                                        "format": "jpg"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d58adc7c-0c62-46c6-8036-f0ab2019eaba.jpg",
                                        "width": 500,
                                        "height": 500,
                                        "format": "jpg"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "blankspace_10582",
                            "name": "爱马仕Hermes大地男士中性香水淡香水30ml/50ml/100ml【香港直邮】",
                            "description": [],
                            "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                            "brand": "Hermes",
                            "displayBrand": "Hermes",
                            "brandId": "9cee9469-4096-3d44-94fb-240c61ade29b",
                            "categoryIds": [
                                "b0m"
                            ],
                            "priceTag": "$42",
                            "priceTagCN": "¥308",
                            "labels": [
                                "final_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "50ml",
                                    "displayName": "50ml"
                                },
                                {
                                    "ids": [],
                                    "name": "100ml",
                                    "displayName": "100ml"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "3.6折起",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "BLANKSPACE",
                        "origin": "[中国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "3.6折起",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "包邮包税",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ]
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 791,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "中国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "1d2bd670-633e-4462-b606-f7757e38c678",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1d2bd670-633e-4462-b606-f7757e38c678.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1d2bd670-633e-4462-b606-f7757e38c678.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "blankspace_10607",
                            "name": "雅诗兰黛多效智妍面霜75ml滋润清爽击退细纹年轻回弹新旧版本随机发【香港直邮】",
                            "description": [],
                            "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                            "brand": "Estée Lauder",
                            "displayBrand": "Estée Lauder",
                            "brandId": "31324581-2dcc-3c7d-a1fc-70541e5e2ba4",
                            "categoryIds": [
                                "b28"
                            ],
                            "priceTag": "$56",
                            "priceTagCN": "¥410",
                            "labels": [
                                "final_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "75ml清爽",
                                    "displayName": "75ml清爽"
                                },
                                {
                                    "ids": [],
                                    "name": "75ml滋润",
                                    "displayName": "75ml滋润"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "3.8折起",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "BLANKSPACE",
                        "origin": "[中国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "3.8折起",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "包邮包税",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ]
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 405,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "中国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                }
            ]
        },
        {
            "id": "accessory",
            "title": "配饰",
            "categoryIds": [
                "f"
            ],
            "brands": [
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/79aa2483-33fa-3a29-b287-792c13b2fbcc.jpg",
                    "id": "fb35adb5-fa93-3307-ab74-a644b26facee",
                    "name": "拉夫·劳伦",
                    "categoryIds": [
                        "14",
                        "24",
                        "f",
                        "86",
                        "95"
                    ],
                    "pathname": "la1-fu1-lao2-lun2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/3bee614d-0e15-35c2-a385-dd7235f1025a.jpg",
                    "id": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                    "name": "纪梵希",
                    "categoryIds": [
                        "14",
                        "24",
                        "f",
                        "86",
                        "95"
                    ],
                    "pathname": "ji4-fan4-xi1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/77f0cfb9-43ac-3916-b067-baeb6d4c6566.jpg",
                    "id": "c260b086-eb36-3736-afbd-dfda6c669b08",
                    "name": "圣罗兰",
                    "categoryIds": [
                        "14",
                        "24",
                        "f",
                        "86",
                        "95"
                    ],
                    "pathname": "sheng4-luo2-lan2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/733763d8-b189-3cf3-bea8-074f1399e35f.jpg",
                    "id": "5db931c1-42cc-3c31-81bc-8c7fb8f3c34b",
                    "name": "Heritage",
                    "categoryIds": [
                        "14",
                        "24",
                        "f",
                        "86",
                        "95"
                    ],
                    "pathname": "heritage"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/5be531d7-4c4d-380b-aa55-b4aee1305d31.jpg",
                    "id": "21e81f3c-56a3-3e2b-a775-312b6698c86f",
                    "name": "纽亦华",
                    "categoryIds": [
                        "14",
                        "24",
                        "f",
                        "86",
                        "95"
                    ],
                    "pathname": "niu3-yi4-hua2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/3d0de6c6-f9b3-3c2b-8b89-60c910bd0024.jpg",
                    "id": "6a124834-98e6-3b12-a541-26c38fd83746",
                    "name": "亚历山大·麦昆",
                    "categoryIds": [
                        "14",
                        "24",
                        "f",
                        "86",
                        "95"
                    ],
                    "pathname": "ya4-li4-shan1-da4-mai4-kun1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/4246e250-2128-355e-88c2-8581d0bedda2.jpg",
                    "id": "41fd220f-05ed-3d8c-96e3-b83af87d45d7",
                    "name": "耐克",
                    "categoryIds": [
                        "14",
                        "24",
                        "f",
                        "86",
                        "95"
                    ],
                    "pathname": "nai4-ke4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/b9f8e3f4-2e13-31a6-b2b2-b7190cd9f0bb.jpg",
                    "id": "41420474-31f5-3974-af18-2c6f3a4982f6",
                    "name": "盖尔斯",
                    "categoryIds": [
                        "14",
                        "24",
                        "f",
                        "86",
                        "95"
                    ],
                    "pathname": "gai4-er3-si1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/23ac47c3-3a09-3283-8801-f4542c4b1d0c.jpg",
                    "id": "04005cf7-5278-3d59-a187-ef0b416c10a2",
                    "name": "卡尔文·克莱恩",
                    "categoryIds": [
                        "14",
                        "24",
                        "f",
                        "86",
                        "95"
                    ],
                    "pathname": "ka3-er3-wen2-ke4-lai2-en1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/d6bd5aaa-8e2c-3c43-9a32-b850624882f8.jpg",
                    "id": "89d021e6-82f1-37a6-bf8e-6fe859cdcc2d",
                    "name": "美国职业棒球大联盟",
                    "categoryIds": [
                        "14",
                        "24",
                        "f",
                        "86",
                        "95"
                    ],
                    "pathname": "mei3-guo2-zhi2-ye4-bang4-qiu2-da4-lian2-meng2"
                }
            ],
            "productList": [
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "3bee614d-0e15-35c2-a385-dd7235f1025a",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/20032280_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3bee614d-0e15-35c2-a385-dd7235f1025a.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3bee614d-0e15-35c2-a385-dd7235f1025a.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Rhodium",
                                    "image": {
                                        "id": "1b5859ed-2304-3bb9-8b29-e1b4f7d29593",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1b5859ed-2304-3bb9-8b29-e1b4f7d29593.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_12955339",
                            "name": "Pavé Twist Bangle Bracelet",
                            "nameCN": "密镶扭纹手镯  莫比乌斯 内侧字母logo标识 60572954",
                            "description": [
                                "Slip on the sweet sparkle of this twisting bangle bracelet from Givenchy.",
                                "Set in gold-tone, silver-tone, or rose gold-tone mixed metal",
                                "Approx. diameter: 2-1/4\"",
                                "Foldover closure",
                                "Photo may have been enlarged and/or enhanced.",
                                "This item cannot be shipped to Alaska, American Samoa, Guam, Hawaii, Marshall Islands, the Pacific Islands, Palau, Puerto Rico, U.S. Virgin Islands, P.O. boxes, or APOs"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Givenchy",
                            "displayBrand": "Givenchy",
                            "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                            "category": "bracelets|bracelet",
                            "categoryIds": [
                                "f64"
                            ],
                            "priceTag": "$33.95",
                            "priceTagCN": "¥249",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "7折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 9744,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "05a8aca1-3944-31b4-aa01-f914f0ceccfc",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/16025288_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/05a8aca1-3944-31b4-aa01-f914f0ceccfc.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/05a8aca1-3944-31b4-aa01-f914f0ceccfc.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Rose Gold",
                                    "image": {
                                        "id": "747f7cfe-8519-3960-b55b-4df84af46794",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/747f7cfe-8519-3960-b55b-4df84af46794.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Silver",
                                    "image": {
                                        "id": "743ee13a-f165-3d29-813f-68c65b5e0a39",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/743ee13a-f165-3d29-813f-68c65b5e0a39.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Gold",
                                    "image": {
                                        "id": "a40c81cf-8a39-39a1-bcb2-824a4bfa553c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a40c81cf-8a39-39a1-bcb2-824a4bfa553c.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_792565",
                            "name": "Crystal Fireball Pendant Necklace 16\" + 2\" extender",
                            "nameCN": "纪梵希 毛衣链 水晶火球项链 满天星 60414680 ",
                            "description": [
                                "Scorching style, Givenchy's pendant features a crystal fireball for endless sparkle.",
                                "Set in rose gold-tone, gold-tone, and silver-tone mixed metal",
                                "Approximate length: 16\" + 2\" extender",
                                "Closure: Lobster clasp closure",
                                "Photo may have been enlarged and/or enhanced."
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Givenchy",
                            "displayBrand": "Givenchy",
                            "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                            "category": "necklaces|necklace",
                            "categoryIds": [
                                "f43"
                            ],
                            "priceTag": "$22.60",
                            "priceTagCN": "¥166",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "6.9折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "6.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 19012,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "2b2f91f1-760f-3b30-8195-d48812cacdcb",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/16025306_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2b2f91f1-760f-3b30-8195-d48812cacdcb.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2b2f91f1-760f-3b30-8195-d48812cacdcb.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Silver",
                                    "image": {
                                        "id": "9a5e9fd5-c5d5-3330-a0e3-1c026e73e5ed",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9a5e9fd5-c5d5-3330-a0e3-1c026e73e5ed.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Rose Gold",
                                    "image": {
                                        "id": "3f4f6b4f-87ae-3497-9365-b5f545bf23e1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3f4f6b4f-87ae-3497-9365-b5f545bf23e1.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Gold",
                                    "image": {
                                        "id": "6ba73b0f-7358-3861-be87-4a2a665fa3d6",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6ba73b0f-7358-3861-be87-4a2a665fa3d6.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_669033",
                            "name": "Crystal Pendant Necklace, 16\" + 2\" Extender",
                            "nameCN": "（手链扣）手链扣 纪梵希 圆形吊坠水晶项链",
                            "description": [
                                "Simple sparkle, Givenchy's small pendant necklace features the prettiest element at the center.",
                                "Set in gold-tone mixed metal, rose gold-tone, or silver-tone mixed metal",
                                "Approx. length: 16\" + 2\" extender; approx. drop: 3/8\"",
                                "Lobster clasp closure",
                                "Photo may have been enlarged and/or enhanced.",
                                "This item cannot be shipped to American Samoa, Guam, Marshall Islands, U.S. Virgin Islands, Puerto Rico, Palau, or the Pacific Islands"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Givenchy",
                            "displayBrand": "Givenchy",
                            "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                            "category": "necklace|necklaces",
                            "categoryIds": [
                                "f65"
                            ],
                            "priceTag": "$22.60",
                            "priceTagCN": "¥166",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "6.9折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "6.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 16083,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "60b9c65a-bad5-39ee-a80f-bb94972e205d",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/3204919_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/60b9c65a-bad5-39ee-a80f-bb94972e205d.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/60b9c65a-bad5-39ee-a80f-bb94972e205d.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Rose Gold",
                                    "image": {
                                        "id": "71c200ac-9084-391b-933c-78ccfcd1b914",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/71c200ac-9084-391b-933c-78ccfcd1b914.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Silver",
                                    "image": {
                                        "id": "43b0a827-6f4a-351b-b7d6-de47606cece5",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/43b0a827-6f4a-351b-b7d6-de47606cece5.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_2112575",
                            "name": "Small Crystal Pavé Stud Earrings",
                            "nameCN": "纪梵希耳环",
                            "description": [
                                "Whenever you need just a little touch of sparkle put on these pretty crystal pavé stud earrings by Givenchy. Crafted of silver-tone mixed metal. Approximate diameter: 3/8 inches.",
                                "Photo may have been enlarged and/or enhanced.",
                                "This item cannot be shipped to American Samoa, Guam, Marshall Islands, U.S. Virgin Islands, Puerto Rico, Palau, or the Pacific Islands"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Givenchy",
                            "displayBrand": "Givenchy",
                            "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                            "category": "earrings",
                            "categoryIds": [
                                "f45"
                            ],
                            "priceTag": "$22.60",
                            "priceTagCN": "¥166",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "6.9折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "6.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 5032,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "23c88544-4471-3189-808e-c6c1e91de3c1",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/16025298_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/23c88544-4471-3189-808e-c6c1e91de3c1.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/23c88544-4471-3189-808e-c6c1e91de3c1.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Silver",
                                    "image": {
                                        "id": "d43355e5-6410-3544-b6d2-7e9c3af6e561",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d43355e5-6410-3544-b6d2-7e9c3af6e561.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Rose Gold",
                                    "image": {
                                        "id": "8795e73b-609b-3c98-8ff1-22cb4550376b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8795e73b-609b-3c98-8ff1-22cb4550376b.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Gold",
                                    "image": {
                                        "id": "5b7047c5-8c61-3274-951d-97c29c279082",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/5b7047c5-8c61-3274-951d-97c29c279082.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_669037",
                            "name": "Crystal Element Bangle Bracelet",
                            "nameCN": "施华洛世奇水晶元素手环【款式参考首图】",
                            "description": [
                                "Givenchy's polished and sleek bangle bracelet features silk elements.",
                                "Set in rose gold-tone, rhodium-plated silver-tone, or 10k gold-plated brass",
                                "Approx. diameter: 2-1/2\"",
                                "Photo may have been enlarged and/or enhanced.",
                                "This item cannot be shipped to American Samoa, Guam, Marshall Islands, U.S. Virgin Islands, Puerto Rico, Palau, or the Pacific Islands"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Givenchy",
                            "displayBrand": "Givenchy",
                            "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                            "category": "bracelets|bracelet",
                            "categoryIds": [
                                "f42"
                            ],
                            "priceTag": "$33.95",
                            "priceTagCN": "¥249",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "7折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 10682,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "961418ba-64e9-3864-954e-2ce351928eed",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/18689327_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/961418ba-64e9-3864-954e-2ce351928eed.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/961418ba-64e9-3864-954e-2ce351928eed.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Silver",
                                    "image": {
                                        "id": "b09e7aac-8ee1-3c41-bd08-a537680a4cd1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b09e7aac-8ee1-3c41-bd08-a537680a4cd1.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_12129485",
                            "name": "Crystal Pendant Necklace",
                            "nameCN": "纪梵希水晶吊坠",
                            "description": [
                                "A sweetly arranged pendant features two stunning stones on Givenchy's necklace design.",
                                "Gold-tone and Silver-tone",
                                "Foldover Closure",
                                "Approx. Length 16\" + 3\" Extender, Approx. Pendant .4\"",
                                "Photo may have been enlarged and/or enhanced.",
                                "This item cannot be shipped to Alaska, American Samoa, Guam, Hawaii, Marshall Islands, the Pacific Islands, Palau, Puerto Rico, U.S. Virgin Islands, P.O. boxes, or APOs"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Givenchy",
                            "displayBrand": "Givenchy",
                            "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                            "category": "necklace|necklaces",
                            "categoryIds": [
                                "f43"
                            ],
                            "priceTag": "$24.75",
                            "priceTagCN": "¥182",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "7折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 8740,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "cd64ec6b-1be0-35ec-809d-c5012cbb2109",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/27878562_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cd64ec6b-1be0-35ec-809d-c5012cbb2109.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cd64ec6b-1be0-35ec-809d-c5012cbb2109.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Crystal Wh",
                                    "image": {
                                        "id": "04b74506-f4a5-3aec-a358-71b74c185812",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/04b74506-f4a5-3aec-a358-71b74c185812.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_18090166",
                            "name": "Silver-Tone Round & Marquise-Cut Cubic Zirconia Tennis Bracelet",
                            "description": [
                                "Round and marquise-cut cubic zirconia alternate in the crafting of this exquisite Givenchy tennis bracelet.",
                                "Approx. length: 7-1/4\"",
                                "Set in silver-tone mixed metal",
                                "Cubic zirconia",
                                "Foldover clasp closure",
                                "Photo may have been enlarged and/or enhanced.",
                                "This item cannot be shipped to American Samoa, Guam, Marshall Islands, U.S. Virgin Islands, Puerto Rico, Palau or the Pacific Islands"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Givenchy",
                            "displayBrand": "Givenchy",
                            "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                            "category": "bracelet|bracelets",
                            "categoryIds": [
                                "f64"
                            ],
                            "priceTag": "$41",
                            "priceTagCN": "¥301",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "ONE SIZE",
                                    "displayName": "ONE SIZE"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "6.9折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "6.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 603,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "cc3e1be0-74c2-3e37-8f81-7b45e5ceb2df",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/11538726_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cc3e1be0-74c2-3e37-8f81-7b45e5ceb2df.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cc3e1be0-74c2-3e37-8f81-7b45e5ceb2df.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Gold/Jet Black",
                                    "image": {
                                        "id": "616e61c6-12a3-3784-9425-756b76d0b52d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/616e61c6-12a3-3784-9425-756b76d0b52d.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Black",
                                    "image": {
                                        "id": "9e37d92a-9b8d-3236-b26e-c95b8aedffa9",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9e37d92a-9b8d-3236-b26e-c95b8aedffa9.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_7059227",
                            "name": "Crystal Flex Bracelet",
                            "nameCN": "水晶弹性手链",
                            "description": [
                                "Exquisite sparkle. Crystals are set within detailed settings in this stunning Givenchy flex bracelet.",
                                "Set in silver-tone or gold-tone mixed metal",
                                "Approx. length: 7-1/4\"",
                                "Foldover clasp closure",
                                "Photo may have been enlarged and/or enhanced."
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Givenchy",
                            "displayBrand": "Givenchy",
                            "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                            "category": "bracelets|bracelet",
                            "categoryIds": [
                                "f42"
                            ],
                            "priceTag": "$41",
                            "priceTagCN": "¥301",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "ONE SIZE",
                                    "displayName": "ONE SIZE"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "6.9折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "6.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 1012,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "c634e8ad-08ee-3305-a12b-b063b1504ca9",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/20796057_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c634e8ad-08ee-3305-a12b-b063b1504ca9.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c634e8ad-08ee-3305-a12b-b063b1504ca9.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Pink",
                                    "image": {
                                        "id": "ede6273d-c8d5-3cd1-a396-1bcbc915a583",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ede6273d-c8d5-3cd1-a396-1bcbc915a583.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_13130159",
                            "name": "Pear-Shape Crystal Orbital Flex Bracelet",
                            "nameCN": "纪梵希 梨形水晶 手链",
                            "description": [
                                "They'll certainly stop for a second look when they catch a glimpse of the pear-shaped orbital design on this chic Givenchy flex bracelet.",
                                "Set in silver-tone or rose gold-tone mixed metal; glass",
                                "Approx. length: 7-1/4\"",
                                "Foldover clasp closure",
                                "Photo may have been enlarged and/or enhanced.",
                                "This item cannot be shipped to Alaska, American Samoa, Guam, Hawaii, Marshall Islands, the Pacific Islands, Palau, Puerto Rico, U.S. Virgin Islands, P.O. boxes, or APOs"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Givenchy",
                            "displayBrand": "Givenchy",
                            "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                            "category": "bracelets|bracelet",
                            "categoryIds": [
                                "f42"
                            ],
                            "priceTag": "$48.10",
                            "priceTagCN": "¥353",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "7折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 368,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                }
            ]
        },
        {
            "id": "womens_clothes",
            "title": "女装",
            "categoryIds": [
                "8"
            ],
            "brands": [
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/a740a1f6-6e61-3828-a431-ec01a4c1484b.jpg",
                    "id": "fb35adb5-fa93-3307-ab74-a644b26facee",
                    "name": "拉夫·劳伦",
                    "categoryIds": [
                        "11",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85"
                    ],
                    "pathname": "la1-fu1-lao2-lun2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/b2313f03-a012-3621-b333-ac3b147fc06f.jpg",
                    "id": "79aed056-90c8-3a69-bb28-92ef539c9357",
                    "name": "巴塔哥尼亚",
                    "categoryIds": [
                        "11",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85"
                    ],
                    "pathname": "ba1-ta3-ge1-ni2-ya4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/80ede303-72b6-300e-933f-a0ac1c7d6b37.jpg",
                    "id": "04005cf7-5278-3d59-a187-ef0b416c10a2",
                    "name": "卡尔文·克莱恩",
                    "categoryIds": [
                        "11",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85"
                    ],
                    "pathname": "ka3-er3-wen2-ke4-lai2-en1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/3d8cee47-fa45-37cd-96bc-ef9f3dbc05f7.jpg",
                    "id": "00e3d77f-2be8-3ccc-b1a0-27f3ee32e81c",
                    "name": "汤米·希尔费格",
                    "categoryIds": [
                        "11",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85"
                    ],
                    "pathname": "tang1-mi3-xi1-er3-fei4-ge2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/b36af3b8-0185-3e34-a01b-28fe331bef03.jpg",
                    "id": "4a932bf9-902e-3627-99ae-9c9c6e495612",
                    "name": "SKIMS",
                    "categoryIds": [
                        "11",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85"
                    ],
                    "pathname": "skims"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/31d03af5-def6-3f41-b9bc-3c409ed0771c.jpg",
                    "id": "273c0224-d38f-3ad8-96cc-56abdf6c5e8d",
                    "name": "露露乐檬",
                    "categoryIds": [
                        "11",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85"
                    ],
                    "pathname": "lu4-lu4-le4-meng2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/41be065b-0820-3d22-9b1b-3f1273b16396.jpg",
                    "id": "719669a8-8608-32c9-845d-cfd2b84b254c",
                    "name": "土拨鼠",
                    "categoryIds": [
                        "11",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85"
                    ],
                    "pathname": "tu3-bo1-shu3"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/19754f5e-3aaa-3a91-8488-8905ad2d937d.jpg",
                    "id": "3077ae92-d0c1-3659-a871-19c21b6670bb",
                    "name": "始祖鸟",
                    "categoryIds": [
                        "11",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85"
                    ],
                    "pathname": "shi3-zu3-niao3"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/f93a2708-9037-3432-98ed-079f49d9e5af.jpg",
                    "id": "28a34010-e84b-381f-b087-359c7e280a08",
                    "name": "阿迪达斯",
                    "categoryIds": [
                        "11",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85"
                    ],
                    "pathname": "a1-di2-da2-si1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/9f2bfe62-390a-3825-acf4-ed47694cb3d1.jpg",
                    "id": "0e42f86f-7098-3292-99dc-2cd5171579c2",
                    "name": "Free People",
                    "categoryIds": [
                        "11",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85"
                    ],
                    "pathname": "free-people"
                }
            ],
            "productList": [
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "b2313f03-a012-3621-b333-ac3b147fc06f",
                                    "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/20PTGWWCPCLDLYGRPAPT_73_Skyline_Wtlnd_Blu_Xdye?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b2313f03-a012-3621-b333-ac3b147fc06f.jpg",
                                        "width": 598,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b2313f03-a012-3621-b333-ac3b147fc06f.jpg",
                                        "width": 204,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "73 Skyline Wtlnd Blu Xdye",
                                    "image": {
                                        "id": "bd51d6ac-5f6a-3a8b-960f-0f1a4d2b64d5",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bd51d6ac-5f6a-3a8b-960f-0f1a4d2b64d5.jpg",
                                            "width": 37,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "dickssportinggoods_20ptgwwcpcldlygrpapt",
                            "name": "Patagonia Women's Capilene Cool Daily Graphic T-Shirt",
                            "nameCN": "女款 Capilene T恤 吸湿排汗",
                            "description": [
                                "Highlights",
                                "Capilene® Cool is Quick Drying and moisture wicking",
                                "HeiQ® Mint odor control",
                                "Chafe-free sleeve design",
                                "Orginal artwork graphic",
                                "Fit & Design:",
                                "Standard fit shirt",
                                "Versatile performance knit offers optimal comfort and function when you’re on the move",
                                "Constructed with set-in sleeves provides total mobility and a chafe-free experience",
                                "Original artwork graphics support a unique outdoor style",
                                "Technology:",
                                "miDori® increases moisture wicking performance speed dries sweat and moisture keeping you cool and dry all day",
                                "HeiQ® Mint odor control technology fights and helps block odor causing microbes keeping you smelling fresh longer",
                                "Additional Details:",
                                "Made in a Fair Trade Certified™ factory, which means the people who made this product earned a premium for their labor",
                                "Gender:Women's",
                                "Best Use:Casual, Hiking",
                                "Sustainability:Contains recycled materials, Fair Trade Certified® sewn, bluesign® approved",
                                "Fabric:Solids: 100% recycled polyester jersey | Heathers and cross-dyes: 100% polyester (50% recycled) jersey",
                                "Shirt Type:T-shirt",
                                "Fit Type:Standard",
                                "Neckline:Crew",
                                "Sleeve Length:Short sleeve",
                                "Moisture Wicking:Yes",
                                "Back Length:Hip length",
                                "Stay comfortable and stylish on your next adventure with the Patagonia Women’s Capilene Cool Daily Graphic T-Shirt. This versatile tee features a standard fit and original artwork graphics that showcase your unique outdoor style. Crafted from recycled materials, it offers optimal comfort and performance with moisture-wicking and odor control technologies, making it perfect for both casual wear and hiking.",
                                "Fit & Design:",
                                "Standard fit shirt",
                                "Versatile performance knit offers optimal comfort and function when you’re on the move",
                                "Constructed with set-in sleeves provides total mobility and a chafe-free experience",
                                "Original artwork graphics support a unique outdoor style",
                                "Technology:",
                                "miDori® increases moisture wicking performance speed dries sweat and moisture keeping you cool and dry all day",
                                "HeiQ® Mint odor control technology fights and helps block odor causing microbes keeping you smelling fresh longer",
                                "Additional Details:",
                                "Made in a Fair Trade Certified™ factory, which means the people who made this product earned a premium for their labor",
                                "Brand :",
                                "Patagonia",
                                "Country of Origin : Imported",
                                "Style : 45250",
                                "Fabric : Solids: 100% recycled polyester jersey; Heathers and cross-dyes: 100% polyester (50% recycled) jersey",
                                "Web ID:",
                                "20PTGWWCPCLDLYGRPAPT"
                            ],
                            "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                            "brand": "Patagonia",
                            "displayBrand": "Patagonia",
                            "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                            "category": "Women's|womensshirtstops-129842|women's|shirts|shirts & tops",
                            "categoryIds": [
                                "78d",
                                "823"
                            ],
                            "priceTag": "$24.85",
                            "priceTagCN": "¥182",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4折",
                        "activityOffs": [],
                        "merchantName": "Dick's Sporting Goods",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 2175,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {
                            "remainingSizes": "剩XL码",
                            "buoyId": "REMAINING_SIZES"
                        }
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "b2313f03-a012-3621-b333-ac3b147fc06f",
                                    "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/20PTGWWCPCLDLYGRPAPT_73_Skyline_Wtlnd_Blu_Xdye?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b2313f03-a012-3621-b333-ac3b147fc06f.jpg",
                                        "width": 598,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b2313f03-a012-3621-b333-ac3b147fc06f.jpg",
                                        "width": 204,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "73 Skyline Wtlnd Blu Xdye",
                                    "image": {
                                        "id": "bd51d6ac-5f6a-3a8b-960f-0f1a4d2b64d5",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bd51d6ac-5f6a-3a8b-960f-0f1a4d2b64d5.jpg",
                                            "width": 37,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "moosejaw_20ptgwwcpcldlygrpapt",
                            "name": "Patagonia Women's Capilene Cool Daily Graphic T-Shirt",
                            "nameCN": "Capilene 女款速干短袖T恤 多款配色",
                            "description": [
                                "Stay comfortable and stylish on your next adventure with the Patagonia Women’s Capilene Cool Daily Graphic T-Shirt. This versatile tee features a standard fit and original artwork graphics that showcase your unique outdoor style. Crafted from recycled materials, it offers optimal comfort and performance with moisture-wicking and odor control technologies, making it perfect for both casual wear and hiking.",
                                "Fit & Design:",
                                "Standard fit shirt",
                                "Versatile performance knit offers optimal comfort and function when you’re on the move",
                                "Constructed with set-in sleeves provides total mobility and a chafe-free experience",
                                "Original artwork graphics support a unique outdoor style",
                                "Technology:",
                                "miDori® increases moisture wicking performance speed dries sweat and moisture keeping you cool and dry all day",
                                "HeiQ® Mint odor control technology fights and helps block odor causing microbes keeping you smelling fresh longer",
                                "Additional Details:",
                                "Made in a Fair Trade Certified™ factory, which means the people who made this product earned a premium for their labor",
                                "Size and Fit:",
                                "Capilene® Cool is Quick Drying and moisture wicking",
                                "HeiQ® Mint odor control",
                                "Chafe-free sleeve design",
                                "Orginal artwork graphic",
                                "Country of Origin: Imported",
                                "Fabric: Solids: 100% recycled polyester jersey; Heathers and cross-dyes: 100% polyester (50% recycled) jersey",
                                "Size and Fit Summary: Capilene® Cool is Quick Drying and moisture wicking | HeiQ® Mint odor control | Chafe-free sleeve design | Orginal artwork graphic",
                                "GenderWomen'sBest UseCasual, HikingSustainabilityContains recycled materials, Fair Trade Certified® sewn, bluesign® approvedFabricSolids: 100% recycled polyester jersey | Heathers and cross-dyes: 100% polyester (50% recycled) jerseyShirt TypeT-shirtFit TypeStandardNecklineCrewSleeve LengthShort sleeveMoisture WickingYesBack LengthHip length"
                            ],
                            "merchantId": "0c32169d-33a8-c50e-8443-ada9dd24e8c7",
                            "brand": "Patagonia",
                            "displayBrand": "Patagonia",
                            "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                            "category": "tees|shirts|crew neck|Women's|shirts & tops|hikingshirts|short sleeve",
                            "categoryIds": [
                                "823",
                                "78d"
                            ],
                            "priceTag": "$29.50",
                            "priceTagCN": "¥216",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "S",
                                    "displayName": "S"
                                },
                                {
                                    "ids": [],
                                    "name": "M",
                                    "displayName": "M"
                                },
                                {
                                    "ids": [],
                                    "name": "L",
                                    "displayName": "L"
                                },
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4.8折",
                        "activityOffs": [],
                        "merchantName": "Public Lands (Moosejaw)",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4.8折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 787,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "6097c800-91e4-3696-9e74-261f24030f2b",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6097c800-91e4-3696-9e74-261f24030f2b.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "jpg"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6097c800-91e4-3696-9e74-261f24030f2b.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "jpg"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "卡其LA黑标",
                                    "image": {
                                        "id": "9630ca37-cace-39e4-ae7b-bda0d16f6e21",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9630ca37-cace-39e4-ae7b-bda0d16f6e21.png",
                                            "width": 50,
                                            "height": 50,
                                            "format": "png"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "卡其NY小标",
                                    "image": {
                                        "id": "a8d4a726-0d09-3cf5-9f22-f25ee77db845",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a8d4a726-0d09-3cf5-9f22-f25ee77db845.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "墨绿LA小标",
                                    "image": {
                                        "id": "88ebf105-1d69-375c-aa9d-3c024c41c00b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/88ebf105-1d69-375c-aa9d-3c024c41c00b.png",
                                            "width": 50,
                                            "height": 50,
                                            "format": "png"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "棕色NY小标",
                                    "image": {
                                        "id": "c786a4e3-72f6-3d2b-9e81-1dea7965eb3d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c786a4e3-72f6-3d2b-9e81-1dea7965eb3d.png",
                                            "width": 50,
                                            "height": 50,
                                            "format": "png"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "灰白NY大标",
                                    "image": {
                                        "id": "1e3d3707-1232-375d-b489-04c5e533eb0e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1e3d3707-1232-375d-b489-04c5e533eb0e.png",
                                            "width": 50,
                                            "height": 50,
                                            "format": "png"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "炭灰NY大标",
                                    "image": {
                                        "id": "62f21a40-ac00-32e7-a366-5c8be93fa2af",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/62f21a40-ac00-32e7-a366-5c8be93fa2af.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "粉色C小标",
                                    "image": {
                                        "id": "45407636-bc57-3e1c-8670-df2781cb1fd8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/45407636-bc57-3e1c-8670-df2781cb1fd8.png",
                                            "width": 50,
                                            "height": 50,
                                            "format": "png"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "粉色LA大标",
                                    "image": {
                                        "id": "d2212936-1649-3311-8356-bb2cb1e37869",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d2212936-1649-3311-8356-bb2cb1e37869.png",
                                            "width": 50,
                                            "height": 50,
                                            "format": "png"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "绿色LA大标",
                                    "image": {
                                        "id": "b5822816-ac4c-35e9-8f80-1a8265c3f715",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b5822816-ac4c-35e9-8f80-1a8265c3f715.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "蓝色LA大标",
                                    "image": {
                                        "id": "594edd43-fb2b-3130-9d6d-aa3b514e5431",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/594edd43-fb2b-3130-9d6d-aa3b514e5431.png",
                                            "width": 50,
                                            "height": 50,
                                            "format": "png"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "藏蓝NY大标",
                                    "image": {
                                        "id": "ccd67c65-f8e1-3ff7-a002-dd89a116ac89",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ccd67c65-f8e1-3ff7-a002-dd89a116ac89.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "藏蓝NY小标",
                                    "image": {
                                        "id": "7512f3b1-f10e-37e6-9d00-65b7cc69dfde",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7512f3b1-f10e-37e6-9d00-65b7cc69dfde.png",
                                            "width": 50,
                                            "height": 50,
                                            "format": "png"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "酒红LA小标",
                                    "image": {
                                        "id": "a0c94e27-da10-37a0-906c-7f3d5aef6ed3",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a0c94e27-da10-37a0-906c-7f3d5aef6ed3.png",
                                            "width": 50,
                                            "height": 50,
                                            "format": "png"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "黑色LA大标",
                                    "image": {
                                        "id": "c74e2cb5-9a78-3258-a92e-00ac474ff5ab",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c74e2cb5-9a78-3258-a92e-00ac474ff5ab.png",
                                            "width": 50,
                                            "height": 50,
                                            "format": "png"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "黑色LA小标",
                                    "image": {
                                        "id": "4909028e-9466-3158-897c-815fef07ea3b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4909028e-9466-3158-897c-815fef07ea3b.png",
                                            "width": 50,
                                            "height": 50,
                                            "format": "png"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "xiangbeiguoji_goodsId_11177",
                            "name": "【享贝家】（国内发货-如断货会砍单）MLB 复古小标软顶棒球帽 大标男女情侣遮阳鸭舌帽 明星同款 多色",
                            "description": [],
                            "merchantId": "1941c66c-af1b-3532-9d8e-6b7019af351c",
                            "displayBrand": "MLB",
                            "brandId": "89d021e6-82f1-37a6-bf8e-6fe859cdcc2d",
                            "categoryIds": [
                                "867"
                            ],
                            "priceTag": "$19.60",
                            "priceTagCN": "¥144",
                            "labels": [],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "FREE",
                                    "displayName": "FREE"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "activityOffs": [],
                        "merchantName": "xiangbeiguoji",
                        "origin": "[韩国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "包邮包税",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ]
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 17584,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "韩国",
                        "buoy": {
                            "remainingSizes": "剩FREE码",
                            "buoyId": "REMAINING_SIZES"
                        }
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "a740a1f6-6e61-3828-a431-ec01a4c1484b",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/28953330_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a740a1f6-6e61-3828-a431-ec01a4c1484b.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a740a1f6-6e61-3828-a431-ec01a4c1484b.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Black/Camel",
                                    "image": {
                                        "id": "1a243a0b-5111-35d4-b8de-cb1bd69b62d2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1a243a0b-5111-35d4-b8de-cb1bd69b62d2.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Navy/Cream",
                                    "image": {
                                        "id": "7b1ccdf0-f130-3035-a641-4ab704116eba",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7b1ccdf0-f130-3035-a641-4ab704116eba.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Camel/Cream",
                                    "image": {
                                        "id": "16c27120-b46d-395e-8541-0e7488c48f9f",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/16c27120-b46d-395e-8541-0e7488c48f9f.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_18618144",
                            "name": "Border Wrap",
                            "nameCN": "拉夫劳伦 女款披肩",
                            "description": [
                                "Elevate your style with this Lauren Border Wrap. Designed for versatility, this chic piece offers two looks in one, perfect for all adventures. Stay cozy and stylish wherever your journey takes you with this must-have cozy companion.",
                                "Approx. dimensions: 60\" W  x 42\" L",
                                "LRL logo bar hardware",
                                "Reversible",
                                "Border stripes",
                                "This item purchased online must be returned to the vendor by mail only. This item cannot be returned to Macy's stores.",
                                "95% Acrylic, 5% Wool",
                                "Dry clean",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Lauren Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "wrap|women's fashion|scarves & wraps",
                            "categoryIds": [
                                "86a"
                            ],
                            "priceTag": "$70",
                            "priceTagCN": "¥513",
                            "labels": [
                                "final_sale",
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "ONE SIZE",
                                    "displayName": "ONE SIZE"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "6.3折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "6.3折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 529,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "28f05734-235b-3a35-952e-b94d1417102a",
                                    "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/products/slm28-30006132-001__1.jpg?v=1623869369",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/28f05734-235b-3a35-952e-b94d1417102a.jpg",
                                        "width": 827,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/28f05734-235b-3a35-952e-b94d1417102a.jpg",
                                        "width": 283,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "madaluxevault_6822635765910",
                            "name": "Cat-Eye Acetate Frame Sunglasses",
                            "nameCN": "YSL 女款 猫眼太阳镜",
                            "description": [
                                "DETAILS",
                                "Temple Length: 140mm; Lens Width: 54mm; Bridge Width: 19mm",
                                "Frame Shape: Cat Eye",
                                "Frame Material: Acetate",
                                "Temple Material: Acetate",
                                "Saddle Nose Bridge",
                                "Non-Polarized",
                                "Comes with a protective designer case and cleaning cloth.",
                                "Made in Italy"
                            ],
                            "merchantId": "915f7e36-9962-1888-3f00-149431e51ec6",
                            "brand": "Saint Laurent",
                            "displayBrand": "Yves Saint Laurent",
                            "brandId": "c260b086-eb36-3736-afbd-dfda6c669b08",
                            "category": "sunglasses|saint-laurent-cat-eye-acetate-frame-slm28-30006132-001-slm28-30006132-001|140|19|47|54|black|cat eye|cat eye womens size chart|employee 25|eyewear|hide-eyewear|saint laurent|smsmeyewear|solid|sunglasses|women|womens",
                            "categoryIds": [
                                "863"
                            ],
                            "priceTag": "$92.54",
                            "priceTagCN": "¥678",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "2.5折",
                        "activityOffs": [
                            "额外八折",
                            "额外九折",
                            "新人补贴价"
                        ],
                        "merchantName": "Maison Beyond",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "额外八折",
                                    "color": "D27D3F"
                                },
                                {
                                    "text": "额外九折",
                                    "color": "D27D3F"
                                },
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "2.5折×额外8折x额外9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$2",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 426,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "f93a2708-9037-3432-98ed-079f49d9e5af",
                                    "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/H48444-A_1l.jpg?v=1755912614",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f93a2708-9037-3432-98ed-079f49d9e5af.jpg",
                                        "width": 1000,
                                        "height": 1000,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f93a2708-9037-3432-98ed-079f49d9e5af.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [],
                            "id": "shoebacca_9976621105434",
                            "name": "3 Stripe Full Zip Jacket",
                            "nameCN": "女款复古三条杠条纹运动衫",
                            "description": [
                                "Dash out the door feeling ready for it all. This track jacket has a slim cut with raglan sleeves for a distraction-free feel while warming up or recovering later on. Side pockets keep a bus pass and music player within reach. This product is made with Primegreen, a series of high-performance recycled materials.",
                                "Slim fit",
                                "Full zip with stand-up collar",
                                "100% polyester (recycled)",
                                "Front pockets",
                                "Raglan sleeves",
                                "Ribbed cuffs and hem",
                                "SKU: \nH48444-A",
                                "Color: \nBlack",
                                "Feature: \nFull Zip, Pockets, Sustainable",
                                "Material: \nPolyester",
                                "Sport: \nTraining",
                                "Style: \nJacket",
                                "Pattern: \nStriped"
                            ],
                            "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                            "brand": "adidas",
                            "displayBrand": "Adidas",
                            "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                            "category": "women|womens|clothes|training|adidas|outerwear|adidas-puma-diadora|clearance|casual|sapg::adi10395 ~ color::blue|adult",
                            "categoryIds": [
                                "822"
                            ],
                            "priceTag": "$23.35",
                            "priceTagCN": "¥171",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "XS",
                                    "displayName": "XS"
                                },
                                {
                                    "ids": [],
                                    "name": "M",
                                    "displayName": "M"
                                },
                                {
                                    "ids": [],
                                    "name": "L",
                                    "displayName": "L"
                                },
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4.1折",
                        "activityOffs": [],
                        "merchantName": "SHOEBACCA",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4.1折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 238,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "06e5b2db-f832-39be-a2c4-816c8ee83d21",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/30160038_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/06e5b2db-f832-39be-a2c4-816c8ee83d21.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/06e5b2db-f832-39be-a2c4-816c8ee83d21.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Navy/camel",
                                    "image": {
                                        "id": "c7c432c6-5546-3b9f-beca-c7ac6f2d9d1e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c7c432c6-5546-3b9f-beca-c7ac6f2d9d1e.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_19924772",
                            "name": "Border Wrap",
                            "nameCN": "女款 拉夫劳伦披肩",
                            "description": [
                                "Elevate your style with the Lauren Border Wrap. Designed for versatility, this chic piece offers two looks in one, perfect for all adventures. Stay cozy and stylish wherever your journey takes you with this must-have chic companion.",
                                "Approx. Dimension: 42\"W x 60\"L",
                                "Reversible",
                                "Border stripes",
                                "LRL logo bar hardware",
                                "This item purchased online must be returned to the vendor by mail only. This item cannot be returned to Macy's stores.",
                                "95% acrylic, 5% wool",
                                "Dry clean",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Lauren Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "wrap|women's fashion|scarves & wraps",
                            "categoryIds": [
                                "86a"
                            ],
                            "priceTag": "$70",
                            "priceTagCN": "¥513",
                            "labels": [
                                "final_sale",
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "ONE SIZE",
                                    "displayName": "ONE SIZE"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "6.3折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "6.3折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 307,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "97f831e5-061a-3745-b834-406e7f52e3f7",
                                    "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/20PTGWWCPCLDLYSHRAPT_Foxglove_Purple?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/97f831e5-061a-3745-b834-406e7f52e3f7.jpg",
                                        "width": 593,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/97f831e5-061a-3745-b834-406e7f52e3f7.jpg",
                                        "width": 203,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Smldr Blu/LghtSmldBlu XDy",
                                    "image": {
                                        "id": "9ce1e036-ff06-3954-95bd-146911a8dcbb",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9ce1e036-ff06-3954-95bd-146911a8dcbb.jpg",
                                            "width": 42,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Pumice/Dyno White X-Dye",
                                    "image": {
                                        "id": "f90a3080-2bbd-32c3-923f-461d3fa20300",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f90a3080-2bbd-32c3-923f-461d3fa20300.jpg",
                                            "width": 27,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Foxglove Purple",
                                    "image": {
                                        "id": "189795d1-78ab-3273-8901-ed21a4f82464",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/189795d1-78ab-3273-8901-ed21a4f82464.jpg",
                                            "width": 39,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "dickssportinggoods_20ptgwwcpcldlyshrapt",
                            "name": "Patagonia Women's Cap Cool Daily T-Shirt",
                            "description": [
                                "Highlights",
                                "Regular fit",
                                "Set-in sleeves for enhanced movement and fit",
                                "Fit and Design:",
                                "Regular fit",
                                "Set-in sleeves for enhanced movement and fit",
                                "Stretch fabric provides enhanced comfort during activities both in and out of water",
                                "Minimal stitching and seams to help reduce chafing",
                                "Made for use on trails or on the water",
                                "Chafe-free comfort and total shoulder mobility",
                                "Technology:",
                                "MiDori™ bioSoft for added wicking and softness",
                                "HeiQ® Fresh durable odor control",
                                "Experience unparalleled comfort and performance with the Patagonia Women's Cap Cool Daily T-Shirt. Designed for versatility, this shirt features a regular fit with set-in sleeves to enhance movement, making it perfect for both trail and water activities. With its innovative fabric blend that wicks moisture and controls odor, you'll stay fresh and comfortable all day long, whether you're hiking, backpacking, or just enjoying casual wear.",
                                "Fit and Design:",
                                "Regular fit",
                                "Set-in sleeves for enhanced movement and fit",
                                "Stretch fabric provides enhanced comfort during activities both in and out of water",
                                "Minimal stitching and seams to help reduce chafing",
                                "Made for use on trails or on the water",
                                "Chafe-free comfort and total shoulder mobility",
                                "Technology:",
                                "MiDori™ bioSoft for added wicking and softness",
                                "HeiQ® Fresh durable odor control",
                                "Brand :",
                                "Patagonia",
                                "Country of Origin : Imported",
                                "Style : 45225",
                                "Fabric : Solids 100% recycled polyester jersey; Heathers: 100% polyester (50% recycled) jersey",
                                "Web ID:",
                                "20PTGWWCPCLDLYSHRAPT"
                            ],
                            "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                            "brand": "Patagonia",
                            "displayBrand": "Patagonia",
                            "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                            "category": "women's|shirts & tops|Women's|shirts|womensshirtstops-129842",
                            "categoryIds": [
                                "78d",
                                "823"
                            ],
                            "priceTag": "$24.05",
                            "priceTagCN": "¥177",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "XS",
                                    "displayName": "XS"
                                },
                                {
                                    "ids": [],
                                    "name": "S",
                                    "displayName": "S"
                                },
                                {
                                    "ids": [],
                                    "name": "M",
                                    "displayName": "M"
                                },
                                {
                                    "ids": [],
                                    "name": "L",
                                    "displayName": "L"
                                },
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4.8折",
                        "activityOffs": [],
                        "merchantName": "Dick's Sporting Goods",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4.8折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 255,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "f20356b4-3b22-38fc-bd56-83d570096218",
                                    "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/16PTGWSYNCHLLSNP1APO_Brisk_Purple?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f20356b4-3b22-38fc-bd56-83d570096218.jpg",
                                        "width": 683,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f20356b4-3b22-38fc-bd56-83d570096218.jpg",
                                        "width": 233,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Mother Tree/Barnade Blue",
                                    "image": {
                                        "id": "1d0e4218-1fb8-3e5b-8ce6-e9439591c6c6",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1d0e4218-1fb8-3e5b-8ce6-e9439591c6c6.jpg",
                                            "width": 38,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Flow/Dyno White",
                                    "image": {
                                        "id": "cca47249-a647-38a6-8512-58be27004e94",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/cca47249-a647-38a6-8512-58be27004e94.jpg",
                                            "width": 38,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Nickle/Permafrost Purple",
                                    "image": {
                                        "id": "23033c0b-8b69-3f45-83c9-7279091e7fce",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/23033c0b-8b69-3f45-83c9-7279091e7fce.jpg",
                                            "width": 37,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Soft Spirea/Dried Vanila",
                                    "image": {
                                        "id": "70d20508-6a4e-3232-9f20-3eba07ed0657",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/70d20508-6a4e-3232-9f20-3eba07ed0657.jpg",
                                            "width": 38,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Small Currents Natural",
                                    "image": {
                                        "id": "1cf0e30f-0f66-37ef-a92b-5d007792f3a7",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1cf0e30f-0f66-37ef-a92b-5d007792f3a7.jpg",
                                            "width": 39,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Brisk Purple",
                                    "image": {
                                        "id": "90720242-71e6-39e3-86ce-9eb8e5937183",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/90720242-71e6-39e3-86ce-9eb8e5937183.jpg",
                                            "width": 38,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "dickssportinggoods_16ptgwsynchllsnp1apo",
                            "name": "Patagonia Women's Synchilla Snap-T Fleece Pullover",
                            "nameCN": "女款Snap-T抓绒套头衫",
                            "description": [
                                "Highlights",
                                "Synchilla® 95-100% recycled polyester double-sided fleece that’s velvety smooth, wicks moisture and dries quickly",
                                "Regular fit Patagonia Fleece",
                                "Classic pullover Snap-T styling includes a four-snap button neck",
                                "Left Chest Pocket",
                                "Fit and Design:",
                                "Regular fit",
                                "Hip length",
                                "Providing everyday warmth and comfort",
                                "Nylon trim on stand-up collar reinforces classic Snap-T four-snap placket",
                                "Yoke-seam detail with nylon chest-pocket flap and snap closure",
                                "Spandex binding at sleeve openings and hem",
                                "Technology:",
                                "Quick Drying for long-lasting comfort",
                                "Additional Details:",
                                "Washes easily",
                                "Gender:Women's",
                                "Best Use:Casual",
                                "Sustainability:Contains recycled materials, Fair Trade Certified™ sewn",
                                "Fabric:100% polyester (85% recycled)",
                                "Quick Drying:Yes",
                                "Hood:No",
                                "Back Length:Hip length",
                                "Weight:12.8 oz",
                                "Pockets:1 snap chest pocket",
                                "Fit and Design:",
                                "Regular fit",
                                "Hip length",
                                "Providing everyday warmth and comfort",
                                "Nylon trim on stand-up collar reinforces classic Snap-T four-snap placket",
                                "Yoke-seam detail with nylon chest-pocket flap and snap closure",
                                "Spandex binding at sleeve openings and hem",
                                "Technology:",
                                "Quick Drying for long-lasting comfort",
                                "Additional Details:",
                                "Washes easily",
                                "Brand :",
                                "Patagonia",
                                "Country of Origin : Imported",
                                "Fabric Content : 100% polyester (85% recycled) double-faced fleece",
                                "Style : 25455",
                                "Fabric : Body: 100% recycled polyester fleece, Placket, pocket and binding:  100% nylon plain weave",
                                "Web ID:",
                                "16PTGWSYNCHLLSNP1APO"
                            ],
                            "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                            "brand": "Patagonia",
                            "displayBrand": "Patagonia",
                            "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                            "category": "womensjacketsvests-129844|jackets & vests|Women's|jackets|women's",
                            "categoryIds": [
                                "822",
                                "818"
                            ],
                            "priceTag": "$57.25",
                            "priceTagCN": "¥420",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "XS",
                                    "displayName": "XS"
                                },
                                {
                                    "ids": [],
                                    "name": "S",
                                    "displayName": "S"
                                },
                                {
                                    "ids": [],
                                    "name": "M",
                                    "displayName": "M"
                                },
                                {
                                    "ids": [],
                                    "name": "L",
                                    "displayName": "L"
                                },
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "3.7折",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Dick's Sporting Goods",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "3.7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 1718,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                }
            ]
        },
        {
            "id": "mens_clothes",
            "title": "男装",
            "categoryIds": [
                "9"
            ],
            "brands": [
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/2d77c1ce-00c1-3706-8115-c7804e512c7c.jpg",
                    "id": "fb35adb5-fa93-3307-ab74-a644b26facee",
                    "name": "拉夫·劳伦",
                    "categoryIds": [
                        "21",
                        "23",
                        "91",
                        "92",
                        "93",
                        "94",
                        "e1",
                        "e2"
                    ],
                    "pathname": "la1-fu1-lao2-lun2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/30027527-a637-32a9-9a8d-81609813e7e8.jpg",
                    "id": "00e3d77f-2be8-3ccc-b1a0-27f3ee32e81c",
                    "name": "汤米·希尔费格",
                    "categoryIds": [
                        "21",
                        "23",
                        "91",
                        "92",
                        "93",
                        "94",
                        "e1",
                        "e2"
                    ],
                    "pathname": "tang1-mi3-xi1-er3-fei4-ge2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/144b7e81-8fc3-3cbf-a131-3d1c88a076a5.jpg",
                    "id": "719669a8-8608-32c9-845d-cfd2b84b254c",
                    "name": "土拨鼠",
                    "categoryIds": [
                        "21",
                        "23",
                        "91",
                        "92",
                        "93",
                        "94",
                        "e1",
                        "e2"
                    ],
                    "pathname": "tu3-bo1-shu3"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/1e1f7f66-6711-3500-92dd-e7eb75404dcc.jpg",
                    "id": "79aed056-90c8-3a69-bb28-92ef539c9357",
                    "name": "巴塔哥尼亚",
                    "categoryIds": [
                        "21",
                        "23",
                        "91",
                        "92",
                        "93",
                        "94",
                        "e1",
                        "e2"
                    ],
                    "pathname": "ba1-ta3-ge1-ni2-ya4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/098484c1-d7c6-37b7-b10e-61dbb8ae297d.jpg",
                    "id": "2611bbae-73ed-3202-9ad9-4dd07c02afaf",
                    "name": "卡哈特",
                    "categoryIds": [
                        "21",
                        "23",
                        "91",
                        "92",
                        "93",
                        "94",
                        "e1",
                        "e2"
                    ],
                    "pathname": "ka3-ha1-te4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/810d3c74-8594-3ccd-9abe-d939a4cb0702.jpg",
                    "id": "28a34010-e84b-381f-b087-359c7e280a08",
                    "name": "阿迪达斯",
                    "categoryIds": [
                        "21",
                        "23",
                        "91",
                        "92",
                        "93",
                        "94",
                        "e1",
                        "e2"
                    ],
                    "pathname": "a1-di2-da2-si1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/f3de222f-8c0e-3f94-b46a-0c6edcaed354.jpg",
                    "id": "9ed285dc-8718-3b9e-9881-910b3bfb8a15",
                    "name": "北面",
                    "categoryIds": [
                        "21",
                        "23",
                        "91",
                        "92",
                        "93",
                        "94",
                        "e1",
                        "e2"
                    ],
                    "pathname": "bei3-mian4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/68706e06-4780-300b-9ade-ac0fb0e66f7c.jpg",
                    "id": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                    "name": "博柏利",
                    "categoryIds": [
                        "21",
                        "23",
                        "91",
                        "92",
                        "93",
                        "94",
                        "e1",
                        "e2"
                    ],
                    "pathname": "bo2-bai3-li4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/c9394250-88fa-310d-a593-cb5cb25cce55.jpg",
                    "id": "04005cf7-5278-3d59-a187-ef0b416c10a2",
                    "name": "卡尔文·克莱恩",
                    "categoryIds": [
                        "21",
                        "23",
                        "91",
                        "92",
                        "93",
                        "94",
                        "e1",
                        "e2"
                    ],
                    "pathname": "ka3-er3-wen2-ke4-lai2-en1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/361779bb-7ba2-33fe-936a-8a1b0f0ddc76.jpg",
                    "id": "efc3bf19-8f47-39c3-aeb4-0c94aa26e19d",
                    "name": "Helly Hansen",
                    "categoryIds": [
                        "21",
                        "23",
                        "91",
                        "92",
                        "93",
                        "94",
                        "e1",
                        "e2"
                    ],
                    "pathname": "helly-hansen"
                }
            ],
            "productList": [
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "144b7e81-8fc3-3cbf-a131-3d1c88a076a5",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/30705562_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/144b7e81-8fc3-3cbf-a131-3d1c88a076a5.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/144b7e81-8fc3-3cbf-a131-3d1c88a076a5.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Black",
                                    "image": {
                                        "id": "d09ee1b7-c33e-35a6-b3b3-cd8e74e1778f",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d09ee1b7-c33e-35a6-b3b3-cd8e74e1778f.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_19391529",
                            "name": "Men's PreCip Eco Pro Jacket",
                            "nameCN": "男款 PreCip Eco Pro 户外夹克",
                            "description": [
                                "Bomber 3L construction keeps buckets of rain at bay no matter how long you hike, canoe or play in the rain. This new addition to a PreCip line honed over two decades is the pinnacle in breathability to help you keep your cool while outstanding durability keeps you fresh for the ages.",
                                "100% Seam-taped for complete leak proof protection",
                                "Fixed hood with peripheral cord adjustment for extra coverage",
                                "Pit zips provide ventilation to regulate body temperature",
                                "Large pack pockets under a welt for protection",
                                "Center front zipper with storm flap to keep out the cold",
                                "Adjustable drawcord hem keeps cold air out",
                                "Marmot NanoPro lamination utilizes advance technology that balances the best in performance of breathability, waterproofness, and water repellency with excellent durability",
                                "Limited Lifetime Warranty",
                                "100% polyester",
                                "Machine washable",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Marmot",
                            "displayBrand": "Marmot",
                            "brandId": "719669a8-8608-32c9-845d-cfd2b84b254c",
                            "category": "men's fashion|jacket|coats & jackets|Men",
                            "categoryIds": [
                                "911"
                            ],
                            "priceTag": "$67.85",
                            "priceTagCN": "¥497",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "L",
                                    "displayName": "L"
                                },
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                },
                                {
                                    "ids": [],
                                    "name": "XXL",
                                    "displayName": "XXL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4.1折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4.1折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 2259,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "1e1f7f66-6711-3500-92dd-e7eb75404dcc",
                                    "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/19PTGMMCPCLDLYSSTAPT_Pumice_Dyno_White_X_Dye?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1e1f7f66-6711-3500-92dd-e7eb75404dcc.jpg",
                                        "width": 623,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1e1f7f66-6711-3500-92dd-e7eb75404dcc.jpg",
                                        "width": 213,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Rnsd Grn/Drk Rnsd Grn Xdy",
                                    "image": {
                                        "id": "bee25a04-0985-3e19-8346-a7cec52b2154",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bee25a04-0985-3e19-8346-a7cec52b2154.jpg",
                                            "width": 38,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Feather Grey",
                                    "image": {
                                        "id": "2e46a5e0-0781-35da-83a2-2282df11a716",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2e46a5e0-0781-35da-83a2-2282df11a716.jpg",
                                            "width": 50,
                                            "height": 31,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Pumice/Dyno White X-Dye",
                                    "image": {
                                        "id": "90fdf172-5bd2-3c73-8b97-cc1a16326e0a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/90fdf172-5bd2-3c73-8b97-cc1a16326e0a.jpg",
                                            "width": 30,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Wtld Blu/Lgt Wtld Blu Xdy",
                                    "image": {
                                        "id": "50d68785-828c-3711-8747-29fc4dbfc645",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/50d68785-828c-3711-8747-29fc4dbfc645.jpg",
                                            "width": 40,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "dickssportinggoods_19ptgmmcpcldlysstapt",
                            "name": "Patagonia Men's Capilene Cool Daily Shirt",
                            "nameCN": "男士Capilene速干T恤",
                            "description": [
                                "Highlights",
                                "Capilene® Cool is a quick-drying, moisture-wicking, recycled polyester stretch fabric that provides enhanced comfort during activities both in and out of water",
                                "HeiQ® Mint odor control for long-lasting freshness",
                                "Regular fit, with set in sleeves",
                                "Fit and Design:",
                                "Regular fit",
                                "Set-in sleeves for enhanced movement and fit",
                                "Stretch fabric provides enhanced comfort during activities both in and out of water",
                                "Minimal stitching and seams to help reduce chafing",
                                "Made for use on trails or on the water",
                                "Chafe-free comfort and total shoulder mobility",
                                "Technology:",
                                "MiDori™ bioSoft for added wicking and softness",
                                "HeiQ® Fresh durable odor control",
                                "Gender:Men's",
                                "Best Use:Casual",
                                "Sustainability:Contains recycled materials, Fair Trade Certified™ sewn, bluesign® approved",
                                "Fabric:Solids: 100% recycled polyester jersey | Heathers and cross-dyes: 100% polyester (50% recycled) jersey",
                                "Shirt Type:T-shirt",
                                "Fit Type:Regular",
                                "Neckline:Crew",
                                "Sleeve Length:Short sleeve",
                                "Moisture Wicking:Yes",
                                "Back Length:Hip length",
                                "Stay cool and comfortable in the Patagonia Men's Capilene Cool Daily Shirt. Perfect for both casual outings and hiking adventures, this shirt features quick-drying, moisture-wicking fabric that keeps you fresh throughout the day. Made from recycled materials and Fair Trade Certified, it's a sustainable choice for eco-conscious individuals.",
                                "Fit and Design:",
                                "Regular fit",
                                "Set-in sleeves for enhanced movement and fit",
                                "Stretch fabric provides enhanced comfort during activities both in and out of water",
                                "Minimal stitching and seams to help reduce chafing",
                                "Made for use on trails or on the water",
                                "Chafe-free comfort and total shoulder mobility",
                                "Technology:",
                                "MiDori™ bioSoft for added wicking and softness",
                                "HeiQ® Fresh durable odor control",
                                "Brand :",
                                "Patagonia",
                                "Country of Origin : Imported",
                                "Style : 45215Z",
                                "Fabric : Solids: 100% recycled polyester jersey, Heathers and cross-dyes: 100% polyester (50% recycled) jersey",
                                "Web ID:",
                                "19PTGMMCPCLDLYSSTAPT"
                            ],
                            "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                            "brand": "Patagonia",
                            "displayBrand": "Patagonia",
                            "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                            "category": "mensshirtstops-129825|shirts & tops|men's|shirts|Men's",
                            "categoryIds": [
                                "78d",
                                "922",
                                "920"
                            ],
                            "priceTag": "$20.20",
                            "priceTagCN": "¥148",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "S",
                                    "displayName": "S"
                                },
                                {
                                    "ids": [],
                                    "name": "M",
                                    "displayName": "M"
                                },
                                {
                                    "ids": [],
                                    "name": "L",
                                    "displayName": "L"
                                },
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                },
                                {
                                    "ids": [],
                                    "name": "XXL",
                                    "displayName": "XXL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4折起",
                        "activityOffs": [],
                        "merchantName": "Dick's Sporting Goods",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4折起",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 3041,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "2d77c1ce-00c1-3706-8115-c7804e512c7c",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/29805560_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2d77c1ce-00c1-3706-8115-c7804e512c7c.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2d77c1ce-00c1-3706-8115-c7804e512c7c.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Camel Melange",
                                    "image": {
                                        "id": "39b61d33-d97f-3846-9d0a-fb66151e322e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/39b61d33-d97f-3846-9d0a-fb66151e322e.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Polo Black",
                                    "image": {
                                        "id": "0c2a67fa-3aa7-33ea-91cf-52aed420cb5f",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0c2a67fa-3aa7-33ea-91cf-52aed420cb5f.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Hunter Navy",
                                    "image": {
                                        "id": "45ccd2b2-d055-394f-b62f-75875162185b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/45ccd2b2-d055-394f-b62f-75875162185b.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Scotch Pine Heather",
                                    "image": {
                                        "id": "533e41d2-61ff-3974-b86f-8b841f25e3c6",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/533e41d2-61ff-3974-b86f-8b841f25e3c6.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_10930482",
                            "name": "Men's Cable-Knit Cotton Sweater",
                            "nameCN": "男式 拉夫劳伦 绞花针织棉毛衣",
                            "description": [
                                "This quarter-zip sweater combines two of Polo Ralph Lauren's most iconic design details: a textural cable-knit motif and our signature Pony.",
                                "Size medium is approx. 26-½\" long",
                                "Regular Fit: wider at the chest while still maintaining a modern silhouette",
                                "Rib-knit mockneck",
                                "Quarter-zip placket with a suede zipper pull",
                                "Long sleeves with rib-knit cuffs",
                                "Rib-knit hem",
                                "Signature embroidered Pony at the left chest",
                                "All cotton",
                                "Machine washable",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Polo Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "sweater|men's fashion|sweaters|Men",
                            "categoryIds": [
                                "923"
                            ],
                            "priceTag": "$105.65",
                            "priceTagCN": "¥774",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "XS",
                                    "displayName": "XS"
                                },
                                {
                                    "ids": [],
                                    "name": "S",
                                    "displayName": "S"
                                },
                                {
                                    "ids": [],
                                    "name": "M",
                                    "displayName": "M"
                                },
                                {
                                    "ids": [],
                                    "name": "L",
                                    "displayName": "L"
                                },
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                },
                                {
                                    "ids": [],
                                    "name": "2XL",
                                    "displayName": "2XL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "6.9折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "6.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 2319,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "44f4560f-71ca-3f13-bbdd-cf9c3bfb5968",
                                    "originalURL": "https://belk.scene7.com/is/image/Belk?layer=0&src=3201602_11787557_A_400&$COM_PRODUCT_PDP_MO_Z_MAX$",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/44f4560f-71ca-3f13-bbdd-cf9c3bfb5968.jpg",
                                        "width": 721,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/44f4560f-71ca-3f13-bbdd-cf9c3bfb5968.jpg",
                                        "width": 246,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Blue",
                                    "image": {
                                        "id": "e1310f33-db0e-36e2-8e56-8c1781977a4b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e1310f33-db0e-36e2-8e56-8c1781977a4b.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Navy",
                                    "image": {
                                        "id": "998f4ba4-285a-3e0a-b27f-f25b5d911dc4",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/998f4ba4-285a-3e0a-b27f-f25b5d911dc4.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "CREAM",
                                    "image": {
                                        "id": "782bdf52-0a19-3a50-a855-c55675bad38a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/782bdf52-0a19-3a50-a855-c55675bad38a.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "belk_320160211787557",
                            "name": "Classic Fit Big Pony Jersey T-Shirt",
                            "nameCN": "男士经典版型 Big Pony 针织 T 恤",
                            "description": [
                                "The Polo Ralph Lauren Classic Fit Big Pony Jersey T-shirt is made with peached cotton jersey and accented with a tonal version of the signature embroidered Big Pony.\n\nClassic Fit: Cut fuller through the chest, waist, and sleeve, with a lower armhole that falls closer to the elbow\nSize medium has a 28.5\" body length (front and back), a 20\" shoulder, and a 44\" chest\nCrew neck\nShort sleeves\nSignature embroidered Big Pony at the left chest\n\nBy choosing Ralph Lauren's cotton products, you’re supporting the investment in the Better Cotton™ mission to help cotton communities survive and thrive while protecting and restoring the environment.\nThis product is sourced via a mass balance system and, therefore, may not contain Better Cotton™.\nVisit bettercotton.org/massbalance for more information about mass balance"
                            ],
                            "merchantId": "bbcd3448-f8da-3eb0-a14e-1f7b807d1754",
                            "brand": "Polo Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "Men|Young Men's Clothing|Shirts|Polo Ralph Lauren Classic Fit Big Pony Jersey T-Shirt",
                            "categoryIds": [
                                "925",
                                "922"
                            ],
                            "priceTag": "$29.05",
                            "priceTagCN": "¥213",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                },
                                {
                                    "ids": [],
                                    "name": "2XL",
                                    "displayName": "2XL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "5折",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Belk",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "5折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 20,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 759,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {
                            "remainingSizes": "剩XL/2XL码",
                            "buoyId": "REMAINING_SIZES"
                        }
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "b998f4a0-fcf1-3953-aa81-aa4c40922b42",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/1797164_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b998f4a0-fcf1-3953-aa81-aa4c40922b42.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b998f4a0-fcf1-3953-aa81-aa4c40922b42.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Navy",
                                    "image": {
                                        "id": "eb858e29-54ef-3634-8290-f77fad0d3828",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/eb858e29-54ef-3634-8290-f77fad0d3828.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Relay Blue",
                                    "image": {
                                        "id": "914891e0-eba8-390f-ac78-d1dbf10e7981",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/914891e0-eba8-390f-ac78-d1dbf10e7981.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Red",
                                    "image": {
                                        "id": "bc07d033-3154-3a37-9191-6653c6b29824",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bc07d033-3154-3a37-9191-6653c6b29824.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Carson Blue",
                                    "image": {
                                        "id": "321bed84-cbe4-33ba-aacb-89d887155e87",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/321bed84-cbe4-33ba-aacb-89d887155e87.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Beige",
                                    "image": {
                                        "id": "044185f2-bb47-3d65-b1a1-56934a3aeb88",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/044185f2-bb47-3d65-b1a1-56934a3aeb88.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "White",
                                    "image": {
                                        "id": "18c9b558-6a39-355d-a83e-a236e5d374ed",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/18c9b558-6a39-355d-a83e-a236e5d374ed.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Black",
                                    "image": {
                                        "id": "e168a9d9-6701-3e7a-a20b-f589746d4567",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e168a9d9-6701-3e7a-a20b-f589746d4567.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Heritage Royal",
                                    "image": {
                                        "id": "3f68fb3e-5dab-3aaf-b0ea-5fff41e8b175",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3f68fb3e-5dab-3aaf-b0ea-5fff41e8b175.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_391810",
                            "name": "Core Classic Sport Cap",
                            "nameCN": "【成毅同款】拉夫劳伦男士经典棒球帽 多色可选",
                            "description": [
                                "A good sport: this classic chino baseball cap in durable washed cotton is distinguished with Polo's signature embroidered pony at front.",
                                "Adjustable back strap",
                                "Embroidered ventilating grommets, seamed bill",
                                "Polo's embroidered pony at front",
                                "A timeless gift for your next occasion.",
                                "All cotton",
                                "Hand Wash",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Polo Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "hats & caps|Men|men's fashion|hat",
                            "categoryIds": [
                                "957"
                            ],
                            "priceTag": "$35",
                            "priceTagCN": "¥257",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "ONE SIZE",
                                    "displayName": "ONE SIZE"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "7折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 4461,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "a083b5f3-3b3c-3a3a-b8d3-13ca192a7f38",
                                    "originalURL": "https://brooksbrothers.bynder.com/match/WebName/MG04048_GREY/?preset=lg&dpr=on%2C2",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a083b5f3-3b3c-3a3a-b8d3-13ca192a7f38.jpg",
                                        "width": 825,
                                        "height": 1000,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a083b5f3-3b3c-3a3a-b8d3-13ca192a7f38.jpg",
                                        "width": 289,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Grey",
                                    "image": {
                                        "id": "90c6769d-d7c9-3008-83b5-46bb5047843c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/90c6769d-d7c9-3008-83b5-46bb5047843c.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Light Blue",
                                    "image": {
                                        "id": "0d5b243f-5c69-3427-81bc-fd3a8bfb014d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0d5b243f-5c69-3427-81bc-fd3a8bfb014d.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Navy",
                                    "image": {
                                        "id": "ae5b6abf-b132-343c-bce9-6d566f4d0ff5",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ae5b6abf-b132-343c-bce9-6d566f4d0ff5.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Pink",
                                    "image": {
                                        "id": "1e74cc51-404d-3627-a4f6-fc8fd81a26d5",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1e74cc51-404d-3627-a4f6-fc8fd81a26d5.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "White",
                                    "image": {
                                        "id": "12b6780d-e748-38bf-838a-6f74285d17f9",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/12b6780d-e748-38bf-838a-6f74285d17f9.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "brooksbrothers_MG04048",
                            "name": "Friday Shirt, Poplin End-on-End",
                            "nameCN": "男士 Friday 衬衫",
                            "description": [
                                "Our new Friday Shirt is cut in a cotton poplin washed for softness and a vintage look to give you that Friday feeling every day of the week. With a slightly relaxed fit and signature Brooks Brothers details like the Original Polo® Button-Down collar we invented and 6-Pleat Shirring® at the cuff, this versatile shirt looks great tucked or untucked, pressed or a little rumpled.",
                                "Polo Button Down Collar",
                                "Barrel Cuff",
                                "100% Cotton",
                                "Machine was according to care instructions for best results.",
                                "Imported",
                                "Our new Friday Shirt is cut in a cotton poplin washed for softness and a vintage look to give you that Friday feeling every day of the week. With a slightly relaxed fit and signature Brooks Brothers details like the Original Polo® Button-Down collar we invented and 6-Pleat Shirring® at the cuff, this versatile shirt looks great tucked or untucked, pressed or a little rumpled.",
                                "Polo Button Down Collar",
                                "Barrel Cuff100% CottonMachine was according to care instructions for best results.Imported"
                            ],
                            "merchantId": "4c043e06-a027-edf4-d040-48f1276c75be",
                            "brand": "Brooks Brothers",
                            "displayBrand": "Brooks Brothers",
                            "brandId": "c3498467-3c03-39ad-b06d-7de62e3abd56",
                            "category": "friday|poplin|shirt|men|end-on-end",
                            "categoryIds": [
                                "920"
                            ],
                            "priceTag": "$32",
                            "priceTagCN": "¥235",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "XS",
                                    "displayName": "XS"
                                },
                                {
                                    "ids": [],
                                    "name": "S",
                                    "displayName": "S"
                                },
                                {
                                    "ids": [],
                                    "name": "M",
                                    "displayName": "M"
                                },
                                {
                                    "ids": [],
                                    "name": "L",
                                    "displayName": "L"
                                },
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "2.7折",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Brooks Brothers",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "2.7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 449,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "300868cc-f7bf-3ad6-92f5-132c77380c9f",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/32908428_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/300868cc-f7bf-3ad6-92f5-132c77380c9f.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/300868cc-f7bf-3ad6-92f5-132c77380c9f.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Red Wine",
                                    "image": {
                                        "id": "3421fc71-a052-3098-9f3b-6542ec56602f",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3421fc71-a052-3098-9f3b-6542ec56602f.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Fatigue",
                                    "image": {
                                        "id": "eb4de223-f776-3205-99f1-fd83e3fa0d15",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/eb4de223-f776-3205-99f1-fd83e3fa0d15.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Pale Cream",
                                    "image": {
                                        "id": "bb8dd247-0e5d-33aa-ac13-7c43036d772e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bb8dd247-0e5d-33aa-ac13-7c43036d772e.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Sunrise Red",
                                    "image": {
                                        "id": "6455b690-0f28-3209-b85c-5ffc351e1add",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6455b690-0f28-3209-b85c-5ffc351e1add.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Gray Cloud Heather",
                                    "image": {
                                        "id": "da7c2fcd-0b5a-3c27-9612-d3fe96934085",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/da7c2fcd-0b5a-3c27-9612-d3fe96934085.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Southport Blue",
                                    "image": {
                                        "id": "52773a41-4a18-3f7a-84ee-25ede67c95ac",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/52773a41-4a18-3f7a-84ee-25ede67c95ac.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Nutmeg Brown",
                                    "image": {
                                        "id": "661f33ac-87d9-3abb-b723-eabdc1e8b226",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/661f33ac-87d9-3abb-b723-eabdc1e8b226.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Collegiate Yellow",
                                    "image": {
                                        "id": "e6004269-a5a6-3f55-8e28-984b70570e91",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e6004269-a5a6-3f55-8e28-984b70570e91.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Spring Violet",
                                    "image": {
                                        "id": "5a285e72-e5d0-3581-abdb-476203745ead",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/5a285e72-e5d0-3581-abdb-476203745ead.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Scotch Pine Heather",
                                    "image": {
                                        "id": "eafe4a06-1ce8-39f4-8b97-cc48f44f2376",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/eafe4a06-1ce8-39f4-8b97-cc48f44f2376.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_13778575",
                            "name": "Men's Classic-Fit Jersey Pocket T-Shirt",
                            "nameCN": "男士棉质平纹针织 T 恤 多款配色",
                            "description": [
                                "Washed for a perfectly broken-in look and feel, Polo Ralph Lauren's cotton jersey T-shirt is an off-duty essential you'll wear again and again.",
                                "Approx. model height is 6'1\" and he is currently wearing a size medium",
                                "Size medium is approx. 28-½\" long",
                                "Classic-Fit: Polo Ralph Lauren's roomiest silhouette",
                                "Cut for a lower armhole and a fuller sleeve that falls closer to the elbow",
                                "Crewneck",
                                "Short sleeves",
                                "Left chest patch pocket",
                                "Signature embroidered Pony at the pocket",
                                "All cotton",
                                "Machine washable",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Polo Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "t-shirt|men's fashion|t-shirts|Men",
                            "categoryIds": [
                                "922"
                            ],
                            "priceTag": "$40.40",
                            "priceTagCN": "¥296",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "XS",
                                    "displayName": "XS"
                                },
                                {
                                    "ids": [],
                                    "name": "S",
                                    "displayName": "S"
                                },
                                {
                                    "ids": [],
                                    "name": "M",
                                    "displayName": "M"
                                },
                                {
                                    "ids": [],
                                    "name": "L",
                                    "displayName": "L"
                                },
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                },
                                {
                                    "ids": [],
                                    "name": "2XL",
                                    "displayName": "2XL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "7.2折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "7.2折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 679,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "e756f8c7-723f-338c-9d72-d09cf900f5f0",
                                    "originalURL": "https://belk.scene7.com/is/image/Belk?layer=0&src=3201602_710934621005_A_020&$COM_PRODUCT_PDP_MO_Z_MAX$",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e756f8c7-723f-338c-9d72-d09cf900f5f0.jpg",
                                        "width": 721,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e756f8c7-723f-338c-9d72-d09cf900f5f0.jpg",
                                        "width": 246,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "GREY HTR",
                                    "image": {
                                        "id": "536efda3-9414-39a5-8f59-b5c71990da40",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/536efda3-9414-39a5-8f59-b5c71990da40.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "belk_320160211787633",
                            "name": "Double-Knit Vest",
                            "nameCN": "男士马甲背心",
                            "description": [
                                "This vest is crafted with a smooth cotton-blend fabric and finished with a signature embroidered Pony at the chest.\n\nSize medium has a 27\" body length (front and back), a 17\" shoulder, and a 44.5\" chest.\t\nMock neck. \nFull-zip front.\t\nStretch binding at the armholes.\t\nLeft chest zipped pocket. \nTwo front waist zipped pockets.\t\nDrawstring hem. \nFully lined with mesh.\t\nSignature embroidered Pony at the left chest.\t\nModel is 6'1\" (185 cm) and wears a size medium.\t\nSize medium has a 27\" body length (front and back), a 17\" shoulder, and a 44.5\" chest.\nMock neck. \nFull-zip front.\nStretch binding at the armholes.\nLeft chest zipped pocket. \nTwo front waist zipped pockets.\nDrawstring hem. \nFully lined with mesh.\nSignature embroidered Pony at the left chest.\nModel is 6'1\" (185 cm) and wears a size medium."
                            ],
                            "merchantId": "bbcd3448-f8da-3eb0-a14e-1f7b807d1754",
                            "brand": "Polo Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "Men|Men's Clothing|Jackets & Coats|Vests|Polo Ralph Lauren Double-Knit Vest",
                            "categoryIds": [
                                "917"
                            ],
                            "priceTag": "$74.75",
                            "priceTagCN": "¥548",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "S",
                                    "displayName": "S"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "5折",
                        "activityOffs": [],
                        "merchantName": "Belk",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "5折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 320,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {
                            "remainingSizes": "剩S码",
                            "buoyId": "REMAINING_SIZES"
                        }
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "300895ff-7d3f-3871-88ab-d48ce4ea8502",
                                    "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/22PTGMMBGGSSHRTS5APBX_Bees_And_Flowers_Stil_Blu?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/300895ff-7d3f-3871-88ab-d48ce4ea8502.jpg",
                                        "width": 800,
                                        "height": 758,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/300895ff-7d3f-3871-88ab-d48ce4ea8502.jpg",
                                        "width": 350,
                                        "height": 332,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Plume Grey W/Plume Grey",
                                    "image": {
                                        "id": "57c6fad4-0584-3de6-81fa-aab691c85b11",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/57c6fad4-0584-3de6-81fa-aab691c85b11.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Heirloom Peach",
                                    "image": {
                                        "id": "6931583f-2738-36e4-94e0-b97ac891adb8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6931583f-2738-36e4-94e0-b97ac891adb8.jpg",
                                            "width": 50,
                                            "height": 27,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Flourish/Abundant Blue",
                                    "image": {
                                        "id": "409878fa-2807-3da5-9868-9e61bfbcc6e8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/409878fa-2807-3da5-9868-9e61bfbcc6e8.jpg",
                                            "width": 49,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Bees And Flowers/Stil Blu",
                                    "image": {
                                        "id": "f77674ab-4bb2-3aa3-8234-7df0e94a94d5",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f77674ab-4bb2-3aa3-8234-7df0e94a94d5.jpg",
                                            "width": 50,
                                            "height": 47,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Tidepl Blu W/Tidepl Blu",
                                    "image": {
                                        "id": "43748212-d5e7-3e09-bf00-0a8d25420943",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/43748212-d5e7-3e09-bf00-0a8d25420943.jpg",
                                            "width": 49,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Swallowtail Geo/Still Blu",
                                    "image": {
                                        "id": "ee838b42-88ac-3968-8cb9-c63f929914f4",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ee838b42-88ac-3968-8cb9-c63f929914f4.jpg",
                                            "width": 50,
                                            "height": 45,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Rinsed Green",
                                    "image": {
                                        "id": "571594bb-b747-3735-8c46-387d39bf444e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/571594bb-b747-3735-8c46-387d39bf444e.jpg",
                                            "width": 50,
                                            "height": 49,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Black w/Black",
                                    "image": {
                                        "id": "a791c44f-9db2-3b4e-a0c9-2163f9fb6f26",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a791c44f-9db2-3b4e-a0c9-2163f9fb6f26.jpg",
                                            "width": 50,
                                            "height": 46,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "dickssportinggoods_22ptgmmbggsshrts5apbx",
                            "name": "Patagonia Men's 5” Baggies Shorts",
                            "nameCN": "男士速干休闲短裤 超多款配色",
                            "description": [
                                "Highlights",
                                "5\" inseam",
                                "Adventure Ready, DWR (water Repellant finish)",
                                "Lined",
                                "Net Plus 100% recycled from fishing net",
                                "Fit & Design:",
                                "Rugged, multifunctional shorts designed for use in and out of the water",
                                "Elasticized waistband with internal drawstring; quick-drying black mesh liner",
                                "Vertical side pockets reduce drag in water; pocket bags have drain-and-dry mesh corners",
                                "Rear pocket has a flap that closes with a low-profile snap for security",
                                "Technology:",
                                "Made with quick-drying NetPlus® postconsumer recycled nylon made from recycled fishing nets",
                                "PFC-free DWR finish (durable water repellent coating that does not contain perfluorinated chemicals)",
                                "Additional Details:",
                                "Inseam: 5”",
                                "Weight: 204 g (7.2 oz)",
                                "Best Use:Water Sports",
                                "Fabric:4-Ply 4.9 oz Recycled Nylon",
                                "Inner Liner:Yes",
                                "Liner Fabric:Mesh",
                                "Sun-Protective Fabric:No",
                                "UPF Rating:N/A",
                                "Moisture Wicking:Yes",
                                "Quick Drying:Yes",
                                "Front Rise:Mid Rise",
                                "Inseam:5 in.",
                                "Gender:Men",
                                "Weight:7.2 oz.",
                                "Sustainability:bluesign® Approved; NetPlus Postconsumer Recycled Nylon",
                                "Stay ready for any adventure with the Patagonia Men's 5” Baggies Shorts. These rugged and versatile shorts are designed for both water and land, featuring an elasticized waistband with an internal drawstring for a secure fit. Made from 100% recycled nylon sourced from fishing nets, they're quick-drying and equipped with pockets that drain and dry, making them perfect for your next outdoor excursion.",
                                "Fit & Design:",
                                "Rugged, multifunctional shorts designed for use in and out of the water",
                                "Elasticized waistband with internal drawstring; quick-drying black mesh liner",
                                "Vertical side pockets reduce drag in water; pocket bags have drain-and-dry mesh corners",
                                "Rear pocket has a flap that closes with a low-profile snap for security",
                                "Technology:",
                                "Made with quick-drying NetPlus® postconsumer recycled nylon made from recycled fishing nets",
                                "PFC-free DWR finish (durable water repellent coating that does not contain perfluorinated chemicals)",
                                "Additional Details:",
                                "Inseam: 5”",
                                "Weight: 204 g (7.2 oz)",
                                "Brand :",
                                "Patagonia",
                                "Country of Origin : Imported",
                                "Style : 57022X",
                                "Fabric : 100% postconsumer recycled nylon made",
                                "Web ID:",
                                "22PTGMMBGGSSHRTS5APBX"
                            ],
                            "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                            "brand": "Patagonia",
                            "displayBrand": "Patagonia",
                            "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                            "category": "multifunction|men's|mensshorts-129829|shorts|Men's",
                            "categoryIds": [
                                "933",
                                "78h"
                            ],
                            "priceTag": "$36.25",
                            "priceTagCN": "¥266",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "S",
                                    "displayName": "S"
                                },
                                {
                                    "ids": [],
                                    "name": "M",
                                    "displayName": "M"
                                },
                                {
                                    "ids": [],
                                    "name": "L",
                                    "displayName": "L"
                                },
                                {
                                    "ids": [],
                                    "name": "XL",
                                    "displayName": "XL"
                                },
                                {
                                    "ids": [],
                                    "name": "XXL",
                                    "displayName": "XXL"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "4.8折",
                        "activityOffs": [
                            "新人补贴价"
                        ],
                        "merchantName": "Dick's Sporting Goods",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "新人补贴价",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "4.8折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "新人补贴减$1",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 977,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                }
            ]
        },
        {
            "id": "children",
            "title": "婴童",
            "categoryIds": [
                "g"
            ],
            "brands": [
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/0e260ee5-a88a-3b8f-b371-80c0e0a2f5ed.jpg",
                    "id": "fb35adb5-fa93-3307-ab74-a644b26facee",
                    "name": "拉夫·劳伦",
                    "categoryIds": [
                        "3",
                        "g"
                    ],
                    "pathname": "la1-fu1-lao2-lun2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/2c1077af-7489-3b15-b42e-265d97b9bd15.jpg",
                    "id": "04005cf7-5278-3d59-a187-ef0b416c10a2",
                    "name": "卡尔文·克莱恩",
                    "categoryIds": [
                        "3",
                        "g"
                    ],
                    "pathname": "ka3-er3-wen2-ke4-lai2-en1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/88f34978-7be6-35cf-b3b1-69fc42946930.jpg",
                    "id": "00e3d77f-2be8-3ccc-b1a0-27f3ee32e81c",
                    "name": "汤米·希尔费格",
                    "categoryIds": [
                        "3",
                        "g"
                    ],
                    "pathname": "tang1-mi3-xi1-er3-fei4-ge2"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/a27e61a8-3871-36ea-aa99-2fcd6941eae4.jpg",
                    "id": "c86eeeb2-b6ca-3ac8-8443-41a54886e7bd",
                    "name": "卡特",
                    "categoryIds": [
                        "3",
                        "g"
                    ],
                    "pathname": "ka3-te4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/4da217a1-34d4-39a2-9dff-8c52e242b915.jpg",
                    "id": "9ceb595d-a66b-353a-bdb5-fb22af83466a",
                    "name": "哥伦比亚",
                    "categoryIds": [
                        "3",
                        "g"
                    ],
                    "pathname": "ge1-lun2-bi3-ya4"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/9761a8b1-2ae8-33ed-9e08-b099ed0eca7c.jpg",
                    "id": "d9f32436-125b-37e0-bd11-fbf1fa62424a",
                    "name": "彪马",
                    "categoryIds": [
                        "3",
                        "g"
                    ],
                    "pathname": "biao1-ma3"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/e9c08bc2-64a9-3258-ab95-0075f3733a63.jpg",
                    "id": "28a34010-e84b-381f-b087-359c7e280a08",
                    "name": "阿迪达斯",
                    "categoryIds": [
                        "3",
                        "g"
                    ],
                    "pathname": "a1-di2-da2-si1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/e2c9e918-316d-31d2-bfc6-30cc42ae7046.jpg",
                    "id": "48806f34-c12d-30e9-8775-d8b09e70518d",
                    "name": "李维斯",
                    "categoryIds": [
                        "3",
                        "g"
                    ],
                    "pathname": "li3-wei2-si1"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/abef5f24-7f6f-39be-b884-3229967c80de.jpg",
                    "id": "0e6348a7-1068-359d-b2e6-f075ec6f31a1",
                    "name": "Huggies",
                    "categoryIds": [
                        "3",
                        "g"
                    ],
                    "pathname": "huggies"
                },
                {
                    "image": "https://5thave-img-cdn-g.bybieyang.com/pt/8f727440-a0da-3ee6-a3d8-9112f930bb50.jpg",
                    "id": "79aed056-90c8-3a69-bb28-92ef539c9357",
                    "name": "巴塔哥尼亚",
                    "categoryIds": [
                        "3",
                        "g"
                    ],
                    "pathname": "ba1-ta3-ge1-ni2-ya4"
                }
            ],
            "productList": [
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "0e260ee5-a88a-3b8f-b371-80c0e0a2f5ed",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/33171594_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0e260ee5-a88a-3b8f-b371-80c0e0a2f5ed.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0e260ee5-a88a-3b8f-b371-80c0e0a2f5ed.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Black",
                                    "image": {
                                        "id": "6c66d9c3-3aca-3063-a4a3-a91a9447a00f",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6c66d9c3-3aca-3063-a4a3-a91a9447a00f.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Hint of Pink",
                                    "image": {
                                        "id": "f3dd9bdc-8eef-3dff-8ed1-a026f5209d6a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f3dd9bdc-8eef-3dff-8ed1-a026f5209d6a.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Hunter Navy",
                                    "image": {
                                        "id": "f0f865b5-8ad8-3512-9225-defc3b0e352d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f0f865b5-8ad8-3512-9225-defc3b0e352d.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Cream",
                                    "image": {
                                        "id": "c3dc1e40-ba43-3523-85d7-d22d1c6c6ddd",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c3dc1e40-ba43-3523-85d7-d22d1c6c6ddd.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Bright White",
                                    "image": {
                                        "id": "a0f8fbe8-80e4-3dbb-85d8-22e68be1c4f1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a0f8fbe8-80e4-3dbb-85d8-22e68be1c4f1.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_348692",
                            "name": "Girls 7-16 Cable-Knit Cotton Cardigan",
                            "nameCN": "赵露思同款女大童纯棉针织开衫，Warm White实物为白色logo",
                            "description": [
                                "A pure Polo piece, this cardigan is cable-knit from lustrous mercerized cotton to keep her warm in signature style.",
                                "Size medium has an 18.5\" body length and a 20\" sleeve length",
                                "Signature embroidered pony at the left chest",
                                "Crewneck",
                                "Buttoned placket",
                                "Long sleeves with ribbed cuff",
                                "Ribbed hem",
                                "100% cotton",
                                "Machine wash",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Polo Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "sweater|kids|sweaters",
                            "categoryIds": [
                                "g87"
                            ],
                            "priceTag": "$49.15",
                            "priceTagCN": "¥360",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "S (7)",
                                    "displayName": "S (7)"
                                },
                                {
                                    "ids": [],
                                    "name": "M (8/10)",
                                    "displayName": "M (8/10)"
                                },
                                {
                                    "ids": [],
                                    "name": "L (12/14)",
                                    "displayName": "L (12/14)"
                                },
                                {
                                    "ids": [],
                                    "name": "XL (16)",
                                    "displayName": "XL (16)"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "7折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 45191,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "24e26426-1643-3392-b021-90a892111797",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/32541100_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/24e26426-1643-3392-b021-90a892111797.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/24e26426-1643-3392-b021-90a892111797.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Cruise Navy",
                                    "image": {
                                        "id": "997487a6-73e1-3535-bf30-35de5603a20e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/997487a6-73e1-3535-bf30-35de5603a20e.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Dark Sport Heather",
                                    "image": {
                                        "id": "56ee27c5-4d6e-338c-b4ef-153ed085fe5a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/56ee27c5-4d6e-338c-b4ef-153ed085fe5a.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Black",
                                    "image": {
                                        "id": "760432a0-79bc-3f16-9097-32985a54b955",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/760432a0-79bc-3f16-9097-32985a54b955.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Avery Heather",
                                    "image": {
                                        "id": "c3785c59-5f15-3be9-91c4-d8a37111c230",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c3785c59-5f15-3be9-91c4-d8a37111c230.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Red",
                                    "image": {
                                        "id": "bb70083a-568b-3761-bd4e-36a6b89adf35",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bb70083a-568b-3761-bd4e-36a6b89adf35.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_1931021",
                            "name": "Big Boys Cotton Fleece Zip Up Hoodie",
                            "nameCN": "大童款拉链连帽衫",
                            "description": [
                                "This cozy hoodie is crafted from a warm cotton blend and features our signature embroidered pony. The attached hood and kangaroo pocket helps this hoodie to be as practical as it is cool, ready for any adventures the day has in store. Ribbed at the cuffs and hemline for comfort and easy wear, there are endless outfits choices that this hoodie can combine with for snug and cozy style season to season.",
                                "Ralph Lauren boys' hoodie",
                                "Hood",
                                "Full-zip front",
                                "Long sleeves with ribbed cuffs",
                                "Split kangaroo pocket",
                                "Ribbed hem",
                                "Signature embroidered pony accents the left chest",
                                "Size medium has a 22.25\" body length and a 28.5\" sleeve length. Sleeve length is taken from the center back of the neck.",
                                "Cotton/polyester",
                                "Machine washable",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Polo Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "sweatshirt|kids|sweatshirts & hoodies",
                            "categoryIds": [
                                "g84"
                            ],
                            "priceTag": "$49.15",
                            "priceTagCN": "¥360",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "S (8)",
                                    "displayName": "S (8)"
                                },
                                {
                                    "ids": [],
                                    "name": "M (10/12)",
                                    "displayName": "M (10/12)"
                                },
                                {
                                    "ids": [],
                                    "name": "L (14/16)",
                                    "displayName": "L (14/16)"
                                },
                                {
                                    "ids": [],
                                    "name": "XL (18/20)",
                                    "displayName": "XL (18/20)"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "7折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "7折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 6439,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "766460cc-f1b5-3cb1-8ad3-72434c39fb8a",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/33277528_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/766460cc-f1b5-3cb1-8ad3-72434c39fb8a.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/766460cc-f1b5-3cb1-8ad3-72434c39fb8a.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Blue",
                                    "image": {
                                        "id": "108517d5-9aac-300b-9bda-b0f3cc68596c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/108517d5-9aac-300b-9bda-b0f3cc68596c.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Red",
                                    "image": {
                                        "id": "334384cf-8b4b-3243-a0dc-11f7654821e8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/334384cf-8b4b-3243-a0dc-11f7654821e8.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Camel Heather",
                                    "image": {
                                        "id": "f3e85fa2-3f58-3491-9ef7-93d9cad67bda",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f3e85fa2-3f58-3491-9ef7-93d9cad67bda.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Windsor Heather",
                                    "image": {
                                        "id": "eb432f2f-7b42-333d-a10e-97cbd5cf9be2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/eb432f2f-7b42-333d-a10e-97cbd5cf9be2.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Preppy Pink",
                                    "image": {
                                        "id": "a055901b-d079-3f54-bfed-fd6b31171bf9",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a055901b-d079-3f54-bfed-fd6b31171bf9.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_20389308",
                            "name": "Girls 7-16 Mini-Cable Cotton Cardigan",
                            "nameCN": "大童款 棉质针织衫",
                            "description": [
                                "As iconic as when it was introduced decades ago, our cable-knit cardigan adds signature Polo style to everything from dresses to jeans and a T-shirt.",
                                "Size medium has an 18.5\" body length (front and back) and a 20\" sleeve length",
                                "Signature embroidered Pony at the left chest",
                                "Crewneck. Buttoned placket. Grosgrain trim along the under placket",
                                "Long sleeves with rib-knit cuffs",
                                "Rib-knit hem",
                                "100% cotton",
                                "Machine wash",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Polo Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "sweater|kids|sweaters",
                            "categoryIds": [
                                "g87"
                            ],
                            "priceTag": "$42.05",
                            "priceTagCN": "¥308",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "S (7)",
                                    "displayName": "S (7)"
                                },
                                {
                                    "ids": [],
                                    "name": "M (8/10)",
                                    "displayName": "M (8/10)"
                                },
                                {
                                    "ids": [],
                                    "name": "L (12/14)",
                                    "displayName": "L (12/14)"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "6.9折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "6.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 1347,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "3f507a17-b195-3cd4-85ff-4a99ecc4dd4b",
                                    "originalURL": "https://media.jdsports.com/i/finishline/BQ6931_007_P1?w=800&h=800&fmt=auto&bg=rgb(237,237,237)",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3f507a17-b195-3cd4-85ff-4a99ecc4dd4b.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3f507a17-b195-3cd4-85ff-4a99ecc4dd4b.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "BQ6931-007/Black/Metallic Gold/White",
                                    "image": {
                                        "id": "84dd7cd2-fca2-3fb4-834f-e0d356bc856a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/84dd7cd2-fca2-3fb4-834f-e0d356bc856a.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "finishline_prod2785454",
                            "name": "Big Kids' Air Jordan Retro 1 Mid SE Casual Shoes",
                            "nameCN": "Boys' Big Kids' Air Jordan 1 Mid SE 篮球鞋",
                            "description": [
                                "How to choose your sizeOur sizing buttons list the Big Kids' size first (K) and the equivalent Women's size second (W)Ex. If you usually wear a Women's size 7, select the button with K 5.5 / W 7.0Product FeaturesCombination leather or suede and synthetic upperPlush foam through the midsoleRubber cupsole designSolid rubber sole with flex groovesThe Air Jordan 1 Mid SE is imported.On the court and off, they're ready for whatever comes their way in the Big Kids' Air Jordan 1 Mid SE Casual Shoes."
                            ],
                            "merchantId": "26415a45-e02c-6a77-1ed7-f40023f03163",
                            "brand": "Jordan",
                            "displayBrand": "Jordan",
                            "brandId": "d16d377a-f76c-39d2-b093-abc22244b342",
                            "category": "shoes|boys|Boys|big kids",
                            "categoryIds": [
                                "g8g"
                            ],
                            "priceTagCN": "¥806",
                            "labels": [],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "3.5",
                                    "displayName": "3.5"
                                },
                                {
                                    "ids": [],
                                    "name": "4.0",
                                    "displayName": "4.0"
                                },
                                {
                                    "ids": [],
                                    "name": "4.5",
                                    "displayName": "4.5"
                                },
                                {
                                    "ids": [],
                                    "name": "5.0",
                                    "displayName": "5.0"
                                },
                                {
                                    "ids": [],
                                    "name": "5.5",
                                    "displayName": "5.5"
                                },
                                {
                                    "ids": [],
                                    "name": "6.0",
                                    "displayName": "6.0"
                                },
                                {
                                    "ids": [],
                                    "name": "6.5",
                                    "displayName": "6.5"
                                },
                                {
                                    "ids": [],
                                    "name": "7.0",
                                    "displayName": "7.0"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "activityOffs": [
                            "满减"
                        ],
                        "merchantName": "Finish Line",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "满减",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "满$100减$10",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 2167,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "attraction": {
                            "badges": [
                                {
                                    "icon": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/img/app/img_limited_tag.png"
                                    },
                                    "type": "PROMO",
                                    "contents": []
                                }
                            ]
                        },
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "248842ec-7841-3c06-82e6-b1148679a5d5",
                                    "originalURL": "https://media.finishline.com/i/finishline/DH2920_001_P1?w=800&h=800&fmt=auto&bg=rgb(237,237,237)",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/248842ec-7841-3c06-82e6-b1148679a5d5.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/248842ec-7841-3c06-82e6-b1148679a5d5.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "DH2920-001/Black/Black",
                                    "image": {
                                        "id": "f59aeecb-0753-32d1-8589-472e96bf1bb5",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f59aeecb-0753-32d1-8589-472e96bf1bb5.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "DH2920-111/White/White",
                                    "image": {
                                        "id": "0de1f7cf-d0fb-394b-b4df-c8964249a1db",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0de1f7cf-d0fb-394b-b4df-c8964249a1db.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "finishline_prod796065",
                            "name": "Big Kids' Nike Air Force 1 Low Casual Shoes",
                            "nameCN": "大童 Air Force 1 低帮训练鞋",
                            "description": [
                                "$8f"
                            ],
                            "merchantId": "26415a45-e02c-6a77-1ed7-f40023f03163",
                            "brand": "Nike",
                            "displayBrand": "NIKE",
                            "brandId": "41fd220f-05ed-3d8c-96e3-b83af87d45d7",
                            "category": "shoes|Boys|boys|big kids",
                            "categoryIds": [
                                "g8g"
                            ],
                            "priceTag": "$90",
                            "priceTagCN": "¥659",
                            "labels": [],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "3.5",
                                    "displayName": "3.5"
                                },
                                {
                                    "ids": [],
                                    "name": "4.0",
                                    "displayName": "4.0"
                                },
                                {
                                    "ids": [],
                                    "name": "4.5",
                                    "displayName": "4.5"
                                },
                                {
                                    "ids": [],
                                    "name": "5.0",
                                    "displayName": "5.0"
                                },
                                {
                                    "ids": [],
                                    "name": "5.5",
                                    "displayName": "5.5"
                                },
                                {
                                    "ids": [],
                                    "name": "6.0",
                                    "displayName": "6.0"
                                },
                                {
                                    "ids": [],
                                    "name": "6.5",
                                    "displayName": "6.5"
                                },
                                {
                                    "ids": [],
                                    "name": "7.0",
                                    "displayName": "7.0"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "activityOffs": [
                            "满减"
                        ],
                        "merchantName": "Finish Line",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "满减",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "满$100减$10",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 1164,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "e4031cb8-a04d-3166-95c5-6381ea1b6beb",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/24882563_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e4031cb8-a04d-3166-95c5-6381ea1b6beb.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e4031cb8-a04d-3166-95c5-6381ea1b6beb.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Light Blue",
                                    "image": {
                                        "id": "18a9566e-3d4e-3eb7-abd4-e370607df180",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/18a9566e-3d4e-3eb7-abd4-e370607df180.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Dark Blue",
                                    "image": {
                                        "id": "621a4d5c-8315-3c26-9e2d-2d27dff50006",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/621a4d5c-8315-3c26-9e2d-2d27dff50006.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_6861397",
                            "name": "Big Boys Cotton Chambray Sport Shirt",
                            "nameCN": "大童全棉休闲衬衫",
                            "description": [
                                "This shirt combines the polished look of the iconic oxford with rugged cotton chambray for quintessential Polo Ralph Lauren style.",
                                "Multicolored signature embroidered pony at the left chest",
                                "Button-down point collar",
                                "Buttoned placket",
                                "Long sleeves with buttoned barrel cuffs",
                                "Box-pleated back yoke",
                                "Dyed with indigo, which may rub off onto fabrics, leather, and upholstery",
                                "Size medium has a 24.5\" front body length, a 24.75\" back body length, and a 28.5\" sleeve length. Sleeve length is taken from the center back of the neck.",
                                "All cotton",
                                "Machine washable",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Polo Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "shirt|kids|shirts & tops",
                            "categoryIds": [
                                "g83"
                            ],
                            "priceTag": "$42.05",
                            "priceTagCN": "¥308",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "S (8)",
                                    "displayName": "S (8)"
                                },
                                {
                                    "ids": [],
                                    "name": "M (10/12)",
                                    "displayName": "M (10/12)"
                                },
                                {
                                    "ids": [],
                                    "name": "L (14/16)",
                                    "displayName": "L (14/16)"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "6.9折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "6.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 2762,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "e90e87a6-f53d-3cac-a118-b1c6b866ede5",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/24881745_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e90e87a6-f53d-3cac-a118-b1c6b866ede5.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e90e87a6-f53d-3cac-a118-b1c6b866ede5.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "White",
                                    "image": {
                                        "id": "ad8e3ae6-1a5d-3fbb-8edd-a404fee592e0",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ad8e3ae6-1a5d-3fbb-8edd-a404fee592e0.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Light Blue",
                                    "image": {
                                        "id": "8ef6299b-4b41-3072-b4c6-3b9b4b3d9e64",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8ef6299b-4b41-3072-b4c6-3b9b4b3d9e64.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "New Rose",
                                    "image": {
                                        "id": "b1b372fa-3c7b-3301-acbe-814db8a8b8b0",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b1b372fa-3c7b-3301-acbe-814db8a8b8b0.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Yellow",
                                    "image": {
                                        "id": "eb7fa3c1-b799-3f73-b8c3-7b2b28b29b39",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/eb7fa3c1-b799-3f73-b8c3-7b2b28b29b39.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "Light Blue Stripe",
                                    "image": {
                                        "id": "d4c24579-81f9-3c72-95d3-51de690593b9",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d4c24579-81f9-3c72-95d3-51de690593b9.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_213890",
                            "name": "Big Boys Embroidered Pony Logo Cotton Oxford Shirt",
                            "nameCN": "男大童 牛津衬衫 纯棉 多款配色",
                            "description": [
                                "The quintessential Oxford shirt is a must-have for any prepster. Classic details include button-down collar, embroidered pony logo on chest, button cuffs, back pleat and rounded hem.",
                                "Polo Ralph Lauren boys' oxford shirt",
                                "Button-down collar",
                                "Shirttail hem",
                                "Embroidered multi-polo player on left chest",
                                "Size medium has a 24.5\" front body length, a 24.75\" back body length, and a 28.5\" sleeve length. Sleeve length is taken from the center back of the neck.",
                                "Cotton",
                                "Machine washable",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Polo Ralph Lauren",
                            "displayBrand": "Ralph Lauren",
                            "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                            "category": "shirt|kids|shirts & tops",
                            "categoryIds": [
                                "g85",
                                "g83"
                            ],
                            "priceTag": "$42.05",
                            "priceTagCN": "¥308",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "S (8)",
                                    "displayName": "S (8)"
                                },
                                {
                                    "ids": [],
                                    "name": "M (10/12)",
                                    "displayName": "M (10/12)"
                                },
                                {
                                    "ids": [],
                                    "name": "L (14/16)",
                                    "displayName": "L (14/16)"
                                },
                                {
                                    "ids": [],
                                    "name": "XL (18/20)",
                                    "displayName": "XL (18/20)"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "6.9折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "6.9折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 10856,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "2c1077af-7489-3b15-b42e-265d97b9bd15",
                                    "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/33060780_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2c1077af-7489-3b15-b42e-265d97b9bd15.jpg",
                                        "width": 838,
                                        "height": 1024,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2c1077af-7489-3b15-b42e-265d97b9bd15.jpg",
                                        "width": 286,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "Black",
                                    "image": {
                                        "id": "ad36209e-4869-3911-bec5-8e38aa2af2f6",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ad36209e-4869-3911-bec5-8e38aa2af2f6.jpg",
                                            "width": 41,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "macys_22581828",
                            "name": "Big Boys Old School Logo Pull On Hoodie",
                            "nameCN": "大童款复古徽标套头连帽衫",
                            "description": [
                                "Featuring a kangaroo pocket for hand-warming comfort, this Hoodie from Calvin Klein Jeans is made of cozy cotton-blend fleece branded with a monogram logo.",
                                "Hood with crossover construction neck coverage",
                                "Ribbed cuffs and hem",
                                "Kangaroo pocket; Printed monogram at front",
                                "60% cotton, 40% polyester",
                                "Machine wash",
                                "Imported"
                            ],
                            "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                            "brand": "Calvin Klein",
                            "displayBrand": "Calvin Klein",
                            "brandId": "04005cf7-5278-3d59-a187-ef0b416c10a2",
                            "category": "sweatshirt|kids|sweatshirts & hoodies",
                            "categoryIds": [
                                "g84"
                            ],
                            "priceTag": "$26.15",
                            "priceTagCN": "¥192",
                            "labels": [
                                "on_sale"
                            ],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "S (8)",
                                    "displayName": "S (8)"
                                },
                                {
                                    "ids": [],
                                    "name": "M (10/12)",
                                    "displayName": "M (10/12)"
                                },
                                {
                                    "ids": [],
                                    "name": "L (14/16)",
                                    "displayName": "L (14/16)"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "off": "5.2折",
                        "activityOffs": [],
                        "merchantName": "Macy's",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "5.2折",
                                            "color": "FFFFFF",
                                            "backgroundColor": "222222",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER",
                                        "PRODUCT_LIST_LAYER"
                                    ],
                                    "kind": "DISCOUNT_LABEL"
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 686,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                },
                {
                    "searchProduct": {
                        "product": {
                            "images": [
                                {
                                    "id": "248842ec-7841-3c06-82e6-b1148679a5d5",
                                    "originalURL": "https://media.finishline.com/i/finishline/DH2920_001_P1?w=800&h=800&fmt=auto&bg=rgb(237,237,237)",
                                    "full": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pf/248842ec-7841-3c06-82e6-b1148679a5d5.jpg",
                                        "width": 800,
                                        "height": 800,
                                        "format": "JPG"
                                    },
                                    "thumbnail": {
                                        "url": "https://5thave-img-cdn-g.bybieyang.com/pt/248842ec-7841-3c06-82e6-b1148679a5d5.jpg",
                                        "width": 350,
                                        "height": 350,
                                        "format": "JPG"
                                    }
                                }
                            ],
                            "colors": [
                                {
                                    "name": "DH2920-001/Black/Black",
                                    "image": {
                                        "id": "f59aeecb-0753-32d1-8589-472e96bf1bb5",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f59aeecb-0753-32d1-8589-472e96bf1bb5.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                },
                                {
                                    "name": "DH2920-111/White/White",
                                    "image": {
                                        "id": "0de1f7cf-d0fb-394b-b4df-c8964249a1db",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0de1f7cf-d0fb-394b-b4df-c8964249a1db.jpg",
                                            "width": 50,
                                            "height": 50,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {}
                                    }
                                }
                            ],
                            "id": "jdsports_prod796065",
                            "name": "Big Kids' Nike Air Force 1 Low Casual Shoes",
                            "description": [
                                "$90"
                            ],
                            "merchantId": "61220bc0-bab6-b4be-4cd0-05ca48e4ff39",
                            "brand": "Nike",
                            "displayBrand": "NIKE",
                            "brandId": "41fd220f-05ed-3d8c-96e3-b83af87d45d7",
                            "category": "shoes|big kids|boys|Boys",
                            "categoryIds": [
                                "g8g"
                            ],
                            "priceTag": "$90",
                            "priceTagCN": "¥659",
                            "labels": [],
                            "badges": [],
                            "keyDetails": [],
                            "inventoryStatus": "AVAILABLE",
                            "sizes": [
                                {
                                    "ids": [],
                                    "name": "3.5",
                                    "displayName": "3.5"
                                },
                                {
                                    "ids": [],
                                    "name": "4.0",
                                    "displayName": "4.0"
                                },
                                {
                                    "ids": [],
                                    "name": "4.5",
                                    "displayName": "4.5"
                                },
                                {
                                    "ids": [],
                                    "name": "5.0",
                                    "displayName": "5.0"
                                },
                                {
                                    "ids": [],
                                    "name": "5.5",
                                    "displayName": "5.5"
                                },
                                {
                                    "ids": [],
                                    "name": "6.0",
                                    "displayName": "6.0"
                                },
                                {
                                    "ids": [],
                                    "name": "6.5",
                                    "displayName": "6.5"
                                },
                                {
                                    "ids": [],
                                    "name": "7.0",
                                    "displayName": "7.0"
                                }
                            ],
                            "availableSkus": [],
                            "marks": [],
                            "badgeList": [],
                            "type": "REGULAR",
                            "videos": [],
                            "unAvailableSkus": [],
                            "descriptionCN": []
                        },
                        "activityOffs": [
                            "满减"
                        ],
                        "merchantName": "JD Sports",
                        "origin": "[美国]",
                        "promotion": {
                            "promotionLabels": [
                                {
                                    "text": "满减",
                                    "color": "D27D3F"
                                }
                            ],
                            "type": "LABEL"
                        },
                        "labelView": {
                            "shortLabels": [
                                {
                                    "labels": [
                                        {
                                            "text": "满$100减$10",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": []
                                },
                                {
                                    "labels": [
                                        {
                                            "text": "独家减免邮费",
                                            "color": "E1660C",
                                            "backgroundColor": "FAF2EB",
                                            "fontSize": 18,
                                            "fontWeight": "REGULAR"
                                        }
                                    ],
                                    "layers": [
                                        "PRODUCT_DETAIL_LAYER"
                                    ],
                                    "kind": "SHIPPING_LABEL"
                                }
                            ],
                            "viewLabelType": "V2_LIST_VIEW"
                        },
                        "numberViews": [
                            {
                                "value": 595,
                                "view": "SALE_VIEW"
                            }
                        ],
                        "merchantOrigin": "美国",
                        "buoy": {}
                    },
                    "type": "PRODUCT"
                }
            ]
        }
    ],
    "topSelling": {
        "tabs": [
            {
                "id": "womens_bag",
                "title": "女包榜",
                "categoryIds": [
                    "13",
                    "e0"
                ],
                "sections": [],
                "sort": 1,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "d932e6ea-5ecc-359a-afa8-8002e7ff4f25",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S3G6HS5B-0200_1?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d932e6ea-5ecc-359a-afa8-8002e7ff4f25.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d932e6ea-5ecc-359a-afa8-8002e7ff4f25.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "768dd130-3fcc-3318-8900-fd2aed8a11df",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S3G6HS5B-0200_2?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/768dd130-3fcc-3318-8900-fd2aed8a11df.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/768dd130-3fcc-3318-8900-fd2aed8a11df.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "617e67fb-bfdb-329d-83be-d106ce2f1817",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S3G6HS5B-0200_4?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/617e67fb-bfdb-329d-83be-d106ce2f1817.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/617e67fb-bfdb-329d-83be-d106ce2f1817.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b3d78bfa-9a39-3113-881b-61ab27a898a6",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S3G6HS5B-0200_7?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b3d78bfa-9a39-3113-881b-61ab27a898a6.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b3d78bfa-9a39-3113-881b-61ab27a898a6.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "BROWN",
                                        "image": {
                                            "id": "bc3ac4be-0318-39b5-84bc-ef6714fc83fe",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bc3ac4be-0318-39b5-84bc-ef6714fc83fe.jpg",
                                                "width": 50,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "VANILLA",
                                        "image": {
                                            "id": "1a174df8-523b-3bb8-b647-62268ed87966",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1a174df8-523b-3bb8-b647-62268ed87966.jpg",
                                                "width": 50,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "michaelkors_35S3G6HS5B",
                                "name": "Sheila Small Signature Logo Satchel",
                                "nameCN": "女士 Sheila 小号徽标挎包",
                                "description": [],
                                "merchantId": "89896b29-9191-a09f-8ffd-e872a296da04",
                                "brand": "Michael Kors",
                                "displayBrand": "Michael Kors",
                                "brandId": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                                "category": "sheila|satchel|signature|bag|logo|women|small",
                                "categoryIds": [
                                    "e08"
                                ],
                                "priceTag": "$67.83",
                                "priceTagCN": "¥497",
                                "originalPriceTag": "$361.60",
                                "officialURL": "https://www.michaelkors.com/sheila-small-signature-logo-satchel/35S3G6HS5B.html?astc=true&dwvar_35S3G6HS5B_color=0200",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.2折",
                            "activityOffs": [
                                "额外八五折"
                            ],
                            "merchantName": "Michael Kors",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外八五折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.2折×额外8.5折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "15804ceb-97ac-31f1-b550-169dbb1a9a86",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/5/optimized/15240125_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/15804ceb-97ac-31f1-b550-169dbb1a9a86.jpg",
                                            "width": 700,
                                            "height": 875,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/15804ceb-97ac-31f1-b550-169dbb1a9a86.jpg",
                                            "width": 280,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "483a24ff-4947-307d-bada-6fb46b02e951",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/6/optimized/15240126_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/483a24ff-4947-307d-bada-6fb46b02e951.jpg",
                                            "width": 700,
                                            "height": 875,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/483a24ff-4947-307d-bada-6fb46b02e951.jpg",
                                            "width": 280,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "80e9d636-0feb-39c2-8bb4-2cf42370790c",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/7/optimized/15240127_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/80e9d636-0feb-39c2-8bb4-2cf42370790c.jpg",
                                            "width": 700,
                                            "height": 875,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/80e9d636-0feb-39c2-8bb4-2cf42370790c.jpg",
                                            "width": 280,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "97ad3ebc-1e56-31c8-86c3-1be720cdda30",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/1/optimized/15240201_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/97ad3ebc-1e56-31c8-86c3-1be720cdda30.jpg",
                                            "width": 700,
                                            "height": 875,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/97ad3ebc-1e56-31c8-86c3-1be720cdda30.jpg",
                                            "width": 280,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "26b6405b-630a-3486-9230-905645625ff9",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/2/optimized/15240202_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/26b6405b-630a-3486-9230-905645625ff9.jpg",
                                            "width": 700,
                                            "height": 875,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/26b6405b-630a-3486-9230-905645625ff9.jpg",
                                            "width": 280,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "1e395994-6b46-3cb1-a48f-73b055c27e49",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1e395994-6b46-3cb1-a48f-73b055c27e49.jpg",
                                                "width": 40,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "bloomingdales_5741524",
                                "name": "We The Free Baby Emerson Tote",
                                "nameCN": "女士 We The Free Baby Emerson系列 托特包",
                                "description": [],
                                "merchantId": "34b7c946-2aec-d75b-66f0-81fcea0ce875",
                                "brand": "Free People",
                                "displayBrand": "Free People",
                                "brandId": "0e42f86f-7098-3292-99dc-2cd5171579c2",
                                "category": "women|handbag|handbags",
                                "categoryIds": [
                                    "e07"
                                ],
                                "priceTag": "$178.90",
                                "priceTagCN": "¥1310",
                                "officialURL": "https://www.bloomingdales.com/shop/product/free-people-we-the-free-baby-emerson-tote?ID=5741524",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Bloomingdale's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "7db9b053-a010-3ee4-aca8-42b678f33c18",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/1/optimized/15240131_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7db9b053-a010-3ee4-aca8-42b678f33c18.jpg",
                                            "width": 700,
                                            "height": 875,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7db9b053-a010-3ee4-aca8-42b678f33c18.jpg",
                                            "width": 280,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "53d5e1c2-43da-3949-926d-0a5095379c0b",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/2/optimized/15240132_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/53d5e1c2-43da-3949-926d-0a5095379c0b.jpg",
                                            "width": 700,
                                            "height": 875,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/53d5e1c2-43da-3949-926d-0a5095379c0b.jpg",
                                            "width": 280,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "51cf5c31-a3ea-33e9-a6b9-09934cbdad7e",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/3/optimized/15240133_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/51cf5c31-a3ea-33e9-a6b9-09934cbdad7e.jpg",
                                            "width": 700,
                                            "height": 875,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/51cf5c31-a3ea-33e9-a6b9-09934cbdad7e.jpg",
                                            "width": 280,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "285b66cf-b9f2-306e-aba3-416f63156ed1",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/1/optimized/15240221_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/285b66cf-b9f2-306e-aba3-416f63156ed1.jpg",
                                            "width": 700,
                                            "height": 875,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/285b66cf-b9f2-306e-aba3-416f63156ed1.jpg",
                                            "width": 280,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Salt",
                                        "image": {
                                            "id": "04e3c8e5-ea1f-38cd-81a0-ce49a935900d",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/04e3c8e5-ea1f-38cd-81a0-ce49a935900d.jpg",
                                                "width": 40,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Secret Sage",
                                        "image": {
                                            "id": "7ef0240d-b919-3cd4-8754-4ddbc140006f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7ef0240d-b919-3cd4-8754-4ddbc140006f.jpg",
                                                "width": 40,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "bloomingdales_5602414",
                                "name": "We The Free Emerson Tote",
                                "nameCN": "FreePeople爆款流浪包 ",
                                "description": [],
                                "merchantId": "34b7c946-2aec-d75b-66f0-81fcea0ce875",
                                "brand": "Free People",
                                "displayBrand": "Free People",
                                "brandId": "0e42f86f-7098-3292-99dc-2cd5171579c2",
                                "category": "women|handbags|handbag",
                                "categoryIds": [
                                    "e07"
                                ],
                                "priceTag": "$249.25",
                                "priceTagCN": "¥1825",
                                "officialURL": "https://www.bloomingdales.com/shop/product/free-people-we-the-free-emerson-tote?ID=5602414",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Bloomingdale's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "e050a0e8-cc3a-3014-b232-af226e8bfa42",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S1GTTC9B-0200_1?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e050a0e8-cc3a-3014-b232-af226e8bfa42.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e050a0e8-cc3a-3014-b232-af226e8bfa42.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "23a90343-b1b5-31c4-ac2f-4848cdf9fb4b",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S1GTTC9B-0200_2?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/23a90343-b1b5-31c4-ac2f-4848cdf9fb4b.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/23a90343-b1b5-31c4-ac2f-4848cdf9fb4b.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8694e23d-ff4f-395a-b07e-5139a70f8188",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S1GTTC9B-0200_3?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8694e23d-ff4f-395a-b07e-5139a70f8188.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8694e23d-ff4f-395a-b07e-5139a70f8188.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c73ea38a-20a7-3add-9cd3-b3c650b67820",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S1GTTC9B-0200_4?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c73ea38a-20a7-3add-9cd3-b3c650b67820.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c73ea38a-20a7-3add-9cd3-b3c650b67820.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "cf24bf70-839f-3147-95ae-44bae49aa54a",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S1GTTC9B-0200_5?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cf24bf70-839f-3147-95ae-44bae49aa54a.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cf24bf70-839f-3147-95ae-44bae49aa54a.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "BROWN",
                                        "image": {
                                            "id": "0cc15dcb-7766-3658-809b-40180d468862",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0cc15dcb-7766-3658-809b-40180d468862.jpg",
                                                "width": 50,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "PWD BLSH MLT",
                                        "image": {
                                            "id": "32f193b3-1dff-3a03-afbd-65d8c82e6846",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/32f193b3-1dff-3a03-afbd-65d8c82e6846.jpg",
                                                "width": 50,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "VANILLA",
                                        "image": {
                                            "id": "e9672619-cfa3-38f4-bd96-32172fcf1625",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e9672619-cfa3-38f4-bd96-32172fcf1625.jpg",
                                                "width": 50,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "michaelkors_35S1GTTC9B",
                                "name": "Jet Set Large Logo Crossbody Bag",
                                "nameCN": "女式 Jet Set 大号徽标斜挎包",
                                "description": [],
                                "merchantId": "89896b29-9191-a09f-8ffd-e872a296da04",
                                "brand": "Michael Kors",
                                "displayBrand": "Michael Kors",
                                "brandId": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                                "category": "?sz=72&start=294|women",
                                "categoryIds": [
                                    "e08"
                                ],
                                "priceTag": "$50.66",
                                "priceTagCN": "¥371",
                                "originalPriceTag": "$260.60",
                                "officialURL": "https://www.michaelkors.com/jet-set-large-logo-crossbody-bag/35S1GTTC9B.html?astc=true&dwvar_35S1GTTC9B_color=0200&priceStatusType=md",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.2折",
                            "activityOffs": [
                                "额外八五折"
                            ],
                            "merchantName": "Michael Kors",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外八五折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.2折×额外8.5折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "ca48d30a-1dd3-354c-8001-ddb0468ed4ff",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35T9GTVT0B-0001_1?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ca48d30a-1dd3-354c-8001-ddb0468ed4ff.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ca48d30a-1dd3-354c-8001-ddb0468ed4ff.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0caeaa4f-4db6-3e06-b613-6520744356de",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35T9GTVT0B-0001_2?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0caeaa4f-4db6-3e06-b613-6520744356de.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0caeaa4f-4db6-3e06-b613-6520744356de.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b37ed429-57f0-3bf0-aabd-41bca5b6d0f0",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35T9GTVT0B-0001_3?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b37ed429-57f0-3bf0-aabd-41bca5b6d0f0.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b37ed429-57f0-3bf0-aabd-41bca5b6d0f0.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "59932057-2944-36b7-9d8a-019e0c51391d",
                                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35T9GTVT0B-0001_4?dpr=on%2C2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/59932057-2944-36b7-9d8a-019e0c51391d.jpg",
                                            "width": 595,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/59932057-2944-36b7-9d8a-019e0c51391d.jpg",
                                            "width": 260,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "PWD BLSH MLT",
                                        "image": {
                                            "id": "242ccbe0-6b72-3b2f-83a2-0a27fafa60d7",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/242ccbe0-6b72-3b2f-83a2-0a27fafa60d7.jpg",
                                                "width": 50,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "BROWN",
                                        "image": {
                                            "id": "8705b855-9e4d-3963-aa2e-4fd0fd57f062",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8705b855-9e4d-3963-aa2e-4fd0fd57f062.jpg",
                                                "width": 50,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "BLACK",
                                        "image": {
                                            "id": "6755fe5f-d74b-3e89-a13b-cbd98d57465c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6755fe5f-d74b-3e89-a13b-cbd98d57465c.jpg",
                                                "width": 50,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "michaelkors_35T9GTVT0B",
                                "name": "Jet Set Travel Extra-Small Logo Top-Zip Tote Bag",
                                "nameCN": "Jet Set超小号托特旅行袋 菜篮子（多种配色）",
                                "description": [],
                                "merchantId": "89896b29-9191-a09f-8ffd-e872a296da04",
                                "brand": "Michael Kors",
                                "displayBrand": "Michael Kors",
                                "brandId": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                                "category": "women|bag|sale",
                                "categoryIds": [
                                    "e07"
                                ],
                                "priceTag": "$67.83",
                                "priceTagCN": "¥497",
                                "originalPriceTag": "$331.30",
                                "officialURL": "https://www.michaelkors.com/jet-set-travel-extra-small-logo-top-zip-tote-bag/35T9GTVT0B.html?astc=true&dwvar_35T9GTVT0B_color=0001",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.4折",
                            "activityOffs": [
                                "额外八五折"
                            ],
                            "merchantName": "Michael Kors",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外八五折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.4折×额外8.5折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "c920f414-018f-3211-bac5-a13812af2688",
                                        "originalURL": "https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/toryb/toryb502601071b/toryb502601071b_1694468073981_2-0.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c920f414-018f-3211-bac5-a13812af2688.jpg",
                                            "width": 578,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c920f414-018f-3211-bac5-a13812af2688.jpg",
                                            "width": 197,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "85fa37a5-b3c5-3685-a5b1-ec46abeda757",
                                        "originalURL": "https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/toryb/toryb502601071b/toryb502601071b_1694468073710_2-0.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/85fa37a5-b3c5-3685-a5b1-ec46abeda757.jpg",
                                            "width": 578,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/85fa37a5-b3c5-3685-a5b1-ec46abeda757.jpg",
                                            "width": 197,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9bf96ac6-2cf1-3042-a469-ac3fa182408d",
                                        "originalURL": "https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/toryb/toryb502601071b/toryb502601071b_1694468073716_2-0.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9bf96ac6-2cf1-3042-a469-ac3fa182408d.jpg",
                                            "width": 578,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9bf96ac6-2cf1-3042-a469-ac3fa182408d.jpg",
                                            "width": 197,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "bcc65ef5-7df0-350d-b88e-8cf50556967d",
                                        "originalURL": "https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/toryb/toryb502601071b/toryb502601071b_1694468074966_2-0.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/bcc65ef5-7df0-350d-b88e-8cf50556967d.jpg",
                                            "width": 578,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/bcc65ef5-7df0-350d-b88e-8cf50556967d.jpg",
                                            "width": 197,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4796b1b4-d9cb-37ae-b5aa-057631120a1a",
                                        "originalURL": "https://m.media-amazon.com/images/G/01/Shopbop/p/prod/products/toryb/toryb502601071b/toryb502601071b_1694468073799_2-0.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4796b1b4-d9cb-37ae-b5aa-057631120a1a.jpg",
                                            "width": 578,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4796b1b4-d9cb-37ae-b5aa-057631120a1a.jpg",
                                            "width": 197,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "1d5140fe-157d-3d39-8c31-f576789a8fe3",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1d5140fe-157d-3d39-8c31-f576789a8fe3.jpg",
                                                "width": 50,
                                                "height": 48,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "shopbop_1544477148",
                                "name": "Ella Chain Tote",
                                "description": [],
                                "merchantId": "aac5af81-b346-3d71-36f6-906fff9d9f8a",
                                "brand": "Tory Burch",
                                "displayBrand": "Tory Burch",
                                "brandId": "dc9a30b7-8e06-3630-ae61-e198fb793425",
                                "category": "tory burch bags|WOMENS|bags|womens|tory burch totes|totes",
                                "categoryIds": [
                                    "e07"
                                ],
                                "priceTag": "$211.60",
                                "priceTagCN": "¥1550",
                                "originalPriceTag": "$302.25",
                                "officialURL": "https://www.shopbop.com/ella-chain-tote-tory-burch/vp/v=1/1544477148.htm",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "One Size",
                                        "displayName": "One Size"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Shopbop",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "97586b14-574b-4867-a625-e150d5b2e24d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/97586b14-574b-4867-a625-e150d5b2e24d.jpg",
                                            "width": 768,
                                            "height": 781,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/97586b14-574b-4867-a625-e150d5b2e24d.jpg",
                                            "width": 768,
                                            "height": 781,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "80b321c8-b8c5-4cb3-8e46-eff16559db5f",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/80b321c8-b8c5-4cb3-8e46-eff16559db5f.jpg",
                                            "width": 754,
                                            "height": 758,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/80b321c8-b8c5-4cb3-8e46-eff16559db5f.jpg",
                                            "width": 754,
                                            "height": 758,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "9de34d3d-8818-4f2b-9d39-ba215fb69b17",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9de34d3d-8818-4f2b-9d39-ba215fb69b17.jpg",
                                            "width": 772,
                                            "height": 737,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9de34d3d-8818-4f2b-9d39-ba215fb69b17.jpg",
                                            "width": 772,
                                            "height": 737,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "3136eabd-d312-4983-821c-3683d3c4d3a2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3136eabd-d312-4983-821c-3683d3c4d3a2.jpg",
                                            "width": 797,
                                            "height": 764,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3136eabd-d312-4983-821c-3683d3c4d3a2.jpg",
                                            "width": 797,
                                            "height": 764,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "b36f3989-1d14-4682-ab4f-573ffeeb10df",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b36f3989-1d14-4682-ab4f-573ffeeb10df.jpg",
                                            "width": 766,
                                            "height": 799,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b36f3989-1d14-4682-ab4f-573ffeeb10df.jpg",
                                            "width": 766,
                                            "height": 799,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "7fd17a2d-33bc-4758-aae2-0d654df5cb86",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7fd17a2d-33bc-4758-aae2-0d654df5cb86.jpg",
                                            "width": 751,
                                            "height": 755,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7fd17a2d-33bc-4758-aae2-0d654df5cb86.jpg",
                                            "width": 751,
                                            "height": 755,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "58aeb9c0-2832-4c19-bec7-944da7deeac2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/58aeb9c0-2832-4c19-bec7-944da7deeac2.jpg",
                                            "width": 742,
                                            "height": 658,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/58aeb9c0-2832-4c19-bec7-944da7deeac2.jpg",
                                            "width": 742,
                                            "height": 658,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "e10a3fe9-e772-4b7b-8077-4345757ae2ad",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e10a3fe9-e772-4b7b-8077-4345757ae2ad.jpg",
                                            "width": 826,
                                            "height": 728,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e10a3fe9-e772-4b7b-8077-4345757ae2ad.jpg",
                                            "width": 826,
                                            "height": 728,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "bac72de8-c60a-4f5e-9afe-fb4fe2e43b26",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/bac72de8-c60a-4f5e-9afe-fb4fe2e43b26.jpg",
                                            "width": 768,
                                            "height": 750,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/bac72de8-c60a-4f5e-9afe-fb4fe2e43b26.jpg",
                                            "width": 768,
                                            "height": 750,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "f7a800be-4dcd-4fe4-a55c-4a669c57ca19",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f7a800be-4dcd-4fe4-a55c-4a669c57ca19.jpg",
                                            "width": 794,
                                            "height": 734,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f7a800be-4dcd-4fe4-a55c-4a669c57ca19.jpg",
                                            "width": 794,
                                            "height": 734,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "3544f067-dcd6-451c-b48b-f6e6a7ba275b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3544f067-dcd6-451c-b48b-f6e6a7ba275b.jpg",
                                            "width": 817,
                                            "height": 727,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3544f067-dcd6-451c-b48b-f6e6a7ba275b.jpg",
                                            "width": 817,
                                            "height": 727,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "黑色",
                                        "image": {
                                            "id": "ac314a35-6c8b-3f54-b402-c58e5ba22521",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ac314a35-6c8b-3f54-b402-c58e5ba22521.jpg",
                                                "width": 553,
                                                "height": 537,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "沙色",
                                        "image": {
                                            "id": "1d5826dd-4562-379f-9e4d-2873ef30bb8a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1d5826dd-4562-379f-9e4d-2873ef30bb8a.jpg",
                                                "width": 741,
                                                "height": 760,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "terriwonder_10728",
                                "name": "珑骧女士多色中小号长柄经典饺子包手提包2605 089（香港仓发货）",
                                "description": [],
                                "merchantId": "845ebfac-d06a-35fd-a5f9-84e686740dd3",
                                "brand": "Longchamp",
                                "displayBrand": "Longchamp",
                                "brandId": "c990953c-4114-3a78-ac7c-b89120e7bd24",
                                "categoryIds": [
                                    "e05"
                                ],
                                "priceTag": "$109.02",
                                "priceTagCN": "¥799",
                                "originalPriceTag": "$155",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8.9折",
                            "activityOffs": [
                                "额外七九折"
                            ],
                            "merchantName": "Terri Wonder",
                            "origin": "[中国香港]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外七九折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8.9折×额外7.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国香港",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "3ef735b5-0d0e-3b71-9796-97f1bff86430",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/31813051_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3ef735b5-0d0e-3b71-9796-97f1bff86430.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3ef735b5-0d0e-3b71-9796-97f1bff86430.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4c2e8a3b-f63d-3bf7-a371-46698bbf8ce1",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/23642481_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4c2e8a3b-f63d-3bf7-a371-46698bbf8ce1.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4c2e8a3b-f63d-3bf7-a371-46698bbf8ce1.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ad1739ab-2bef-3a6e-b0df-a1b6b441130c",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/17807094_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ad1739ab-2bef-3a6e-b0df-a1b6b441130c.jpg",
                                            "width": 837,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ad1739ab-2bef-3a6e-b0df-a1b6b441130c.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c390ca0d-a302-3a49-8712-35e09030f142",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/17807086_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c390ca0d-a302-3a49-8712-35e09030f142.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c390ca0d-a302-3a49-8712-35e09030f142.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "048a05ad-ae25-3c6e-86a9-810b239b76bd",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/30901616_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/048a05ad-ae25-3c6e-86a9-810b239b76bd.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/048a05ad-ae25-3c6e-86a9-810b239b76bd.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black/Taupe/Gold",
                                        "image": {
                                            "id": "cf9a08cf-d433-3dbf-b947-9a287a36a2ac",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/cf9a08cf-d433-3dbf-b947-9a287a36a2ac.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Lauren Tan/Orange/Gold",
                                        "image": {
                                            "id": "a4c307ac-af87-3375-9054-41320ae3e1af",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a4c307ac-af87-3375-9054-41320ae3e1af.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Soft White/beaumont Plaid",
                                        "image": {
                                            "id": "76be45bd-129c-3221-8c66-da08602a02bd",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/76be45bd-129c-3221-8c66-da08602a02bd.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black/malecon Stripe",
                                        "image": {
                                            "id": "af142059-6deb-3fa0-9b06-cdbacb60ee62",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/af142059-6deb-3fa0-9b06-cdbacb60ee62.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Capri Blue/oia Palms",
                                        "image": {
                                            "id": "e1cc9aa1-42da-358e-854b-1ee9f25e889b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e1cc9aa1-42da-358e-854b-1ee9f25e889b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sand Dune/sunset Plaid",
                                        "image": {
                                            "id": "2c8b6aa6-5651-3b16-8c06-2da278cd09d3",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2c8b6aa6-5651-3b16-8c06-2da278cd09d3.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Refined Navy/dark Garnet",
                                        "image": {
                                            "id": "083d2686-00b8-3480-a4fd-a1ae69bb362b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/083d2686-00b8-3480-a4fd-a1ae69bb362b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Rider Geo/taupe Brown",
                                        "image": {
                                            "id": "06859ecc-c608-3367-b20b-01c622282608",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/06859ecc-c608-3367-b20b-01c622282608.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Stratford Links Print/black",
                                        "image": {
                                            "id": "351776e3-9d79-37b6-90b0-4cca3b26e7e2",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/351776e3-9d79-37b6-90b0-4cca3b26e7e2.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_18557328",
                                "name": "Faux-Leather Reversible Tote Bag",
                                "nameCN": "大号手提包",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Lauren Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "handbag|women's fashion|handbags, wallets & accessories",
                                "categoryIds": [
                                    "e07"
                                ],
                                "priceTag": "$159.10",
                                "priceTagCN": "¥1165",
                                "originalPriceTag": "$227.25",
                                "officialURL": "https://www.macys.com/shop/product/lauren-ralph-lauren-large-reversible-extra-large-tote-bag?ID=18557328",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    }
                ]
            },
            {
                "id": "womens_shoes",
                "title": "女鞋榜",
                "categoryIds": [
                    "12",
                    "k1",
                    "7e"
                ],
                "sections": [],
                "sort": 2,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "6fb4fdea-37cb-369a-9bcc-1b0d610f48bb",
                                        "originalURL": "https://n.nordstrommedia.com/it/417f6c96-152f-4bbe-887f-8a5eadddbf4c.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6fb4fdea-37cb-369a-9bcc-1b0d610f48bb.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6fb4fdea-37cb-369a-9bcc-1b0d610f48bb.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0fc655f1-7f96-3003-9eb2-d1114954d844",
                                        "originalURL": "https://n.nordstrommedia.com/it/5d1542f0-43ba-49a8-8df7-62ca524fe981.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0fc655f1-7f96-3003-9eb2-d1114954d844.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0fc655f1-7f96-3003-9eb2-d1114954d844.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "cbf7752f-041a-3dce-8ea0-48d8050fad2b",
                                        "originalURL": "https://n.nordstrommedia.com/it/dc0f9511-bb27-4fe9-a8cf-ed3a374e5853.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cbf7752f-041a-3dce-8ea0-48d8050fad2b.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cbf7752f-041a-3dce-8ea0-48d8050fad2b.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "6c2beb84-ee82-3f00-bab6-4e121dc2e84d",
                                        "originalURL": "https://n.nordstrommedia.com/it/daffce7e-5bcf-49e7-bdb6-88dec8e28085.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6c2beb84-ee82-3f00-bab6-4e121dc2e84d.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6c2beb84-ee82-3f00-bab6-4e121dc2e84d.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "dd4798b6-2edb-3fa3-b46e-68bfad343500",
                                        "originalURL": "https://n.nordstrommedia.com/it/2136d1ab-f261-4056-8c20-04259c207703.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dd4798b6-2edb-3fa3-b46e-68bfad343500.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dd4798b6-2edb-3fa3-b46e-68bfad343500.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b8e4ba7f-4b41-3ce5-b7eb-ef0ab18ebc73",
                                        "originalURL": "https://n.nordstrommedia.com/it/d2a916b7-4a70-4adf-8562-2db5af5e4a99.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b8e4ba7f-4b41-3ce5-b7eb-ef0ab18ebc73.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b8e4ba7f-4b41-3ce5-b7eb-ef0ab18ebc73.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d59b9b5a-833e-3c17-92a5-bb9a76f39543",
                                        "originalURL": "https://n.nordstrommedia.com/it/191992cc-a835-4827-939d-756fb55dbd01.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d59b9b5a-833e-3c17-92a5-bb9a76f39543.jpg",
                                            "width": 560,
                                            "height": 336,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d59b9b5a-833e-3c17-92a5-bb9a76f39543.jpg",
                                            "width": 350,
                                            "height": 210,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Che",
                                        "image": {
                                            "id": "d54d8ec8-809c-303a-91f3-b74845027dfc",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d54d8ec8-809c-303a-91f3-b74845027dfc.jpg",
                                                "width": 31,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "nordstromrack_7518609",
                                "name": "Tazzlita Genuine Shearling Trim Platform Slipper",
                                "nameCN": "女款厚底保暖鞋",
                                "description": [],
                                "merchantId": "f8828b5b-30d5-d492-d151-7b87aec09f96",
                                "brand": "UGG®",
                                "displayBrand": "UGG",
                                "brandId": "0748f099-3da0-30ae-9370-d8ef28fb8766",
                                "category": "slippers|shoes|female|women",
                                "categoryIds": [
                                    "k18"
                                ],
                                "priceTag": "$99.65",
                                "priceTagCN": "¥730",
                                "originalPriceTag": "$166.15",
                                "officialURL": "https://www.nordstromrack.com/s/ugg-tazzlita-genuine-shearling-trim-platform-slipper-women/7518609",
                                "labels": [
                                    "ADULT",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_24",
                                            "eu_38",
                                            "uk_5",
                                            "us_7"
                                        ],
                                        "name": "7",
                                        "displayName": "欧码38(适合脚长24cm)",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "cm_25",
                                            "eu_39",
                                            "uk_6",
                                            "us_8"
                                        ],
                                        "name": "8",
                                        "displayName": "欧码39(适合脚长25cm)",
                                        "type": "eu",
                                        "label": "39"
                                    },
                                    {
                                        "ids": [
                                            "cm_26",
                                            "eu_40",
                                            "uk_7",
                                            "us_9"
                                        ],
                                        "name": "9",
                                        "displayName": "欧码40(适合脚长26cm)",
                                        "type": "eu",
                                        "label": "40"
                                    },
                                    {
                                        "ids": [
                                            "cm_27",
                                            "eu_41",
                                            "uk_8",
                                            "us_10"
                                        ],
                                        "name": "10",
                                        "displayName": "欧码41(适合脚长27cm)",
                                        "type": "eu",
                                        "label": "41"
                                    },
                                    {
                                        "ids": [
                                            "cm_28",
                                            "eu_42",
                                            "uk_9",
                                            "us_11"
                                        ],
                                        "name": "11",
                                        "displayName": "欧码42(适合脚长28cm)",
                                        "type": "eu",
                                        "label": "42"
                                    },
                                    {
                                        "ids": [
                                            "cm_29",
                                            "eu_43",
                                            "uk_10",
                                            "us_12"
                                        ],
                                        "name": "12",
                                        "displayName": "欧码43(适合脚长29cm)",
                                        "type": "eu",
                                        "label": "43"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5.9折",
                            "activityOffs": [],
                            "merchantName": "Nordstrom Rack",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "fb253eab-ec87-3b9d-9d57-3723311a92eb",
                                        "originalURL": "https://n.nordstrommedia.com/it/c3aace0e-ff10-47d9-b4b4-18e4880a48b2.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fb253eab-ec87-3b9d-9d57-3723311a92eb.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fb253eab-ec87-3b9d-9d57-3723311a92eb.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e4164eaa-1eb2-32f5-a2c7-0e4412bab62f",
                                        "originalURL": "https://n.nordstrommedia.com/it/9bc1e50e-d6ec-4ab5-93b7-4d016ed5b02c.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e4164eaa-1eb2-32f5-a2c7-0e4412bab62f.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e4164eaa-1eb2-32f5-a2c7-0e4412bab62f.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "956d2c00-30f9-33be-85e0-8889c8fdd691",
                                        "originalURL": "https://n.nordstrommedia.com/it/a984fb83-5112-4ed3-9c75-3af50f5f5899.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/956d2c00-30f9-33be-85e0-8889c8fdd691.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/956d2c00-30f9-33be-85e0-8889c8fdd691.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "44c3e050-46d4-3821-9e2e-69e31f519e42",
                                        "originalURL": "https://n.nordstrommedia.com/it/6431b401-3ed8-4d59-8268-a0de0391d2b5.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/44c3e050-46d4-3821-9e2e-69e31f519e42.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/44c3e050-46d4-3821-9e2e-69e31f519e42.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b2066f81-e931-3921-bae1-88ed79413533",
                                        "originalURL": "https://n.nordstrommedia.com/it/d6e75612-8a66-4b80-87ea-4d8485561f86.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b2066f81-e931-3921-bae1-88ed79413533.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b2066f81-e931-3921-bae1-88ed79413533.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "846e6a04-109d-3081-8db4-93d72e13481b",
                                        "originalURL": "https://n.nordstrommedia.com/it/fde1f601-f338-45e3-a966-e04bb8321c85.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/846e6a04-109d-3081-8db4-93d72e13481b.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/846e6a04-109d-3081-8db4-93d72e13481b.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a31a8089-66e9-3d08-9b72-9eb2b3a94e66",
                                        "originalURL": "https://n.nordstrommedia.com/it/17406db8-3e2b-4998-a673-2f1a76dfd54d.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a31a8089-66e9-3d08-9b72-9eb2b3a94e66.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a31a8089-66e9-3d08-9b72-9eb2b3a94e66.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ceaf4eb9-ff26-346c-8736-f8dacf2b6c5c",
                                        "originalURL": "https://n.nordstrommedia.com/it/5c9962b7-78a3-4c6a-a3fb-ea5dddb12858.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ceaf4eb9-ff26-346c-8736-f8dacf2b6c5c.jpg",
                                            "width": 560,
                                            "height": 336,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ceaf4eb9-ff26-346c-8736-f8dacf2b6c5c.jpg",
                                            "width": 350,
                                            "height": 210,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Cbg",
                                        "image": {
                                            "id": "65da2d88-eadf-34d8-ae0f-8ab3aa05aca4",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/65da2d88-eadf-34d8-ae0f-8ab3aa05aca4.jpg",
                                                "width": 31,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black / Birch",
                                        "image": {
                                            "id": "97711845-f528-3ae8-ba11-067baaf6b228",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/97711845-f528-3ae8-ba11-067baaf6b228.jpg",
                                                "width": 31,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Mustard Seed / Cream",
                                        "image": {
                                            "id": "53bd96f1-be81-32fa-b16d-9c7a3f290a0c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/53bd96f1-be81-32fa-b16d-9c7a3f290a0c.jpg",
                                                "width": 31,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "nordstromrack_8582203",
                                "name": "Tasman Waterproof Hybrid Slip-On",
                                "nameCN": "秋季男女同款 厚底塔斯曼时尚雪地靴（可能无鞋盒）",
                                "description": [],
                                "merchantId": "f8828b5b-30d5-d492-d151-7b87aec09f96",
                                "brand": "UGG®",
                                "displayBrand": "UGG",
                                "brandId": "0748f099-3da0-30ae-9370-d8ef28fb8766",
                                "category": "mens|men|slippers|shoes|male",
                                "categoryIds": [
                                    "k18",
                                    "k04"
                                ],
                                "priceTag": "$88.55",
                                "priceTagCN": "¥649",
                                "originalPriceTag": "$177.20",
                                "officialURL": "https://www.nordstromrack.com/s/ugg-tasman-waterproof-hybrid-slip-on-men/8582203",
                                "labels": [
                                    "ADULT",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_23",
                                            "eu_38",
                                            "uk_4",
                                            "us_5"
                                        ],
                                        "name": "5",
                                        "displayName": "欧码38(适合脚长23cm)",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "cm_24",
                                            "eu_39",
                                            "uk_5",
                                            "us_6"
                                        ],
                                        "name": "6",
                                        "displayName": "欧码39(适合脚长24cm)",
                                        "type": "eu",
                                        "label": "39"
                                    },
                                    {
                                        "ids": [
                                            "cm_25",
                                            "eu_40",
                                            "uk_6",
                                            "us_7"
                                        ],
                                        "name": "7",
                                        "displayName": "欧码40(适合脚长25cm)",
                                        "type": "eu",
                                        "label": "40"
                                    },
                                    {
                                        "ids": [
                                            "cm_26",
                                            "eu_41",
                                            "uk_7",
                                            "us_8"
                                        ],
                                        "name": "8",
                                        "displayName": "欧码41(适合脚长26cm)",
                                        "type": "eu",
                                        "label": "41"
                                    },
                                    {
                                        "ids": [
                                            "cm_33",
                                            "eu_49.5",
                                            "uk_14",
                                            "us_15"
                                        ],
                                        "name": "15",
                                        "displayName": "欧码49.5(适合脚长33cm)",
                                        "type": "eu",
                                        "label": "49.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_34",
                                            "eu_50.5",
                                            "uk_15",
                                            "us_16"
                                        ],
                                        "name": "16",
                                        "displayName": "欧码50.5(适合脚长34cm)",
                                        "type": "eu",
                                        "label": "50.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_35",
                                            "eu_51",
                                            "uk_16",
                                            "us_17"
                                        ],
                                        "name": "17",
                                        "displayName": "欧码51(适合脚长35cm)",
                                        "type": "eu",
                                        "label": "51"
                                    },
                                    {
                                        "ids": [
                                            "cm_36",
                                            "eu_52",
                                            "uk_17",
                                            "us_18"
                                        ],
                                        "name": "18",
                                        "displayName": "欧码52(适合脚长36cm)",
                                        "type": "eu",
                                        "label": "52"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.9折起",
                            "activityOffs": [],
                            "merchantName": "Nordstrom Rack",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.9折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "b438b974-2fdd-3159-a9ca-f0767f69085a",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/39914502_1l.jpg?v=1755912231",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b438b974-2fdd-3159-a9ca-f0767f69085a.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b438b974-2fdd-3159-a9ca-f0767f69085a.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "56d190ca-5e7b-34ac-99ef-1caecda0288d",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/39914502_2l.jpg?v=1755912231",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/56d190ca-5e7b-34ac-99ef-1caecda0288d.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/56d190ca-5e7b-34ac-99ef-1caecda0288d.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b2865069-0747-344e-96b3-60430d99de6a",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/39914502_3l.jpg?v=1755912231",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b2865069-0747-344e-96b3-60430d99de6a.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b2865069-0747-344e-96b3-60430d99de6a.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b5e4864f-a7f9-3f07-8d73-43e56a0db01b",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/39914502_4l.jpg?v=1755912231",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b5e4864f-a7f9-3f07-8d73-43e56a0db01b.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b5e4864f-a7f9-3f07-8d73-43e56a0db01b.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b1d607fe-64b9-3498-a90f-78da7a256238",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/39914502_5l.jpg?v=1755912231",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b1d607fe-64b9-3498-a90f-78da7a256238.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b1d607fe-64b9-3498-a90f-78da7a256238.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "shoebacca_9976619860250",
                                "name": "Amplifier Speckle Lace Up Sneakers",
                                "description": [],
                                "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                                "brand": "PUMA",
                                "displayBrand": "Puma",
                                "brandId": "d9f32436-125b-37e0-bd11-fbf1fa62424a",
                                "category": "women|puma|womens|sapg::puma38099 ~ color::black|adidas-puma-diadora|clearance|sneakers|casual|shoes|adult",
                                "categoryIds": [
                                    "7e0"
                                ],
                                "priceTag": "$40.65",
                                "priceTagCN": "¥298",
                                "originalPriceTag": "$71.25",
                                "officialURL": "https://www.shoebacca.com/products/amplifier-speckle-lace-up-sneakers-39914502",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_22",
                                            "eu_35.5",
                                            "uk_3",
                                            "us_5.5"
                                        ],
                                        "name": "5.5",
                                        "displayName": "欧码35.5(适合脚长22cm)",
                                        "type": "eu",
                                        "label": "35.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_22.5",
                                            "eu_36",
                                            "uk_3.5",
                                            "us_6"
                                        ],
                                        "name": "6",
                                        "displayName": "欧码36(适合脚长22.5cm)",
                                        "type": "eu",
                                        "label": "36"
                                    },
                                    {
                                        "ids": [
                                            "cm_23",
                                            "eu_37",
                                            "uk_4",
                                            "us_6.5"
                                        ],
                                        "name": "6.5",
                                        "displayName": "欧码37(适合脚长23cm)",
                                        "type": "eu",
                                        "label": "37"
                                    },
                                    {
                                        "ids": [
                                            "cm_23.5",
                                            "eu_37.5",
                                            "uk_4.5",
                                            "us_7"
                                        ],
                                        "name": "7",
                                        "displayName": "欧码37.5(适合脚长23.5cm)",
                                        "type": "eu",
                                        "label": "37.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_24",
                                            "eu_38",
                                            "uk_5",
                                            "us_7.5"
                                        ],
                                        "name": "7.5",
                                        "displayName": "欧码38(适合脚长24cm)",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "cm_24.5",
                                            "eu_38.5",
                                            "uk_5.5",
                                            "us_8"
                                        ],
                                        "name": "8",
                                        "displayName": "欧码38.5(适合脚长24.5cm)",
                                        "type": "eu",
                                        "label": "38.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_25",
                                            "eu_39",
                                            "uk_6",
                                            "us_8.5"
                                        ],
                                        "name": "8.5",
                                        "displayName": "欧码39(适合脚长25cm)",
                                        "type": "eu",
                                        "label": "39"
                                    },
                                    {
                                        "ids": [
                                            "cm_25.5",
                                            "eu_40",
                                            "uk_6.5",
                                            "us_9"
                                        ],
                                        "name": "9",
                                        "displayName": "欧码40(适合脚长25.5cm)",
                                        "type": "eu",
                                        "label": "40"
                                    },
                                    {
                                        "ids": [
                                            "cm_26",
                                            "eu_40.5",
                                            "uk_7",
                                            "us_9.5"
                                        ],
                                        "name": "9.5",
                                        "displayName": "欧码40.5(适合脚长26cm)",
                                        "type": "eu",
                                        "label": "40.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_26.5",
                                            "eu_41",
                                            "uk_7.5",
                                            "us_10"
                                        ],
                                        "name": "10",
                                        "displayName": "欧码41(适合脚长26.5cm)",
                                        "type": "eu",
                                        "label": "41"
                                    },
                                    {
                                        "ids": [
                                            "cm_27",
                                            "eu_42",
                                            "uk_8",
                                            "us_10.5"
                                        ],
                                        "name": "10.5",
                                        "displayName": "欧码42(适合脚长27cm)",
                                        "type": "eu",
                                        "label": "42"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5.7折",
                            "activityOffs": [],
                            "merchantName": "SHOEBACCA",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "tideShoes": true,
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5.7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "bde44cb5-b1b8-3888-875e-09436ddbd7ad",
                                        "originalURL": "https://n.nordstrommedia.com/it/bd8a3bec-df5f-49c2-9384-3f446145309d.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/bde44cb5-b1b8-3888-875e-09436ddbd7ad.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/bde44cb5-b1b8-3888-875e-09436ddbd7ad.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8a2f9901-c7c2-3d54-9631-8fd4fdae9384",
                                        "originalURL": "https://n.nordstrommedia.com/it/49b2f3cd-bf89-4fbe-af36-5ffc649456c6.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8a2f9901-c7c2-3d54-9631-8fd4fdae9384.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8a2f9901-c7c2-3d54-9631-8fd4fdae9384.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "756ba402-42d1-369c-9041-8f2def95c474",
                                        "originalURL": "https://n.nordstrommedia.com/it/726f9e88-b378-4ecb-a3ae-6012644128b1.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/756ba402-42d1-369c-9041-8f2def95c474.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/756ba402-42d1-369c-9041-8f2def95c474.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c089fda2-90ad-3d5c-9e19-c3b0a6a92e6a",
                                        "originalURL": "https://n.nordstrommedia.com/it/6559add0-8736-4d77-8605-c75706a81bc1.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c089fda2-90ad-3d5c-9e19-c3b0a6a92e6a.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c089fda2-90ad-3d5c-9e19-c3b0a6a92e6a.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5b79cd1a-60e5-30a6-a282-92fa22486641",
                                        "originalURL": "https://n.nordstrommedia.com/it/02edc0b5-4e89-4f48-b23d-52bb452240c1.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5b79cd1a-60e5-30a6-a282-92fa22486641.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5b79cd1a-60e5-30a6-a282-92fa22486641.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "f14b76bb-ef9a-3d8f-acf1-c1162e3aceca",
                                        "originalURL": "https://n.nordstrommedia.com/it/665abea5-a529-4def-89b4-0c382c0ba513.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f14b76bb-ef9a-3d8f-acf1-c1162e3aceca.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f14b76bb-ef9a-3d8f-acf1-c1162e3aceca.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "088a1168-1c35-36f4-91dc-daa4f269b39c",
                                        "originalURL": "https://n.nordstrommedia.com/it/88bf8cdc-5112-47ab-9f80-1d16c04c8a3f.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/088a1168-1c35-36f4-91dc-daa4f269b39c.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/088a1168-1c35-36f4-91dc-daa4f269b39c.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e89f424d-773d-34e9-9f16-7e1aa1ca6f64",
                                        "originalURL": "https://n.nordstrommedia.com/it/e9e9bcf6-d2f1-4532-9526-531e97c837bd.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e89f424d-773d-34e9-9f16-7e1aa1ca6f64.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e89f424d-773d-34e9-9f16-7e1aa1ca6f64.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b771125e-3988-3f94-94ea-461bac9516d6",
                                        "originalURL": "https://n.nordstrommedia.com/it/87d5c764-47a2-4474-b000-5d7de147bf28.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b771125e-3988-3f94-94ea-461bac9516d6.jpg",
                                            "width": 560,
                                            "height": 336,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b771125e-3988-3f94-94ea-461bac9516d6.jpg",
                                            "width": 350,
                                            "height": 210,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Blk",
                                        "image": {
                                            "id": "a1b17c06-086c-3825-9988-c4dcd87f1ab3",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a1b17c06-086c-3825-9988-c4dcd87f1ab3.jpg",
                                                "width": 31,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Che",
                                        "image": {
                                            "id": "c5ff8b4a-753e-3403-a699-6c008a1d5026",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c5ff8b4a-753e-3403-a699-6c008a1d5026.jpg",
                                                "width": 31,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "nordstromrack_7712178",
                                "name": "Classic Short Crescent Bootie",
                                "description": [],
                                "merchantId": "f8828b5b-30d5-d492-d151-7b87aec09f96",
                                "brand": "UGG®",
                                "displayBrand": "UGG",
                                "brandId": "0748f099-3da0-30ae-9370-d8ef28fb8766",
                                "category": "women|boots|female|shoes",
                                "categoryIds": [
                                    "k10"
                                ],
                                "priceTag": "$99.65",
                                "priceTagCN": "¥730",
                                "originalPriceTag": "$199.35",
                                "officialURL": "https://www.nordstromrack.com/s/ugg-classic-short-crescent-bootie-women/7712178",
                                "labels": [
                                    "ADULT",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_22",
                                            "eu_36",
                                            "uk_3",
                                            "us_5"
                                        ],
                                        "name": "5",
                                        "displayName": "欧码36(适合脚长22cm)",
                                        "type": "eu",
                                        "label": "36"
                                    },
                                    {
                                        "ids": [
                                            "cm_23",
                                            "eu_37",
                                            "uk_4",
                                            "us_6"
                                        ],
                                        "name": "6",
                                        "displayName": "欧码37(适合脚长23cm)",
                                        "type": "eu",
                                        "label": "37"
                                    },
                                    {
                                        "ids": [
                                            "cm_24",
                                            "eu_38",
                                            "uk_5",
                                            "us_7"
                                        ],
                                        "name": "7",
                                        "displayName": "欧码38(适合脚长24cm)",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "cm_25",
                                            "eu_39",
                                            "uk_6",
                                            "us_8"
                                        ],
                                        "name": "8",
                                        "displayName": "欧码39(适合脚长25cm)",
                                        "type": "eu",
                                        "label": "39"
                                    },
                                    {
                                        "ids": [
                                            "cm_26",
                                            "eu_40",
                                            "uk_7",
                                            "us_9"
                                        ],
                                        "name": "9",
                                        "displayName": "欧码40(适合脚长26cm)",
                                        "type": "eu",
                                        "label": "40"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.9折起",
                            "activityOffs": [],
                            "merchantName": "Nordstrom Rack",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.9折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "4e9ced69-0ac5-32d8-98eb-142c115b317b",
                                        "originalURL": "https://m.media-amazon.com/images/I/71KDJThrHML.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4e9ced69-0ac5-32d8-98eb-142c115b317b.jpg",
                                            "width": 878,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4e9ced69-0ac5-32d8-98eb-142c115b317b.jpg",
                                            "width": 300,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "11bc9c27-08fa-33a2-8a1d-b191b0539fde",
                                        "originalURL": "https://m.media-amazon.com/images/I/71O7-P75paL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/11bc9c27-08fa-33a2-8a1d-b191b0539fde.jpg",
                                            "width": 878,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/11bc9c27-08fa-33a2-8a1d-b191b0539fde.jpg",
                                            "width": 300,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "2c367fbc-71a1-34e2-b4b5-a5a876e52452",
                                        "originalURL": "https://m.media-amazon.com/images/I/71nwgkrYbhL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2c367fbc-71a1-34e2-b4b5-a5a876e52452.jpg",
                                            "width": 878,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2c367fbc-71a1-34e2-b4b5-a5a876e52452.jpg",
                                            "width": 300,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "f5218a15-6f2f-3407-b999-c3e30e589ad9",
                                        "originalURL": "https://m.media-amazon.com/images/I/71HkxtuOrfL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f5218a15-6f2f-3407-b999-c3e30e589ad9.jpg",
                                            "width": 1024,
                                            "height": 768,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f5218a15-6f2f-3407-b999-c3e30e589ad9.jpg",
                                            "width": 350,
                                            "height": 262,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5921b290-e566-39a6-a0d2-56b17074124b",
                                        "originalURL": "https://m.media-amazon.com/images/I/71wpXxk3sCL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5921b290-e566-39a6-a0d2-56b17074124b.jpg",
                                            "width": 878,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5921b290-e566-39a6-a0d2-56b17074124b.jpg",
                                            "width": 300,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "14155416-4973-3254-bcd6-467710d36c19",
                                        "originalURL": "https://m.media-amazon.com/images/I/811jCWlILWL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/14155416-4973-3254-bcd6-467710d36c19.jpg",
                                            "width": 878,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/14155416-4973-3254-bcd6-467710d36c19.jpg",
                                            "width": 300,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "57e43220-bccb-3fff-8d09-3bd9bd4ce6af",
                                        "originalURL": "https://m.media-amazon.com/images/I/61TVm293v3L.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/57e43220-bccb-3fff-8d09-3bd9bd4ce6af.jpg",
                                            "width": 878,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/57e43220-bccb-3fff-8d09-3bd9bd4ce6af.jpg",
                                            "width": 300,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black Extra Tough 50/50/Ajax",
                                        "image": {
                                            "id": "b8858ad4-ad87-3891-a192-c044ee2f01e5",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b8858ad4-ad87-3891-a192-c044ee2f01e5.jpg",
                                                "width": 43,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black Wyoming",
                                        "image": {
                                            "id": "e7c5b0b4-57dd-3189-b524-b98045e03485",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e7c5b0b4-57dd-3189-b524-b98045e03485.jpg",
                                                "width": 50,
                                                "height": 38,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Dark Brown Crazy Horse",
                                        "image": {
                                            "id": "0582cbc9-a768-3bc2-874f-c1b126997d0a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0582cbc9-a768-3bc2-874f-c1b126997d0a.jpg",
                                                "width": 43,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "zappos_9520939",
                                "name": "Reeder",
                                "nameCN": "马丁博士Reeder鞋  Coyseio主理人同款",
                                "description": [],
                                "merchantId": "725755ff-5f38-95fd-eec5-b3535bce2fd5",
                                "brand": "Dr. Martens",
                                "displayBrand": "Dr. Martens",
                                "brandId": "239cbe9a-021a-3368-b8f1-9e059d0b77fc",
                                "category": "free shipping|Women|men|zappos.com|reeder|shoes|Men|women|oxfords",
                                "categoryIds": [
                                    "k1d"
                                ],
                                "priceTag": "$73.60",
                                "priceTagCN": "¥539",
                                "originalPriceTag": "$98.10",
                                "officialURL": "https://www.zappos.com/p/unisex-dr-martens-reeder-dark-brown-crazy-horse/product/9520939/color/65553",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_22",
                                            "eu_36",
                                            "uk_3",
                                            "us_m_4",
                                            "us_w_5"
                                        ],
                                        "name": "UK 3 (US Men's 4, Women's 5)",
                                        "displayName": "欧码36(适合脚长22cm)",
                                        "type": "eu",
                                        "label": "36"
                                    },
                                    {
                                        "ids": [
                                            "cm_23",
                                            "eu_37",
                                            "uk_4",
                                            "us_m_5",
                                            "us_w_6"
                                        ],
                                        "name": "UK 4 (US Men's 5, Women's 6)",
                                        "displayName": "欧码37(适合脚长23cm)",
                                        "type": "eu",
                                        "label": "37"
                                    },
                                    {
                                        "ids": [
                                            "cm_23.5",
                                            "eu_38",
                                            "uk_5",
                                            "us_m_6",
                                            "us_w_7"
                                        ],
                                        "name": "UK 5 (US Men's 6, Women's 7)",
                                        "displayName": "欧码38(适合脚长23.5cm)",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "cm_24.5",
                                            "eu_39",
                                            "uk_6",
                                            "us_m_7",
                                            "us_w_8"
                                        ],
                                        "name": "UK 6 (US Men's 7, US Women's 8)",
                                        "displayName": "欧码39(适合脚长24.5cm)",
                                        "type": "eu",
                                        "label": "39"
                                    },
                                    {
                                        "ids": [
                                            "cm_25.5",
                                            "eu_41",
                                            "uk_7",
                                            "us_m_8",
                                            "us_w_9"
                                        ],
                                        "name": "UK 7 (US Men's 8, US Women's 9)",
                                        "displayName": "欧码41(适合脚长25.5cm)",
                                        "type": "eu",
                                        "label": "41"
                                    },
                                    {
                                        "ids": [
                                            "cm_26",
                                            "eu_42",
                                            "uk_8",
                                            "us_m_9",
                                            "us_w_10"
                                        ],
                                        "name": "UK 8 (US Men's 9, US Women's 10)",
                                        "displayName": "欧码42(适合脚长26cm)",
                                        "type": "eu",
                                        "label": "42"
                                    },
                                    {
                                        "ids": [
                                            "cm_27",
                                            "eu_43",
                                            "uk_9",
                                            "us_m_10",
                                            "us_w_11"
                                        ],
                                        "name": "UK 9 (US Men's 10, US Women's 11)",
                                        "displayName": "欧码43(适合脚长27cm)",
                                        "type": "eu",
                                        "label": "43"
                                    },
                                    {
                                        "ids": [
                                            "cm_28",
                                            "eu_45",
                                            "uk_10",
                                            "us_m_11",
                                            "us_w_12"
                                        ],
                                        "name": "UK 10 (US Men's 11, Women's 12)",
                                        "displayName": "欧码45(适合脚长28cm)",
                                        "type": "eu",
                                        "label": "45"
                                    },
                                    {
                                        "ids": [
                                            "cm_29",
                                            "eu_46",
                                            "uk_11",
                                            "us_m_12",
                                            "us_w_13"
                                        ],
                                        "name": "UK 11 (US Men's 12, Women's 13)",
                                        "displayName": "欧码46(适合脚长29cm)",
                                        "type": "eu",
                                        "label": "46"
                                    },
                                    {
                                        "ids": [
                                            "cm_29.5",
                                            "eu_47",
                                            "uk_12",
                                            "us_m_13",
                                            "us_w_14"
                                        ],
                                        "name": "UK 12 (US Men's 13, Women's 14)",
                                        "displayName": "欧码47(适合脚长29.5cm)",
                                        "type": "eu",
                                        "label": "47"
                                    },
                                    {
                                        "ids": [
                                            "eu_48",
                                            "uk_13",
                                            "us_m_14",
                                            "us_w_15"
                                        ],
                                        "name": "UK 13 (US Men's 14, Women's 15)",
                                        "displayName": "欧码48",
                                        "type": "eu",
                                        "label": "48"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7.2折起",
                            "activityOffs": [],
                            "merchantName": "Zappos",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "tideShoes": true,
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7.2折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "f0111688-00cd-3017-bbfd-15b0ff741971",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/29225186_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f0111688-00cd-3017-bbfd-15b0ff741971.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f0111688-00cd-3017-bbfd-15b0ff741971.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "32b7ad2e-a91f-3413-b600-9ab042084112",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/29224509_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/32b7ad2e-a91f-3413-b600-9ab042084112.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/32b7ad2e-a91f-3413-b600-9ab042084112.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "01f9ef61-4185-3114-8016-b2a7549c890e",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/29224451_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/01f9ef61-4185-3114-8016-b2a7549c890e.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/01f9ef61-4185-3114-8016-b2a7549c890e.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7827c94b-4ccd-34f0-b05d-7f9b05869ca1",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/29224504_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7827c94b-4ccd-34f0-b05d-7f9b05869ca1.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7827c94b-4ccd-34f0-b05d-7f9b05869ca1.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "dadb3f41-2691-3c3e-848c-fbb60fd3c9f6",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/29224454_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dadb3f41-2691-3c3e-848c-fbb60fd3c9f6.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dadb3f41-2691-3c3e-848c-fbb60fd3c9f6.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "e766c579-8bc3-370b-92ea-cac8c16293ae",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e766c579-8bc3-370b-92ea-cac8c16293ae.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Cognac",
                                        "image": {
                                            "id": "b7daeca2-c89a-3782-b521-24c0c0ecf0df",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b7daeca2-c89a-3782-b521-24c0c0ecf0df.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Olive",
                                        "image": {
                                            "id": "1db384b4-b3a4-3e3f-bae4-7bd23074a58b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1db384b4-b3a4-3e3f-bae4-7bd23074a58b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Slate Blue",
                                        "image": {
                                            "id": "ff2085da-2f6b-368e-81f7-a6ea00638ed6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ff2085da-2f6b-368e-81f7-a6ea00638ed6.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_24000151",
                                "name": "Women's Oney Closed Toe Slippers",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Juicy Couture",
                                "displayBrand": "Juicy Couture",
                                "brandId": "5cb502e0-ff52-341b-a304-54307164573c",
                                "category": "shoe|women's fashion|slippers",
                                "categoryIds": [
                                    "k18"
                                ],
                                "priceTag": "$31.10",
                                "priceTagCN": "¥228",
                                "originalPriceTag": "$55.55",
                                "officialURL": "https://www.macys.com/shop/product/juicy-couture-womens-oney-closed-toe-slippers?ID=24000151",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "us_6.0",
                                            "eu_36.0"
                                        ],
                                        "name": "6M",
                                        "displayName": "欧码36.0",
                                        "type": "eu",
                                        "label": "36"
                                    },
                                    {
                                        "ids": [
                                            "us_7.0",
                                            "eu_37.0"
                                        ],
                                        "name": "7M",
                                        "displayName": "欧码37.0",
                                        "type": "eu",
                                        "label": "37"
                                    },
                                    {
                                        "ids": [
                                            "us_8.0",
                                            "eu_38.0"
                                        ],
                                        "name": "8M",
                                        "displayName": "欧码38.0",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "us_9.0",
                                            "eu_39.0"
                                        ],
                                        "name": "9M",
                                        "displayName": "欧码39.0",
                                        "type": "eu",
                                        "label": "39"
                                    },
                                    {
                                        "ids": [
                                            "us_10.0",
                                            "eu_40.0"
                                        ],
                                        "name": "10M",
                                        "displayName": "欧码40.0",
                                        "type": "eu",
                                        "label": "40"
                                    },
                                    {
                                        "ids": [
                                            "us_11.0",
                                            "eu_41.0"
                                        ],
                                        "name": "11M",
                                        "displayName": "欧码41.0",
                                        "type": "eu",
                                        "label": "41"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5.5折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5.5折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "bd20ea55-2393-3fef-bfd5-3a214496a650",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/25561147_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/bd20ea55-2393-3fef-bfd5-3a214496a650.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/bd20ea55-2393-3fef-bfd5-3a214496a650.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5f161ca8-b09d-3efa-bfc8-916b7fbfd6d5",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/25561148_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5f161ca8-b09d-3efa-bfc8-916b7fbfd6d5.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5f161ca8-b09d-3efa-bfc8-916b7fbfd6d5.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "3fde3340-d61b-3a5b-bfe8-de90a59f9f22",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/25561149_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3fde3340-d61b-3a5b-bfe8-de90a59f9f22.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3fde3340-d61b-3a5b-bfe8-de90a59f9f22.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "2454c28b-dac4-3465-b39d-9d0675c1e3e6",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/25561150_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2454c28b-dac4-3465-b39d-9d0675c1e3e6.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2454c28b-dac4-3465-b39d-9d0675c1e3e6.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "419f3004-7785-31dd-8842-2b0e5a56d273",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/25561145_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/419f3004-7785-31dd-8842-2b0e5a56d273.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/419f3004-7785-31dd-8842-2b0e5a56d273.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "3e9a35f3-f916-3d55-af7f-5a9f2c72e632",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3e9a35f3-f916-3d55-af7f-5a9f2c72e632.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Cognac",
                                        "image": {
                                            "id": "e991a528-1558-3f20-a73a-db64eff9b1ce",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e991a528-1558-3f20-a73a-db64eff9b1ce.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Red",
                                        "image": {
                                            "id": "207d9dc1-2da6-364f-8594-7327a76cba8a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/207d9dc1-2da6-364f-8594-7327a76cba8a.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Blush",
                                        "image": {
                                            "id": "f143392b-fe0a-31ca-987e-74b5bf4f1e73",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f143392b-fe0a-31ca-987e-74b5bf4f1e73.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Light Natural",
                                        "image": {
                                            "id": "fe984e1f-2ab0-3268-a614-d87d64bc0e19",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fe984e1f-2ab0-3268-a614-d87d64bc0e19.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Leopard",
                                        "image": {
                                            "id": "65bc321a-cc0f-392c-adaf-2005256470b8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/65bc321a-cc0f-392c-adaf-2005256470b8.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Slate Blue",
                                        "image": {
                                            "id": "86414e35-5184-3e3f-89cb-e8d7e184c385",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/86414e35-5184-3e3f-89cb-e8d7e184c385.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_16504300",
                                "name": "Women's King Cozy Cold Weather Booties",
                                "nameCN": "女士 舒适冬靴",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Juicy Couture",
                                "displayBrand": "Juicy Couture",
                                "brandId": "5cb502e0-ff52-341b-a304-54307164573c",
                                "category": "shoe|women's fashion|boots",
                                "categoryIds": [
                                    "k10"
                                ],
                                "priceTag": "$45.10",
                                "priceTagCN": "¥331",
                                "originalPriceTag": "$80.60",
                                "officialURL": "https://www.macys.com/shop/product/juicy-couture-womens-king-cozy-cold-weather-booties?ID=16504300",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "us_5.0",
                                            "eu_35.0"
                                        ],
                                        "name": "5M",
                                        "displayName": "欧码35.0",
                                        "type": "eu",
                                        "label": "35"
                                    },
                                    {
                                        "ids": [
                                            "us_6.0",
                                            "eu_36.0"
                                        ],
                                        "name": "6M",
                                        "displayName": "欧码36.0",
                                        "type": "eu",
                                        "label": "36"
                                    },
                                    {
                                        "ids": [
                                            "us_7.0",
                                            "eu_37.0"
                                        ],
                                        "name": "7M",
                                        "displayName": "欧码37.0",
                                        "type": "eu",
                                        "label": "37"
                                    },
                                    {
                                        "ids": [
                                            "us_8.0",
                                            "eu_38.0"
                                        ],
                                        "name": "8M",
                                        "displayName": "欧码38.0",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "us_9.0",
                                            "eu_39.0"
                                        ],
                                        "name": "9M",
                                        "displayName": "欧码39.0",
                                        "type": "eu",
                                        "label": "39"
                                    },
                                    {
                                        "ids": [
                                            "us_10.0",
                                            "eu_40.0"
                                        ],
                                        "name": "10M",
                                        "displayName": "欧码40.0",
                                        "type": "eu",
                                        "label": "40"
                                    },
                                    {
                                        "ids": [
                                            "us_11.0",
                                            "eu_41.0"
                                        ],
                                        "name": "11M",
                                        "displayName": "欧码41.0",
                                        "type": "eu",
                                        "label": "41"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5.5折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5.5折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "4a24eb73-1a08-3133-b4fe-cd910de772bf",
                                        "originalURL": "https://res.cloudinary.com/ssenseweb/image/upload/241799F127021_1.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4a24eb73-1a08-3133-b4fe-cd910de772bf.jpg",
                                            "width": 856,
                                            "height": 512,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4a24eb73-1a08-3133-b4fe-cd910de772bf.jpg",
                                            "width": 350,
                                            "height": 209,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "f6e2302f-5215-322e-91a8-0bdcf773f996",
                                        "originalURL": "https://res.cloudinary.com/ssenseweb/image/upload/241799F127021_2.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f6e2302f-5215-322e-91a8-0bdcf773f996.jpg",
                                            "width": 856,
                                            "height": 712,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f6e2302f-5215-322e-91a8-0bdcf773f996.jpg",
                                            "width": 350,
                                            "height": 291,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ee7fc030-e15d-3a41-a373-8ac8d75a1c4e",
                                        "originalURL": "https://res.cloudinary.com/ssenseweb/image/upload/241799F127021_3.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ee7fc030-e15d-3a41-a373-8ac8d75a1c4e.jpg",
                                            "width": 856,
                                            "height": 512,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ee7fc030-e15d-3a41-a373-8ac8d75a1c4e.jpg",
                                            "width": 350,
                                            "height": 209,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4dce39a2-6150-372c-92f3-16f8f8c23b96",
                                        "originalURL": "https://res.cloudinary.com/ssenseweb/image/upload/241799F127021_4.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4dce39a2-6150-372c-92f3-16f8f8c23b96.jpg",
                                            "width": 856,
                                            "height": 528,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4dce39a2-6150-372c-92f3-16f8f8c23b96.jpg",
                                            "width": 350,
                                            "height": 216,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "abd1a446-4aec-3052-9402-8f9069bef67f",
                                        "originalURL": "https://res.cloudinary.com/ssenseweb/image/upload/241799F127021_5.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/abd1a446-4aec-3052-9402-8f9069bef67f.jpg",
                                            "width": 334,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/abd1a446-4aec-3052-9402-8f9069bef67f.jpg",
                                            "width": 114,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "ssenseus_14363761",
                                "name": "Black Chuck Taylor All Star Pro Sneakers",
                                "nameCN": "匡威Black Chuck Taylor All Star Pro运动鞋",
                                "description": [],
                                "merchantId": "ddaac9a3-3bca-3cfb-9503-421dd9b59f3a",
                                "brand": "Converse",
                                "displayBrand": "Converse",
                                "brandId": "6a97ca61-7ed8-3bd8-8a75-ff9ca539a4e4",
                                "category": "women|high top sneakers",
                                "categoryIds": [
                                    "7e3"
                                ],
                                "priceTag": "$22.60",
                                "priceTagCN": "¥166",
                                "originalPriceTag": "$90.40",
                                "officialURL": "https://www.ssense.com/en-us/women/product/converse/black-chuck-taylor-all-star-pro-sneakers/14363761",
                                "labels": [
                                    "final_sale",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_22",
                                            "eu_35",
                                            "uk_3",
                                            "us_5"
                                        ],
                                        "name": "US 5 = IT 35",
                                        "displayName": "欧码35(适合脚长22cm)",
                                        "type": "eu",
                                        "label": "35"
                                    },
                                    {
                                        "ids": [
                                            "cm_22.5",
                                            "eu_36",
                                            "uk_3.5",
                                            "us_5.5"
                                        ],
                                        "name": "US 5.5 = IT 35.5",
                                        "displayName": "欧码36(适合脚长22.5cm)",
                                        "type": "eu",
                                        "label": "36"
                                    },
                                    {
                                        "ids": [
                                            "cm_23",
                                            "eu_36.5",
                                            "uk_4",
                                            "us_6"
                                        ],
                                        "name": "US 6 = IT 36",
                                        "displayName": "欧码36.5(适合脚长23cm)",
                                        "type": "eu",
                                        "label": "36.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_23.5",
                                            "eu_37",
                                            "uk_4.5",
                                            "us_6.5"
                                        ],
                                        "name": "US 6.5 = IT 36.5",
                                        "displayName": "欧码37(适合脚长23.5cm)",
                                        "type": "eu",
                                        "label": "37"
                                    },
                                    {
                                        "ids": [
                                            "cm_24",
                                            "eu_37.5",
                                            "uk_5",
                                            "us_7"
                                        ],
                                        "name": "US 7 = IT 37",
                                        "displayName": "欧码37.5(适合脚长24cm)",
                                        "type": "eu",
                                        "label": "37.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_24.5",
                                            "eu_38",
                                            "uk_5.5",
                                            "us_7.5"
                                        ],
                                        "name": "US 7.5 = IT 37.5",
                                        "displayName": "欧码38(适合脚长24.5cm)",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "cm_24.5",
                                            "eu_39",
                                            "uk_6",
                                            "us_8"
                                        ],
                                        "name": "US 8 = IT 38",
                                        "displayName": "欧码39(适合脚长24.5cm)",
                                        "type": "eu",
                                        "label": "39"
                                    },
                                    {
                                        "ids": [
                                            "cm_25",
                                            "eu_39.5",
                                            "uk_6.5",
                                            "us_8.5"
                                        ],
                                        "name": "US 8.5 = IT 38.5",
                                        "displayName": "欧码39.5(适合脚长25cm)",
                                        "type": "eu",
                                        "label": "39.5"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.5折",
                            "activityOffs": [],
                            "merchantName": "Ssense US",
                            "origin": "[加拿大]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "tideShoes": true,
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.5折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "加拿大"
                        }
                    }
                ]
            },
            {
                "id": "mens_shoes",
                "title": "男鞋榜",
                "categoryIds": [
                    "22",
                    "k0",
                    "71",
                    "75"
                ],
                "sections": [],
                "sort": 3,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "c067c13d-5b04-3b3c-86a1-e10cdf594a5e",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IG8188_1l.jpg?v=1729219603",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c067c13d-5b04-3b3c-86a1-e10cdf594a5e.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c067c13d-5b04-3b3c-86a1-e10cdf594a5e.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "af82903a-5322-31ab-bca7-96781c0f7878",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IG8188_2l.jpg?v=1729219603",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/af82903a-5322-31ab-bca7-96781c0f7878.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/af82903a-5322-31ab-bca7-96781c0f7878.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7aa18b4b-ee1a-3fc0-871e-8f59bbfea4d7",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IG8188_3l.jpg?v=1729219604",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7aa18b4b-ee1a-3fc0-871e-8f59bbfea4d7.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7aa18b4b-ee1a-3fc0-871e-8f59bbfea4d7.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "cac2af96-2138-3866-9681-1035835e1535",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IG8188_4l.jpg?v=1729219604",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cac2af96-2138-3866-9681-1035835e1535.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cac2af96-2138-3866-9681-1035835e1535.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "shoebacca_9635520184602",
                                "name": "adidas Yeezy 950 Round Toe Lace Up Boots",
                                "nameCN": "Yeezy 950 Boots 男款 短筒 户外靴 舒适百搭  IG8188",
                                "description": [],
                                "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                                "brand": "adidas",
                                "displayBrand": "Adidas",
                                "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                                "category": "casual|sapg::adi08277 ~ color::black|adult|shoes|men|boots|mens|adidas|clearance",
                                "categoryIds": [
                                    "k05"
                                ],
                                "priceTag": "$254.95",
                                "priceTagCN": "¥1867",
                                "originalPriceTag": "$612",
                                "officialURL": "https://www.shoebacca.com/products/adidas-yeezy-950-lace-up-boots-ig8188",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_23",
                                            "eu_37 1/3",
                                            "uk_4.5",
                                            "us_5"
                                        ],
                                        "name": "5",
                                        "displayName": "欧码37 1/3(适合脚长23cm)",
                                        "type": "eu",
                                        "label": "37 1/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_23.5",
                                            "eu_38",
                                            "uk_5",
                                            "us_5.5"
                                        ],
                                        "name": "5.5",
                                        "displayName": "欧码38(适合脚长23.5cm)",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "cm_24",
                                            "eu_38 2/3",
                                            "uk_5.5",
                                            "us_6"
                                        ],
                                        "name": "6",
                                        "displayName": "欧码38 2/3(适合脚长24cm)",
                                        "type": "eu",
                                        "label": "38 2/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_24.5",
                                            "eu_39 1/3",
                                            "uk_6",
                                            "us_6.5"
                                        ],
                                        "name": "6.5",
                                        "displayName": "欧码39 1/3(适合脚长24.5cm)",
                                        "type": "eu",
                                        "label": "39 1/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_25",
                                            "eu_40",
                                            "uk_6.5",
                                            "us_7"
                                        ],
                                        "name": "7",
                                        "displayName": "欧码40(适合脚长25cm)",
                                        "type": "eu",
                                        "label": "40"
                                    },
                                    {
                                        "ids": [
                                            "cm_25.5",
                                            "eu_40 2/3",
                                            "uk_7",
                                            "us_7.5"
                                        ],
                                        "name": "7.5",
                                        "displayName": "欧码40 2/3(适合脚长25.5cm)",
                                        "type": "eu",
                                        "label": "40 2/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_26",
                                            "eu_41 1/3",
                                            "uk_7.5",
                                            "us_8"
                                        ],
                                        "name": "8",
                                        "displayName": "欧码41 1/3(适合脚长26cm)",
                                        "type": "eu",
                                        "label": "41 1/3"
                                    },
                                    {
                                        "ids": [
                                            "us_17.0",
                                            "eu_53  1/3",
                                            "cm_35.0"
                                        ],
                                        "name": "17",
                                        "displayName": "欧码53  1/3(适合脚长35.0cm)",
                                        "type": "eu",
                                        "label": "53  1/3"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.1折",
                            "activityOffs": [],
                            "merchantName": "SHOEBACCA",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.1折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "fb253eab-ec87-3b9d-9d57-3723311a92eb",
                                        "originalURL": "https://n.nordstrommedia.com/it/c3aace0e-ff10-47d9-b4b4-18e4880a48b2.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fb253eab-ec87-3b9d-9d57-3723311a92eb.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fb253eab-ec87-3b9d-9d57-3723311a92eb.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e4164eaa-1eb2-32f5-a2c7-0e4412bab62f",
                                        "originalURL": "https://n.nordstrommedia.com/it/9bc1e50e-d6ec-4ab5-93b7-4d016ed5b02c.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e4164eaa-1eb2-32f5-a2c7-0e4412bab62f.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e4164eaa-1eb2-32f5-a2c7-0e4412bab62f.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "956d2c00-30f9-33be-85e0-8889c8fdd691",
                                        "originalURL": "https://n.nordstrommedia.com/it/a984fb83-5112-4ed3-9c75-3af50f5f5899.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/956d2c00-30f9-33be-85e0-8889c8fdd691.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/956d2c00-30f9-33be-85e0-8889c8fdd691.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "44c3e050-46d4-3821-9e2e-69e31f519e42",
                                        "originalURL": "https://n.nordstrommedia.com/it/6431b401-3ed8-4d59-8268-a0de0391d2b5.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/44c3e050-46d4-3821-9e2e-69e31f519e42.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/44c3e050-46d4-3821-9e2e-69e31f519e42.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b2066f81-e931-3921-bae1-88ed79413533",
                                        "originalURL": "https://n.nordstrommedia.com/it/d6e75612-8a66-4b80-87ea-4d8485561f86.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b2066f81-e931-3921-bae1-88ed79413533.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b2066f81-e931-3921-bae1-88ed79413533.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "846e6a04-109d-3081-8db4-93d72e13481b",
                                        "originalURL": "https://n.nordstrommedia.com/it/fde1f601-f338-45e3-a966-e04bb8321c85.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/846e6a04-109d-3081-8db4-93d72e13481b.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/846e6a04-109d-3081-8db4-93d72e13481b.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a31a8089-66e9-3d08-9b72-9eb2b3a94e66",
                                        "originalURL": "https://n.nordstrommedia.com/it/17406db8-3e2b-4998-a673-2f1a76dfd54d.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a31a8089-66e9-3d08-9b72-9eb2b3a94e66.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a31a8089-66e9-3d08-9b72-9eb2b3a94e66.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ceaf4eb9-ff26-346c-8736-f8dacf2b6c5c",
                                        "originalURL": "https://n.nordstrommedia.com/it/5c9962b7-78a3-4c6a-a3fb-ea5dddb12858.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ceaf4eb9-ff26-346c-8736-f8dacf2b6c5c.jpg",
                                            "width": 560,
                                            "height": 336,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ceaf4eb9-ff26-346c-8736-f8dacf2b6c5c.jpg",
                                            "width": 350,
                                            "height": 210,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Cbg",
                                        "image": {
                                            "id": "65da2d88-eadf-34d8-ae0f-8ab3aa05aca4",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/65da2d88-eadf-34d8-ae0f-8ab3aa05aca4.jpg",
                                                "width": 31,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black / Birch",
                                        "image": {
                                            "id": "97711845-f528-3ae8-ba11-067baaf6b228",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/97711845-f528-3ae8-ba11-067baaf6b228.jpg",
                                                "width": 31,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Mustard Seed / Cream",
                                        "image": {
                                            "id": "53bd96f1-be81-32fa-b16d-9c7a3f290a0c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/53bd96f1-be81-32fa-b16d-9c7a3f290a0c.jpg",
                                                "width": 31,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "nordstromrack_8582203",
                                "name": "Tasman Waterproof Hybrid Slip-On",
                                "nameCN": "秋季男女同款 厚底塔斯曼时尚雪地靴（可能无鞋盒）",
                                "description": [],
                                "merchantId": "f8828b5b-30d5-d492-d151-7b87aec09f96",
                                "brand": "UGG®",
                                "displayBrand": "UGG",
                                "brandId": "0748f099-3da0-30ae-9370-d8ef28fb8766",
                                "category": "mens|men|slippers|shoes|male",
                                "categoryIds": [
                                    "k18",
                                    "k04"
                                ],
                                "priceTag": "$88.55",
                                "priceTagCN": "¥649",
                                "originalPriceTag": "$177.20",
                                "officialURL": "https://www.nordstromrack.com/s/ugg-tasman-waterproof-hybrid-slip-on-men/8582203",
                                "labels": [
                                    "ADULT",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_23",
                                            "eu_38",
                                            "uk_4",
                                            "us_5"
                                        ],
                                        "name": "5",
                                        "displayName": "欧码38(适合脚长23cm)",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "cm_24",
                                            "eu_39",
                                            "uk_5",
                                            "us_6"
                                        ],
                                        "name": "6",
                                        "displayName": "欧码39(适合脚长24cm)",
                                        "type": "eu",
                                        "label": "39"
                                    },
                                    {
                                        "ids": [
                                            "cm_25",
                                            "eu_40",
                                            "uk_6",
                                            "us_7"
                                        ],
                                        "name": "7",
                                        "displayName": "欧码40(适合脚长25cm)",
                                        "type": "eu",
                                        "label": "40"
                                    },
                                    {
                                        "ids": [
                                            "cm_26",
                                            "eu_41",
                                            "uk_7",
                                            "us_8"
                                        ],
                                        "name": "8",
                                        "displayName": "欧码41(适合脚长26cm)",
                                        "type": "eu",
                                        "label": "41"
                                    },
                                    {
                                        "ids": [
                                            "cm_33",
                                            "eu_49.5",
                                            "uk_14",
                                            "us_15"
                                        ],
                                        "name": "15",
                                        "displayName": "欧码49.5(适合脚长33cm)",
                                        "type": "eu",
                                        "label": "49.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_34",
                                            "eu_50.5",
                                            "uk_15",
                                            "us_16"
                                        ],
                                        "name": "16",
                                        "displayName": "欧码50.5(适合脚长34cm)",
                                        "type": "eu",
                                        "label": "50.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_35",
                                            "eu_51",
                                            "uk_16",
                                            "us_17"
                                        ],
                                        "name": "17",
                                        "displayName": "欧码51(适合脚长35cm)",
                                        "type": "eu",
                                        "label": "51"
                                    },
                                    {
                                        "ids": [
                                            "cm_36",
                                            "eu_52",
                                            "uk_17",
                                            "us_18"
                                        ],
                                        "name": "18",
                                        "displayName": "欧码52(适合脚长36cm)",
                                        "type": "eu",
                                        "label": "52"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.9折起",
                            "activityOffs": [],
                            "merchantName": "Nordstrom Rack",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.9折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "269a2ce3-373d-369f-992b-f882f9fc3e62",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IF6683_1l.jpg?v=1731448550",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/269a2ce3-373d-369f-992b-f882f9fc3e62.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/269a2ce3-373d-369f-992b-f882f9fc3e62.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "2ae56010-9ae0-3891-8f66-f9b11fbcffd8",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IF6683_2l.jpg?v=1731448550",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2ae56010-9ae0-3891-8f66-f9b11fbcffd8.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2ae56010-9ae0-3891-8f66-f9b11fbcffd8.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "811bba22-819e-3fb8-b8c6-ddb7d99ef648",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IF6683_3l.jpg?v=1731448550",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/811bba22-819e-3fb8-b8c6-ddb7d99ef648.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/811bba22-819e-3fb8-b8c6-ddb7d99ef648.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "019f5171-3142-3703-83b8-2bf608c916f9",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IF6683_4l.jpg?v=1731448550",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/019f5171-3142-3703-83b8-2bf608c916f9.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/019f5171-3142-3703-83b8-2bf608c916f9.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "shoebacca_9677114245402",
                                "name": "Fear of God x Athletics 86 Hi High Top Sneakers",
                                "nameCN": "男款 FOG联名 Athletics 86系列 高帮休闲运动鞋",
                                "description": [],
                                "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                                "brand": "adidas",
                                "displayBrand": "Adidas",
                                "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                                "category": "adult|adidas|clearance|shoes|men|casual|mens|sneakers|sapg::adi08794 ~ color::beige",
                                "categoryIds": [
                                    "751"
                                ],
                                "priceTag": "$81.55",
                                "priceTagCN": "¥598",
                                "originalPriceTag": "$224.40",
                                "officialURL": "https://www.shoebacca.com/products/fear-of-god-x-athletics-86-hi-high-top-sneakers-if6683",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_22",
                                            "eu_36",
                                            "uk_3.5",
                                            "us_4"
                                        ],
                                        "name": "4",
                                        "displayName": "欧码36(适合脚长22cm)",
                                        "type": "eu",
                                        "label": "36"
                                    },
                                    {
                                        "ids": [
                                            "cm_22.5",
                                            "eu_36 2/3",
                                            "uk_4",
                                            "us_4.5"
                                        ],
                                        "name": "4.5",
                                        "displayName": "欧码36 2/3(适合脚长22.5cm)",
                                        "type": "eu",
                                        "label": "36 2/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_23",
                                            "eu_37 1/3",
                                            "uk_4.5",
                                            "us_5"
                                        ],
                                        "name": "5",
                                        "displayName": "欧码37 1/3(适合脚长23cm)",
                                        "type": "eu",
                                        "label": "37 1/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_23.5",
                                            "eu_38",
                                            "uk_5",
                                            "us_5.5"
                                        ],
                                        "name": "5.5",
                                        "displayName": "欧码38(适合脚长23.5cm)",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "cm_24",
                                            "eu_38 2/3",
                                            "uk_5.5",
                                            "us_6"
                                        ],
                                        "name": "6",
                                        "displayName": "欧码38 2/3(适合脚长24cm)",
                                        "type": "eu",
                                        "label": "38 2/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_24.5",
                                            "eu_39 1/3",
                                            "uk_6",
                                            "us_6.5"
                                        ],
                                        "name": "6.5",
                                        "displayName": "欧码39 1/3(适合脚长24.5cm)",
                                        "type": "eu",
                                        "label": "39 1/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_25",
                                            "eu_40",
                                            "uk_6.5",
                                            "us_7"
                                        ],
                                        "name": "7",
                                        "displayName": "欧码40(适合脚长25cm)",
                                        "type": "eu",
                                        "label": "40"
                                    },
                                    {
                                        "ids": [
                                            "cm_25.5",
                                            "eu_40 2/3",
                                            "uk_7",
                                            "us_7.5"
                                        ],
                                        "name": "7.5",
                                        "displayName": "欧码40 2/3(适合脚长25.5cm)",
                                        "type": "eu",
                                        "label": "40 2/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_26",
                                            "eu_41 1/3",
                                            "uk_7.5",
                                            "us_8"
                                        ],
                                        "name": "8",
                                        "displayName": "欧码41 1/3(适合脚长26cm)",
                                        "type": "eu",
                                        "label": "41 1/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_26.5",
                                            "eu_42",
                                            "uk_8",
                                            "us_8.5"
                                        ],
                                        "name": "8.5",
                                        "displayName": "欧码42(适合脚长26.5cm)",
                                        "type": "eu",
                                        "label": "42"
                                    },
                                    {
                                        "ids": [
                                            "cm_27",
                                            "eu_42 2/3",
                                            "uk_8.5",
                                            "us_9"
                                        ],
                                        "name": "9",
                                        "displayName": "欧码42 2/3(适合脚长27cm)",
                                        "type": "eu",
                                        "label": "42 2/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_27.5",
                                            "eu_43 1/3",
                                            "uk_9",
                                            "us_9.5"
                                        ],
                                        "name": "9.5",
                                        "displayName": "欧码43 1/3(适合脚长27.5cm)",
                                        "type": "eu",
                                        "label": "43 1/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_28",
                                            "eu_44",
                                            "uk_9.5",
                                            "us_10"
                                        ],
                                        "name": "10",
                                        "displayName": "欧码44(适合脚长28cm)",
                                        "type": "eu",
                                        "label": "44"
                                    },
                                    {
                                        "ids": [
                                            "cm_28.5",
                                            "eu_44 2/3",
                                            "uk_10",
                                            "us_10.5"
                                        ],
                                        "name": "10.5",
                                        "displayName": "欧码44 2/3(适合脚长28.5cm)",
                                        "type": "eu",
                                        "label": "44 2/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_29",
                                            "eu_45 1/3",
                                            "uk_10.5",
                                            "us_11"
                                        ],
                                        "name": "11",
                                        "displayName": "欧码45 1/3(适合脚长29cm)",
                                        "type": "eu",
                                        "label": "45 1/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_29.5",
                                            "eu_46",
                                            "uk_11",
                                            "us_11.5"
                                        ],
                                        "name": "11.5",
                                        "displayName": "欧码46(适合脚长29.5cm)",
                                        "type": "eu",
                                        "label": "46"
                                    },
                                    {
                                        "ids": [
                                            "cm_30.5",
                                            "eu_47 1/3",
                                            "uk_12",
                                            "us_12.5"
                                        ],
                                        "name": "12.5",
                                        "displayName": "欧码47 1/3(适合脚长30.5cm)",
                                        "type": "eu",
                                        "label": "47 1/3"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "3.6折",
                            "activityOffs": [],
                            "merchantName": "SHOEBACCA",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "tideShoes": true,
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "3.6折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "fecb7dbb-6853-332d-aa91-f595a14ed442",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/19NIKANKHGHJMPLTBTRC_White_Obsidian_Crimson?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fecb7dbb-6853-332d-aa91-f595a14ed442.jpg",
                                            "width": 800,
                                            "height": 346,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fecb7dbb-6853-332d-aa91-f595a14ed442.jpg",
                                            "width": 350,
                                            "height": 151,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e09239f0-1b4a-3636-9ff8-8ae3ea10f13d",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/FZ9636-101_WhiteRed_TOP?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e09239f0-1b4a-3636-9ff8-8ae3ea10f13d.jpg",
                                            "width": 783,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e09239f0-1b4a-3636-9ff8-8ae3ea10f13d.jpg",
                                            "width": 268,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "81972643-1c83-3213-916c-76a49ab6737e",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/FZ9636-101_WhiteRed_SOLE?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/81972643-1c83-3213-916c-76a49ab6737e.jpg",
                                            "width": 800,
                                            "height": 296,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/81972643-1c83-3213-916c-76a49ab6737e.jpg",
                                            "width": 350,
                                            "height": 130,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c84b656c-0516-32ff-b643-f01e6f5843ca",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/FZ9636-101_WhiteRed_INS?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c84b656c-0516-32ff-b643-f01e6f5843ca.jpg",
                                            "width": 800,
                                            "height": 341,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c84b656c-0516-32ff-b643-f01e6f5843ca.jpg",
                                            "width": 350,
                                            "height": 149,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "3aee0413-165c-3d74-b154-99f930144c6e",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/FZ9636-101_WhiteRed_BCK?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3aee0413-165c-3d74-b154-99f930144c6e.jpg",
                                            "width": 800,
                                            "height": 490,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3aee0413-165c-3d74-b154-99f930144c6e.jpg",
                                            "width": 350,
                                            "height": 214,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "bfd32f07-9302-3bec-ac93-81fd219851de",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/FZ9636-101_WhiteRed_DET?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/bfd32f07-9302-3bec-ac93-81fd219851de.jpg",
                                            "width": 800,
                                            "height": 955,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/bfd32f07-9302-3bec-ac93-81fd219851de.jpg",
                                            "width": 293,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d885c7b3-beb1-3419-9336-23a09607cda2",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/FZ9636-101_WhiteRed_DET-alt1?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d885c7b3-beb1-3419-9336-23a09607cda2.jpg",
                                            "width": 800,
                                            "height": 698,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d885c7b3-beb1-3419-9336-23a09607cda2.jpg",
                                            "width": 350,
                                            "height": 305,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8820fd46-2404-360e-ab14-9abde3f2a7c8",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/FZ9636-101_WhiteRed_DET-alt2?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8820fd46-2404-360e-ab14-9abde3f2a7c8.jpg",
                                            "width": 800,
                                            "height": 812,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8820fd46-2404-360e-ab14-9abde3f2a7c8.jpg",
                                            "width": 345,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "eb84251f-1e6c-3031-a64f-78074cd2a8c1",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/FZ9636-101_WhiteRed_DET-alt3?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/eb84251f-1e6c-3031-a64f-78074cd2a8c1.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/eb84251f-1e6c-3031-a64f-78074cd2a8c1.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "98ad5877-f698-3249-b109-e128639b6ca1",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/FZ9636-101_WhiteRed_DET-alt4?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/98ad5877-f698-3249-b109-e128639b6ca1.jpg",
                                            "width": 800,
                                            "height": 824,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/98ad5877-f698-3249-b109-e128639b6ca1.jpg",
                                            "width": 340,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "White/Obsidian Crimson",
                                        "image": {
                                            "id": "d189ee02-1ecf-39c0-ab8b-43f59cfaa8cc",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d189ee02-1ecf-39c0-ab8b-43f59cfaa8cc.jpg",
                                                "width": 50,
                                                "height": 22,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Red/Orange",
                                        "image": {
                                            "id": "5b1978f5-85a8-380f-9dd9-40ad39e4a94a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/5b1978f5-85a8-380f-9dd9-40ad39e4a94a.jpg",
                                                "width": 50,
                                                "height": 23,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "White/Green",
                                        "image": {
                                            "id": "55f685a9-0e31-32ae-8900-5c744a6fc0dd",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/55f685a9-0e31-32ae-8900-5c744a6fc0dd.jpg",
                                                "width": 50,
                                                "height": 22,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "dickssportinggoods_19nikankhghjmpltbtrc",
                                "name": "Nike High Jump Elite Track and Field Shoes",
                                "description": [],
                                "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                                "brand": "Nike",
                                "displayBrand": "NIKE",
                                "brandId": "41fd220f-05ed-3d8c-96e3-b83af87d45d7",
                                "category": "cleats|menstrackfieldcleats-129904|adult|Men's",
                                "categoryIds": [
                                    "22"
                                ],
                                "priceTag": "$41.65",
                                "priceTagCN": "¥305",
                                "originalPriceTag": "$155.40",
                                "officialURL": "https://www.dickssportinggoods.com/p/nike-high-jump-elite-track-and-field-shoes-19nikankhghjmpltbtrc/19nikankhghjmpltbtrc",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_22.5",
                                            "eu_36",
                                            "uk_3",
                                            "us_m_4",
                                            "us_w_5.5"
                                        ],
                                        "name": "M4.0/W5.5",
                                        "displayName": "欧码36(适合脚长22.5cm)",
                                        "type": "eu",
                                        "label": "36"
                                    },
                                    {
                                        "ids": [
                                            "cm_23",
                                            "eu_36.5",
                                            "uk_3.5",
                                            "us_m_4.5",
                                            "us_w_6"
                                        ],
                                        "name": "M4.5/W6.0",
                                        "displayName": "欧码36.5(适合脚长23cm)",
                                        "type": "eu",
                                        "label": "36.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_23.5",
                                            "eu_37.5",
                                            "uk_4",
                                            "us_m_5",
                                            "us_w_6.5"
                                        ],
                                        "name": "M5.0/W6.5",
                                        "displayName": "欧码37.5(适合脚长23.5cm)",
                                        "type": "eu",
                                        "label": "37.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_24",
                                            "eu_38",
                                            "uk_4.5",
                                            "us_m_5.5",
                                            "us_w_7"
                                        ],
                                        "name": "M5.5/W7.0",
                                        "displayName": "欧码38(适合脚长24cm)",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "cm_24.5",
                                            "eu_38.5",
                                            "uk_5",
                                            "us_m_6",
                                            "us_w_7.5"
                                        ],
                                        "name": "M6.0/W7.5",
                                        "displayName": "欧码38.5(适合脚长24.5cm)",
                                        "type": "eu",
                                        "label": "38.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_25",
                                            "eu_39",
                                            "uk_5.5",
                                            "us_m_6.5",
                                            "us_w_8"
                                        ],
                                        "name": "M6.5/W8.0",
                                        "displayName": "欧码39(适合脚长25cm)",
                                        "type": "eu",
                                        "label": "39"
                                    },
                                    {
                                        "ids": [
                                            "cm_25.5",
                                            "eu_40",
                                            "uk_6",
                                            "us_m_7",
                                            "us_w_8.5"
                                        ],
                                        "name": "M7.0/W8.5",
                                        "displayName": "欧码40(适合脚长25.5cm)",
                                        "type": "eu",
                                        "label": "40"
                                    },
                                    {
                                        "ids": [
                                            "cm_26",
                                            "eu_40.5",
                                            "uk_6.5",
                                            "us_m_7.5",
                                            "us_w_9"
                                        ],
                                        "name": "M7.5/W9.0",
                                        "displayName": "欧码40.5(适合脚长26cm)",
                                        "type": "eu",
                                        "label": "40.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_26.5",
                                            "eu_41",
                                            "uk_7",
                                            "us_m_8",
                                            "us_w_9.5"
                                        ],
                                        "name": "M8.0/W9.5",
                                        "displayName": "欧码41(适合脚长26.5cm)",
                                        "type": "eu",
                                        "label": "41"
                                    },
                                    {
                                        "ids": [
                                            "cm_27",
                                            "eu_42",
                                            "uk_7.5",
                                            "us_m_8.5",
                                            "us_w_10"
                                        ],
                                        "name": "M8.5/W10.0",
                                        "displayName": "欧码42(适合脚长27cm)",
                                        "type": "eu",
                                        "label": "42"
                                    },
                                    {
                                        "ids": [
                                            "cm_27.5",
                                            "eu_42.5",
                                            "uk_8",
                                            "us_m_9",
                                            "us_w_10.5"
                                        ],
                                        "name": "M9.0/W10.5",
                                        "displayName": "欧码42.5(适合脚长27.5cm)",
                                        "type": "eu",
                                        "label": "42.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_28",
                                            "eu_43",
                                            "uk_8.5",
                                            "us_m_9.5",
                                            "us_w_11"
                                        ],
                                        "name": "M9.5/W11.0",
                                        "displayName": "欧码43(适合脚长28cm)",
                                        "type": "eu",
                                        "label": "43"
                                    },
                                    {
                                        "ids": [
                                            "cm_28.5",
                                            "eu_44",
                                            "uk_9",
                                            "us_m_10",
                                            "us_w_11.5"
                                        ],
                                        "name": "M10.0/W11.5",
                                        "displayName": "欧码44(适合脚长28.5cm)",
                                        "type": "eu",
                                        "label": "44"
                                    },
                                    {
                                        "ids": [
                                            "cm_29",
                                            "eu_44.5",
                                            "uk_9.5",
                                            "us_m_10.5",
                                            "us_w_12"
                                        ],
                                        "name": "M10.5/W12.0",
                                        "displayName": "欧码44.5(适合脚长29cm)",
                                        "type": "eu",
                                        "label": "44.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_29.5",
                                            "eu_45",
                                            "uk_10",
                                            "us_m_11",
                                            "us_w_12.5"
                                        ],
                                        "name": "M11.0/W12.5",
                                        "displayName": "欧码45(适合脚长29.5cm)",
                                        "type": "eu",
                                        "label": "45"
                                    },
                                    {
                                        "ids": [
                                            "cm_30",
                                            "eu_45.5",
                                            "uk_10.5",
                                            "us_m_11.5",
                                            "us_w_13"
                                        ],
                                        "name": "M11.5/W13.0",
                                        "displayName": "欧码45.5(适合脚长30cm)",
                                        "type": "eu",
                                        "label": "45.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_30.5",
                                            "eu_46",
                                            "uk_11",
                                            "us_m_12",
                                            "us_w_13.5"
                                        ],
                                        "name": "M12.0/W13.5",
                                        "displayName": "欧码46(适合脚长30.5cm)",
                                        "type": "eu",
                                        "label": "46"
                                    },
                                    {
                                        "ids": [
                                            "cm_32.5",
                                            "eu_48.5",
                                            "uk_13",
                                            "us_m_14",
                                            "us_w_15.5"
                                        ],
                                        "name": "M14.0/W15.5",
                                        "displayName": "欧码48.5(适合脚长32.5cm)",
                                        "type": "eu",
                                        "label": "48.5"
                                    },
                                    {
                                        "ids": [
                                            "cm_33.5",
                                            "eu_50",
                                            "uk_14",
                                            "us_m_15",
                                            "us_w_16.5"
                                        ],
                                        "name": "M15.0/W16.5",
                                        "displayName": "欧码50(适合脚长33.5cm)",
                                        "type": "eu",
                                        "label": "50"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.7折",
                            "activityOffs": [
                                "硬核补贴"
                            ],
                            "merchantName": "Dick's Sporting Goods",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "硬核补贴",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "硬核补贴",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "6393b747-5ac0-38b4-86c5-70b8682a6206",
                                        "originalURL": "https://n.nordstrommedia.com/it/5a32d2ab-fb07-4fae-bba6-e2caf090f1b7.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6393b747-5ac0-38b4-86c5-70b8682a6206.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6393b747-5ac0-38b4-86c5-70b8682a6206.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d773b7d9-046d-36de-ae06-1ae03579dab7",
                                        "originalURL": "https://n.nordstrommedia.com/it/e7c77a4a-f74f-4e08-beb6-c6a77245d1f0.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d773b7d9-046d-36de-ae06-1ae03579dab7.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d773b7d9-046d-36de-ae06-1ae03579dab7.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "89aac224-3a60-3787-9717-8dcd3e957e89",
                                        "originalURL": "https://n.nordstrommedia.com/it/9ecee33f-31ee-44ed-b52b-278f89a97586.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/89aac224-3a60-3787-9717-8dcd3e957e89.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/89aac224-3a60-3787-9717-8dcd3e957e89.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fcf544d5-be60-337a-9e1a-761cf3526829",
                                        "originalURL": "https://n.nordstrommedia.com/it/ce872a6d-1699-4919-873f-d72ec7396bca.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fcf544d5-be60-337a-9e1a-761cf3526829.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fcf544d5-be60-337a-9e1a-761cf3526829.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e180087c-f420-32b8-bd35-e168b59f81f0",
                                        "originalURL": "https://n.nordstrommedia.com/it/410c22b0-4a9e-41e8-b38c-6670cdfe83ac.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e180087c-f420-32b8-bd35-e168b59f81f0.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e180087c-f420-32b8-bd35-e168b59f81f0.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "3da5ebb2-fe49-368f-8632-492ea864f303",
                                        "originalURL": "https://n.nordstrommedia.com/it/e3626a3b-7e5e-49fc-8f70-03145f41302d.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3da5ebb2-fe49-368f-8632-492ea864f303.jpg",
                                            "width": 668,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3da5ebb2-fe49-368f-8632-492ea864f303.jpg",
                                            "width": 228,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "dda9d95a-f37e-3b0e-81b9-1c16fab870bb",
                                        "originalURL": "https://n.nordstrommedia.com/it/0b45eb4b-d469-4463-b2c4-fd043d4f3b53.jpeg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dda9d95a-f37e-3b0e-81b9-1c16fab870bb.jpg",
                                            "width": 560,
                                            "height": 336,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dda9d95a-f37e-3b0e-81b9-1c16fab870bb.jpg",
                                            "width": 350,
                                            "height": 210,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black Suede",
                                        "image": {
                                            "id": "7de3523b-892a-35eb-96dd-222b6a6243ab",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7de3523b-892a-35eb-96dd-222b6a6243ab.jpg",
                                                "width": 31,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Ctsd",
                                        "image": {
                                            "id": "067d5a52-4b4c-3a4a-b43c-34c60d018b88",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/067d5a52-4b4c-3a4a-b43c-34c60d018b88.jpg",
                                                "width": 31,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "nordstromrack_7554415",
                                "name": "Highland High Top Heritage Hiking Boot",
                                "nameCN": "男士 高地高帮复古徒步靴",
                                "description": [],
                                "merchantId": "f8828b5b-30d5-d492-d151-7b87aec09f96",
                                "brand": "UGG®",
                                "displayBrand": "UGG",
                                "brandId": "0748f099-3da0-30ae-9370-d8ef28fb8766",
                                "category": "men|shoes|sneaker|male|mens",
                                "categoryIds": [
                                    "k05"
                                ],
                                "priceTag": "$77.50",
                                "priceTagCN": "¥568",
                                "originalPriceTag": "$132.90",
                                "officialURL": "https://www.nordstromrack.com/s/highland-high-top-heritage-hiking-boot-men/7554415",
                                "labels": [
                                    "ADULT",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_25",
                                            "eu_40",
                                            "uk_6",
                                            "us_7"
                                        ],
                                        "name": "7",
                                        "displayName": "欧码40(适合脚长25cm)",
                                        "type": "eu",
                                        "label": "40"
                                    },
                                    {
                                        "ids": [
                                            "cm_26",
                                            "eu_41",
                                            "uk_7",
                                            "us_8"
                                        ],
                                        "name": "8",
                                        "displayName": "欧码41(适合脚长26cm)",
                                        "type": "eu",
                                        "label": "41"
                                    },
                                    {
                                        "ids": [
                                            "cm_27",
                                            "eu_42",
                                            "uk_8",
                                            "us_9"
                                        ],
                                        "name": "9",
                                        "displayName": "欧码42(适合脚长27cm)",
                                        "type": "eu",
                                        "label": "42"
                                    },
                                    {
                                        "ids": [
                                            "cm_28",
                                            "eu_43",
                                            "uk_9",
                                            "us_10"
                                        ],
                                        "name": "10",
                                        "displayName": "欧码43(适合脚长28cm)",
                                        "type": "eu",
                                        "label": "43"
                                    },
                                    {
                                        "ids": [
                                            "cm_29",
                                            "eu_44",
                                            "uk_10",
                                            "us_11"
                                        ],
                                        "name": "11",
                                        "displayName": "欧码44(适合脚长29cm)",
                                        "type": "eu",
                                        "label": "44"
                                    },
                                    {
                                        "ids": [
                                            "cm_30",
                                            "eu_45",
                                            "uk_11",
                                            "us_12"
                                        ],
                                        "name": "12",
                                        "displayName": "欧码45(适合脚长30cm)",
                                        "type": "eu",
                                        "label": "45"
                                    },
                                    {
                                        "ids": [
                                            "cm_31",
                                            "eu_46",
                                            "uk_12",
                                            "us_13"
                                        ],
                                        "name": "13",
                                        "displayName": "欧码46(适合脚长31cm)",
                                        "type": "eu",
                                        "label": "46"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5.8折",
                            "activityOffs": [],
                            "merchantName": "Nordstrom Rack",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "ce4358a8-772b-3d03-aa2a-b3c35ba4269c",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-check-pillow-drawstring-boots-8074738.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ce4358a8-772b-3d03-aa2a-b3c35ba4269c.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ce4358a8-772b-3d03-aa2a-b3c35ba4269c.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "31e67584-57cb-300c-b22a-44974c160adc",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-check-pillow-drawstring-boots-8074738_2.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/31e67584-57cb-300c-b22a-44974c160adc.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/31e67584-57cb-300c-b22a-44974c160adc.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ad9b52ad-f613-3f36-a271-66cc5a4d23a4",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-check-pillow-drawstring-boots-8074738_3.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ad9b52ad-f613-3f36-a271-66cc5a4d23a4.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ad9b52ad-f613-3f36-a271-66cc5a4d23a4.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "jomashop_8074738",
                                "name": "Check Pillow Drawstring Boots",
                                "description": [],
                                "merchantId": "dfcf41b9-6034-05cd-ba41-158f21d80888",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "category": "male|men",
                                "categoryIds": [
                                    "k05"
                                ],
                                "priceTag": "$198",
                                "priceTagCN": "¥1450",
                                "originalPriceTag": "$1050",
                                "officialURL": "https://www.jomashop.com/burberry-check-pillow-drawstring-boots-8074738.html?product_id=1386485",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "eu_43"
                                        ],
                                        "name": "43 ( US Size 10 )",
                                        "displayName": "欧码43",
                                        "type": "eu",
                                        "label": "43"
                                    },
                                    {
                                        "ids": [
                                            "eu_44"
                                        ],
                                        "name": "44 ( US Size 11 )",
                                        "displayName": "欧码44",
                                        "type": "eu",
                                        "label": "44"
                                    },
                                    {
                                        "ids": [
                                            "eu_46"
                                        ],
                                        "name": "46 ( US Size 13 )",
                                        "displayName": "欧码46",
                                        "type": "eu",
                                        "label": "46"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "1.8折",
                            "activityOffs": [
                                "满减"
                            ],
                            "merchantName": "Jomashop",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "1.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$300减$10",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "1d67a2aa-5240-353e-911a-dd29d7801095",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IG7831_1l.jpg?v=1730409645",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1d67a2aa-5240-353e-911a-dd29d7801095.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1d67a2aa-5240-353e-911a-dd29d7801095.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "58b0528e-32d3-3a9c-8e57-01d5678ed83c",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IG7831_2l.jpg?v=1730409645",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/58b0528e-32d3-3a9c-8e57-01d5678ed83c.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/58b0528e-32d3-3a9c-8e57-01d5678ed83c.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "619f1e37-6278-33e3-aba4-4599c095bb08",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IG7831_3l.jpg?v=1730409646",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/619f1e37-6278-33e3-aba4-4599c095bb08.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/619f1e37-6278-33e3-aba4-4599c095bb08.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "81bf3c68-fae1-3e22-9d9a-1ad95e25bcd8",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IG7831_4l.jpg?v=1730409646",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/81bf3c68-fae1-3e22-9d9a-1ad95e25bcd8.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/81bf3c68-fae1-3e22-9d9a-1ad95e25bcd8.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "shoebacca_9657173999898",
                                "name": "adidas Yeezy Knit RNR Slip On Sneakers",
                                "nameCN": "男款 Yeezy Knit RNR 休闲鞋",
                                "description": [],
                                "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                                "brand": "adidas",
                                "displayBrand": "Adidas",
                                "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                                "category": "casual|sapg::adi08252 ~ color::grey|clearance|shoes|adidas|men|sneakers|mens|adult",
                                "categoryIds": [
                                    "751"
                                ],
                                "priceTag": "$71.35",
                                "priceTagCN": "¥523",
                                "originalPriceTag": "$214.20",
                                "officialURL": "https://www.shoebacca.com/products/adidas-yeezy-knit-rnr-slip-on-sneakers-ig7831",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "cm_22",
                                            "eu_36",
                                            "uk_3.5",
                                            "us_4"
                                        ],
                                        "name": "4",
                                        "displayName": "欧码36(适合脚长22cm)",
                                        "type": "eu",
                                        "label": "36"
                                    },
                                    {
                                        "ids": [
                                            "cm_22.5",
                                            "eu_36 2/3",
                                            "uk_4",
                                            "us_4.5"
                                        ],
                                        "name": "4.5",
                                        "displayName": "欧码36 2/3(适合脚长22.5cm)",
                                        "type": "eu",
                                        "label": "36 2/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_23",
                                            "eu_37 1/3",
                                            "uk_4.5",
                                            "us_5"
                                        ],
                                        "name": "5",
                                        "displayName": "欧码37 1/3(适合脚长23cm)",
                                        "type": "eu",
                                        "label": "37 1/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_23.5",
                                            "eu_38",
                                            "uk_5",
                                            "us_5.5"
                                        ],
                                        "name": "5.5",
                                        "displayName": "欧码38(适合脚长23.5cm)",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "cm_24",
                                            "eu_38 2/3",
                                            "uk_5.5",
                                            "us_6"
                                        ],
                                        "name": "6",
                                        "displayName": "欧码38 2/3(适合脚长24cm)",
                                        "type": "eu",
                                        "label": "38 2/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_24.5",
                                            "eu_39 1/3",
                                            "uk_6",
                                            "us_6.5"
                                        ],
                                        "name": "6.5",
                                        "displayName": "欧码39 1/3(适合脚长24.5cm)",
                                        "type": "eu",
                                        "label": "39 1/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_25",
                                            "eu_40",
                                            "uk_6.5",
                                            "us_7"
                                        ],
                                        "name": "7",
                                        "displayName": "欧码40(适合脚长25cm)",
                                        "type": "eu",
                                        "label": "40"
                                    },
                                    {
                                        "ids": [
                                            "cm_25.5",
                                            "eu_40 2/3",
                                            "uk_7",
                                            "us_7.5"
                                        ],
                                        "name": "7.5",
                                        "displayName": "欧码40 2/3(适合脚长25.5cm)",
                                        "type": "eu",
                                        "label": "40 2/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_26",
                                            "eu_41 1/3",
                                            "uk_7.5",
                                            "us_8"
                                        ],
                                        "name": "8",
                                        "displayName": "欧码41 1/3(适合脚长26cm)",
                                        "type": "eu",
                                        "label": "41 1/3"
                                    },
                                    {
                                        "ids": [
                                            "cm_26.5",
                                            "eu_42",
                                            "uk_8",
                                            "us_8.5"
                                        ],
                                        "name": "8.5",
                                        "displayName": "欧码42(适合脚长26.5cm)",
                                        "type": "eu",
                                        "label": "42"
                                    },
                                    {
                                        "ids": [
                                            "cm_27",
                                            "eu_42 2/3",
                                            "uk_8.5",
                                            "us_9"
                                        ],
                                        "name": "9",
                                        "displayName": "欧码42 2/3(适合脚长27cm)",
                                        "type": "eu",
                                        "label": "42 2/3"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "3.3折",
                            "activityOffs": [],
                            "merchantName": "SHOEBACCA",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "tideShoes": true,
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "3.3折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "c28ffcb7-ae44-3afa-bf4d-eb83afccb209",
                                        "originalURL": "https://www.yoox.com/images/items/17/17242683GU_14_f.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c28ffcb7-ae44-3afa-bf4d-eb83afccb209.jpg",
                                            "width": 804,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c28ffcb7-ae44-3afa-bf4d-eb83afccb209.jpg",
                                            "width": 275,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b4a0d299-1a54-3037-8e07-f662dfdca9b9",
                                        "originalURL": "https://www.yoox.com/images/items/17/17242683GU_14_r.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b4a0d299-1a54-3037-8e07-f662dfdca9b9.jpg",
                                            "width": 804,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b4a0d299-1a54-3037-8e07-f662dfdca9b9.jpg",
                                            "width": 275,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9ce5439e-dc29-3442-9c3d-a3a6bd8233fe",
                                        "originalURL": "https://www.yoox.com/images/items/17/17242683GU_14_d.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9ce5439e-dc29-3442-9c3d-a3a6bd8233fe.jpg",
                                            "width": 804,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9ce5439e-dc29-3442-9c3d-a3a6bd8233fe.jpg",
                                            "width": 275,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9963d27c-aa65-33ea-9084-5bc6695be828",
                                        "originalURL": "https://www.yoox.com/images/items/17/17242683GU_14_e.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9963d27c-aa65-33ea-9084-5bc6695be828.jpg",
                                            "width": 804,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9963d27c-aa65-33ea-9084-5bc6695be828.jpg",
                                            "width": 275,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "White",
                                        "image": {
                                            "id": "be32c4c6-0c95-30d9-a97c-3b94e6ab87ae",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/be32c4c6-0c95-30d9-a97c-3b94e6ab87ae.jpg",
                                                "width": 39,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "yooxhk_17242683",
                                "name": "Sneakers",
                                "description": [],
                                "merchantId": "1909da89-b21b-38c3-b449-378e79039eae",
                                "brand": "CONVERSE x DRKSHDW",
                                "displayBrand": "Converse",
                                "brandId": "6a97ca61-7ed8-3bd8-8a75-ff9ca539a4e4",
                                "category": "sneakers|men",
                                "categoryIds": [
                                    "751"
                                ],
                                "priceTag": "$92.96",
                                "priceTagCN": "¥681",
                                "originalPriceTag": "$250.05",
                                "officialURL": "https://www.yoox.com/hk/17242683GU/item",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "eu_40.5"
                                        ],
                                        "name": "40.5(EU)",
                                        "displayName": "欧码40.5",
                                        "type": "eu",
                                        "label": "40.5"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.6折",
                            "activityOffs": [
                                "额外八折"
                            ],
                            "merchantName": "Yoox HK",
                            "origin": "[意大利]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "tideShoes": true,
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.6折×额外8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "意大利",
                            "allowExpressBuy": true
                        }
                    }
                ]
            },
            {
                "id": "beauty_skincare",
                "title": "美护榜",
                "categoryIds": [
                    "5",
                    "b"
                ],
                "sections": [],
                "sort": 4,
                "subTab": [],
                "excludeCategoryIds": [
                    "b16"
                ],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "a52f015a-fe26-42fd-b1a1-d622201e0946",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a52f015a-fe26-42fd-b1a1-d622201e0946.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a52f015a-fe26-42fd-b1a1-d622201e0946.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "d8c6eae4-58c7-4467-bb03-0094ad0e8f1c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d8c6eae4-58c7-4467-bb03-0094ad0e8f1c.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d8c6eae4-58c7-4467-bb03-0094ad0e8f1c.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "b2ef6cf2-df27-4283-9e10-5d920c8390cf",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b2ef6cf2-df27-4283-9e10-5d920c8390cf.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b2ef6cf2-df27-4283-9e10-5d920c8390cf.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "31c007cb-241c-4c0b-a60e-5a1ba01c542b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/31c007cb-241c-4c0b-a60e-5a1ba01c542b.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/31c007cb-241c-4c0b-a60e-5a1ba01c542b.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "1c520d32-f1be-49d5-bedd-d24134389d61",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1c520d32-f1be-49d5-bedd-d24134389d61.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1c520d32-f1be-49d5-bedd-d24134389d61.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "754b7db4-1430-4c4f-83b8-dac40b18b84c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/754b7db4-1430-4c4f-83b8-dac40b18b84c.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/754b7db4-1430-4c4f-83b8-dac40b18b84c.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "b5bc6afc-6ac0-45d3-97a0-63793f80dffe",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b5bc6afc-6ac0-45d3-97a0-63793f80dffe.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b5bc6afc-6ac0-45d3-97a0-63793f80dffe.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "d8cae78d-7892-413f-8f02-4750ab63c4be",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d8cae78d-7892-413f-8f02-4750ab63c4be.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d8cae78d-7892-413f-8f02-4750ab63c4be.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "d2695d33-fb9e-49dd-8dd2-41e34d3125f6",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d2695d33-fb9e-49dd-8dd2-41e34d3125f6.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d2695d33-fb9e-49dd-8dd2-41e34d3125f6.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "68f1ba46-30d8-4568-937a-015f5a9b1079",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/68f1ba46-30d8-4568-937a-015f5a9b1079.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/68f1ba46-30d8-4568-937a-015f5a9b1079.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "04#红棕色调",
                                        "image": {
                                            "id": "37781c03-1d60-336d-83e1-12e91b6b2dba",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/37781c03-1d60-336d-83e1-12e91b6b2dba.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "20#蜜桃色调",
                                        "image": {
                                            "id": "818d8b5f-97c4-30c6-9e1e-dfb75e7d4386",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/818d8b5f-97c4-30c6-9e1e-dfb75e7d4386.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "26#新色落日盘",
                                        "image": {
                                            "id": "7a35e411-52ab-3328-a52c-415c67af4f7e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7a35e411-52ab-3328-a52c-415c67af4f7e.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "31#沙漠之夏初恋盘",
                                        "image": {
                                            "id": "74cd01f6-93da-39c1-a782-ee354ea14673",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/74cd01f6-93da-39c1-a782-ee354ea14673.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "luxurybeauty_10370",
                                "name": "汤姆福特 TF幻魅经典四色眼影盘 6g 软糯服帖持色 灵动妆感 tf20 tf35 tf36 tfX1",
                                "description": [],
                                "merchantId": "eb66d114-c281-3762-ac98-b204b3352dd4",
                                "brand": "Tom Ford",
                                "displayBrand": "Tom Ford",
                                "brandId": "ee6d6a48-2195-3239-a9fe-63aab4f0f73d",
                                "categoryIds": [
                                    "b0d"
                                ],
                                "priceTag": "$42.00",
                                "priceTagCN": "¥308",
                                "originalPriceTag": "$99",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "10g",
                                        "displayName": "10g"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5.9折",
                            "activityOffs": [
                                "满折",
                                "限时价"
                            ],
                            "merchantName": "LuxuryBeauty",
                            "origin": "[中国香港]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件8.5折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国香港"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "0cd4e67d-8d35-4525-9d16-80ea4a19c004",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0cd4e67d-8d35-4525-9d16-80ea4a19c004.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0cd4e67d-8d35-4525-9d16-80ea4a19c004.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "43538ad8-97aa-4341-98d9-1a3d77508242",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/43538ad8-97aa-4341-98d9-1a3d77508242.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/43538ad8-97aa-4341-98d9-1a3d77508242.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "blankspace_10279",
                                "name": "Nars纳斯裸光透明色蜜粉饼10g控油定妆焦柔美肌【香港直邮】",
                                "description": [],
                                "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                                "brand": "NARS",
                                "displayBrand": "NARS",
                                "brandId": "18a0671d-ef16-39ec-9be6-c3b23035c28c",
                                "categoryIds": [
                                    "b05"
                                ],
                                "priceTag": "$20.50",
                                "priceTagCN": "¥151",
                                "originalPriceTag": "$50",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.1折",
                            "activityOffs": [],
                            "merchantName": "BLANKSPACE",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.1折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "1ee43a9d-b6bb-4681-84d0-b9d0cd99b28a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1ee43a9d-b6bb-4681-84d0-b9d0cd99b28a.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1ee43a9d-b6bb-4681-84d0-b9d0cd99b28a.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "26685882-a1e3-416f-85c9-d90fb3f1c5ad",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/26685882-a1e3-416f-85c9-d90fb3f1c5ad.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/26685882-a1e3-416f-85c9-d90fb3f1c5ad.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "e70584ab-2320-493b-8da0-cbffdfca30bd",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e70584ab-2320-493b-8da0-cbffdfca30bd.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e70584ab-2320-493b-8da0-cbffdfca30bd.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "b1fd3520-4cf2-49b1-be50-4bcbdbc9e2cb",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b1fd3520-4cf2-49b1-be50-4bcbdbc9e2cb.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b1fd3520-4cf2-49b1-be50-4bcbdbc9e2cb.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "6a2bc8e5-f0c3-40d6-ac48-56198577a34f",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6a2bc8e5-f0c3-40d6-ac48-56198577a34f.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6a2bc8e5-f0c3-40d6-ac48-56198577a34f.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "5905d2c5-9351-4fc3-8ba8-80c8ced0f0c8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5905d2c5-9351-4fc3-8ba8-80c8ced0f0c8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5905d2c5-9351-4fc3-8ba8-80c8ced0f0c8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "6b076086-2ce0-4652-8c27-c9dbe79b0602",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6b076086-2ce0-4652-8c27-c9dbe79b0602.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6b076086-2ce0-4652-8c27-c9dbe79b0602.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "f7d58382-03f9-4835-b791-220d49d2d7ca",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f7d58382-03f9-4835-b791-220d49d2d7ca.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f7d58382-03f9-4835-b791-220d49d2d7ca.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "0e75ce57-a578-4fd5-8c71-2adf61155c2e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0e75ce57-a578-4fd5-8c71-2adf61155c2e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0e75ce57-a578-4fd5-8c71-2adf61155c2e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "206dfdbc-b9a3-4413-9f17-e2c5953212c7",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/206dfdbc-b9a3-4413-9f17-e2c5953212c7.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/206dfdbc-b9a3-4413-9f17-e2c5953212c7.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": " 缎光005",
                                        "image": {
                                            "id": "7d03e4bd-636c-32da-83f6-c86d8b941847",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7d03e4bd-636c-32da-83f6-c86d8b941847.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "哑光001M",
                                        "image": {
                                            "id": "4318c2ff-a150-35af-a00c-341ab5dfe4b8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4318c2ff-a150-35af-a00c-341ab5dfe4b8.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "哑光002M",
                                        "image": {
                                            "id": "78b95fd0-01e2-319c-828b-cbcdac73fa68",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/78b95fd0-01e2-319c-828b-cbcdac73fa68.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "哑光148M",
                                        "image": {
                                            "id": "b8c5f109-3a6f-3798-a529-620ff3c3b433",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b8c5f109-3a6f-3798-a529-620ff3c3b433.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "哑光342M",
                                        "image": {
                                            "id": "8e79c9e4-cc66-3bd5-be04-db63818c04a7",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8e79c9e4-cc66-3bd5-be04-db63818c04a7.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "哑光513M",
                                        "image": {
                                            "id": "0e73b703-1d44-3039-8e0b-5207191f7823",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0e73b703-1d44-3039-8e0b-5207191f7823.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "哑光888M",
                                        "image": {
                                            "id": "e7132e22-bd3e-3f04-8eb8-596d1261a082",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e7132e22-bd3e-3f04-8eb8-596d1261a082.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "锻光111",
                                        "image": {
                                            "id": "bf21d021-8eca-395d-ad0b-939f7b84e115",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bf21d021-8eca-395d-ad0b-939f7b84e115.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": " 缎光816",
                                        "image": {
                                            "id": "bba9b622-9b82-32a1-907e-e10a60bef46d",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bba9b622-9b82-32a1-907e-e10a60bef46d.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": " 缎光354",
                                        "image": {
                                            "id": "b32b6101-1833-37be-a456-dbc81df80582",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b32b6101-1833-37be-a456-dbc81df80582.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "vpfrance_19990",
                                "name": "路铂廷 女王权杖唇膏3.8g cl萝卜丁口红 ",
                                "description": [],
                                "merchantId": "a7dbaa3e-55a8-3190-a04c-ee838af8c328",
                                "brand": "Christian Louboutin",
                                "displayBrand": "Christian Louboutin",
                                "brandId": "5e3360de-527f-3418-aa29-56d17cd44406",
                                "categoryIds": [
                                    "b0g"
                                ],
                                "priceTag": "$25.42",
                                "priceTagCN": "¥187",
                                "originalPriceTag": "$113.80",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "9.9折",
                            "activityOffs": [
                                "满折",
                                "限时价",
                                "额外九八折"
                            ],
                            "merchantName": "VP FRANCE",
                            "origin": "[法国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "9.9折×额外9.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件9.9折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "法国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "83130d6a-36d6-3c16-a9d7-a303c8b9a212",
                                        "originalURL": "https://www.peterthomasroth.com/cdn/shop/files/22-06-248_UW_Eye_Super_Size_capon_noref_2000x2000_gray.jpg?v=1724187329&width=1280",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/83130d6a-36d6-3c16-a9d7-a303c8b9a212.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/83130d6a-36d6-3c16-a9d7-a303c8b9a212.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "406963ca-accc-389b-b831-214d6b00eb7c",
                                        "originalURL": "https://www.peterthomasroth.com/cdn/shop/files/22-06-248_UnWrinkle_Eye_concentrate_1oz_2000x2000_81fe7e06-f7d5-4f42-90e2-17db0b81be01.jpg?v=1721325938&width=1280",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/406963ca-accc-389b-b831-214d6b00eb7c.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/406963ca-accc-389b-b831-214d6b00eb7c.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "peterthomasroth_2206248",
                                "name": "Super-Size Un-Wrinkle Eye Concentrate|30 ml / 1 oz",
                                "nameCN": "抗皱紧肤修护眼霜(抗皱眼霜) 30ml - 价值$200美金",
                                "description": [],
                                "merchantId": "97f01347-3d82-cc95-a7c5-824b2841721f",
                                "brand": "Peter Thomas Roth",
                                "displayBrand": "Peter Thomas Roth",
                                "brandId": "1f8ee8c7-746c-3353-abcf-7c6000e6504b",
                                "category": "more|shop|collections",
                                "categoryIds": [
                                    "b22",
                                    "b24"
                                ],
                                "priceTag": "$204",
                                "priceTagCN": "¥1494",
                                "officialURL": "https://www.peterthomasroth.com/products/super-size-un-wrinkle-eye-concentrate-2206248",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "30 ml / 1 oz",
                                        "displayName": "30 ml / 1 oz"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Peter Thomas Roth",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "ce2c96d9-6822-41e7-bb30-c04ce143eb45",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ce2c96d9-6822-41e7-bb30-c04ce143eb45.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ce2c96d9-6822-41e7-bb30-c04ce143eb45.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "ce4a92b3-19e5-4518-844b-d5651d668ad6",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ce4a92b3-19e5-4518-844b-d5651d668ad6.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ce4a92b3-19e5-4518-844b-d5651d668ad6.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "40112afb-d317-47e4-b856-40e302cde9e8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/40112afb-d317-47e4-b856-40e302cde9e8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/40112afb-d317-47e4-b856-40e302cde9e8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "cfad0438-3e9c-468b-aba3-b32b96e2bad5",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cfad0438-3e9c-468b-aba3-b32b96e2bad5.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cfad0438-3e9c-468b-aba3-b32b96e2bad5.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "78b78b82-1e1d-4537-b709-865e3cf67b6c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/78b78b82-1e1d-4537-b709-865e3cf67b6c.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/78b78b82-1e1d-4537-b709-865e3cf67b6c.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "18a91c25-1597-41df-8ecd-5b0764961d49",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/18a91c25-1597-41df-8ecd-5b0764961d49.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/18a91c25-1597-41df-8ecd-5b0764961d49.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "da311778-dc18-4ad5-9007-f05c915e6a33",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/da311778-dc18-4ad5-9007-f05c915e6a33.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/da311778-dc18-4ad5-9007-f05c915e6a33.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "457958eb-5904-4c44-986e-fb8d80e0bac2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/457958eb-5904-4c44-986e-fb8d80e0bac2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/457958eb-5904-4c44-986e-fb8d80e0bac2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "20ml",
                                        "image": {
                                            "id": "98bb615e-d567-3f9a-aee0-f792e5f248a2",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/98bb615e-d567-3f9a-aee0-f792e5f248a2.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "5ml*3 3瓶体验装",
                                        "image": {
                                            "id": "4a8f4825-7995-3d5e-afb1-7a1e46089753",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4a8f4825-7995-3d5e-afb1-7a1e46089753.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "5ml体验装",
                                        "image": {
                                            "id": "0836b63b-4b92-3558-b044-381439e7cffd",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0836b63b-4b92-3558-b044-381439e7cffd.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "luxurybeauty_10070",
                                "name": "兰蔻 菁纯眼霜 滋润焕亮淡化细纹紧致眼周抗老眼霜 20ml",
                                "description": [],
                                "merchantId": "eb66d114-c281-3762-ac98-b204b3352dd4",
                                "brand": "Lancôme",
                                "displayBrand": "Lancôme",
                                "brandId": "8c3ccaca-ed0e-37bb-8e39-9baeca9e3d26",
                                "categoryIds": [
                                    "b24"
                                ],
                                "priceTag": "$12.07",
                                "priceTagCN": "¥89",
                                "originalPriceTag": "$35",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5.4折",
                            "activityOffs": [
                                "满折",
                                "限时价"
                            ],
                            "merchantName": "LuxuryBeauty",
                            "origin": "[中国香港]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5.4折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件8.5折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国香港"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "2996076a-88f0-4de9-952a-a602b01eea82",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2996076a-88f0-4de9-952a-a602b01eea82.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2996076a-88f0-4de9-952a-a602b01eea82.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "201ed133-edcc-4f2a-b5c0-af187f4fc459",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/201ed133-edcc-4f2a-b5c0-af187f4fc459.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/201ed133-edcc-4f2a-b5c0-af187f4fc459.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "97089b85-7d19-4ff0-8e80-6c40b7252cf1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/97089b85-7d19-4ff0-8e80-6c40b7252cf1.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/97089b85-7d19-4ff0-8e80-6c40b7252cf1.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "17959c8c-d156-4eea-a20c-9566f4523d98",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/17959c8c-d156-4eea-a20c-9566f4523d98.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/17959c8c-d156-4eea-a20c-9566f4523d98.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "6bb2bdb3-6819-474d-91a4-99455f7933ec",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6bb2bdb3-6819-474d-91a4-99455f7933ec.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6bb2bdb3-6819-474d-91a4-99455f7933ec.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "blankspace_10564",
                                "name": "娇韵诗兰花/三檀/莲花舒颜护理油30ml滋润保湿护肤面部精华油 【香港直邮】",
                                "description": [],
                                "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                                "brand": "Clarins",
                                "displayBrand": "Clarins",
                                "brandId": "95ab3b7d-33fb-3a53-b475-8629c6f28478",
                                "categoryIds": [
                                    "b25"
                                ],
                                "priceTag": "$30",
                                "priceTagCN": "¥220",
                                "originalPriceTag": "$60",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "兰花油30ml",
                                        "displayName": "兰花油30ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "莲花油30ml",
                                        "displayName": "莲花油30ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "三檀油30ml",
                                        "displayName": "三檀油30ml"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5折",
                            "activityOffs": [],
                            "merchantName": "BLANKSPACE",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "1d2bd670-633e-4462-b606-f7757e38c678",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1d2bd670-633e-4462-b606-f7757e38c678.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1d2bd670-633e-4462-b606-f7757e38c678.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "da5ff851-c116-4801-b2ab-5e7398e31182",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/da5ff851-c116-4801-b2ab-5e7398e31182.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/da5ff851-c116-4801-b2ab-5e7398e31182.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "77bc0108-b792-4ed2-89d6-3a4356b690bd",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/77bc0108-b792-4ed2-89d6-3a4356b690bd.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/77bc0108-b792-4ed2-89d6-3a4356b690bd.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "blankspace_10607",
                                "name": "雅诗兰黛多效智妍面霜75ml滋润清爽击退细纹年轻回弹新旧版本随机发【香港直邮】",
                                "description": [],
                                "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                                "brand": "Estée Lauder",
                                "displayBrand": "Estée Lauder",
                                "brandId": "31324581-2dcc-3c7d-a1fc-70541e5e2ba4",
                                "categoryIds": [
                                    "b28"
                                ],
                                "priceTag": "$57",
                                "priceTagCN": "¥418",
                                "originalPriceTag": "$150",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "75ml清爽",
                                        "displayName": "75ml清爽"
                                    },
                                    {
                                        "ids": [],
                                        "name": "75ml滋润",
                                        "displayName": "75ml滋润"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "3.8折起",
                            "activityOffs": [],
                            "merchantName": "BLANKSPACE",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "3.8折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "d9e7f73b-f8ab-428e-99a7-417d504ac9bb",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d9e7f73b-f8ab-428e-99a7-417d504ac9bb.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d9e7f73b-f8ab-428e-99a7-417d504ac9bb.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "691f5f8b-df11-4c77-a9df-60b1d1dce912",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/691f5f8b-df11-4c77-a9df-60b1d1dce912.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/691f5f8b-df11-4c77-a9df-60b1d1dce912.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "blankspace_10128",
                                "name": "clarins娇韵诗双萃精华30ml/50ml/75ml/100ml双双效抗初老多版本随机发 香港直邮",
                                "description": [],
                                "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                                "brand": "Clarins",
                                "displayBrand": "Clarins",
                                "brandId": "95ab3b7d-33fb-3a53-b475-8629c6f28478",
                                "categoryIds": [
                                    "b25"
                                ],
                                "priceTag": "$42",
                                "priceTagCN": "¥308",
                                "originalPriceTag": "$102",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "30ml",
                                        "displayName": "30ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "50ml",
                                        "displayName": "50ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "75ml",
                                        "displayName": "75ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ml",
                                        "displayName": "100ml"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "3.6折起",
                            "activityOffs": [],
                            "merchantName": "BLANKSPACE",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "3.6折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    }
                ]
            },
            {
                "id": "accessory",
                "title": "配饰榜",
                "categoryIds": [
                    "14",
                    "24",
                    "f",
                    "86",
                    "95"
                ],
                "sections": [],
                "sort": 5,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "b998f4a0-fcf1-3953-aa81-aa4c40922b42",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/1797164_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b998f4a0-fcf1-3953-aa81-aa4c40922b42.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b998f4a0-fcf1-3953-aa81-aa4c40922b42.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "cc7bf95a-3650-3e02-aed9-3079aa3e0caa",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/8617295_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cc7bf95a-3650-3e02-aed9-3079aa3e0caa.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cc7bf95a-3650-3e02-aed9-3079aa3e0caa.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Navy",
                                        "image": {
                                            "id": "eb858e29-54ef-3634-8290-f77fad0d3828",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/eb858e29-54ef-3634-8290-f77fad0d3828.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Relay Blue",
                                        "image": {
                                            "id": "914891e0-eba8-390f-ac78-d1dbf10e7981",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/914891e0-eba8-390f-ac78-d1dbf10e7981.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Red",
                                        "image": {
                                            "id": "bc07d033-3154-3a37-9191-6653c6b29824",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bc07d033-3154-3a37-9191-6653c6b29824.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Carson Blue",
                                        "image": {
                                            "id": "321bed84-cbe4-33ba-aacb-89d887155e87",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/321bed84-cbe4-33ba-aacb-89d887155e87.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Beige",
                                        "image": {
                                            "id": "044185f2-bb47-3d65-b1a1-56934a3aeb88",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/044185f2-bb47-3d65-b1a1-56934a3aeb88.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "White",
                                        "image": {
                                            "id": "18c9b558-6a39-355d-a83e-a236e5d374ed",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/18c9b558-6a39-355d-a83e-a236e5d374ed.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "e168a9d9-6701-3e7a-a20b-f589746d4567",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e168a9d9-6701-3e7a-a20b-f589746d4567.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Heritage Royal",
                                        "image": {
                                            "id": "3f68fb3e-5dab-3aaf-b0ea-5fff41e8b175",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3f68fb3e-5dab-3aaf-b0ea-5fff41e8b175.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_391810",
                                "name": "Core Classic Sport Cap",
                                "nameCN": "【成毅同款】拉夫劳伦男士经典棒球帽 多色可选",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "hats & caps|Men|men's fashion|hat",
                                "categoryIds": [
                                    "957"
                                ],
                                "priceTag": "$35",
                                "priceTagCN": "¥257",
                                "originalPriceTag": "$50",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-core-classic-sport-cap?ID=391810",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "ONE SIZE",
                                        "displayName": "ONE SIZE"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "a740a1f6-6e61-3828-a431-ec01a4c1484b",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/28953330_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a740a1f6-6e61-3828-a431-ec01a4c1484b.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a740a1f6-6e61-3828-a431-ec01a4c1484b.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "22f97301-e423-3395-9677-35c6bf747030",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/29303693_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/22f97301-e423-3395-9677-35c6bf747030.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/22f97301-e423-3395-9677-35c6bf747030.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8733da01-a325-3efd-9867-20d37a3b681d",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/29303696_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8733da01-a325-3efd-9867-20d37a3b681d.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8733da01-a325-3efd-9867-20d37a3b681d.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black/Camel",
                                        "image": {
                                            "id": "1a243a0b-5111-35d4-b8de-cb1bd69b62d2",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1a243a0b-5111-35d4-b8de-cb1bd69b62d2.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Navy/Cream",
                                        "image": {
                                            "id": "7b1ccdf0-f130-3035-a641-4ab704116eba",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7b1ccdf0-f130-3035-a641-4ab704116eba.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Camel/Cream",
                                        "image": {
                                            "id": "16c27120-b46d-395e-8541-0e7488c48f9f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/16c27120-b46d-395e-8541-0e7488c48f9f.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_18618144",
                                "name": "Border Wrap",
                                "nameCN": "拉夫劳伦 女款披肩",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Lauren Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "wrap|women's fashion|scarves & wraps",
                                "categoryIds": [
                                    "86a"
                                ],
                                "priceTag": "$70",
                                "priceTagCN": "¥513",
                                "originalPriceTag": "$111.10",
                                "officialURL": "https://www.macys.com/shop/product/lauren-ralph-lauren-border-wrap?ID=18618144",
                                "labels": [
                                    "final_sale",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "ONE SIZE",
                                        "displayName": "ONE SIZE"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.3折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.3折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "60b9c65a-bad5-39ee-a80f-bb94972e205d",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/3204919_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/60b9c65a-bad5-39ee-a80f-bb94972e205d.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/60b9c65a-bad5-39ee-a80f-bb94972e205d.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9d96aa69-656b-3559-aac5-e6b42c55ce4e",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/10760311_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9d96aa69-656b-3559-aac5-e6b42c55ce4e.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9d96aa69-656b-3559-aac5-e6b42c55ce4e.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Rose Gold",
                                        "image": {
                                            "id": "71c200ac-9084-391b-933c-78ccfcd1b914",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/71c200ac-9084-391b-933c-78ccfcd1b914.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Silver",
                                        "image": {
                                            "id": "43b0a827-6f4a-351b-b7d6-de47606cece5",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/43b0a827-6f4a-351b-b7d6-de47606cece5.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_2112575",
                                "name": "Small Crystal Pavé Stud Earrings",
                                "nameCN": "纪梵希耳环",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Givenchy",
                                "displayBrand": "Givenchy",
                                "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                                "category": "earrings",
                                "categoryIds": [
                                    "f45"
                                ],
                                "priceTag": "$22.60",
                                "priceTagCN": "¥166",
                                "originalPriceTag": "$32.30",
                                "officialURL": "https://www.macys.com/shop/product/givenchy-small-crystal-pave-stud-earrings?ID=2112575",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.9折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "eb9b2a9f-2481-361d-99b3-5f509d27e264",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/34640516_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/eb9b2a9f-2481-361d-99b3-5f509d27e264.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/eb9b2a9f-2481-361d-99b3-5f509d27e264.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "78166959-03bf-3aa9-b2d5-6f81d96c6ae6",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/34640514_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/78166959-03bf-3aa9-b2d5-6f81d96c6ae6.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/78166959-03bf-3aa9-b2d5-6f81d96c6ae6.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "92d2cb73-4adc-36ad-a2d4-8805c575cbbb",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/34640515_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/92d2cb73-4adc-36ad-a2d4-8805c575cbbb.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/92d2cb73-4adc-36ad-a2d4-8805c575cbbb.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Camel/cream",
                                        "image": {
                                            "id": "0d891a2d-7937-3b5d-aacd-6024eacf3f8b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0d891a2d-7937-3b5d-aacd-6024eacf3f8b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Dk olive/camel",
                                        "image": {
                                            "id": "34482040-fd56-3aa6-9674-fc7f4c59e6fe",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/34482040-fd56-3aa6-9674-fc7f4c59e6fe.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black/gray heather",
                                        "image": {
                                            "id": "c0515b57-c2ff-3868-aaa0-58c05106fd1a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c0515b57-c2ff-3868-aaa0-58c05106fd1a.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_24794411",
                                "name": "Iconic Equestrian Blanket Wrap",
                                "nameCN": "女士围巾 披肩 含羊毛",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Lauren Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "wrap|women's fashion|scarves & wraps",
                                "categoryIds": [
                                    "860"
                                ],
                                "priceTag": "$77.40",
                                "priceTagCN": "¥567",
                                "originalPriceTag": "$110.55",
                                "officialURL": "https://www.macys.com/shop/product/lauren-ralph-lauren-iconic-equestrian-blanket-wrap?ID=24794411",
                                "labels": [
                                    "new_arrivals",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "ONE SIZE",
                                        "displayName": "ONE SIZE"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "06e5b2db-f832-39be-a2c4-816c8ee83d21",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/30160038_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/06e5b2db-f832-39be-a2c4-816c8ee83d21.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/06e5b2db-f832-39be-a2c4-816c8ee83d21.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ca54ad63-a811-33e3-887b-25d0c2a53516",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/30160044_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ca54ad63-a811-33e3-887b-25d0c2a53516.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ca54ad63-a811-33e3-887b-25d0c2a53516.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d7d91711-0e4c-3006-ba8d-de09e057d560",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/30160037_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d7d91711-0e4c-3006-ba8d-de09e057d560.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d7d91711-0e4c-3006-ba8d-de09e057d560.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Navy/camel",
                                        "image": {
                                            "id": "c7c432c6-5546-3b9f-beca-c7ac6f2d9d1e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c7c432c6-5546-3b9f-beca-c7ac6f2d9d1e.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_19924772",
                                "name": "Border Wrap",
                                "nameCN": "女款 拉夫劳伦披肩",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Lauren Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "wrap|women's fashion|scarves & wraps",
                                "categoryIds": [
                                    "86a"
                                ],
                                "priceTag": "$70",
                                "priceTagCN": "¥513",
                                "originalPriceTag": "$111.10",
                                "officialURL": "https://www.macys.com/shop/product/lauren-ralph-lauren-border-wrap?ID=19924772",
                                "labels": [
                                    "final_sale",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "ONE SIZE",
                                        "displayName": "ONE SIZE"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.3折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.3折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "5cdf554e-d38f-3850-b86d-4febae67484f",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/33499614_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5cdf554e-d38f-3850-b86d-4febae67484f.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5cdf554e-d38f-3850-b86d-4febae67484f.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b6949926-a69c-3f40-9071-74396a9df32a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/33499613_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b6949926-a69c-3f40-9071-74396a9df32a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b6949926-a69c-3f40-9071-74396a9df32a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4c9e7f91-69aa-344b-95ac-5481f2e9dc49",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/33499612_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4c9e7f91-69aa-344b-95ac-5481f2e9dc49.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4c9e7f91-69aa-344b-95ac-5481f2e9dc49.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "360 Cream/oatmeal",
                                        "image": {
                                            "id": "f138e178-c153-3f62-adce-f2f35d0b5bd8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f138e178-c153-3f62-adce-f2f35d0b5bd8.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "225 Classic Camel",
                                        "image": {
                                            "id": "9afec548-5e0a-3c80-be49-6b73e4bd88bc",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9afec548-5e0a-3c80-be49-6b73e4bd88bc.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_23252053",
                                "name": "Woven Twill-Border Ruana",
                                "nameCN": "女款编织斜纹边 ruana 披肩",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Lauren Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "wrap|women's fashion|scarves & wraps",
                                "categoryIds": [
                                    "860"
                                ],
                                "priceTag": "$79.55",
                                "priceTagCN": "¥583",
                                "originalPriceTag": "$126.25",
                                "officialURL": "https://www.macys.com/shop/product/lauren-ralph-lauren-woven-twill-border-ruana?ID=23252053",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "ONE SIZE",
                                        "displayName": "ONE SIZE"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.3折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.3折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "bfd886a6-778f-3242-aea6-6a4211b35f19",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/34654469_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/bfd886a6-778f-3242-aea6-6a4211b35f19.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/bfd886a6-778f-3242-aea6-6a4211b35f19.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e05a7ef5-1bcc-3ab3-a67a-9040ce0c7560",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/34640241_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e05a7ef5-1bcc-3ab3-a67a-9040ce0c7560.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e05a7ef5-1bcc-3ab3-a67a-9040ce0c7560.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8fc61e0d-2da5-3408-8770-a9daebb2cc26",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/34640242_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8fc61e0d-2da5-3408-8770-a9daebb2cc26.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8fc61e0d-2da5-3408-8770-a9daebb2cc26.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Camel/brown",
                                        "image": {
                                            "id": "6fd0548c-fac4-396f-8ba5-d9c13f50e50d",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6fd0548c-fac4-396f-8ba5-d9c13f50e50d.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Charcoal/light gray",
                                        "image": {
                                            "id": "67d53b33-13a7-3c04-86b7-50d17b9879f4",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/67d53b33-13a7-3c04-86b7-50d17b9879f4.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Dk olive/camel",
                                        "image": {
                                            "id": "8a1ddfd2-9af1-34c1-bd6f-857e6cc6b08b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8a1ddfd2-9af1-34c1-bd6f-857e6cc6b08b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_24795446",
                                "name": "Equestrian Jacquard Oversized Ruana",
                                "nameCN": "女士超大号披肩 Oversized 含羊毛",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Lauren Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "wrap|women's fashion|scarves & wraps",
                                "categoryIds": [
                                    "860"
                                ],
                                "priceTag": "$130.15",
                                "priceTagCN": "¥953",
                                "originalPriceTag": "$185.95",
                                "officialURL": "https://www.macys.com/shop/product/lauren-ralph-lauren-equestrian-jacquard-oversized-ruana?ID=24795446",
                                "labels": [
                                    "new_arrivals",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "ONE SIZE",
                                        "displayName": "ONE SIZE"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.9折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "08704ceb-5eb9-31d1-91c2-07d7d11287ec",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/12851417_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/08704ceb-5eb9-31d1-91c2-07d7d11287ec.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/08704ceb-5eb9-31d1-91c2-07d7d11287ec.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Silver",
                                        "image": {
                                            "id": "2de5eb26-3012-3ed0-a891-e903b42671b5",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2de5eb26-3012-3ed0-a891-e903b42671b5.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_8875954",
                                "name": "Crystal Flex Bracelet",
                                "nameCN": "水晶弹性手链",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Givenchy",
                                "displayBrand": "Givenchy",
                                "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                                "category": "bracelets|bracelet",
                                "categoryIds": [
                                    "f42"
                                ],
                                "priceTag": "$48.10",
                                "priceTagCN": "¥353",
                                "originalPriceTag": "$68.70",
                                "officialURL": "https://www.macys.com/shop/product/givenchy-crystal-flex-bracelet?ID=8875954",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    }
                ]
            },
            {
                "id": "womens_clothes",
                "title": "女装榜",
                "categoryIds": [
                    "11",
                    "81",
                    "82",
                    "83",
                    "84",
                    "85"
                ],
                "sections": [],
                "sort": 6,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "b3c739d4-f89b-3be0-bcf7-7f7ae6d036e5",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/32426479_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b3c739d4-f89b-3be0-bcf7-7f7ae6d036e5.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b3c739d4-f89b-3be0-bcf7-7f7ae6d036e5.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9f4eed0d-836b-3593-afea-f2427b8601d0",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/32426472_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9f4eed0d-836b-3593-afea-f2427b8601d0.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9f4eed0d-836b-3593-afea-f2427b8601d0.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "99473858-2986-36c4-ab0b-291208daac80",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/32426474_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/99473858-2986-36c4-ab0b-291208daac80.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/99473858-2986-36c4-ab0b-291208daac80.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "93b8148c-0c70-384d-bae9-c626694e61ed",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/32426473_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/93b8148c-0c70-384d-bae9-c626694e61ed.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/93b8148c-0c70-384d-bae9-c626694e61ed.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9bc0c553-ffea-337e-b6eb-0ff54cbdaecf",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/32426475_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9bc0c553-ffea-337e-b6eb-0ff54cbdaecf.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9bc0c553-ffea-337e-b6eb-0ff54cbdaecf.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c7077b1d-8cf9-39d8-bf29-4d5d295a10ce",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/32426477_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c7077b1d-8cf9-39d8-bf29-4d5d295a10ce.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c7077b1d-8cf9-39d8-bf29-4d5d295a10ce.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9aac1943-2740-36c1-8359-f285c72ee22e",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/32426476_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9aac1943-2740-36c1-8359-f285c72ee22e.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9aac1943-2740-36c1-8359-f285c72ee22e.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Vetiver",
                                        "image": {
                                            "id": "9073170e-495b-3069-9704-80b7f67fb140",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9073170e-495b-3069-9704-80b7f67fb140.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_19031241",
                                "name": "Women's PreCip Eco Pro Hooded Collar Jacket",
                                "nameCN": "土拨鼠女款透气 防水连帽夹克PreCip Eco",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Marmot",
                                "displayBrand": "Marmot",
                                "brandId": "719669a8-8608-32c9-845d-cfd2b84b254c",
                                "category": "jacket|women's fashion|coats & jackets",
                                "categoryIds": [
                                    "812"
                                ],
                                "priceTag": "$48.40",
                                "priceTagCN": "¥355",
                                "originalPriceTag": "$161.60",
                                "officialURL": "https://www.macys.com/shop/product/marmot-womens-precip-eco-pro-hooded-collar-jacket?ID=19031241",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.9折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "358a4366-deca-3718-bf05-f49bec108590",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/28449136_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/358a4366-deca-3718-bf05-f49bec108590.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/358a4366-deca-3718-bf05-f49bec108590.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0f0fc891-3f8e-3d05-a2f0-627381794d22",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/27610746_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0f0fc891-3f8e-3d05-a2f0-627381794d22.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0f0fc891-3f8e-3d05-a2f0-627381794d22.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fc0ba1e3-e492-3c43-a342-14d915ba51fc",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/27610747_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fc0ba1e3-e492-3c43-a342-14d915ba51fc.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fc0ba1e3-e492-3c43-a342-14d915ba51fc.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "38478539-5867-3a2a-be7b-6c1ae1c3b8c5",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/27610748_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/38478539-5867-3a2a-be7b-6c1ae1c3b8c5.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/38478539-5867-3a2a-be7b-6c1ae1c3b8c5.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c280eacb-fee5-30e2-b49d-c03fd297d586",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/28449137_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c280eacb-fee5-30e2-b49d-c03fd297d586.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c280eacb-fee5-30e2-b49d-c03fd297d586.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "43aee2f1-9a59-35c5-90d5-aa060975adad",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/43aee2f1-9a59-35c5-90d5-aa060975adad.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Litchfield Loden",
                                        "image": {
                                            "id": "fd825f40-4999-3e40-9c2b-89976f0823ab",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fd825f40-4999-3e40-9c2b-89976f0823ab.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Classic Camel",
                                        "image": {
                                            "id": "f4803d0c-cd43-38e9-922d-44754e27f45c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f4803d0c-cd43-38e9-922d-44754e27f45c.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Dk Navy",
                                        "image": {
                                            "id": "c234c42c-2685-3c6c-8365-f835146258ca",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c234c42c-2685-3c6c-8365-f835146258ca.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_23784051",
                                "name": "Women's Hooded Anorak Quilted Coat, P/XS-XX",
                                "nameCN": "女式连帽羽绒服绗缝大衣，P/XS-XX",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Lauren Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "coat|women's fashion|coats & jackets",
                                "categoryIds": [
                                    "812"
                                ],
                                "priceTag": "$115.95",
                                "priceTagCN": "¥849",
                                "originalPriceTag": "$237.35",
                                "officialURL": "https://www.macys.com/shop/product/lauren-ralph-lauren-petite-hooded-quilted-anorak-coat?ID=18174877",
                                "labels": [
                                    "final_sale",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "P/XL x Petite",
                                        "displayName": "Size:P/XL,Type:Petite",
                                        "label": "Size:P/XL,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "P/XS x Petite",
                                        "displayName": "Size:P/XS,Type:Petite",
                                        "label": "Size:P/XS,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "P/S x Petite",
                                        "displayName": "Size:P/S,Type:Petite",
                                        "label": "Size:P/S,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "P/M x Petite",
                                        "displayName": "Size:P/M,Type:Petite",
                                        "label": "Size:P/M,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "P/L x Petite",
                                        "displayName": "Size:P/L,Type:Petite",
                                        "label": "Size:P/L,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XS x Regular",
                                        "displayName": "Size:XS,Type:Regular",
                                        "label": "Size:XS,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S x Regular",
                                        "displayName": "Size:S,Type:Regular",
                                        "label": "Size:S,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M x Regular",
                                        "displayName": "Size:M,Type:Regular",
                                        "label": "Size:M,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L x Regular",
                                        "displayName": "Size:L,Type:Regular",
                                        "label": "Size:L,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL x Regular",
                                        "displayName": "Size:XL,Type:Regular",
                                        "label": "Size:XL,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XXL x Regular",
                                        "displayName": "Size:XXL,Type:Regular",
                                        "label": "Size:XXL,Type:Regular"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.8折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "ca778f4e-cf45-32d8-a2df-466829a8385b",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/27243207_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ca778f4e-cf45-32d8-a2df-466829a8385b.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ca778f4e-cf45-32d8-a2df-466829a8385b.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "345f646b-8995-38b6-bbd5-6ef5814f62dd",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/27243212_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/345f646b-8995-38b6-bbd5-6ef5814f62dd.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/345f646b-8995-38b6-bbd5-6ef5814f62dd.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a2088e9c-02f9-389a-bf07-0cfd75a3b282",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/27243213_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a2088e9c-02f9-389a-bf07-0cfd75a3b282.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a2088e9c-02f9-389a-bf07-0cfd75a3b282.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4b21cef9-c050-3527-90c8-1475292b480d",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/27243211_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4b21cef9-c050-3527-90c8-1475292b480d.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4b21cef9-c050-3527-90c8-1475292b480d.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ade72d62-301b-31fa-98dc-16d97a234f67",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/27243210_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ade72d62-301b-31fa-98dc-16d97a234f67.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ade72d62-301b-31fa-98dc-16d97a234f67.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "af7b4d35-172c-3b32-8885-b945e8882c88",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/27243214_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/af7b4d35-172c-3b32-8885-b945e8882c88.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/af7b4d35-172c-3b32-8885-b945e8882c88.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "28c7f888-d130-3ff0-97a0-8eed978a471d",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/28c7f888-d130-3ff0-97a0-8eed978a471d.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Vetiver",
                                        "image": {
                                            "id": "c46c36cd-c0be-3f9d-997c-53551f86960f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c46c36cd-c0be-3f9d-997c-53551f86960f.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Twilight Blue",
                                        "image": {
                                            "id": "c6f4f0e8-4f55-3da2-b1db-baa90f46fc51",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c6f4f0e8-4f55-3da2-b1db-baa90f46fc51.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sumac",
                                        "image": {
                                            "id": "f957ca81-a8f3-3181-bd01-6503cb0541c4",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f957ca81-a8f3-3181-bd01-6503cb0541c4.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_17771775",
                                "name": "Women's Leconte Fleece Hoody",
                                "nameCN": "女士全拉链抓绒连帽衫",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Marmot",
                                "displayBrand": "Marmot",
                                "brandId": "719669a8-8608-32c9-845d-cfd2b84b254c",
                                "category": "sweatshirt|women's fashion|hoodies & sweatshirts",
                                "categoryIds": [
                                    "822"
                                ],
                                "priceTag": "$33.25",
                                "priceTagCN": "¥244",
                                "originalPriceTag": "$111.10",
                                "officialURL": "https://www.macys.com/shop/product/marmot-womens-leconte-fleece-full-zip-hoodie?ID=17771775",
                                "labels": [
                                    "final_sale",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.9折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "f2dc1ab2-d7cd-3969-9868-92f0b18c1a8d",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/28449391_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f2dc1ab2-d7cd-3969-9868-92f0b18c1a8d.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f2dc1ab2-d7cd-3969-9868-92f0b18c1a8d.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d2fa9bb1-fffe-3ae8-a943-d7a35c292f68",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/27610766_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d2fa9bb1-fffe-3ae8-a943-d7a35c292f68.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d2fa9bb1-fffe-3ae8-a943-d7a35c292f68.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "65c54e81-b806-323c-a777-a9ec7baf2753",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/27610767_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/65c54e81-b806-323c-a777-a9ec7baf2753.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/65c54e81-b806-323c-a777-a9ec7baf2753.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a9b70255-9b68-3278-9c58-dbf6cfc8bc63",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/27610768_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a9b70255-9b68-3278-9c58-dbf6cfc8bc63.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a9b70255-9b68-3278-9c58-dbf6cfc8bc63.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "98a09dc6-fa19-38ac-a406-5f28334d0ce6",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/28449404_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/98a09dc6-fa19-38ac-a406-5f28334d0ce6.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/98a09dc6-fa19-38ac-a406-5f28334d0ce6.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "66112f26-f6e7-38d2-a841-4f98d55a6fc9",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/66112f26-f6e7-38d2-a841-4f98d55a6fc9.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black Cream Herringbone",
                                        "image": {
                                            "id": "8ba05b70-da4a-3ab2-8b4e-311d59dcc92b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8ba05b70-da4a-3ab2-8b4e-311d59dcc92b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Dark Navy",
                                        "image": {
                                            "id": "314ebbc0-77d0-3223-8437-ab5b1936e110",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/314ebbc0-77d0-3223-8437-ab5b1936e110.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Classic Camel",
                                        "image": {
                                            "id": "04499550-6c46-3afa-8053-1212bf1b75dd",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/04499550-6c46-3afa-8053-1212bf1b75dd.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Dark Garnet",
                                        "image": {
                                            "id": "ab1ec32a-0d11-38d4-ab62-0f9e10b1fbd2",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ab1ec32a-0d11-38d4-ab62-0f9e10b1fbd2.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Loden Check",
                                        "image": {
                                            "id": "c53897b6-f94b-34c5-91ab-75ae366dcc35",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c53897b6-f94b-34c5-91ab-75ae366dcc35.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_23784052",
                                "name": "Women's Quilted Velboa-Lined Coat, P/XS-XX",
                                "nameCN": "女款老钱风棉服 菱格夹克",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Lauren Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "coat|women's fashion|coats & jackets",
                                "categoryIds": [
                                    "812"
                                ],
                                "priceTag": "$96.15",
                                "priceTagCN": "¥704",
                                "originalPriceTag": "$196.95",
                                "officialURL": "https://www.macys.com/shop/product/lauren-ralph-lauren-womens-quilted-velboa-lined-coat?ID=18144875",
                                "labels": [
                                    "final_sale",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "P/XL x Petite",
                                        "displayName": "Size:P/XL,Type:Petite",
                                        "label": "Size:P/XL,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "P/XS x Petite",
                                        "displayName": "Size:P/XS,Type:Petite",
                                        "label": "Size:P/XS,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "P/S x Petite",
                                        "displayName": "Size:P/S,Type:Petite",
                                        "label": "Size:P/S,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "P/M x Petite",
                                        "displayName": "Size:P/M,Type:Petite",
                                        "label": "Size:P/M,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "P/L x Petite",
                                        "displayName": "Size:P/L,Type:Petite",
                                        "label": "Size:P/L,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XS x Regular",
                                        "displayName": "Size:XS,Type:Regular",
                                        "label": "Size:XS,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S x Regular",
                                        "displayName": "Size:S,Type:Regular",
                                        "label": "Size:S,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M x Regular",
                                        "displayName": "Size:M,Type:Regular",
                                        "label": "Size:M,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L x Regular",
                                        "displayName": "Size:L,Type:Regular",
                                        "label": "Size:L,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL x Regular",
                                        "displayName": "Size:XL,Type:Regular",
                                        "label": "Size:XL,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XXL x Regular",
                                        "displayName": "Size:XXL,Type:Regular",
                                        "label": "Size:XXL,Type:Regular"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.8折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "871ea323-808d-3f15-b29a-4a4b741c511e",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/W4493R_01660_b1_s1_a1_1_m206_750x.jpg?v=1731610831",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/871ea323-808d-3f15-b29a-4a4b741c511e.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/871ea323-808d-3f15-b29a-4a4b741c511e.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7da07f12-17e4-3906-9ac5-0dbc3f181130",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/W4313R_01660_b1_s1_ai_m206_750x.jpg?v=1759182559",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7da07f12-17e4-3906-9ac5-0dbc3f181130.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7da07f12-17e4-3906-9ac5-0dbc3f181130.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "49dfb176-8637-3857-98d1-d6e2d9676187",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/W4493R_01660_b1_s1_a2_1_m206_750x.jpg?v=1731610831",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/49dfb176-8637-3857-98d1-d6e2d9676187.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/49dfb176-8637-3857-98d1-d6e2d9676187.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "746669f5-ab47-38e0-a4a5-4bb3e63ac891",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/W4493R_01660_b1_s1_a4_1_m206_750x.jpg?v=1731610831",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/746669f5-ab47-38e0-a4a5-4bb3e63ac891.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/746669f5-ab47-38e0-a4a5-4bb3e63ac891.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Camel",
                                        "image": {
                                            "id": "877e1dcd-a314-3e0a-955f-c10d1d84ac93",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/877e1dcd-a314-3e0a-955f-c10d1d84ac93.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "db28021a-fb5c-3090-9249-b224aec337f8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/db28021a-fb5c-3090-9249-b224aec337f8.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Ivory",
                                        "image": {
                                            "id": "4508a792-1ca1-335b-968c-583825f74d8a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4508a792-1ca1-335b-968c-583825f74d8a.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "aloyoga_W4313R",
                                "name": "Foxy Sherpa Jacket - Ivory",
                                "nameCN": "羊羔毛短款连帽外套   Foxy Sherpa",
                                "description": [],
                                "merchantId": "ad4a17c1-7ed8-e5d2-acee-a6d9711d1ef0",
                                "brand": "Alo Yoga",
                                "displayBrand": "Alo",
                                "brandId": "1b2ccf52-b54e-32c9-868c-a24fbe164919",
                                "category": "alo|yoga",
                                "categoryIds": [
                                    "843"
                                ],
                                "priceTag": "$237.10",
                                "priceTagCN": "¥1736",
                                "officialURL": "https://www.aloyoga.com/products/w4493r-foxy-sherpa-jacket-ivory",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XXS",
                                        "displayName": "XXS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Alo yoga",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "12c62c41-4423-32c3-9416-94bb0b89e381",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/27610640_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/12c62c41-4423-32c3-9416-94bb0b89e381.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/12c62c41-4423-32c3-9416-94bb0b89e381.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b3bf5546-0ca0-3575-ae28-a369138d3926",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/27610641_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b3bf5546-0ca0-3575-ae28-a369138d3926.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b3bf5546-0ca0-3575-ae28-a369138d3926.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fd08108d-538f-37c2-a480-14e4350ef431",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/27610642_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fd08108d-538f-37c2-a480-14e4350ef431.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fd08108d-538f-37c2-a480-14e4350ef431.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fc1b4645-31cb-3016-8800-52cdeb0ba6fd",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/27610643_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fc1b4645-31cb-3016-8800-52cdeb0ba6fd.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fc1b4645-31cb-3016-8800-52cdeb0ba6fd.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e8abdd89-7d58-3dfc-a9a8-a25feec6fb5d",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/28874595_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e8abdd89-7d58-3dfc-a9a8-a25feec6fb5d.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e8abdd89-7d58-3dfc-a9a8-a25feec6fb5d.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "0be521e7-2a10-3c4f-990f-932d92a0b926",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0be521e7-2a10-3c4f-990f-932d92a0b926.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sand",
                                        "image": {
                                            "id": "77183d8e-ca49-3079-beeb-00ab43b8e621",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/77183d8e-ca49-3079-beeb-00ab43b8e621.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Dark Navy",
                                        "image": {
                                            "id": "3491ccc5-e829-32e1-86c4-b57b1ff00230",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3491ccc5-e829-32e1-86c4-b57b1ff00230.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_23784053",
                                "name": "Women's Belted Water-Resistant Trench Coat, P/XS-XX",
                                "nameCN": "女士系带防水风衣，尺码：P/XS-XX",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Lauren Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "coat|women's fashion|coats & jackets",
                                "categoryIds": [
                                    "813"
                                ],
                                "priceTag": "$111",
                                "priceTagCN": "¥813",
                                "originalPriceTag": "$227.25",
                                "officialURL": "https://www.macys.com/shop/product/lauren-ralph-lauren-womens-belted-water-resistant-trench-coat?ID=18237806",
                                "labels": [
                                    "final_sale",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "P/XL x Petite",
                                        "displayName": "Size:P/XL,Type:Petite",
                                        "label": "Size:P/XL,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "P/S x Petite",
                                        "displayName": "Size:P/S,Type:Petite",
                                        "label": "Size:P/S,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "P/M x Petite",
                                        "displayName": "Size:P/M,Type:Petite",
                                        "label": "Size:P/M,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "P/L x Petite",
                                        "displayName": "Size:P/L,Type:Petite",
                                        "label": "Size:P/L,Type:Petite"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XS x Regular",
                                        "displayName": "Size:XS,Type:Regular",
                                        "label": "Size:XS,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S x Regular",
                                        "displayName": "Size:S,Type:Regular",
                                        "label": "Size:S,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M x Regular",
                                        "displayName": "Size:M,Type:Regular",
                                        "label": "Size:M,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L x Regular",
                                        "displayName": "Size:L,Type:Regular",
                                        "label": "Size:L,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL x Regular",
                                        "displayName": "Size:XL,Type:Regular",
                                        "label": "Size:XL,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XXL x Regular",
                                        "displayName": "Size:XXL,Type:Regular",
                                        "label": "Size:XXL,Type:Regular"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XXS x Regular",
                                        "displayName": "Size:XXS,Type:Regular",
                                        "label": "Size:XXS,Type:Regular"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.8折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "f20356b4-3b22-38fc-bd56-83d570096218",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/16PTGWSYNCHLLSNP1APO_Brisk_Purple?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f20356b4-3b22-38fc-bd56-83d570096218.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f20356b4-3b22-38fc-bd56-83d570096218.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c1fde862-44b1-31d5-9bfb-a9006152bcdb",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/25455_BriskPurple_MODBCK?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c1fde862-44b1-31d5-9bfb-a9006152bcdb.jpg",
                                            "width": 707,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c1fde862-44b1-31d5-9bfb-a9006152bcdb.jpg",
                                            "width": 242,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b23c49ca-5edc-3222-931d-da18e29c3f4f",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/25455_BriskPurple_LDF?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b23c49ca-5edc-3222-931d-da18e29c3f4f.jpg",
                                            "width": 800,
                                            "height": 894,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b23c49ca-5edc-3222-931d-da18e29c3f4f.jpg",
                                            "width": 313,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Mother Tree/Barnade Blue",
                                        "image": {
                                            "id": "1d0e4218-1fb8-3e5b-8ce6-e9439591c6c6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1d0e4218-1fb8-3e5b-8ce6-e9439591c6c6.jpg",
                                                "width": 38,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Flow/Dyno White",
                                        "image": {
                                            "id": "cca47249-a647-38a6-8512-58be27004e94",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/cca47249-a647-38a6-8512-58be27004e94.jpg",
                                                "width": 38,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Nickle/Permafrost Purple",
                                        "image": {
                                            "id": "23033c0b-8b69-3f45-83c9-7279091e7fce",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/23033c0b-8b69-3f45-83c9-7279091e7fce.jpg",
                                                "width": 37,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Soft Spirea/Dried Vanila",
                                        "image": {
                                            "id": "70d20508-6a4e-3232-9f20-3eba07ed0657",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/70d20508-6a4e-3232-9f20-3eba07ed0657.jpg",
                                                "width": 38,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Small Currents Natural",
                                        "image": {
                                            "id": "1cf0e30f-0f66-37ef-a92b-5d007792f3a7",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1cf0e30f-0f66-37ef-a92b-5d007792f3a7.jpg",
                                                "width": 39,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Brisk Purple",
                                        "image": {
                                            "id": "90720242-71e6-39e3-86ce-9eb8e5937183",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/90720242-71e6-39e3-86ce-9eb8e5937183.jpg",
                                                "width": 38,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "dickssportinggoods_16ptgwsynchllsnp1apo",
                                "name": "Patagonia Women's Synchilla Snap-T Fleece Pullover",
                                "nameCN": "女款Snap-T抓绒套头衫",
                                "description": [],
                                "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                                "brand": "Patagonia",
                                "displayBrand": "Patagonia",
                                "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                                "category": "womensjacketsvests-129844|jackets & vests|Women's|jackets|women's",
                                "categoryIds": [
                                    "822",
                                    "818"
                                ],
                                "priceTag": "$58.25",
                                "priceTagCN": "¥427",
                                "originalPriceTag": "$154.30",
                                "officialURL": "https://www.dickssportinggoods.com/p/patagonia-womens-synchilla-snap-t-fleece-pullover-16ptgwsynchllsnp1apo/16ptgwsynchllsnp1apo",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "3.7折",
                            "activityOffs": [],
                            "merchantName": "Dick's Sporting Goods",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "3.7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "41be065b-0820-3d22-9b1b-3f1273b16396",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/27242850_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/41be065b-0820-3d22-9b1b-3f1273b16396.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/41be065b-0820-3d22-9b1b-3f1273b16396.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5654c26b-9617-3eb1-880b-9a5cf3945c5b",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/27242858_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5654c26b-9617-3eb1-880b-9a5cf3945c5b.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5654c26b-9617-3eb1-880b-9a5cf3945c5b.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8f0c5c1b-9ffa-3965-813c-2e9a907aad0b",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/29134023_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8f0c5c1b-9ffa-3965-813c-2e9a907aad0b.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8f0c5c1b-9ffa-3965-813c-2e9a907aad0b.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "16c6a9ed-d559-31a4-ba97-467ae74f4952",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/29134025_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/16c6a9ed-d559-31a4-ba97-467ae74f4952.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/16c6a9ed-d559-31a4-ba97-467ae74f4952.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8c500509-539c-309f-b18f-058058b5ca90",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/29134026_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8c500509-539c-309f-b18f-058058b5ca90.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8c500509-539c-309f-b18f-058058b5ca90.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "f7f247db-4e16-31dc-8ec5-fb1eb8ca6fe1",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/29134027_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f7f247db-4e16-31dc-8ec5-fb1eb8ca6fe1.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f7f247db-4e16-31dc-8ec5-fb1eb8ca6fe1.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "eb8730ad-adf6-37b3-8ac9-3574928b4bc8",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/29134028_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/eb8730ad-adf6-37b3-8ac9-3574928b4bc8.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/eb8730ad-adf6-37b3-8ac9-3574928b4bc8.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e1f81f2c-ca52-3f16-b3c8-8e3a000f9de9",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/29134029_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e1f81f2c-ca52-3f16-b3c8-8e3a000f9de9.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e1f81f2c-ca52-3f16-b3c8-8e3a000f9de9.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e9978661-563c-378d-9551-375653ce6dce",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/29134030_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e9978661-563c-378d-9551-375653ce6dce.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e9978661-563c-378d-9551-375653ce6dce.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7bc11d5f-9240-3749-92fa-db21f91efd57",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/27242863_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7bc11d5f-9240-3749-92fa-db21f91efd57.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7bc11d5f-9240-3749-92fa-db21f91efd57.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "66e94d06-d98c-3e99-b339-a073e5e03890",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/27242860_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/66e94d06-d98c-3e99-b339-a073e5e03890.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/66e94d06-d98c-3e99-b339-a073e5e03890.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "99cfec90-7769-3b50-a59d-c6ca13d8cd09",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/27242861_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/99cfec90-7769-3b50-a59d-c6ca13d8cd09.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/99cfec90-7769-3b50-a59d-c6ca13d8cd09.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9c26d350-a1ab-3494-a40a-9084a3d3e113",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/27242862_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9c26d350-a1ab-3494-a40a-9084a3d3e113.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9c26d350-a1ab-3494-a40a-9084a3d3e113.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "add02dd0-1231-3115-a8d5-0ecc9e1ec00b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/add02dd0-1231-3115-a8d5-0ecc9e1ec00b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Shale Grey",
                                        "image": {
                                            "id": "ee3e32d0-72ca-3593-b34d-32baf877765b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ee3e32d0-72ca-3593-b34d-32baf877765b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_17771779",
                                "name": "Women's Cascade Jacket",
                                "nameCN": "土拨鼠女款户外徒步夹克",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Marmot",
                                "displayBrand": "Marmot",
                                "brandId": "719669a8-8608-32c9-845d-cfd2b84b254c",
                                "category": "jacket|women's fashion|coats & jackets",
                                "categoryIds": [
                                    "812"
                                ],
                                "priceTag": "$47.50",
                                "priceTagCN": "¥348",
                                "originalPriceTag": "$101",
                                "officialURL": "https://www.macys.com/shop/product/marmot-womens-cascade-hooded-waterproof-jacket?ID=17771779",
                                "labels": [
                                    "final_sale",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.9折起",
                            "activityOffs": [
                                "硬核补贴"
                            ],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "硬核补贴",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.9折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "硬核补贴",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    }
                ]
            },
            {
                "id": "mens_clothes",
                "title": "男士榜",
                "categoryIds": [
                    "21",
                    "23",
                    "91",
                    "92",
                    "93",
                    "94",
                    "e1",
                    "e2"
                ],
                "sections": [],
                "sort": 7,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "d0f1f5a8-4366-390b-97e0-f9f94ce44c1f",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/26471842_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d0f1f5a8-4366-390b-97e0-f9f94ce44c1f.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d0f1f5a8-4366-390b-97e0-f9f94ce44c1f.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e3c277fb-3df7-390a-b8ce-313dc748998c",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/29806974_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e3c277fb-3df7-390a-b8ce-313dc748998c.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e3c277fb-3df7-390a-b8ce-313dc748998c.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "f4b9cc7c-a1cc-335c-86c1-2716bc3bd60a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/29808356_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f4b9cc7c-a1cc-335c-86c1-2716bc3bd60a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f4b9cc7c-a1cc-335c-86c1-2716bc3bd60a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9cc46032-2f98-3159-96f6-f5bbf9cdc6b1",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/29808357_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9cc46032-2f98-3159-96f6-f5bbf9cdc6b1.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9cc46032-2f98-3159-96f6-f5bbf9cdc6b1.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "24be2fcc-8927-3b90-83c4-7734eef2b931",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/29808358_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/24be2fcc-8927-3b90-83c4-7734eef2b931.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/24be2fcc-8927-3b90-83c4-7734eef2b931.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4e1e423c-780a-3cd6-8ddf-00a05e034903",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/29847535_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4e1e423c-780a-3cd6-8ddf-00a05e034903.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4e1e423c-780a-3cd6-8ddf-00a05e034903.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fbcaf5d9-bbe9-3ad5-bd4f-4527ac29f13d",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/29847995_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fbcaf5d9-bbe9-3ad5-bd4f-4527ac29f13d.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fbcaf5d9-bbe9-3ad5-bd4f-4527ac29f13d.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Polo Black",
                                        "image": {
                                            "id": "a6b90b2d-5792-3354-8670-a0b7c6e32dde",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a6b90b2d-5792-3354-8670-a0b7c6e32dde.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Hunter Navy",
                                        "image": {
                                            "id": "c8b7053b-b378-32ca-91eb-84c7051943c6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c8b7053b-b378-32ca-91eb-84c7051943c6.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Moss Agate",
                                        "image": {
                                            "id": "6ad896e3-b578-32fe-9c09-73b94d99b6dd",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6ad896e3-b578-32fe-9c09-73b94d99b6dd.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Park Ave Red",
                                        "image": {
                                            "id": "3ddfbbe9-5ad0-3907-83be-eb95832331ed",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3ddfbbe9-5ad0-3907-83be-eb95832331ed.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Andover Cream",
                                        "image": {
                                            "id": "6caef219-869e-3786-a399-c0baf574b84d",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6caef219-869e-3786-a399-c0baf574b84d.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Dark Granite Hthr",
                                        "image": {
                                            "id": "5ffbcf7c-cf9a-3cde-876c-a53519c3e4d5",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/5ffbcf7c-cf9a-3cde-876c-a53519c3e4d5.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sapphire Star",
                                        "image": {
                                            "id": "dbe64c0f-4f97-3f80-8704-0832fe313104",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/dbe64c0f-4f97-3f80-8704-0832fe313104.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Cacao Brown Heather",
                                        "image": {
                                            "id": "f576e8c6-ae10-320b-a8df-6434caa3564e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f576e8c6-ae10-320b-a8df-6434caa3564e.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_13905268",
                                "name": "Men's Wool-Cashmere Cable-Knit Sweater",
                                "nameCN": "拉夫劳伦男士经典花纹针织毛衣 多色可选",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "sweaters|sweater|men's fashion|Men",
                                "categoryIds": [
                                    "923"
                                ],
                                "priceTag": "$105.65",
                                "priceTagCN": "¥774",
                                "originalPriceTag": "$150.95",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-mens-wool-cashmere-cable-knit-sweater?ID=13905268",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "2XL",
                                        "displayName": "2XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.9折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "144b7e81-8fc3-3cbf-a131-3d1c88a076a5",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/30705562_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/144b7e81-8fc3-3cbf-a131-3d1c88a076a5.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/144b7e81-8fc3-3cbf-a131-3d1c88a076a5.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d3111ffb-e537-36bc-8692-cfbab51500f5",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/30705564_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d3111ffb-e537-36bc-8692-cfbab51500f5.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d3111ffb-e537-36bc-8692-cfbab51500f5.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e017899b-43aa-39f5-8734-de45501d44aa",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/32120348_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e017899b-43aa-39f5-8734-de45501d44aa.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e017899b-43aa-39f5-8734-de45501d44aa.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fa1262d7-0c18-3809-97f2-c1ca20b18524",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/30705567_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fa1262d7-0c18-3809-97f2-c1ca20b18524.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fa1262d7-0c18-3809-97f2-c1ca20b18524.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d0641ce9-197d-3cbb-8578-984cd55d0386",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/30705554_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d0641ce9-197d-3cbb-8578-984cd55d0386.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d0641ce9-197d-3cbb-8578-984cd55d0386.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8b2c409c-3215-31d0-a278-4c5dab1f8f19",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/30705557_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8b2c409c-3215-31d0-a278-4c5dab1f8f19.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8b2c409c-3215-31d0-a278-4c5dab1f8f19.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "d09ee1b7-c33e-35a6-b3b3-cd8e74e1778f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d09ee1b7-c33e-35a6-b3b3-cd8e74e1778f.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_19391529",
                                "name": "Men's PreCip Eco Pro Jacket",
                                "nameCN": "男款 PreCip Eco Pro 户外夹克",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Marmot",
                                "displayBrand": "Marmot",
                                "brandId": "719669a8-8608-32c9-845d-cfd2b84b254c",
                                "category": "men's fashion|jacket|coats & jackets|Men",
                                "categoryIds": [
                                    "911"
                                ],
                                "priceTag": "$67.85",
                                "priceTagCN": "¥497",
                                "originalPriceTag": "$161.60",
                                "officialURL": "https://www.macys.com/shop/product/marmot-mens-precip-eco-pro-jacket?ID=19391529",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XXL",
                                        "displayName": "XXL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.1折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.1折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "48057cc0-fe90-3f8a-bd4e-71111d24d29d",
                                        "originalURL": "https://slimages.macysassets.com/is/image/MCY/products/5/optimized/17207415_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/48057cc0-fe90-3f8a-bd4e-71111d24d29d.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/48057cc0-fe90-3f8a-bd4e-71111d24d29d.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "bc50d92f-8fcd-39d3-8196-ba14f80af9db",
                                        "originalURL": "https://slimages.macysassets.com/is/image/MCY/products/4/optimized/24657454_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/bc50d92f-8fcd-39d3-8196-ba14f80af9db.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/bc50d92f-8fcd-39d3-8196-ba14f80af9db.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "17181a6e-1d9f-396c-9e58-985579102a56",
                                        "originalURL": "https://slimages.macysassets.com/is/image/MCY/products/3/optimized/24657453_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/17181a6e-1d9f-396c-9e58-985579102a56.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/17181a6e-1d9f-396c-9e58-985579102a56.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d96ebf72-960f-3861-b839-9d38cd5da0b0",
                                        "originalURL": "https://slimages.macysassets.com/is/image/MCY/products/2/optimized/24657452_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d96ebf72-960f-3861-b839-9d38cd5da0b0.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d96ebf72-960f-3861-b839-9d38cd5da0b0.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0a7cc309-ac3b-3040-aeff-719a5b85e47e",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/24657432_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0a7cc309-ac3b-3040-aeff-719a5b85e47e.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0a7cc309-ac3b-3040-aeff-719a5b85e47e.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e912fb48-c1af-3d85-a822-b467f91a2f89",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/24657431_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e912fb48-c1af-3d85-a822-b467f91a2f89.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e912fb48-c1af-3d85-a822-b467f91a2f89.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "671be646-a54a-3ba9-ab8d-e54aca2d766e",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/24657430_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/671be646-a54a-3ba9-ab8d-e54aca2d766e.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/671be646-a54a-3ba9-ab8d-e54aca2d766e.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "272c2813-95c9-3a83-b1ff-e94166172f8f",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/30160535_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/272c2813-95c9-3a83-b1ff-e94166172f8f.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/272c2813-95c9-3a83-b1ff-e94166172f8f.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Refined Navy",
                                        "image": {
                                            "id": "ec3dbbe5-16df-3147-a012-a48d09986984",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ec3dbbe5-16df-3147-a012-a48d09986984.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Polo Black",
                                        "image": {
                                            "id": "f2da2cc6-0fde-3c8e-8e98-9de7e7c9e182",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f2da2cc6-0fde-3c8e-8e98-9de7e7c9e182.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Khaki",
                                        "image": {
                                            "id": "fb6f24ca-7db6-3f04-9977-037f27a3248b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fb6f24ca-7db6-3f04-9977-037f27a3248b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_1902680",
                                "name": "Men's Lightweight Windbreaker",
                                "nameCN": "男式 拉夫劳伦 轻量夹克",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "jacket|men's fashion|Men|coats & jackets",
                                "categoryIds": [
                                    "912"
                                ],
                                "priceTag": "$130.80",
                                "priceTagCN": "¥958",
                                "originalPriceTag": "$186.85",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-mens-lightweight-windbreaker?ID=1902680",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "2XL",
                                        "displayName": "2XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "5123e64d-7585-36a5-a614-bacf05c6b450",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/29780462_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5123e64d-7585-36a5-a614-bacf05c6b450.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5123e64d-7585-36a5-a614-bacf05c6b450.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "69c05ba6-b1a8-3dd0-8fce-c77c31c931f2",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/29780649_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/69c05ba6-b1a8-3dd0-8fce-c77c31c931f2.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/69c05ba6-b1a8-3dd0-8fce-c77c31c931f2.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8360cc78-f3aa-3fc2-8b19-35ec778c32f3",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/29780648_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8360cc78-f3aa-3fc2-8b19-35ec778c32f3.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8360cc78-f3aa-3fc2-8b19-35ec778c32f3.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4cd935f2-e842-3d3a-8e4e-5b52eb11d4dd",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/29780647_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4cd935f2-e842-3d3a-8e4e-5b52eb11d4dd.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4cd935f2-e842-3d3a-8e4e-5b52eb11d4dd.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e79f0acd-98d6-3652-b069-2463354cd40b",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/29780650_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e79f0acd-98d6-3652-b069-2463354cd40b.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e79f0acd-98d6-3652-b069-2463354cd40b.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Polo Black",
                                        "image": {
                                            "id": "3c617663-1bd4-3cd0-9f7f-e1fb9a1e2b18",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3c617663-1bd4-3cd0-9f7f-e1fb9a1e2b18.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Parchment Cream",
                                        "image": {
                                            "id": "595a5d7a-194e-350c-8be3-fd99d66b631f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/595a5d7a-194e-350c-8be3-fd99d66b631f.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Cruise Navy",
                                        "image": {
                                            "id": "e855d76b-1bbb-3e8e-934c-f3d7af6ca119",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e855d76b-1bbb-3e8e-934c-f3d7af6ca119.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Scotch Pine Heather",
                                        "image": {
                                            "id": "30db2e94-61c0-306b-99d7-6bac99583a66",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/30db2e94-61c0-306b-99d7-6bac99583a66.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Andover Heather",
                                        "image": {
                                            "id": "58c17970-5b83-3090-9010-004576d28b5e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/58c17970-5b83-3090-9010-004576d28b5e.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Spring Wine Heather",
                                        "image": {
                                            "id": "391f76e8-efc5-3341-84df-1bfcc23950e7",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/391f76e8-efc5-3341-84df-1bfcc23950e7.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Nutmeg Brown Heather",
                                        "image": {
                                            "id": "d721477e-3592-3ba7-92c0-b23e3ece3f53",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d721477e-3592-3ba7-92c0-b23e3ece3f53.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sapphire Star/Barclay Heather Int",
                                        "image": {
                                            "id": "5985cda3-e3c3-3549-adc3-34476c95203f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/5985cda3-e3c3-3549-adc3-34476c95203f.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Real Light Red/Barclay Heather Int",
                                        "image": {
                                            "id": "53a462cb-4662-3ceb-ad66-3fc66b46cf26",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/53a462cb-4662-3ceb-ad66-3fc66b46cf26.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Cabana Purple/Barlcay Heather Int",
                                        "image": {
                                            "id": "1d5afc93-90c6-32cf-a893-e69f1b2e7b48",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1d5afc93-90c6-32cf-a893-e69f1b2e7b48.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Blackwatch Plaid/Red",
                                        "image": {
                                            "id": "30313d82-6a18-3ea7-97ad-bc7f9efd7812",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/30313d82-6a18-3ea7-97ad-bc7f9efd7812.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Blackwatch Plaid",
                                        "image": {
                                            "id": "993551f7-9cff-3747-b0cb-797c7fedc83a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/993551f7-9cff-3747-b0cb-797c7fedc83a.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Micro Holiday Check- Red",
                                        "image": {
                                            "id": "73f7b410-96e3-3367-ab53-0adf8504c0ee",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/73f7b410-96e3-3367-ab53-0adf8504c0ee.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Herringbone",
                                        "image": {
                                            "id": "17aed6da-d452-3d30-82b8-6bb4ca84a35b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/17aed6da-d452-3d30-82b8-6bb4ca84a35b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Glenboyle Fair Isle",
                                        "image": {
                                            "id": "c3663aaa-2f16-37be-bc73-38082b227c38",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c3663aaa-2f16-37be-bc73-38082b227c38.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_4589776",
                                "name": "Men's Estate-Rib Cotton Quarter-Zip Pullover",
                                "nameCN": "男士全棉套头衫 多配色",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "men's fashion|sweaters|Men|sweater",
                                "categoryIds": [
                                    "921",
                                    "923"
                                ],
                                "priceTag": "$95.45",
                                "priceTagCN": "¥699",
                                "originalPriceTag": "$136.35",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-mens-estate-rib-cotton-quarter-zip-pullover?ID=4589776",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "2XL",
                                        "displayName": "2XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.9折起",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.9折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "a7151daa-a76d-3f93-8cbf-59aeddf1a7e1",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/34561032_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a7151daa-a76d-3f93-8cbf-59aeddf1a7e1.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a7151daa-a76d-3f93-8cbf-59aeddf1a7e1.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "2783cb49-9171-3ad9-bcc3-299cfee46f17",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/34561030_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2783cb49-9171-3ad9-bcc3-299cfee46f17.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2783cb49-9171-3ad9-bcc3-299cfee46f17.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d3d3a38d-e912-3493-9a5a-0dfe86efcadb",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/34561027_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d3d3a38d-e912-3493-9a5a-0dfe86efcadb.jpg",
                                            "width": 948,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d3d3a38d-e912-3493-9a5a-0dfe86efcadb.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "33c6d482-acc7-326a-9c43-b88c55084002",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/34561029_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/33c6d482-acc7-326a-9c43-b88c55084002.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/33c6d482-acc7-326a-9c43-b88c55084002.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7db8f1da-8c10-330b-a45a-e6ac1d221580",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/34561031_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7db8f1da-8c10-330b-a45a-e6ac1d221580.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7db8f1da-8c10-330b-a45a-e6ac1d221580.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Gray Marl",
                                        "image": {
                                            "id": "c5009d87-0b32-3bb8-bdc2-a059e0eef8f8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c5009d87-0b32-3bb8-bdc2-a059e0eef8f8.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_21382253",
                                "name": "Men's Donegal Mock Neck Cardigan",
                                "nameCN": "男士针织开衫",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "sweater|sweaters|Men|men's fashion",
                                "categoryIds": [
                                    "923"
                                ],
                                "priceTag": "$161.20",
                                "priceTagCN": "¥1181",
                                "originalPriceTag": "$230.30",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-mens-donegal-mock-neck-cardigan?ID=21382253",
                                "labels": [
                                    "new_arrivals",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "2XL",
                                        "displayName": "2XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.9折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "5e2bff7e-7821-3f15-b8e9-c6ac5b474183",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/30945456_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5e2bff7e-7821-3f15-b8e9-c6ac5b474183.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5e2bff7e-7821-3f15-b8e9-c6ac5b474183.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a3eaee54-e654-3d8b-a43a-10239e39aea8",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/30945460_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a3eaee54-e654-3d8b-a43a-10239e39aea8.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a3eaee54-e654-3d8b-a43a-10239e39aea8.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4bfe19b6-89b5-3839-b6a8-2be74d5bc2f9",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/30945458_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4bfe19b6-89b5-3839-b6a8-2be74d5bc2f9.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4bfe19b6-89b5-3839-b6a8-2be74d5bc2f9.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "28678a1b-1ce0-3093-a9a8-c870e983861a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/30945457_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/28678a1b-1ce0-3093-a9a8-c870e983861a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/28678a1b-1ce0-3093-a9a8-c870e983861a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Fall Yellow",
                                        "image": {
                                            "id": "adb8db26-466e-3265-8471-590401fb4916",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/adb8db26-466e-3265-8471-590401fb4916.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Hunter Navy",
                                        "image": {
                                            "id": "128f1d3b-bc5a-309e-8277-37bcc94b36c2",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/128f1d3b-bc5a-309e-8277-37bcc94b36c2.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Fawn Gray Heather",
                                        "image": {
                                            "id": "931d50a9-45e4-3040-b099-a192242d2ae8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/931d50a9-45e4-3040-b099-a192242d2ae8.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Andover Cream",
                                        "image": {
                                            "id": "ed4da219-d574-3228-bfd4-e27032ad5e4e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ed4da219-d574-3228-bfd4-e27032ad5e4e.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Polo Black",
                                        "image": {
                                            "id": "f5f8abc6-b863-381c-a001-4f87db98de14",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f5f8abc6-b863-381c-a001-4f87db98de14.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Park Avenue Red",
                                        "image": {
                                            "id": "6f380916-6f46-34b6-8d88-ee52f9b62bb7",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6f380916-6f46-34b6-8d88-ee52f9b62bb7.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Camel Melange",
                                        "image": {
                                            "id": "3c045ea5-c5bb-3a6d-9c11-b84ef5082879",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3c045ea5-c5bb-3a6d-9c11-b84ef5082879.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Mulberry Jam Heather",
                                        "image": {
                                            "id": "c58fc201-7da3-3c98-863d-c06c16c6be96",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c58fc201-7da3-3c98-863d-c06c16c6be96.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Nutmeg Brown Heather",
                                        "image": {
                                            "id": "4ffbe7e4-c230-37f7-95ea-10f3dae37808",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4ffbe7e4-c230-37f7-95ea-10f3dae37808.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Scotch Pine Heather",
                                        "image": {
                                            "id": "e46dcaa7-6753-3629-be26-f2491afd409e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e46dcaa7-6753-3629-be26-f2491afd409e.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sapphire Star",
                                        "image": {
                                            "id": "9bfc34a7-e8f8-316b-9a08-bfe81542b4ba",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9bfc34a7-e8f8-316b-9a08-bfe81542b4ba.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Soft Royal Heather",
                                        "image": {
                                            "id": "6f51cce1-9527-33db-8183-9b8f6eb721d8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6f51cce1-9527-33db-8183-9b8f6eb721d8.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Palm Green Heather",
                                        "image": {
                                            "id": "101b66b6-fb00-3c4e-9cd3-5f0e3fc379eb",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/101b66b6-fb00-3c4e-9cd3-5f0e3fc379eb.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sunrise Red",
                                        "image": {
                                            "id": "a2326528-b361-3288-b9a7-ce2d732d4c3f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a2326528-b361-3288-b9a7-ce2d732d4c3f.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_10502776",
                                "name": "Men's Cable-Knit Cotton Sweater",
                                "nameCN": "男士棉质毛衣",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "men's fashion|Men|sweater|sweaters",
                                "categoryIds": [
                                    "923"
                                ],
                                "priceTag": "$103.55",
                                "priceTagCN": "¥759",
                                "originalPriceTag": "$147.90",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-mens-cable-knit-cotton-sweater?ID=10502776",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "2XL",
                                        "displayName": "2XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "2d77c1ce-00c1-3706-8115-c7804e512c7c",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/29805560_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2d77c1ce-00c1-3706-8115-c7804e512c7c.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2d77c1ce-00c1-3706-8115-c7804e512c7c.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b17d638d-4e2e-30aa-b137-d023c642250a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/29805792_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b17d638d-4e2e-30aa-b137-d023c642250a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b17d638d-4e2e-30aa-b137-d023c642250a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8a58b4be-cfcb-325b-a23c-fce5ec53dcd0",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/29805793_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8a58b4be-cfcb-325b-a23c-fce5ec53dcd0.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8a58b4be-cfcb-325b-a23c-fce5ec53dcd0.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8c321640-ba0e-3cf6-8fac-58955415a7a8",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/29805794_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8c321640-ba0e-3cf6-8fac-58955415a7a8.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8c321640-ba0e-3cf6-8fac-58955415a7a8.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "1a4c55d7-2123-38c2-9fc2-15dd460360e5",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/29805795_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1a4c55d7-2123-38c2-9fc2-15dd460360e5.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1a4c55d7-2123-38c2-9fc2-15dd460360e5.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "460a2ac4-96f6-31cb-912e-64bed4b166dd",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/17814489_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/460a2ac4-96f6-31cb-912e-64bed4b166dd.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/460a2ac4-96f6-31cb-912e-64bed4b166dd.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Camel Melange",
                                        "image": {
                                            "id": "39b61d33-d97f-3846-9d0a-fb66151e322e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/39b61d33-d97f-3846-9d0a-fb66151e322e.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Polo Black",
                                        "image": {
                                            "id": "0c2a67fa-3aa7-33ea-91cf-52aed420cb5f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0c2a67fa-3aa7-33ea-91cf-52aed420cb5f.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Hunter Navy",
                                        "image": {
                                            "id": "45ccd2b2-d055-394f-b62f-75875162185b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/45ccd2b2-d055-394f-b62f-75875162185b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Scotch Pine Heather",
                                        "image": {
                                            "id": "533e41d2-61ff-3974-b86f-8b841f25e3c6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/533e41d2-61ff-3974-b86f-8b841f25e3c6.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_10930482",
                                "name": "Men's Cable-Knit Cotton Sweater",
                                "nameCN": "男式 拉夫劳伦 绞花针织棉毛衣",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "sweater|men's fashion|sweaters|Men",
                                "categoryIds": [
                                    "923"
                                ],
                                "priceTag": "$105.65",
                                "priceTagCN": "¥774",
                                "originalPriceTag": "$150.95",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-mens-cable-knit-cotton-sweater?ID=10930482",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "2XL",
                                        "displayName": "2XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.9折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "2f6511a5-628b-3a10-883f-f7449939d796",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/29646432_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2f6511a5-628b-3a10-883f-f7449939d796.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2f6511a5-628b-3a10-883f-f7449939d796.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e001bb0d-cac1-3a59-8135-ec86ada23f46",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/29646434_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e001bb0d-cac1-3a59-8135-ec86ada23f46.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e001bb0d-cac1-3a59-8135-ec86ada23f46.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "55a58bca-fc32-3feb-8d8e-d53641811375",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/29646435_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/55a58bca-fc32-3feb-8d8e-d53641811375.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/55a58bca-fc32-3feb-8d8e-d53641811375.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "6c1f2d4c-9526-3e2f-ab40-516e07db9223",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/29646447_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6c1f2d4c-9526-3e2f-ab40-516e07db9223.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6c1f2d4c-9526-3e2f-ab40-516e07db9223.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "b48db160-bb99-3bed-9b52-9ddc663ea6ae",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b48db160-bb99-3bed-9b52-9ddc663ea6ae.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_17950989",
                                "name": "Men's Big Pony Fleece Baseball Jacket",
                                "nameCN": "男款 Big Pony 棒球夹克",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "jacket|Men|coats & jackets|men's fashion",
                                "categoryIds": [
                                    "911"
                                ],
                                "priceTag": "$140",
                                "priceTagCN": "¥1025",
                                "originalPriceTag": "$200",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-mens-big-pony-fleece-baseball-jacket?ID=17950989",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "2XL",
                                        "displayName": "2XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    }
                ]
            },
            {
                "id": "children",
                "title": "婴童榜",
                "categoryIds": [
                    "3",
                    "g"
                ],
                "sections": [],
                "sort": 8,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "0e260ee5-a88a-3b8f-b371-80c0e0a2f5ed",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/33171594_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0e260ee5-a88a-3b8f-b371-80c0e0a2f5ed.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0e260ee5-a88a-3b8f-b371-80c0e0a2f5ed.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a358a82b-2f38-3d91-80ef-096525848a3b",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/33171595_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a358a82b-2f38-3d91-80ef-096525848a3b.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a358a82b-2f38-3d91-80ef-096525848a3b.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "6c66d9c3-3aca-3063-a4a3-a91a9447a00f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6c66d9c3-3aca-3063-a4a3-a91a9447a00f.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Hint of Pink",
                                        "image": {
                                            "id": "f3dd9bdc-8eef-3dff-8ed1-a026f5209d6a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f3dd9bdc-8eef-3dff-8ed1-a026f5209d6a.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Hunter Navy",
                                        "image": {
                                            "id": "f0f865b5-8ad8-3512-9225-defc3b0e352d",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f0f865b5-8ad8-3512-9225-defc3b0e352d.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Cream",
                                        "image": {
                                            "id": "c3dc1e40-ba43-3523-85d7-d22d1c6c6ddd",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c3dc1e40-ba43-3523-85d7-d22d1c6c6ddd.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Bright White",
                                        "image": {
                                            "id": "a0f8fbe8-80e4-3dbb-85d8-22e68be1c4f1",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a0f8fbe8-80e4-3dbb-85d8-22e68be1c4f1.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_348692",
                                "name": "Girls 7-16 Cable-Knit Cotton Cardigan",
                                "nameCN": "赵露思同款女大童纯棉针织开衫，Warm White实物为白色logo",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "sweater|kids|sweaters",
                                "categoryIds": [
                                    "g87"
                                ],
                                "priceTag": "$49.15",
                                "priceTagCN": "¥360",
                                "originalPriceTag": "$70.20",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-girls-2t-16-cable-knit-cotton-cardigan?ID=348692",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S (7)",
                                        "displayName": "S (7)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M (8/10)",
                                        "displayName": "M (8/10)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L (12/14)",
                                        "displayName": "L (12/14)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL (16)",
                                        "displayName": "XL (16)"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "e4031cb8-a04d-3166-95c5-6381ea1b6beb",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/24882563_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e4031cb8-a04d-3166-95c5-6381ea1b6beb.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e4031cb8-a04d-3166-95c5-6381ea1b6beb.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4019d9a1-71d1-306f-b37f-3bcad315da9a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/24882562_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4019d9a1-71d1-306f-b37f-3bcad315da9a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4019d9a1-71d1-306f-b37f-3bcad315da9a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "124b0744-7eb6-3ecf-b04e-bdd85ef3bcf3",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/24882564_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/124b0744-7eb6-3ecf-b04e-bdd85ef3bcf3.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/124b0744-7eb6-3ecf-b04e-bdd85ef3bcf3.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0d60ce1d-8ff5-3284-9704-d64e733914a0",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/24882565_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0d60ce1d-8ff5-3284-9704-d64e733914a0.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0d60ce1d-8ff5-3284-9704-d64e733914a0.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c7eb12e2-cb44-34d1-86a3-b694ac1833b4",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/10143755_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c7eb12e2-cb44-34d1-86a3-b694ac1833b4.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c7eb12e2-cb44-34d1-86a3-b694ac1833b4.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ae865ded-c607-348a-a1b1-931dbb608fb8",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/10143757_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ae865ded-c607-348a-a1b1-931dbb608fb8.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ae865ded-c607-348a-a1b1-931dbb608fb8.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "87f61a57-bd8a-3dd3-8727-a60f177e3a9a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/24882706_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/87f61a57-bd8a-3dd3-8727-a60f177e3a9a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/87f61a57-bd8a-3dd3-8727-a60f177e3a9a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Light Blue",
                                        "image": {
                                            "id": "18a9566e-3d4e-3eb7-abd4-e370607df180",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/18a9566e-3d4e-3eb7-abd4-e370607df180.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Dark Blue",
                                        "image": {
                                            "id": "621a4d5c-8315-3c26-9e2d-2d27dff50006",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/621a4d5c-8315-3c26-9e2d-2d27dff50006.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_6861397",
                                "name": "Big Boys Cotton Chambray Sport Shirt",
                                "nameCN": "大童全棉休闲衬衫",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "shirt|kids|shirts & tops",
                                "categoryIds": [
                                    "g83"
                                ],
                                "priceTag": "$42.05",
                                "priceTagCN": "¥308",
                                "originalPriceTag": "$60.10",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-big-boys-cotton-chambray-sport-shirt?ID=6861397",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S (8)",
                                        "displayName": "S (8)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M (10/12)",
                                        "displayName": "M (10/12)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L (14/16)",
                                        "displayName": "L (14/16)"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.9折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "24e26426-1643-3392-b021-90a892111797",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/32541100_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/24e26426-1643-3392-b021-90a892111797.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/24e26426-1643-3392-b021-90a892111797.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "54878117-0b79-39ac-8909-8a189ee9f30a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/32541099_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/54878117-0b79-39ac-8909-8a189ee9f30a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/54878117-0b79-39ac-8909-8a189ee9f30a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7ba00e3f-fdca-34aa-b41d-ae496f1262cc",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/32541101_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7ba00e3f-fdca-34aa-b41d-ae496f1262cc.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7ba00e3f-fdca-34aa-b41d-ae496f1262cc.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4369a660-be96-3434-9d5b-57fc93bf1f84",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/9537888_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4369a660-be96-3434-9d5b-57fc93bf1f84.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4369a660-be96-3434-9d5b-57fc93bf1f84.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4273824f-b4fe-306b-bc73-11db3351dfdb",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/10144512_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4273824f-b4fe-306b-bc73-11db3351dfdb.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4273824f-b4fe-306b-bc73-11db3351dfdb.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Cruise Navy",
                                        "image": {
                                            "id": "997487a6-73e1-3535-bf30-35de5603a20e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/997487a6-73e1-3535-bf30-35de5603a20e.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Dark Sport Heather",
                                        "image": {
                                            "id": "56ee27c5-4d6e-338c-b4ef-153ed085fe5a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/56ee27c5-4d6e-338c-b4ef-153ed085fe5a.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "760432a0-79bc-3f16-9097-32985a54b955",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/760432a0-79bc-3f16-9097-32985a54b955.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Avery Heather",
                                        "image": {
                                            "id": "c3785c59-5f15-3be9-91c4-d8a37111c230",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c3785c59-5f15-3be9-91c4-d8a37111c230.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Red",
                                        "image": {
                                            "id": "bb70083a-568b-3761-bd4e-36a6b89adf35",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bb70083a-568b-3761-bd4e-36a6b89adf35.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_1931021",
                                "name": "Big Boys Cotton Fleece Zip Up Hoodie",
                                "nameCN": "大童款拉链连帽衫",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "sweatshirt|kids|sweatshirts & hoodies",
                                "categoryIds": [
                                    "g84"
                                ],
                                "priceTag": "$49.15",
                                "priceTagCN": "¥360",
                                "originalPriceTag": "$70.20",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-big-boys-cotton-fleece-zip-up-hoodie?ID=1931021",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S (8)",
                                        "displayName": "S (8)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M (10/12)",
                                        "displayName": "M (10/12)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L (14/16)",
                                        "displayName": "L (14/16)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL (18/20)",
                                        "displayName": "XL (18/20)"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "e90e87a6-f53d-3cac-a118-b1c6b866ede5",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/24881745_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e90e87a6-f53d-3cac-a118-b1c6b866ede5.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e90e87a6-f53d-3cac-a118-b1c6b866ede5.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "1402db25-2ab1-3772-be34-cf2305e4573b",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/24881746_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1402db25-2ab1-3772-be34-cf2305e4573b.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1402db25-2ab1-3772-be34-cf2305e4573b.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fcfbb98d-95d3-3dbf-a5b0-c5cfc996ea1c",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/23457208_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fcfbb98d-95d3-3dbf-a5b0-c5cfc996ea1c.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fcfbb98d-95d3-3dbf-a5b0-c5cfc996ea1c.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4c55bb62-d005-3fd3-9e3b-91a41a0087ec",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/8901465_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4c55bb62-d005-3fd3-9e3b-91a41a0087ec.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4c55bb62-d005-3fd3-9e3b-91a41a0087ec.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e421c267-b63f-3e68-a3c3-bce9d88c2412",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/8901463_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e421c267-b63f-3e68-a3c3-bce9d88c2412.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e421c267-b63f-3e68-a3c3-bce9d88c2412.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "White",
                                        "image": {
                                            "id": "ad8e3ae6-1a5d-3fbb-8edd-a404fee592e0",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ad8e3ae6-1a5d-3fbb-8edd-a404fee592e0.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Light Blue",
                                        "image": {
                                            "id": "8ef6299b-4b41-3072-b4c6-3b9b4b3d9e64",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8ef6299b-4b41-3072-b4c6-3b9b4b3d9e64.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "New Rose",
                                        "image": {
                                            "id": "b1b372fa-3c7b-3301-acbe-814db8a8b8b0",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b1b372fa-3c7b-3301-acbe-814db8a8b8b0.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Yellow",
                                        "image": {
                                            "id": "eb7fa3c1-b799-3f73-b8c3-7b2b28b29b39",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/eb7fa3c1-b799-3f73-b8c3-7b2b28b29b39.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Light Blue Stripe",
                                        "image": {
                                            "id": "d4c24579-81f9-3c72-95d3-51de690593b9",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d4c24579-81f9-3c72-95d3-51de690593b9.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_213890",
                                "name": "Big Boys Embroidered Pony Logo Cotton Oxford Shirt",
                                "nameCN": "男大童 牛津衬衫 纯棉 多款配色",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "shirt|kids|shirts & tops",
                                "categoryIds": [
                                    "g85",
                                    "g83"
                                ],
                                "priceTag": "$42.05",
                                "priceTagCN": "¥308",
                                "originalPriceTag": "$60.10",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-big-boys-embroidered-pony-logo-cotton-oxford-shirt?ID=213890",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S (8)",
                                        "displayName": "S (8)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M (10/12)",
                                        "displayName": "M (10/12)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L (14/16)",
                                        "displayName": "L (14/16)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL (18/20)",
                                        "displayName": "XL (18/20)"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.9折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "766460cc-f1b5-3cb1-8ad3-72434c39fb8a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/33277528_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/766460cc-f1b5-3cb1-8ad3-72434c39fb8a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/766460cc-f1b5-3cb1-8ad3-72434c39fb8a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e284891d-3733-3aab-8e73-6ccca9f90cdc",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/33277527_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e284891d-3733-3aab-8e73-6ccca9f90cdc.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e284891d-3733-3aab-8e73-6ccca9f90cdc.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Blue",
                                        "image": {
                                            "id": "108517d5-9aac-300b-9bda-b0f3cc68596c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/108517d5-9aac-300b-9bda-b0f3cc68596c.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Red",
                                        "image": {
                                            "id": "334384cf-8b4b-3243-a0dc-11f7654821e8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/334384cf-8b4b-3243-a0dc-11f7654821e8.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Camel Heather",
                                        "image": {
                                            "id": "f3e85fa2-3f58-3491-9ef7-93d9cad67bda",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f3e85fa2-3f58-3491-9ef7-93d9cad67bda.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Windsor Heather",
                                        "image": {
                                            "id": "eb432f2f-7b42-333d-a10e-97cbd5cf9be2",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/eb432f2f-7b42-333d-a10e-97cbd5cf9be2.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Preppy Pink",
                                        "image": {
                                            "id": "a055901b-d079-3f54-bfed-fd6b31171bf9",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a055901b-d079-3f54-bfed-fd6b31171bf9.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_20389308",
                                "name": "Girls 7-16 Mini-Cable Cotton Cardigan",
                                "nameCN": "大童款 棉质针织衫",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "sweater|kids|sweaters",
                                "categoryIds": [
                                    "g87"
                                ],
                                "priceTag": "$42.05",
                                "priceTagCN": "¥308",
                                "originalPriceTag": "$60.10",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-girls-7-16-mini-cable-cotton-cardigan?ID=20389308",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S (7)",
                                        "displayName": "S (7)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M (8/10)",
                                        "displayName": "M (8/10)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L (12/14)",
                                        "displayName": "L (12/14)"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.9折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "20804ea6-023e-3d06-8fed-1e97bfc1490f",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/32540738_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/20804ea6-023e-3d06-8fed-1e97bfc1490f.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/20804ea6-023e-3d06-8fed-1e97bfc1490f.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "56e2255b-450a-3bdf-a76a-8b118b67240e",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/32540739_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/56e2255b-450a-3bdf-a76a-8b118b67240e.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/56e2255b-450a-3bdf-a76a-8b118b67240e.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4fdb98c7-8dea-334f-b7b7-257e183785a8",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/32540737_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4fdb98c7-8dea-334f-b7b7-257e183785a8.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4fdb98c7-8dea-334f-b7b7-257e183785a8.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ea492541-f603-3630-916a-ab3fe75d8eaf",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/19555566_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ea492541-f603-3630-916a-ab3fe75d8eaf.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ea492541-f603-3630-916a-ab3fe75d8eaf.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "600f509e-f730-344b-b50d-e13e30a0ea44",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/19555303_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/600f509e-f730-344b-b50d-e13e30a0ea44.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/600f509e-f730-344b-b50d-e13e30a0ea44.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Scottsdale Blue",
                                        "image": {
                                            "id": "fba33b87-a237-37a8-83e8-4732fd2fadb2",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fba33b87-a237-37a8-83e8-4732fd2fadb2.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Rl 2000 Red",
                                        "image": {
                                            "id": "65d6cb70-3b0b-33f0-8d54-5e211353074c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/65d6cb70-3b0b-33f0-8d54-5e211353074c.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Andover Heather Gray",
                                        "image": {
                                            "id": "853e1e48-50ac-3f54-9362-58ec23df301b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/853e1e48-50ac-3f54-9362-58ec23df301b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Polo Black",
                                        "image": {
                                            "id": "814bd03e-7a9a-34e6-aa52-f0a0b3eb0015",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/814bd03e-7a9a-34e6-aa52-f0a0b3eb0015.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Carmel Pink",
                                        "image": {
                                            "id": "21293a0c-c3d0-3c87-9a81-95ab339a562b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/21293a0c-c3d0-3c87-9a81-95ab339a562b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "White",
                                        "image": {
                                            "id": "e14de398-52d7-3329-9e69-4075ba57335c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e14de398-52d7-3329-9e69-4075ba57335c.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Cruise Navy",
                                        "image": {
                                            "id": "e5cc749f-b048-35df-accb-2ed8d3efb20b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e5cc749f-b048-35df-accb-2ed8d3efb20b.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_12631499",
                                "name": "Big Boys Cotton Jersey Crewneck T-Shirt",
                                "nameCN": "【周雨彤同款】大童款全棉短袖T恤",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "t-shirt|kids|shirts & tops",
                                "categoryIds": [
                                    "gbc",
                                    "g85"
                                ],
                                "priceTag": "$24.75",
                                "priceTagCN": "¥182",
                                "originalPriceTag": "$35.35",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-big-boys-cotton-jersey-crewneck-t-shirt?ID=12631499",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S (8)",
                                        "displayName": "S (8)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M (10/12)",
                                        "displayName": "M (10/12)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L (14/16)",
                                        "displayName": "L (14/16)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL (18/20)",
                                        "displayName": "XL (18/20)"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "ff9e604b-cae6-374b-9ae2-c82ea453c5c1",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/20362919_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ff9e604b-cae6-374b-9ae2-c82ea453c5c1.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ff9e604b-cae6-374b-9ae2-c82ea453c5c1.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "2c4b017f-657e-3bab-a0cb-7aa7cbc97e14",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/20362921_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2c4b017f-657e-3bab-a0cb-7aa7cbc97e14.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2c4b017f-657e-3bab-a0cb-7aa7cbc97e14.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "bd67f5dc-b96d-3dba-8d41-cdbabd4af86f",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/21211417_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/bd67f5dc-b96d-3dba-8d41-cdbabd4af86f.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/bd67f5dc-b96d-3dba-8d41-cdbabd4af86f.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Cruise Navy",
                                        "image": {
                                            "id": "acd2d7fb-e59c-32fe-be9d-3d999fb04e1a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/acd2d7fb-e59c-32fe-be9d-3d999fb04e1a.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Rl2000 Red",
                                        "image": {
                                            "id": "d150e65f-1369-31b8-8753-d328b2f4cb73",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d150e65f-1369-31b8-8753-d328b2f4cb73.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "White",
                                        "image": {
                                            "id": "d8fca103-9eb1-3a37-9b18-377255e0a763",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d8fca103-9eb1-3a37-9b18-377255e0a763.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Andover Heather",
                                        "image": {
                                            "id": "ea493bbe-91ab-3e2d-910b-ad70bdbb6ce0",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ea493bbe-91ab-3e2d-910b-ad70bdbb6ce0.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "RL Black",
                                        "image": {
                                            "id": "97c30905-38d0-3e44-b48d-d22beeb434a3",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/97c30905-38d0-3e44-b48d-d22beeb434a3.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_12977637",
                                "name": "Big Boys Cotton Jersey Long-Sleeve T-shirt",
                                "nameCN": "大童平纹针织长袖 T 恤",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "t-shirt|kids|shirts & tops",
                                "categoryIds": [
                                    "g85",
                                    "gbc"
                                ],
                                "priceTag": "$27.95",
                                "priceTagCN": "¥205",
                                "originalPriceTag": "$39.90",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-big-boys-cotton-jersey-long-sleeve-t-shirt?ID=12977637",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S (8)",
                                        "displayName": "S (8)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M (10/12)",
                                        "displayName": "M (10/12)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L (14/16)",
                                        "displayName": "L (14/16)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL (18/20)",
                                        "displayName": "XL (18/20)"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "664bfca1-d711-3f35-ad43-1943d5d951b9",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/19555551_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/664bfca1-d711-3f35-ad43-1943d5d951b9.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/664bfca1-d711-3f35-ad43-1943d5d951b9.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "de7c90a2-326e-352a-865d-99e8f5a20351",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/19555294_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/de7c90a2-326e-352a-865d-99e8f5a20351.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/de7c90a2-326e-352a-865d-99e8f5a20351.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Carmel Pink",
                                        "image": {
                                            "id": "c1f44d5f-ded6-3f94-80e6-659d7d6bc0b0",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c1f44d5f-ded6-3f94-80e6-659d7d6bc0b0.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Polo Black",
                                        "image": {
                                            "id": "73dd5a74-bc19-35fc-8a5e-a47c6ca124a1",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/73dd5a74-bc19-35fc-8a5e-a47c6ca124a1.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "White",
                                        "image": {
                                            "id": "6297dda3-2978-3fa3-a136-eb1a595ccd1c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6297dda3-2978-3fa3-a136-eb1a595ccd1c.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Rl2000 Red",
                                        "image": {
                                            "id": "54c43d38-21ba-38d7-8096-f12a554fafe6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/54c43d38-21ba-38d7-8096-f12a554fafe6.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Cruise Navy",
                                        "image": {
                                            "id": "420c684a-0f6d-3cb8-b5ae-70994bc67829",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/420c684a-0f6d-3cb8-b5ae-70994bc67829.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Andover Heather Gray",
                                        "image": {
                                            "id": "3425fea5-696f-31d6-973b-a9c10511e27d",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3425fea5-696f-31d6-973b-a9c10511e27d.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_12631506",
                                "name": "Big Boys Cotton Jersey V-Neck T-Shirt",
                                "nameCN": "大童款 V领 棉质T恤",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Polo Ralph Lauren",
                                "displayBrand": "Ralph Lauren",
                                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                                "category": "t-shirt|kids|shirts & tops",
                                "categoryIds": [
                                    "g85"
                                ],
                                "priceTag": "$24.75",
                                "priceTagCN": "¥182",
                                "originalPriceTag": "$35.35",
                                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-big-boys-cotton-jersey-v-neck-t-shirt?ID=12631506",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S (8)",
                                        "displayName": "S (8)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M (10/12)",
                                        "displayName": "M (10/12)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L (14/16)",
                                        "displayName": "L (14/16)"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL (18/20)",
                                        "displayName": "XL (18/20)"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    }
                ]
            },
            {
                "id": "health",
                "title": "健康榜",
                "categoryIds": [
                    "6",
                    "d",
                    "m"
                ],
                "sections": [],
                "sort": 9,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "fd6e9db6-3c30-3201-9830-90f9b720126f",
                                        "originalURL": "https://pics.drugstore.com/prodimg/482621/900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fd6e9db6-3c30-3201-9830-90f9b720126f.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fd6e9db6-3c30-3201-9830-90f9b720126f.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "eb094383-879c-3ea7-a3fe-d6dad71a2ce1",
                                        "originalURL": "https://pics.drugstore.com/prodimg/482621/2_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/eb094383-879c-3ea7-a3fe-d6dad71a2ce1.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/eb094383-879c-3ea7-a3fe-d6dad71a2ce1.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "walgreens_prod6123639",
                                "name": "Ultra CoQ10 100 mg Dietary Supplement Softgels",
                                "nameCN": "Qunol 超级辅酶Q10 三倍吸收 100mg  备孕/心脏/抗衰老",
                                "description": [],
                                "merchantId": "63ea689e-3888-7d2a-25b1-f57a6f86748f",
                                "brand": "Qunol",
                                "displayBrand": "Qunol",
                                "brandId": "b327e495-e087-3615-8509-d340ba200ad6",
                                "category": "vitamins|supplements|coq10",
                                "categoryIds": [
                                    "d21"
                                ],
                                "priceTag": "$57.72",
                                "priceTagCN": "¥423",
                                "officialURL": "https://www.walgreens.com/store/c/qunol-ultra-coq10-100-mg-dietary-supplement-softgels/ID=prod6123639-product",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [
                                "满折",
                                "满免"
                            ],
                            "merchantName": "Walgreens",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "满免",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "满二免一",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$40享8折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "cf8d8ee1-dad5-34ac-86c9-05e9f302fdde",
                                        "originalURL": "https://pics.walgreens.com/prodimg/188988/900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cf8d8ee1-dad5-34ac-86c9-05e9f302fdde.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cf8d8ee1-dad5-34ac-86c9-05e9f302fdde.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "68de7801-9b8f-3e0f-87bd-410f213def9b",
                                        "originalURL": "https://pics.walgreens.com/prodimg/188988/2_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/68de7801-9b8f-3e0f-87bd-410f213def9b.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/68de7801-9b8f-3e0f-87bd-410f213def9b.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "cf7922e3-606e-3fe7-81db-fa6a6b835d24",
                                        "originalURL": "https://pics.walgreens.com/prodimg/188988/3_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cf7922e3-606e-3fe7-81db-fa6a6b835d24.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cf7922e3-606e-3fe7-81db-fa6a6b835d24.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "46a38a40-b4ca-3217-ac07-ec4543982150",
                                        "originalURL": "https://pics.walgreens.com/prodimg/188988/4_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/46a38a40-b4ca-3217-ac07-ec4543982150.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/46a38a40-b4ca-3217-ac07-ec4543982150.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "90c15a30-3c07-351f-94d0-6a9f657de33e",
                                        "originalURL": "https://pics.walgreens.com/prodimg/188988/5_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/90c15a30-3c07-351f-94d0-6a9f657de33e.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/90c15a30-3c07-351f-94d0-6a9f657de33e.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "98ffd886-b024-3f9c-8ae3-6713bb7328a6",
                                        "originalURL": "https://pics.walgreens.com/prodimg/188988/6_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/98ffd886-b024-3f9c-8ae3-6713bb7328a6.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/98ffd886-b024-3f9c-8ae3-6713bb7328a6.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7a0b2d83-b1c0-35ed-ab56-9c8e74790ed7",
                                        "originalURL": "https://pics.walgreens.com/prodimg/188988/7_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7a0b2d83-b1c0-35ed-ab56-9c8e74790ed7.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7a0b2d83-b1c0-35ed-ab56-9c8e74790ed7.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d7af63d0-d0a4-3380-bd0e-a173db59ff98",
                                        "originalURL": "https://pics.walgreens.com/prodimg/188988/8_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d7af63d0-d0a4-3380-bd0e-a173db59ff98.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d7af63d0-d0a4-3380-bd0e-a173db59ff98.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "walgreens_prod3946814",
                                "name": "Joint Health Advanced + MSM with Glucosamine Chondroitin, Tablets",
                                "nameCN": "氨糖软骨素含钙片 MSM 高能绿标120粒",
                                "description": [],
                                "merchantId": "63ea689e-3888-7d2a-25b1-f57a6f86748f",
                                "brand": "Schiff Move Free",
                                "displayBrand": "Move Free",
                                "brandId": "f761f04d-18ec-38c1-a5b7-f730b753ca5c",
                                "category": "by|shop|benefit|health|joint|vitamins|bone|supplements",
                                "categoryIds": [
                                    "d4a",
                                    "d07"
                                ],
                                "priceTag": "$29.99",
                                "priceTagCN": "¥220",
                                "officialURL": "https://www.walgreens.com/store/c/schiff-move-free-joint-health-advanced---msm-with-glucosamine-chondroitin,-tablets/ID=prod3946814-product",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [
                                "满折"
                            ],
                            "merchantName": "Walgreens",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "满$40享8折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "a0ddb765-2e8d-308a-ae14-d90b369c8b4d",
                                        "originalURL": "https://pics.walgreens.com/prodimg/338906/900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a0ddb765-2e8d-308a-ae14-d90b369c8b4d.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a0ddb765-2e8d-308a-ae14-d90b369c8b4d.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "aaca020e-30f9-3d05-bea3-7b327ecd54d6",
                                        "originalURL": "https://pics.walgreens.com/prodimg/338906/2_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/aaca020e-30f9-3d05-bea3-7b327ecd54d6.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/aaca020e-30f9-3d05-bea3-7b327ecd54d6.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a2acd034-e9fb-361f-a969-04b0471804b9",
                                        "originalURL": "https://pics.walgreens.com/prodimg/338906/3_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a2acd034-e9fb-361f-a969-04b0471804b9.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a2acd034-e9fb-361f-a969-04b0471804b9.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "53e004fa-460e-324f-85ea-caa8d65af479",
                                        "originalURL": "https://pics.walgreens.com/prodimg/338906/4_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/53e004fa-460e-324f-85ea-caa8d65af479.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/53e004fa-460e-324f-85ea-caa8d65af479.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "99b0270d-5c67-3fae-b8f4-75a07bc7156e",
                                        "originalURL": "https://pics.walgreens.com/prodimg/338906/5_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/99b0270d-5c67-3fae-b8f4-75a07bc7156e.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/99b0270d-5c67-3fae-b8f4-75a07bc7156e.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a79370e4-ea94-3c5c-8aae-d74cbda0a87c",
                                        "originalURL": "https://pics.walgreens.com/prodimg/338906/6_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a79370e4-ea94-3c5c-8aae-d74cbda0a87c.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a79370e4-ea94-3c5c-8aae-d74cbda0a87c.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "3f476687-6855-3139-a342-35b3b54a6733",
                                        "originalURL": "https://pics.walgreens.com/prodimg/338906/7_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3f476687-6855-3139-a342-35b3b54a6733.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3f476687-6855-3139-a342-35b3b54a6733.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "3f5a720b-2c3c-324a-9491-8f9a0f06e487",
                                        "originalURL": "https://pics.walgreens.com/prodimg/338906/8_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3f5a720b-2c3c-324a-9491-8f9a0f06e487.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3f5a720b-2c3c-324a-9491-8f9a0f06e487.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e9690960-662d-3288-98b6-8eea617ee898",
                                        "originalURL": "https://pics.drugstore.com/prodimg/338906/9_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e9690960-662d-3288-98b6-8eea617ee898.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e9690960-662d-3288-98b6-8eea617ee898.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "walgreens_prod6063821",
                                "name": "CoQ10 200mg Softgels",
                                "nameCN": "辅酶 CoQ10软胶囊200mg 80粒",
                                "description": [],
                                "merchantId": "63ea689e-3888-7d2a-25b1-f57a6f86748f",
                                "brand": "Nature Made",
                                "displayBrand": "Nature Made",
                                "brandId": "ff12a199-57f4-3f90-af53-f608b7af0ebe",
                                "category": "vitamins|supplements|coq10",
                                "categoryIds": [
                                    "d21"
                                ],
                                "priceTag": "$53.28",
                                "priceTagCN": "¥391",
                                "officialURL": "https://www.walgreens.com/store/c/nature-made-coq10-200mg-softgels/ID=prod6063821-product",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [
                                "满折",
                                "满免"
                            ],
                            "merchantName": "Walgreens",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "满免",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "满二免一",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$40享8折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "be8aac73-84a0-3b81-b6c3-6f130a20baba",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/be8aac73-84a0-3b81-b6c3-6f130a20baba.jpg",
                                            "width": 1600,
                                            "height": 1600,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/be8aac73-84a0-3b81-b6c3-6f130a20baba.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "bonpont_by2212021280007",
                                "name": "【10件包邮装】Hisamitsu  久光制药 关节痛贴 颈肩腰椎贴 7片/袋*10",
                                "description": [],
                                "merchantId": "c0720238-225c-353e-ab26-1ac240a78e83",
                                "displayBrand": "Hisamitsu",
                                "brandId": "573a6132-c1ff-3421-b10b-4fe6fdc60557",
                                "categoryIds": [
                                    "m34"
                                ],
                                "priceTag": "$42.18",
                                "priceTagCN": "¥309",
                                "originalPriceTag": "$120",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "7片/袋",
                                        "displayName": "7片/袋"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.6折",
                            "activityOffs": [
                                "满折"
                            ],
                            "merchantName": "Bonpont",
                            "origin": "[中国香港]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.6折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件7.6折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国香港"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "d0fb0d1e-6ca0-3704-b4e8-69e0f956acab",
                                        "originalURL": "https://pics.drugstore.com/prodimg/599686/900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d0fb0d1e-6ca0-3704-b4e8-69e0f956acab.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d0fb0d1e-6ca0-3704-b4e8-69e0f956acab.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "39f5af2c-339f-3503-88e0-6f18eaf90893",
                                        "originalURL": "https://pics.drugstore.com/prodimg/599686/2_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/39f5af2c-339f-3503-88e0-6f18eaf90893.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/39f5af2c-339f-3503-88e0-6f18eaf90893.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "219f1b0c-e7ba-3d0c-90dc-a94bc1797f04",
                                        "originalURL": "https://pics.drugstore.com/prodimg/232858/3_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/219f1b0c-e7ba-3d0c-90dc-a94bc1797f04.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/219f1b0c-e7ba-3d0c-90dc-a94bc1797f04.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "652acc0c-c170-3f82-b27d-8aa510d9ef2f",
                                        "originalURL": "https://pics.drugstore.com/prodimg/599686/4_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/652acc0c-c170-3f82-b27d-8aa510d9ef2f.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/652acc0c-c170-3f82-b27d-8aa510d9ef2f.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7d679b66-9ccb-39e3-bd6f-45e44c85f88c",
                                        "originalURL": "https://pics.drugstore.com/prodimg/599686/5_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7d679b66-9ccb-39e3-bd6f-45e44c85f88c.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7d679b66-9ccb-39e3-bd6f-45e44c85f88c.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "444c7774-bbe5-3b4c-a061-cc0e71168209",
                                        "originalURL": "https://pics.drugstore.com/prodimg/599686/6_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/444c7774-bbe5-3b4c-a061-cc0e71168209.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/444c7774-bbe5-3b4c-a061-cc0e71168209.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c4d10707-128e-3aa5-9bb3-e55eceea2199",
                                        "originalURL": "https://pics.drugstore.com/prodimg/599686/7_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c4d10707-128e-3aa5-9bb3-e55eceea2199.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c4d10707-128e-3aa5-9bb3-e55eceea2199.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "be0470c5-26ed-39c0-96fa-5d0dd5a78217",
                                        "originalURL": "https://pics.drugstore.com/prodimg/599686/8_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/be0470c5-26ed-39c0-96fa-5d0dd5a78217.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/be0470c5-26ed-39c0-96fa-5d0dd5a78217.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "19a66a1d-3626-3166-afbc-1ca0223eaada",
                                        "originalURL": "https://pics.drugstore.com/prodimg/599686/9_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/19a66a1d-3626-3166-afbc-1ca0223eaada.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/19a66a1d-3626-3166-afbc-1ca0223eaada.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "73ced3d6-b4cc-3735-8905-1fa536b7da7f",
                                        "originalURL": "https://pics.drugstore.com/prodimg/599686/10_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/73ced3d6-b4cc-3735-8905-1fa536b7da7f.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/73ced3d6-b4cc-3735-8905-1fa536b7da7f.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "walgreens_prod6358196",
                                "name": "Fish Oil 1200 mg Softgels",
                                "nameCN": "鱼油1200mg 100粒",
                                "description": [],
                                "merchantId": "63ea689e-3888-7d2a-25b1-f57a6f86748f",
                                "brand": "Nature Made",
                                "displayBrand": "Nature Made",
                                "brandId": "ff12a199-57f4-3f90-af53-f608b7af0ebe",
                                "category": "omegas|fish|vitamins|oil|supplements",
                                "categoryIds": [
                                    "d51",
                                    "d12"
                                ],
                                "priceTag": "$34.99",
                                "priceTagCN": "¥257",
                                "officialURL": "https://www.walgreens.com/store/c/nature-made-fish-oil-1200-mg-softgels/ID=prod6358196-product",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [
                                "满折",
                                "满免"
                            ],
                            "merchantName": "Walgreens",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "满免",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "满二免一",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$40享8折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "0bc50d96-6fef-3a90-981f-6b447286f574",
                                        "originalURL": "https://pics.drugstore.com/prodimg/647097/900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0bc50d96-6fef-3a90-981f-6b447286f574.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0bc50d96-6fef-3a90-981f-6b447286f574.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "16b50f67-4ff3-36d6-947f-0275d6643def",
                                        "originalURL": "https://pics.drugstore.com/prodimg/647097/2_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/16b50f67-4ff3-36d6-947f-0275d6643def.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/16b50f67-4ff3-36d6-947f-0275d6643def.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "41f94895-0274-351b-96dd-b1db75a8f4b5",
                                        "originalURL": "https://pics.drugstore.com/prodimg/647097/3_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/41f94895-0274-351b-96dd-b1db75a8f4b5.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/41f94895-0274-351b-96dd-b1db75a8f4b5.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9825cc1c-979f-3b71-b5b6-b7382a649ef6",
                                        "originalURL": "https://pics.drugstore.com/prodimg/647097/4_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9825cc1c-979f-3b71-b5b6-b7382a649ef6.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9825cc1c-979f-3b71-b5b6-b7382a649ef6.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9ee614cf-cadf-3693-8f13-fea7d1003d83",
                                        "originalURL": "https://pics.drugstore.com/prodimg/647097/5_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9ee614cf-cadf-3693-8f13-fea7d1003d83.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9ee614cf-cadf-3693-8f13-fea7d1003d83.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "33ae98d4-81c3-34c9-b16f-51b295690878",
                                        "originalURL": "https://pics.drugstore.com/prodimg/647097/6_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/33ae98d4-81c3-34c9-b16f-51b295690878.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/33ae98d4-81c3-34c9-b16f-51b295690878.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4bfff08b-3b7e-39e2-92e5-8afaa28b65a3",
                                        "originalURL": "https://pics.drugstore.com/prodimg/647097/7_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4bfff08b-3b7e-39e2-92e5-8afaa28b65a3.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4bfff08b-3b7e-39e2-92e5-8afaa28b65a3.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "3ac796fb-e6cd-3bdb-99e3-f2039ce4993b",
                                        "originalURL": "https://pics.drugstore.com/prodimg/647097/8_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3ac796fb-e6cd-3bdb-99e3-f2039ce4993b.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3ac796fb-e6cd-3bdb-99e3-f2039ce4993b.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8a50904c-1fa5-377c-8e77-590a56a82bee",
                                        "originalURL": "https://pics.drugstore.com/prodimg/647097/9_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8a50904c-1fa5-377c-8e77-590a56a82bee.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8a50904c-1fa5-377c-8e77-590a56a82bee.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "walgreens_300425544",
                                "name": "Vitamin D3 + K2 Softgels",
                                "description": [],
                                "merchantId": "63ea689e-3888-7d2a-25b1-f57a6f86748f",
                                "brand": "Nature Made",
                                "displayBrand": "Nature Made",
                                "brandId": "ff12a199-57f4-3f90-af53-f608b7af0ebe",
                                "category": "letter|vitamins|vitamin|a-k|supplements|d",
                                "categoryIds": [
                                    "d45"
                                ],
                                "priceTag": "$18.99",
                                "priceTagCN": "¥140",
                                "officialURL": "https://www.walgreens.com/store/c/nature-made-vitamin-d3---k2-softgels/ID=300425544-product",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [
                                "满折",
                                "满免"
                            ],
                            "merchantName": "Walgreens",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "满免",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "满二免一",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$40享8折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "a6164c9f-ddb1-323d-9fac-e160c7fb8188",
                                        "originalURL": "https://pics.drugstore.com/prodimg/635271/900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a6164c9f-ddb1-323d-9fac-e160c7fb8188.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a6164c9f-ddb1-323d-9fac-e160c7fb8188.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5b27f646-a0e2-30de-a52f-ca1b668ca4f5",
                                        "originalURL": "https://pics.drugstore.com/prodimg/635271/2_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5b27f646-a0e2-30de-a52f-ca1b668ca4f5.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5b27f646-a0e2-30de-a52f-ca1b668ca4f5.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "219f1b0c-e7ba-3d0c-90dc-a94bc1797f04",
                                        "originalURL": "https://pics.drugstore.com/prodimg/232858/3_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/219f1b0c-e7ba-3d0c-90dc-a94bc1797f04.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/219f1b0c-e7ba-3d0c-90dc-a94bc1797f04.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "90b67381-283f-3273-9e58-5b05472d43f5",
                                        "originalURL": "https://pics.drugstore.com/prodimg/635271/4_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/90b67381-283f-3273-9e58-5b05472d43f5.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/90b67381-283f-3273-9e58-5b05472d43f5.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c0fe8043-083b-3208-b533-80ff3f3a0b9b",
                                        "originalURL": "https://pics.drugstore.com/prodimg/635271/5_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c0fe8043-083b-3208-b533-80ff3f3a0b9b.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c0fe8043-083b-3208-b533-80ff3f3a0b9b.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c37d0237-5fd8-3a2a-a142-6f0508477d64",
                                        "originalURL": "https://pics.drugstore.com/prodimg/635271/6_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c37d0237-5fd8-3a2a-a142-6f0508477d64.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c37d0237-5fd8-3a2a-a142-6f0508477d64.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c4d10707-128e-3aa5-9bb3-e55eceea2199",
                                        "originalURL": "https://pics.drugstore.com/prodimg/599686/7_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c4d10707-128e-3aa5-9bb3-e55eceea2199.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c4d10707-128e-3aa5-9bb3-e55eceea2199.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b5e05b88-10e9-353a-a23b-50fcf55fba95",
                                        "originalURL": "https://pics.drugstore.com/prodimg/635271/8_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b5e05b88-10e9-353a-a23b-50fcf55fba95.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b5e05b88-10e9-353a-a23b-50fcf55fba95.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a8a26909-be6a-3852-a7e3-ad90a01bfd69",
                                        "originalURL": "https://pics.drugstore.com/prodimg/635271/9_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a8a26909-be6a-3852-a7e3-ad90a01bfd69.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a8a26909-be6a-3852-a7e3-ad90a01bfd69.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "2637c80c-2c0b-344e-8708-ffc5191eedd5",
                                        "originalURL": "https://pics.drugstore.com/prodimg/635271/10_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2637c80c-2c0b-344e-8708-ffc5191eedd5.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2637c80c-2c0b-344e-8708-ffc5191eedd5.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "walgreens_300414158",
                                "name": "Fish Oil 2800 mg Softgels",
                                "description": [],
                                "merchantId": "63ea689e-3888-7d2a-25b1-f57a6f86748f",
                                "brand": "Nature Made",
                                "displayBrand": "Nature Made",
                                "brandId": "ff12a199-57f4-3f90-af53-f608b7af0ebe",
                                "category": "home",
                                "categoryIds": [
                                    "d12"
                                ],
                                "priceTag": "$31.99",
                                "priceTagCN": "¥235",
                                "officialURL": "https://www.walgreens.com/store/c/nature-made-fish-oil-2800-mg-softgels/ID=300414158-product",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [
                                "满折"
                            ],
                            "merchantName": "Walgreens",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "满$40享8折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "958ee5e8-a174-3447-b1c8-86dd0096512e",
                                        "originalURL": "https://pics.drugstore.com/prodimg/356047/900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/958ee5e8-a174-3447-b1c8-86dd0096512e.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/958ee5e8-a174-3447-b1c8-86dd0096512e.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "798e5191-ba0f-31bc-9a36-b5c17a9842b3",
                                        "originalURL": "https://pics.drugstore.com/prodimg/356052/2_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/798e5191-ba0f-31bc-9a36-b5c17a9842b3.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/798e5191-ba0f-31bc-9a36-b5c17a9842b3.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b207f32c-c0ae-3db4-a02b-960df330ba04",
                                        "originalURL": "https://pics.drugstore.com/prodimg/356047/3_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b207f32c-c0ae-3db4-a02b-960df330ba04.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b207f32c-c0ae-3db4-a02b-960df330ba04.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "57a0a4f1-d9e0-34e8-8bc2-ac41389d83e4",
                                        "originalURL": "https://pics.drugstore.com/prodimg/356047/4_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/57a0a4f1-d9e0-34e8-8bc2-ac41389d83e4.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/57a0a4f1-d9e0-34e8-8bc2-ac41389d83e4.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5c631242-36c5-30f5-a5c5-3fd1a6175ebf",
                                        "originalURL": "https://pics.drugstore.com/prodimg/356052/5_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5c631242-36c5-30f5-a5c5-3fd1a6175ebf.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5c631242-36c5-30f5-a5c5-3fd1a6175ebf.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "aad1d110-c992-3524-997c-2f81991e8afd",
                                        "originalURL": "https://pics.drugstore.com/prodimg/356047/6_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/aad1d110-c992-3524-997c-2f81991e8afd.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/aad1d110-c992-3524-997c-2f81991e8afd.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fdf1df35-1e8b-3429-885c-c901ca6a812f",
                                        "originalURL": "https://pics.drugstore.com/prodimg/356047/7_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fdf1df35-1e8b-3429-885c-c901ca6a812f.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fdf1df35-1e8b-3429-885c-c901ca6a812f.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fdf1df35-1e8b-3429-885c-c901ca6a812f",
                                        "originalURL": "https://pics.drugstore.com/prodimg/356047/7_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fdf1df35-1e8b-3429-885c-c901ca6a812f.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fdf1df35-1e8b-3429-885c-c901ca6a812f.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "walgreens_prod6091533",
                                "name": "Super B Complex with Vitamin C and Folic Acid Tablets",
                                "nameCN": "维生素B复合片",
                                "description": [],
                                "merchantId": "63ea689e-3888-7d2a-25b1-f57a6f86748f",
                                "brand": "Nature Made",
                                "displayBrand": "Nature Made",
                                "brandId": "ff12a199-57f4-3f90-af53-f608b7af0ebe",
                                "category": "b|letter|vitamins|vitamin|a-k|supplements",
                                "categoryIds": [
                                    "d4g"
                                ],
                                "priceTag": "$16.99",
                                "priceTagCN": "¥125",
                                "officialURL": "https://www.walgreens.com/store/c/nature-made-super-b-complex-with-vitamin-c-and-folic-acid-tablets/ID=prod6091533-product",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [
                                "满折",
                                "满免"
                            ],
                            "merchantName": "Walgreens",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "满免",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "满二免一",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$40享8折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    }
                ]
            },
            {
                "id": "life",
                "title": "生活榜",
                "categoryIds": [
                    "4",
                    "h",
                    "i",
                    "j",
                    "n"
                ],
                "sections": [],
                "sort": 10,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "5823e2b5-6785-3155-83c4-a7be156c85fd",
                                        "originalURL": "https://images.urbndata.com/is/image/UrbanOutfitters/84382746_616_b?$redesign-zoom-5x$",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5823e2b5-6785-3155-83c4-a7be156c85fd.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5823e2b5-6785-3155-83c4-a7be156c85fd.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e4af2d66-64ba-3af1-a8a4-1d0fc1f02a4e",
                                        "originalURL": "https://images.urbndata.com/is/image/UrbanOutfitters/84382746_616_b2?$redesign-zoom-5x$",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e4af2d66-64ba-3af1-a8a4-1d0fc1f02a4e.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e4af2d66-64ba-3af1-a8a4-1d0fc1f02a4e.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "2ab78230-b946-3cc6-8ee5-a41936a12c6c",
                                        "originalURL": "https://images.urbndata.com/is/image/UrbanOutfitters/84382746_616_b3?$redesign-zoom-5x$",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2ab78230-b946-3cc6-8ee5-a41936a12c6c.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2ab78230-b946-3cc6-8ee5-a41936a12c6c.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Pointsettia",
                                        "image": {
                                            "id": "a5097ce5-ffdf-3f79-aa35-ed0f3857eae4",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a5097ce5-ffdf-3f79-aa35-ed0f3857eae4.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Winter Green",
                                        "image": {
                                            "id": "ee2c0447-29e3-3930-92b5-2e3c6137ebf6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ee2c0447-29e3-3930-92b5-2e3c6137ebf6.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Autumn Vista",
                                        "image": {
                                            "id": "0213ed57-af27-3a33-a641-31448ccec305",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0213ed57-af27-3a33-a641-31448ccec305.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Burgundy Bay",
                                        "image": {
                                            "id": "fc2a2d7c-7ea5-3ea9-b6e2-7a1219b07d2b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fc2a2d7c-7ea5-3ea9-b6e2-7a1219b07d2b.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Terracotta Sunset",
                                        "image": {
                                            "id": "20d444ab-f3e9-314f-873d-4a5eec144830",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/20d444ab-f3e9-314f-873d-4a5eec144830.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Shy Marshmellow",
                                        "image": {
                                            "id": "8e7a3121-578a-33fb-b321-500d9ddf3ddf",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8e7a3121-578a-33fb-b321-500d9ddf3ddf.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Peachy Keen",
                                        "image": {
                                            "id": "34b84310-eeb3-3027-b01e-e708e80d0a3c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/34b84310-eeb3-3027-b01e-e708e80d0a3c.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sugar High",
                                        "image": {
                                            "id": "f8312ccf-b43c-368b-95df-a4fc116dc703",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f8312ccf-b43c-368b-95df-a4fc116dc703.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Open Air",
                                        "image": {
                                            "id": "652b8c9b-0a43-3a8c-af8f-e34d73f8e755",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/652b8c9b-0a43-3a8c-af8f-e34d73f8e755.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Summer Paradise",
                                        "image": {
                                            "id": "9eec6a72-9d89-37a9-9c79-39049737a1e2",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9eec6a72-9d89-37a9-9c79-39049737a1e2.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Spring Revival",
                                        "image": {
                                            "id": "f9f1aa73-ff03-3daf-947b-f48a8df8cf30",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f9f1aa73-ff03-3daf-947b-f48a8df8cf30.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Citrus Crush",
                                        "image": {
                                            "id": "c427d960-e1dc-3cdc-8710-e1ff1d7a016a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c427d960-e1dc-3cdc-8710-e1ff1d7a016a.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Greenhouse",
                                        "image": {
                                            "id": "8cb5e410-98d7-3b47-a0b5-156e5749c88b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8cb5e410-98d7-3b47-a0b5-156e5749c88b.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Rose Quartz",
                                        "image": {
                                            "id": "e89fe6b6-7e56-3ad9-a1a1-f2c2f4c98fe3",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e89fe6b6-7e56-3ad9-a1a1-f2c2f4c98fe3.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Crown Jewel",
                                        "image": {
                                            "id": "932705c1-0b64-38ee-bd21-fe5cc3144a58",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/932705c1-0b64-38ee-bd21-fe5cc3144a58.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Coastal Mist",
                                        "image": {
                                            "id": "e4f53027-2a61-3d59-90f8-601a28782f4f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e4f53027-2a61-3d59-90f8-601a28782f4f.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Candy Coated",
                                        "image": {
                                            "id": "f37e25b8-e248-3b33-90fe-f05d7fb3e365",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f37e25b8-e248-3b33-90fe-f05d7fb3e365.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Lemon Limeade",
                                        "image": {
                                            "id": "200501f0-809e-32ae-aad0-0b5e63badb93",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/200501f0-809e-32ae-aad0-0b5e63badb93.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "urbanoutfitters_84382746",
                                "name": "Owala FreeSip 24 oz Water Bottle",
                                "nameCN": "保温水瓶  约709ml 多款配色",
                                "description": [],
                                "merchantId": "676ab34f-c2ac-459b-80ba-0f96fbad003c",
                                "brand": "Owala",
                                "displayBrand": "Owala",
                                "brandId": "67907d84-fd1a-38ba-9668-853f0108f76c",
                                "category": "kitchen|bar|+|home",
                                "categoryIds": [
                                    "i34"
                                ],
                                "priceTag": "$30.30",
                                "priceTagCN": "¥222",
                                "officialURL": "https://www.urbanoutfitters.com/shop/owala-freesip-24-oz-water-bottle?color=616&type=REGULAR",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "ONE SIZE",
                                        "displayName": "ONE SIZE"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Urban Outfitters",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "ef8e4474-4c9b-3a69-b9b8-7c9b482e3718",
                                        "originalURL": "https://images.urbndata.com/is/image/UrbanOutfitters/102747789_379_b?$redesign-zoom-5x$",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ef8e4474-4c9b-3a69-b9b8-7c9b482e3718.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ef8e4474-4c9b-3a69-b9b8-7c9b482e3718.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fef93f60-5d22-3f37-a29e-01f7e88b133f",
                                        "originalURL": "https://images.urbndata.com/is/image/UrbanOutfitters/102747789_379_b2?$redesign-zoom-5x$",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fef93f60-5d22-3f37-a29e-01f7e88b133f.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fef93f60-5d22-3f37-a29e-01f7e88b133f.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d41555e7-63b0-31fb-a112-c08b5fb29dd6",
                                        "originalURL": "https://images.urbndata.com/is/image/UrbanOutfitters/102747789_379_b3?$redesign-zoom-5x$",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d41555e7-63b0-31fb-a112-c08b5fb29dd6.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d41555e7-63b0-31fb-a112-c08b5fb29dd6.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Winter Green",
                                        "image": {
                                            "id": "54738ff8-a751-3b14-af5f-47c94d21099b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/54738ff8-a751-3b14-af5f-47c94d21099b.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Pointsettia",
                                        "image": {
                                            "id": "fc26a9eb-7452-33a5-b080-f1c5928e9f52",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fc26a9eb-7452-33a5-b080-f1c5928e9f52.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Terracotta Sunset",
                                        "image": {
                                            "id": "fc2a2d7c-7ea5-3ea9-b6e2-7a1219b07d2b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fc2a2d7c-7ea5-3ea9-b6e2-7a1219b07d2b.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Burgundy Bay",
                                        "image": {
                                            "id": "6381f9be-0b6a-352a-b15b-f6ae4102a7b1",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6381f9be-0b6a-352a-b15b-f6ae4102a7b1.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Open Air",
                                        "image": {
                                            "id": "0fdc102a-ec0e-3d76-944a-151595946585",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0fdc102a-ec0e-3d76-944a-151595946585.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sugar High",
                                        "image": {
                                            "id": "4659cad5-3e54-3789-97b6-ad9db06ac7f3",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4659cad5-3e54-3789-97b6-ad9db06ac7f3.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sparkling Sherbert",
                                        "image": {
                                            "id": "7e1bfc3c-5e6a-314f-bdf1-fcae9ff45861",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7e1bfc3c-5e6a-314f-bdf1-fcae9ff45861.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Peachy Keen",
                                        "image": {
                                            "id": "4c650c56-b709-330c-8b74-13af639a6c8e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4c650c56-b709-330c-8b74-13af639a6c8e.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Beachfront",
                                        "image": {
                                            "id": "cdccaa98-3a32-38c0-bb74-7a9b1c753bf8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/cdccaa98-3a32-38c0-bb74-7a9b1c753bf8.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Very Very Dark",
                                        "image": {
                                            "id": "d800d4c6-b39f-33c2-a094-f07dc495d499",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d800d4c6-b39f-33c2-a094-f07dc495d499.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "urbanoutfitters_102747789",
                                "name": "Owala FreeSip® Sway 30 oz Water Bottle",
                                "description": [],
                                "merchantId": "676ab34f-c2ac-459b-80ba-0f96fbad003c",
                                "brand": "Owala",
                                "displayBrand": "Owala",
                                "brandId": "67907d84-fd1a-38ba-9668-853f0108f76c",
                                "category": "kitchen|bar|+|home",
                                "categoryIds": [
                                    "i34"
                                ],
                                "priceTag": "$35.50",
                                "priceTagCN": "¥260",
                                "officialURL": "https://www.urbanoutfitters.com/shop/owala-freesip-sway-30-oz-water-bottle?color=379&type=REGULAR",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "ONE SIZE",
                                        "displayName": "ONE SIZE"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Urban Outfitters",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "d0299a2b-fde6-34bc-8081-484b5b36b69f",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/1355974/Owala-FreeSip-Stainless-Steel-24oz-Water-Bottle---Neo-Sage.jpg?v=638230518969870000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d0299a2b-fde6-34bc-8081-484b5b36b69f.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d0299a2b-fde6-34bc-8081-484b5b36b69f.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "cb25a538-f81f-3de2-815c-d58b5d2dfa0f",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/1355975/Owala-FreeSip-Stainless-Steel-24oz-Water-Bottle---Neo-Sage.jpg?v=638230518974400000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cb25a538-f81f-3de2-815c-d58b5d2dfa0f.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cb25a538-f81f-3de2-815c-d58b5d2dfa0f.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "75f59fd1-5b4a-3c43-b2d7-6ad3dc7fc97d",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/1355976/Owala-FreeSip-Stainless-Steel-24oz-Water-Bottle---Neo-Sage.jpg?v=638230518977700000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/75f59fd1-5b4a-3c43-b2d7-6ad3dc7fc97d.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/75f59fd1-5b4a-3c43-b2d7-6ad3dc7fc97d.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "30b0299a-9f7c-3ba1-bc89-0b2cc2abf62e",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/1355977/Owala-FreeSip-Stainless-Steel-24oz-Water-Bottle---Neo-Sage.jpg?v=638230518981600000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/30b0299a-9f7c-3ba1-bc89-0b2cc2abf62e.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/30b0299a-9f7c-3ba1-bc89-0b2cc2abf62e.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Neo Sage",
                                        "image": {
                                            "id": "e2b3a0d0-3d4b-3275-9804-ff54aa7aaad6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e2b3a0d0-3d4b-3275-9804-ff54aa7aaad6.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sunny Daze",
                                        "image": {
                                            "id": "ef0f0ec8-dbca-37d4-94d7-a05f2edd005f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ef0f0ec8-dbca-37d4-94d7-a05f2edd005f.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Citrus Crush",
                                        "image": {
                                            "id": "8630a445-baeb-3165-b414-bb964b26e630",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8630a445-baeb-3165-b414-bb964b26e630.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Rock-On",
                                        "image": {
                                            "id": "67415a35-174e-31f3-b990-91bc5db2953c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/67415a35-174e-31f3-b990-91bc5db2953c.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sugar High",
                                        "image": {
                                            "id": "f269741d-e751-312d-90cf-d16b77044598",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f269741d-e751-312d-90cf-d16b77044598.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Beachfront",
                                        "image": {
                                            "id": "7b16c5e6-f466-3842-80e1-dd685c07c3f3",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7b16c5e6-f466-3842-80e1-dd685c07c3f3.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Calm Waters",
                                        "image": {
                                            "id": "3012f057-3af9-3837-be90-f21e6c0649b2",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3012f057-3af9-3837-be90-f21e6c0649b2.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Green House",
                                        "image": {
                                            "id": "24ff9568-c4a8-33bb-8cad-9f3952a8025a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/24ff9568-c4a8-33bb-8cad-9f3952a8025a.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Peachy Keen",
                                        "image": {
                                            "id": "d7b85a0b-253e-3c09-87ea-8c9f9f645fc5",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d7b85a0b-253e-3c09-87ea-8c9f9f645fc5.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "als_10486906",
                                "name": "Owala FreeSip Stainless Steel Water Bottle - 24 oz",
                                "description": [],
                                "merchantId": "56265678-ebdb-36b3-9a18-aef83f2742be",
                                "brand": "Owala",
                                "displayBrand": "Owala",
                                "brandId": "67907d84-fd1a-38ba-9668-853f0108f76c",
                                "category": "accessories|bottles|drinkware",
                                "categoryIds": [
                                    "i34"
                                ],
                                "priceTag": "$32.45",
                                "priceTagCN": "¥238",
                                "officialURL": "https://www.als.com/owala-freesip-stainless-steel-water-bottle-24-oz-10486906/p?skuId=1326135",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "ALS",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "c8add255-e391-36bd-b410-c748a4551b8a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/13367405_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c8add255-e391-36bd-b410-c748a4551b8a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c8add255-e391-36bd-b410-c748a4551b8a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c9a1d950-34af-3499-98c6-7e22790071f0",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/13340686_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c9a1d950-34af-3499-98c6-7e22790071f0.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c9a1d950-34af-3499-98c6-7e22790071f0.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ed5193d5-97a8-334c-b695-c8193dfa9e70",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/13340687_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ed5193d5-97a8-334c-b695-c8193dfa9e70.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ed5193d5-97a8-334c-b695-c8193dfa9e70.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5726af72-0133-3af7-b593-3b051862ed2c",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/13340688_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5726af72-0133-3af7-b593-3b051862ed2c.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5726af72-0133-3af7-b593-3b051862ed2c.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "macys_1961022",
                                "name": "BL610 Professional 72-oz 1000W Blender",
                                "nameCN": "多功能搅拌机料理机 72盎司 1000w 需变压  BL610",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Ninja",
                                "displayBrand": "Ninja",
                                "brandId": "3899dcba-b79f-32af-b27c-2190bbd8abc5",
                                "category": "appliances|small|home|blender",
                                "categoryIds": [
                                    "j1l"
                                ],
                                "priceTag": "$90.90",
                                "priceTagCN": "¥666",
                                "originalPriceTag": "$111.10",
                                "officialURL": "https://www.macys.com/shop/product/ninja-bl610-professional-72-oz-1000w-blender?ID=1961022",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8.1折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8.1折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "f7cebd3f-4830-3a17-86c4-56c6bfbaa5c3",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/23YETU16ZRMBLRSTKHYD_Black_Stone?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f7cebd3f-4830-3a17-86c4-56c6bfbaa5c3.jpg",
                                            "width": 704,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f7cebd3f-4830-3a17-86c4-56c6bfbaa5c3.jpg",
                                            "width": 241,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "18252ac9-4d9c-3f7b-996f-1362cbcafe83",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/YRAM16STK_BlackStone_BCK?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/18252ac9-4d9c-3f7b-996f-1362cbcafe83.jpg",
                                            "width": 697,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/18252ac9-4d9c-3f7b-996f-1362cbcafe83.jpg",
                                            "width": 238,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b2acc171-611a-3256-aca5-b308617bf147",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/YRAM16STK_BlackStone_AL?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b2acc171-611a-3256-aca5-b308617bf147.jpg",
                                            "width": 679,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b2acc171-611a-3256-aca5-b308617bf147.jpg",
                                            "width": 232,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "badc259c-c3bb-3290-a2d1-4b0375a2abea",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/YRAM16STK_BlackStone_SET?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/badc259c-c3bb-3290-a2d1-4b0375a2abea.jpg",
                                            "width": 800,
                                            "height": 706,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/badc259c-c3bb-3290-a2d1-4b0375a2abea.jpg",
                                            "width": 350,
                                            "height": 309,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black Stone",
                                        "image": {
                                            "id": "019e8279-1442-3812-8f9d-883ab3f075d8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/019e8279-1442-3812-8f9d-883ab3f075d8.jpg",
                                                "width": 35,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Tropical Pink",
                                        "image": {
                                            "id": "18abc898-4221-3351-87ea-f4878c9d12c6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/18abc898-4221-3351-87ea-f4878c9d12c6.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Cape Taupe",
                                        "image": {
                                            "id": "2f578704-a5a4-3f39-ade0-bb4926b1ea64",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2f578704-a5a4-3f39-ade0-bb4926b1ea64.jpg",
                                                "width": 42,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Moon Dust",
                                        "image": {
                                            "id": "025341ad-a686-31b8-b3c1-adfcec4a7aa0",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/025341ad-a686-31b8-b3c1-adfcec4a7aa0.jpg",
                                                "width": 35,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Cherry Blossom",
                                        "image": {
                                            "id": "efcc47f2-5fa9-3699-aaf7-252ff4653f67",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/efcc47f2-5fa9-3699-aaf7-252ff4653f67.jpg",
                                                "width": 47,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Navy",
                                        "image": {
                                            "id": "8bdaf218-12dd-34f2-8889-2b83762865ef",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8bdaf218-12dd-34f2-8889-2b83762865ef.jpg",
                                                "width": 35,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "eddf7d04-ff4b-3b55-a47b-5fa74e8ecad8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/eddf7d04-ff4b-3b55-a47b-5fa74e8ecad8.jpg",
                                                "width": 35,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Rescue Red",
                                        "image": {
                                            "id": "a95e22e8-7271-3961-a897-1d0f60c815e7",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a95e22e8-7271-3961-a897-1d0f60c815e7.jpg",
                                                "width": 36,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "White",
                                        "image": {
                                            "id": "ffbbe0fa-ffa2-35b0-9253-9aa1d863194f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ffbbe0fa-ffa2-35b0-9253-9aa1d863194f.jpg",
                                                "width": 35,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black Forest Green",
                                        "image": {
                                            "id": "16822a6d-a9b2-3036-abc9-bb356a7be6e4",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/16822a6d-a9b2-3036-abc9-bb356a7be6e4.jpg",
                                                "width": 36,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "moosejaw_23yetu16zrmblrstkhyd",
                                "name": "YETI 16 oz. Rambler Stackable Cup",
                                "nameCN": "车载杯 16 oz./473ml 保冷保温杯 双壁真空 多配色",
                                "description": [],
                                "merchantId": "0c32169d-33a8-c50e-8443-ada9dd24e8c7",
                                "brand": "YETI",
                                "displayBrand": "YETI",
                                "brandId": "4e563b71-ca56-3d57-b1ad-94a208fa0af5",
                                "category": "more|Unisex|tumblers",
                                "categoryIds": [
                                    "i31"
                                ],
                                "priceTag": "$27.75",
                                "priceTagCN": "¥204",
                                "officialURL": "https://www.publiclands.com/p/yeti-16-ozrambler-stackable-cup-23yetu16zrmblrstkhyd/23yetu16zrmblrstkhyd",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Public Lands (Moosejaw)",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "dbfb9a5c-f0b9-3f76-bb4b-7d45e109363b",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/23TFYU24ZWLFRSPBTHYD_Calm_Waters?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dbfb9a5c-f0b9-3f76-bb4b-7d45e109363b.jpg",
                                            "width": 410,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dbfb9a5c-f0b9-3f76-bb4b-7d45e109363b.jpg",
                                            "width": 140,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "209c6620-fcbf-3690-a46d-d833e816e521",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/24FREESIPBTLDSG_CalmWaters_TOP?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/209c6620-fcbf-3690-a46d-d833e816e521.jpg",
                                            "width": 800,
                                            "height": 928,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/209c6620-fcbf-3690-a46d-d833e816e521.jpg",
                                            "width": 302,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d64f1d00-8dd0-3a30-b21e-e7d8a2cb5d23",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/24FREESIPBTLDSG_CalmWaters_CLD?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d64f1d00-8dd0-3a30-b21e-e7d8a2cb5d23.jpg",
                                            "width": 757,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d64f1d00-8dd0-3a30-b21e-e7d8a2cb5d23.jpg",
                                            "width": 259,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "12538d97-952a-3687-bba4-cf8906ef3255",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/24FREESIPBTLDSG_CalmWaters_DET?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/12538d97-952a-3687-bba4-cf8906ef3255.jpg",
                                            "width": 616,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/12538d97-952a-3687-bba4-cf8906ef3255.jpg",
                                            "width": 211,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "da60258c-56aa-320f-b041-d5c0dde9ed8c",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/24FREESIPBTLDSG_CalmWaters_SET?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/da60258c-56aa-320f-b041-d5c0dde9ed8c.jpg",
                                            "width": 410,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/da60258c-56aa-320f-b041-d5c0dde9ed8c.jpg",
                                            "width": 140,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Beachfront",
                                        "image": {
                                            "id": "198486cd-2f39-3b2f-85aa-86a79e39c71a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/198486cd-2f39-3b2f-85aa-86a79e39c71a.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Crown Jewel",
                                        "image": {
                                            "id": "662881b9-6b87-35db-8c73-e3baae1822db",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/662881b9-6b87-35db-8c73-e3baae1822db.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Boneyard",
                                        "image": {
                                            "id": "b2fe28e1-6e12-312f-bc1f-58322b22daca",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b2fe28e1-6e12-312f-bc1f-58322b22daca.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Smell The Roses",
                                        "image": {
                                            "id": "413c6d9a-c1fa-3a26-be22-cb0b82906abf",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/413c6d9a-c1fa-3a26-be22-cb0b82906abf.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "80s Ski Slopes 2",
                                        "image": {
                                            "id": "70652b70-bae2-3967-927f-b99da65af9b8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/70652b70-bae2-3967-927f-b99da65af9b8.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Blue Jay",
                                        "image": {
                                            "id": "16ccd069-ce2d-37e5-afe4-9f7a26015445",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/16ccd069-ce2d-37e5-afe4-9f7a26015445.jpg",
                                                "width": 16,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Limestone",
                                        "image": {
                                            "id": "7cda74fa-ea3a-32fc-b9d3-f68b69e52440",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7cda74fa-ea3a-32fc-b9d3-f68b69e52440.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Lemon Limeade",
                                        "image": {
                                            "id": "7ba7f820-cc09-3e46-afb7-9c94f7307334",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/7ba7f820-cc09-3e46-afb7-9c94f7307334.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Shy Marshmallow 2",
                                        "image": {
                                            "id": "5fa5c5be-aec3-33f6-bc14-94d2072fd1ea",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/5fa5c5be-aec3-33f6-bc14-94d2072fd1ea.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sweet Pea",
                                        "image": {
                                            "id": "a80695bc-da8e-367c-a75b-ddbca4dfd09a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a80695bc-da8e-367c-a75b-ddbca4dfd09a.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Fruit Punch",
                                        "image": {
                                            "id": "4c4052ae-c7e0-33b8-a15a-a96f5c65e367",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4c4052ae-c7e0-33b8-a15a-a96f5c65e367.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "SPRING REVIVAL",
                                        "image": {
                                            "id": "bb9d84b0-b6de-3e15-b50c-31c0cb293f82",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bb9d84b0-b6de-3e15-b50c-31c0cb293f82.jpg",
                                                "width": 50,
                                                "height": 42,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "OFF THE GRID",
                                        "image": {
                                            "id": "0f579256-6e0f-3bf5-a1ef-0f2053f3d399",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0f579256-6e0f-3bf5-a1ef-0f2053f3d399.jpg",
                                                "width": 16,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Peachy Keen",
                                        "image": {
                                            "id": "231ef419-1ac2-3ea5-9de2-a5f3d1599fa3",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/231ef419-1ac2-3ea5-9de2-a5f3d1599fa3.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Open Air",
                                        "image": {
                                            "id": "2c53bc4a-e422-3efb-842a-f9e527c99a99",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2c53bc4a-e422-3efb-842a-f9e527c99a99.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "80s Ski Slopes",
                                        "image": {
                                            "id": "722d4c12-8ca2-32ae-843d-87a4537d7b18",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/722d4c12-8ca2-32ae-843d-87a4537d7b18.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Rock On",
                                        "image": {
                                            "id": "77d5c423-be9d-3c1e-8653-4ed7794a0945",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/77d5c423-be9d-3c1e-8653-4ed7794a0945.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Night Safari",
                                        "image": {
                                            "id": "449b94e4-5f7e-3658-95f2-4312b39c1534",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/449b94e4-5f7e-3658-95f2-4312b39c1534.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Calm Waters",
                                        "image": {
                                            "id": "3ad076f6-2b1c-38c9-8cdc-d6930c2a9b63",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3ad076f6-2b1c-38c9-8cdc-d6930c2a9b63.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sunny Daze",
                                        "image": {
                                            "id": "5dff3794-8b9c-3b3f-9633-e7687e8493d4",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/5dff3794-8b9c-3b3f-9633-e7687e8493d4.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Crown Jewel 2",
                                        "image": {
                                            "id": "662881b9-6b87-35db-8c73-e3baae1822db",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/662881b9-6b87-35db-8c73-e3baae1822db.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Lemon Meringue",
                                        "image": {
                                            "id": "cb54e84a-d1a5-31bc-baad-434ff669586f",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/cb54e84a-d1a5-31bc-baad-434ff669586f.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Sand Storm",
                                        "image": {
                                            "id": "5b4d3126-ee12-30e5-b6bf-8acbf93cad83",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/5b4d3126-ee12-30e5-b6bf-8acbf93cad83.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Vigilante",
                                        "image": {
                                            "id": "df448ba3-fac7-3bf6-94f0-728adcf49791",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/df448ba3-fac7-3bf6-94f0-728adcf49791.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Citrus Crush",
                                        "image": {
                                            "id": "46cf6c1c-9d51-347f-8a21-91246d56c728",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/46cf6c1c-9d51-347f-8a21-91246d56c728.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Down To Earth",
                                        "image": {
                                            "id": "08fd6dab-04bc-33e4-b625-deda41d7982c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/08fd6dab-04bc-33e4-b625-deda41d7982c.jpg",
                                                "width": 27,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "moosejaw_23tfyu24zwlfrspbthyd",
                                "name": "Owala 24 oz. FreeSip Stainless Steel Water Bottle",
                                "nameCN": "多巴胺不锈钢保温保冷杯24 oz.（约709ml)内置吸管 多款配色",
                                "description": [],
                                "merchantId": "0c32169d-33a8-c50e-8443-ada9dd24e8c7",
                                "brand": "Owala",
                                "displayBrand": "Owala",
                                "brandId": "67907d84-fd1a-38ba-9668-853f0108f76c",
                                "category": "water bottles|more|Unisex",
                                "categoryIds": [
                                    "i38"
                                ],
                                "priceTag": "$26.65",
                                "priceTagCN": "¥196",
                                "originalPriceTag": "$33.30",
                                "officialURL": "https://www.publiclands.com/p/owala-24-ozfreesip-stainless-steel-water-bottle-23tfyu24zwlfrspbthyd/23tfyu24zwlfrspbthyd",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8折起",
                            "activityOffs": [],
                            "merchantName": "Public Lands (Moosejaw)",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "7e6ebea8-03c6-3afc-957f-7bf688764879",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/21372682_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7e6ebea8-03c6-3afc-957f-7bf688764879.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7e6ebea8-03c6-3afc-957f-7bf688764879.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "621e9344-3fdc-3c09-b5e5-306fb06cbaeb",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/21372685_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/621e9344-3fdc-3c09-b5e5-306fb06cbaeb.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/621e9344-3fdc-3c09-b5e5-306fb06cbaeb.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9a4c1d29-93f7-3be7-8771-a0f5d9ebf1c0",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/21372686_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9a4c1d29-93f7-3be7-8771-a0f5d9ebf1c0.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9a4c1d29-93f7-3be7-8771-a0f5d9ebf1c0.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "085db37f-8b49-38a7-92e1-73c1113e22bf",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/21372687_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/085db37f-8b49-38a7-92e1-73c1113e22bf.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/085db37f-8b49-38a7-92e1-73c1113e22bf.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8648d726-00bf-3cf8-bc75-1b6403bc5bea",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/21372688_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8648d726-00bf-3cf8-bc75-1b6403bc5bea.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8648d726-00bf-3cf8-bc75-1b6403bc5bea.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "372d5d63-be7a-34a4-a330-6ddcda978fa1",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/21372691_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/372d5d63-be7a-34a4-a330-6ddcda978fa1.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/372d5d63-be7a-34a4-a330-6ddcda978fa1.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b601419a-e5f2-33c4-a310-683c4ec5bb56",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/21372692_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b601419a-e5f2-33c4-a310-683c4ec5bb56.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b601419a-e5f2-33c4-a310-683c4ec5bb56.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "450543c5-e205-3b76-a87b-2125ce9ebe0e",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/21372693_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/450543c5-e205-3b76-a87b-2125ce9ebe0e.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/450543c5-e205-3b76-a87b-2125ce9ebe0e.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a4e5a17a-b4c4-3243-94a1-d622860c9805",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/21372694_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a4e5a17a-b4c4-3243-94a1-d622860c9805.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a4e5a17a-b4c4-3243-94a1-d622860c9805.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "1b3915e8-d2de-35ee-8319-3fae6f12ec37",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/21372695_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1b3915e8-d2de-35ee-8319-3fae6f12ec37.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1b3915e8-d2de-35ee-8319-3fae6f12ec37.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Platinum",
                                        "image": {
                                            "id": "8069eeda-178c-3b13-8370-a203595b3de5",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8069eeda-178c-3b13-8370-a203595b3de5.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_14030516",
                                "name": "TWISTi™ HIGH-SPEED Blender DUO",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Ninja",
                                "displayBrand": "Ninja",
                                "brandId": "3899dcba-b79f-32af-b27c-2190bbd8abc5",
                                "category": "appliances|small|blender|home",
                                "categoryIds": [
                                    "j1l"
                                ],
                                "priceTag": "$111.10",
                                "priceTagCN": "¥814",
                                "originalPriceTag": "$141.40",
                                "officialURL": "https://www.macys.com/shop/product/ninja-twisti-high-speed-blender-duo?ID=14030516",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7.8折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "6eafa785-715d-3096-856e-e273c75e274a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/28144811_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6eafa785-715d-3096-856e-e273c75e274a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6eafa785-715d-3096-856e-e273c75e274a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "56fb108b-dce4-3eec-b216-676dccf92478",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/28144807_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/56fb108b-dce4-3eec-b216-676dccf92478.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/56fb108b-dce4-3eec-b216-676dccf92478.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "92b00f44-093d-37fa-bbc7-9604f6971463",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/28144808_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/92b00f44-093d-37fa-bbc7-9604f6971463.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/92b00f44-093d-37fa-bbc7-9604f6971463.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0a6f9376-ed4b-3fa8-ae7e-4b4a0b2ffc3a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/28144809_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0a6f9376-ed4b-3fa8-ae7e-4b4a0b2ffc3a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0a6f9376-ed4b-3fa8-ae7e-4b4a0b2ffc3a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8148778f-8f86-37da-82dd-2b5ebe6332a5",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/28144810_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8148778f-8f86-37da-82dd-2b5ebe6332a5.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8148778f-8f86-37da-82dd-2b5ebe6332a5.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Stainless Steel",
                                        "image": {
                                            "id": "bb59dcdc-abf0-3a4b-939d-abe1a8e68a9e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bb59dcdc-abf0-3a4b-939d-abe1a8e68a9e.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_18577731",
                                "name": "BBQ Stainless Steel Grill Spoon",
                                "nameCN": "双立人烧烤不锈钢烤勺",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "ZWILLING",
                                "displayBrand": "ZWILLING",
                                "brandId": "2ff454ab-2532-3a42-af67-36be1bfd32a0",
                                "category": "gadget|home|utensils|gadgets|kitchen",
                                "categoryIds": [
                                    "423"
                                ],
                                "priceTag": "$27.25",
                                "priceTagCN": "¥200",
                                "originalPriceTag": "$46.45",
                                "officialURL": "https://www.macys.com/shop/product/zwilling-bbq-stainless-steel-grill-spoon?ID=18577731",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5.8折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    }
                ]
            },
            {
                "id": "sport",
                "title": "运动户外榜",
                "categoryIds": [
                    "70",
                    "76",
                    "77",
                    "78",
                    "7a",
                    "7b",
                    "7c",
                    "7d"
                ],
                "sections": [],
                "sort": 11,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "39a6adfb-8a0d-33a4-a063-64f611cc0d58",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/3446922/10575692x1309057.jpg?v=638924729227270000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/39a6adfb-8a0d-33a4-a063-64f611cc0d58.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/39a6adfb-8a0d-33a4-a063-64f611cc0d58.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ad2425ae-0d1e-36b5-a377-f23027ebe664",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/3447373/10575692x1309057_alt1.jpg?v=638924732416130000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ad2425ae-0d1e-36b5-a377-f23027ebe664.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ad2425ae-0d1e-36b5-a377-f23027ebe664.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "2dca0f8d-e820-30fd-b5e0-ae81f81711f6",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/3448599/10575692x1309057_alt2.jpg?v=638924740638030000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2dca0f8d-e820-30fd-b5e0-ae81f81711f6.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2dca0f8d-e820-30fd-b5e0-ae81f81711f6.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "92b92856-73eb-382e-b9ef-ec73404d7db5",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/3449058/10575692x1309057_alt3.jpg?v=638924743792770000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/92b92856-73eb-382e-b9ef-ec73404d7db5.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/92b92856-73eb-382e-b9ef-ec73404d7db5.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "62273479-3297-36f7-add0-8325ce0d8d1d",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/3450147/10575692x1309057_alt4.jpg?v=638924750805100000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/62273479-3297-36f7-add0-8325ce0d8d1d.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/62273479-3297-36f7-add0-8325ce0d8d1d.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "482d4ec4-7030-33b5-8cef-d0b79ca90283",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/3450532/10575692x1309057_alt5.jpg?v=638924753255330000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/482d4ec4-7030-33b5-8cef-d0b79ca90283.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/482d4ec4-7030-33b5-8cef-d0b79ca90283.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ef22b0eb-f6b5-3843-be11-8fff4e270dd0",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/3451370/10575692x1309057_alt6.jpg?v=638924758688430000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ef22b0eb-f6b5-3843-be11-8fff4e270dd0.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ef22b0eb-f6b5-3843-be11-8fff4e270dd0.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "85b7b50c-b06c-3902-afab-0b99bb4ea845",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/3451636/10575692x1309057_alt7.jpg?v=638924760388070000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/85b7b50c-b06c-3902-afab-0b99bb4ea845.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/85b7b50c-b06c-3902-afab-0b99bb4ea845.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8287ee40-a532-331b-a77f-df72e38bb948",
                                        "originalURL": "https://alssports.vteximg.com.br/arquivos/ids/3452393/10575692x1309057_alt8.jpg?v=638924765612600000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8287ee40-a532-331b-a77f-df72e38bb948.jpg",
                                            "width": 1024,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8287ee40-a532-331b-a77f-df72e38bb948.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black Sapphire X",
                                        "image": {
                                            "id": "a8e11e4f-ee34-3c28-aae5-111218134922",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a8e11e4f-ee34-3c28-aae5-111218134922.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "als_10575692",
                                "name": "Arc'teryx Beta Jacket - Men's",
                                "nameCN": "男款 Beta 硬壳夹克 冲锋衣  防水、防风、透气",
                                "description": [],
                                "merchantId": "56265678-ebdb-36b3-9a18-aef83f2742be",
                                "brand": "Arc'teryx",
                                "displayBrand": "Arc'teryx",
                                "brandId": "3077ae92-d0c1-3659-a871-19c21b6670bb",
                                "category": "Clothing|Men's Clothing|Men's Jackets|Men's Technical Shell Jackets",
                                "categoryIds": [
                                    "787"
                                ],
                                "priceTag": "$346.40",
                                "priceTagCN": "¥2536",
                                "originalPriceTag": "$433",
                                "officialURL": "https://www.als.com/arcteryx-beta-jacket-mens-10575692/p?skuId=3044362",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XXL",
                                        "displayName": "XXL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "3XL",
                                        "displayName": "3XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8折",
                            "activityOffs": [],
                            "merchantName": "ALS",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "b2313f03-a012-3621-b333-ac3b147fc06f",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/20PTGWWCPCLDLYGRPAPT_73_Skyline_Wtlnd_Blu_Xdye?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b2313f03-a012-3621-b333-ac3b147fc06f.jpg",
                                            "width": 598,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b2313f03-a012-3621-b333-ac3b147fc06f.jpg",
                                            "width": 204,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "1dd2bcea-73af-3274-9349-b277c1bca728",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/45250_73SkylineWtlndBluXdye_MODFRT?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1dd2bcea-73af-3274-9349-b277c1bca728.jpg",
                                            "width": 602,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1dd2bcea-73af-3274-9349-b277c1bca728.jpg",
                                            "width": 206,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "aab2b998-148c-35ab-add6-4e1d2e430590",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/20PTGWWCPCLDLYGRPAPT_73_Skyline_Wtlnd_Blu_Xdye?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/aab2b998-148c-35ab-add6-4e1d2e430590.jpg",
                                            "width": 800,
                                            "height": 884,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/aab2b998-148c-35ab-add6-4e1d2e430590.jpg",
                                            "width": 317,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5a657683-3faa-3886-875a-1b4ff9089aef",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/45250_73SkylineWtlndBluXdye_LDF-alt1?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5a657683-3faa-3886-875a-1b4ff9089aef.jpg",
                                            "width": 800,
                                            "height": 842,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5a657683-3faa-3886-875a-1b4ff9089aef.jpg",
                                            "width": 333,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "73 Skyline Wtlnd Blu Xdye",
                                        "image": {
                                            "id": "bd51d6ac-5f6a-3a8b-960f-0f1a4d2b64d5",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bd51d6ac-5f6a-3a8b-960f-0f1a4d2b64d5.jpg",
                                                "width": 37,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "dickssportinggoods_20ptgwwcpcldlygrpapt",
                                "name": "Patagonia Women's Capilene Cool Daily Graphic T-Shirt",
                                "nameCN": "女款 Capilene T恤 吸湿排汗",
                                "description": [],
                                "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                                "brand": "Patagonia",
                                "displayBrand": "Patagonia",
                                "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                                "category": "Women's|womensshirtstops-129842|women's|shirts|shirts & tops",
                                "categoryIds": [
                                    "78d",
                                    "823"
                                ],
                                "priceTag": "$24.85",
                                "priceTagCN": "¥182",
                                "originalPriceTag": "$61.05",
                                "officialURL": "https://www.dickssportinggoods.com/p/patagonia-womens-capilene-cool-daily-graphic-t-shirt-20ptgwwcpcldlygrpapt/20ptgwwcpcldlygrpapt",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4折",
                            "activityOffs": [],
                            "merchantName": "Dick's Sporting Goods",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "15632514-c48b-3900-a232-d2a0f9e1200f",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/22PTGMMFTZRYCNRSPAPB_Fleck_Blue?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/15632514-c48b-3900-a232-d2a0f9e1200f.jpg",
                                            "width": 647,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/15632514-c48b-3900-a232-d2a0f9e1200f.jpg",
                                            "width": 221,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "312e3e58-a0a7-3d15-9cb8-aa09139d496a",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/37665_FleckBlue_MODBCK?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/312e3e58-a0a7-3d15-9cb8-aa09139d496a.jpg",
                                            "width": 682,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/312e3e58-a0a7-3d15-9cb8-aa09139d496a.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "10082310-f332-39f9-a14e-0fe238382c6d",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/37665_FleckBlue_MODDET?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/10082310-f332-39f9-a14e-0fe238382c6d.jpg",
                                            "width": 800,
                                            "height": 1017,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/10082310-f332-39f9-a14e-0fe238382c6d.jpg",
                                            "width": 275,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0d3359f3-fce8-369c-8a64-05fd97564a6f",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/22PTGMMFTZRYCNRSPAPB_Fleck_Blue?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0d3359f3-fce8-369c-8a64-05fd97564a6f.jpg",
                                            "width": 800,
                                            "height": 821,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0d3359f3-fce8-369c-8a64-05fd97564a6f.jpg",
                                            "width": 341,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Rock Melon",
                                        "image": {
                                            "id": "063a86e9-b692-3878-98b2-51d66219824b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/063a86e9-b692-3878-98b2-51d66219824b.jpg",
                                                "width": 36,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Birch White",
                                        "image": {
                                            "id": "58c83cc5-5d25-3588-b3be-3b46e9f050b0",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/58c83cc5-5d25-3588-b3be-3b46e9f050b0.jpg",
                                                "width": 28,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Rinsed Green",
                                        "image": {
                                            "id": "4fe9f9b8-d31c-3aa6-9825-e162951739da",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4fe9f9b8-d31c-3aa6-9825-e162951739da.jpg",
                                                "width": 39,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "dickssportinggoods_22ptgmmftzrycnrspapb",
                                "name": "Patagonia Adult Fitz Roy Icon Responsibili-Tee T-Shirt",
                                "nameCN": "男女短袖T恤（选项为男码）",
                                "description": [],
                                "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                                "brand": "Patagonia",
                                "displayBrand": "Patagonia",
                                "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                                "category": "mensshirtstops-129825|adult|Women's|shirts|shirts & tops",
                                "categoryIds": [
                                    "78d"
                                ],
                                "priceTag": "$14.95",
                                "priceTagCN": "¥110",
                                "originalPriceTag": "$49.95",
                                "officialURL": "https://www.dickssportinggoods.com/p/patagonia-mens-fitz-roy-icon-responsibili-tee-t-shirt-22ptgmmftzrycnrspapb/22ptgmmftzrycnrspapb",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XXL",
                                        "displayName": "XXL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.9折起",
                            "activityOffs": [],
                            "merchantName": "Dick's Sporting Goods",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.9折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "803dcc85-f72a-3a6d-bb3b-4eccb3a8beb0",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/24PTGMMBGGSLGHTS6APB_Forever_Grey?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/803dcc85-f72a-3a6d-bb3b-4eccb3a8beb0.jpg",
                                            "width": 800,
                                            "height": 600,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/803dcc85-f72a-3a6d-bb3b-4eccb3a8beb0.jpg",
                                            "width": 350,
                                            "height": 263,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "21ae8f7c-6721-36fa-a751-ce98e9507e46",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/58049Z_ForeverGrey_MODSTL?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/21ae8f7c-6721-36fa-a751-ce98e9507e46.jpg",
                                            "width": 800,
                                            "height": 600,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/21ae8f7c-6721-36fa-a751-ce98e9507e46.jpg",
                                            "width": 350,
                                            "height": 263,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9e5cb2b4-3091-3147-9bf3-50042b0045de",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/58049Z_ForeverGrey_MODBCK?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9e5cb2b4-3091-3147-9bf3-50042b0045de.jpg",
                                            "width": 800,
                                            "height": 600,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9e5cb2b4-3091-3147-9bf3-50042b0045de.jpg",
                                            "width": 350,
                                            "height": 263,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "656dc1a4-7471-31b3-909a-e8c0c176ef98",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/58049Z_ForeverGrey_LDF?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/656dc1a4-7471-31b3-909a-e8c0c176ef98.jpg",
                                            "width": 800,
                                            "height": 698,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/656dc1a4-7471-31b3-909a-e8c0c176ef98.jpg",
                                            "width": 350,
                                            "height": 305,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "River Rock Green",
                                        "image": {
                                            "id": "d2638ad6-d9ba-35ee-8186-60688db25ac9",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d2638ad6-d9ba-35ee-8186-60688db25ac9.jpg",
                                                "width": 50,
                                                "height": 27,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "12163784-3a28-3b7b-99b7-7e1d457048ed",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/12163784-3a28-3b7b-99b7-7e1d457048ed.jpg",
                                                "width": 40,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Robin Brown",
                                        "image": {
                                            "id": "b2cd4b23-2be6-3d92-b79a-224c0d330abc",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b2cd4b23-2be6-3d92-b79a-224c0d330abc.jpg",
                                                "width": 50,
                                                "height": 27,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Still Blue",
                                        "image": {
                                            "id": "453d6f0d-ef43-33fc-80a1-7773a8ea6604",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/453d6f0d-ef43-33fc-80a1-7773a8ea6604.jpg",
                                                "width": 50,
                                                "height": 27,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Forever Grey",
                                        "image": {
                                            "id": "857f6e16-f643-3cda-9924-7e4a1a00844c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/857f6e16-f643-3cda-9924-7e4a1a00844c.jpg",
                                                "width": 50,
                                                "height": 27,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "dickssportinggoods_24ptgmmbggslghts6apb",
                                "name": "Patagonia Men's Baggies Lights 6\" Shorts",
                                "description": [],
                                "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                                "brand": "Patagonia",
                                "displayBrand": "Patagonia",
                                "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                                "category": "men's|multifunction|shorts|mensshorts-129829|Men's",
                                "categoryIds": [
                                    "78h",
                                    "933"
                                ],
                                "priceTag": "$40.40",
                                "priceTagCN": "¥296",
                                "originalPriceTag": "$87.70",
                                "officialURL": "https://www.dickssportinggoods.com/p/patagonia-mens-baggies-lights-6-shorts-24ptgmmbggslghts6apb/24ptgmmbggslghts6apb",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XXL",
                                        "displayName": "XXL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.6折",
                            "activityOffs": [],
                            "merchantName": "Dick's Sporting Goods",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.6折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "b4529033-7e40-46f8-a2a2-acf3bf42a35b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b4529033-7e40-46f8-a2a2-acf3bf42a35b.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b4529033-7e40-46f8-a2a2-acf3bf42a35b.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "brilliant_34582",
                                "name": "【Brilliant|包邮包税】男款三件装科技长款裤MW3HBMPL20 ",
                                "description": [],
                                "merchantId": "2542f450-2ba2-a576-3206-dee81fe91607",
                                "brand": "Montbell",
                                "displayBrand": "Montbell",
                                "brandId": "fe72c5dd-a979-37f2-8438-50dfd0951ba4",
                                "categoryIds": [
                                    "78h"
                                ],
                                "priceTag": "$54",
                                "priceTagCN": "¥396",
                                "originalPriceTag": "$512",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "078",
                                        "displayName": "078"
                                    },
                                    {
                                        "ids": [],
                                        "name": "082",
                                        "displayName": "082"
                                    },
                                    {
                                        "ids": [],
                                        "name": "092",
                                        "displayName": "092"
                                    },
                                    {
                                        "ids": [],
                                        "name": "096",
                                        "displayName": "096"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100",
                                        "displayName": "100"
                                    },
                                    {
                                        "ids": [],
                                        "name": "086",
                                        "displayName": "086"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "1.1折",
                            "activityOffs": [
                                "额外九折"
                            ],
                            "merchantName": "Brilliant Beauty",
                            "origin": "[韩国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外九折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "1.1折×额外9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "韩国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "9e80d861-7ef6-3b11-91da-ad89a013e85f",
                                        "originalURL": "https://s3.amazonaws.com/syncpigeon/alti_prod/images/hag-606050_desert-yellow.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9e80d861-7ef6-3b11-91da-ad89a013e85f.jpg",
                                            "width": 725,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9e80d861-7ef6-3b11-91da-ad89a013e85f.jpg",
                                            "width": 248,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "83b135fb-5cdb-365a-bec6-c61cd5961120",
                                        "originalURL": "https://s3.amazonaws.com/syncpigeon/alti_prod/images/hag-606050__back1-desert-yellow.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/83b135fb-5cdb-365a-bec6-c61cd5961120.jpg",
                                            "width": 726,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/83b135fb-5cdb-365a-bec6-c61cd5961120.jpg",
                                            "width": 248,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "01b87988-079e-36f6-ab82-0adf4432a7f4",
                                        "originalURL": "https://s3.amazonaws.com/syncpigeon/alti_prod/images/hag-606050__side-desert-yellow.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/01b87988-079e-36f6-ab82-0adf4432a7f4.jpg",
                                            "width": 325,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/01b87988-079e-36f6-ab82-0adf4432a7f4.jpg",
                                            "width": 111,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "70d0e7cb-122e-3ef3-a982-51ebb29204ca",
                                        "originalURL": "https://s3.amazonaws.com/syncpigeon/alti_prod/images/hag-606050__front-desert-yellow.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/70d0e7cb-122e-3ef3-a982-51ebb29204ca.jpg",
                                            "width": 519,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/70d0e7cb-122e-3ef3-a982-51ebb29204ca.jpg",
                                            "width": 178,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c22ce967-76f5-3ff9-8d58-94bf44380557",
                                        "originalURL": "https://s3.amazonaws.com/syncpigeon/alti_prod/images/hag-606050__detail-desert-yellow.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c22ce967-76f5-3ff9-8d58-94bf44380557.jpg",
                                            "width": 947,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c22ce967-76f5-3ff9-8d58-94bf44380557.jpg",
                                            "width": 324,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b59490ea-f972-398d-bbd3-8cb305be7c5e",
                                        "originalURL": "https://s3.amazonaws.com/syncpigeon/alti_prod/images/hag-606050__back2-desert-yellow.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b59490ea-f972-398d-bbd3-8cb305be7c5e.jpg",
                                            "width": 534,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b59490ea-f972-398d-bbd3-8cb305be7c5e.jpg",
                                            "width": 183,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Desert Yellow",
                                        "image": {
                                            "id": "42a383eb-ea49-393e-a5d5-efbdac7c66f9",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/42a383eb-ea49-393e-a5d5-efbdac7c66f9.jpg",
                                                "width": 35,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "thelasthunt_HAG-606050",
                                "name": "Koyal Proof Jacket - Men's",
                                "nameCN": "火柴棍男士防水轻便透气夹克",
                                "description": [],
                                "merchantId": "6a15c73e-6317-3c8f-9644-1e9a8c581857",
                                "brand": "Haglöfs",
                                "displayBrand": "Haglofs",
                                "brandId": "c8a4b0a1-9f7d-32b3-8b75-3051fc77a34d",
                                "category": "jackets and vests|clothing|n|e|parkas and winter jackets|m",
                                "categoryIds": [
                                    "787"
                                ],
                                "priceTag": "$138.29",
                                "priceTagCN": "¥1013",
                                "originalPriceTag": "$260.92",
                                "officialURL": "https://www.thelasthunt.com/p/haglofs-koyal-proof-jacket-mens-hag-606050",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5.3折",
                            "activityOffs": [
                                "满折"
                            ],
                            "merchantName": "The Last Hunt",
                            "origin": "[加拿大]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5.3折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$165享8折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "加拿大",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "526df65e-d3e5-3c9b-990d-1ff0ce89f3c0",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/25PTGWWLSSYCTPCKTAPB_Undyed_Natural?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/526df65e-d3e5-3c9b-990d-1ff0ce89f3c0.jpg",
                                            "width": 596,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/526df65e-d3e5-3c9b-990d-1ff0ce89f3c0.jpg",
                                            "width": 204,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "cae82e78-60c2-31e1-a8c2-fe71973a63d2",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/105ab_mw_pat_lifemay_25Q2pt1_0189_PDP_LFS?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cae82e78-60c2-31e1-a8c2-fe71973a63d2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cae82e78-60c2-31e1-a8c2-fe71973a63d2.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "00f7041f-9a3b-3dc7-8406-c4144718527e",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/37810X_UndyedNatural_MODSTL?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/00f7041f-9a3b-3dc7-8406-c4144718527e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/00f7041f-9a3b-3dc7-8406-c4144718527e.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b9866d5a-51e6-34c9-96cf-f2826dce03c6",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/37810X_UndyedNatural_MODBCK?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b9866d5a-51e6-34c9-96cf-f2826dce03c6.jpg",
                                            "width": 605,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b9866d5a-51e6-34c9-96cf-f2826dce03c6.jpg",
                                            "width": 207,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a3864544-dc0e-377a-b160-f188d9964ef6",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/37810X_UndyedNatural_LDF?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a3864544-dc0e-377a-b160-f188d9964ef6.jpg",
                                            "width": 800,
                                            "height": 838,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a3864544-dc0e-377a-b160-f188d9964ef6.jpg",
                                            "width": 334,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "1743ff24-73b2-358a-919a-9c50a1419b14",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/105ab_mw_pat_lifemay_25Q2pt1_0269_PDP_LFS?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1743ff24-73b2-358a-919a-9c50a1419b14.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1743ff24-73b2-358a-919a-9c50a1419b14.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "726994fb-0649-3f48-a85d-db3ae2a9d7e8",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/105ab_mw_pat_lifemay_25Q2pt1_0741_PDP_LFS?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/726994fb-0649-3f48-a85d-db3ae2a9d7e8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/726994fb-0649-3f48-a85d-db3ae2a9d7e8.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "2a985a97-9fe0-3198-a368-cab2f2055098",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/105ab_mw_pat_lifemay_25Q2pt1_0801_PDP_LFS?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2a985a97-9fe0-3198-a368-cab2f2055098.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2a985a97-9fe0-3198-a368-cab2f2055098.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Undyed Natural",
                                        "image": {
                                            "id": "fd0bfe75-c278-3856-a73f-a5b6a7fab068",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fd0bfe75-c278-3856-a73f-a5b6a7fab068.jpg",
                                                "width": 39,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Wetland Blue",
                                        "image": {
                                            "id": "d0d6f5a6-6f7a-3c1f-a2e2-1b0bf8c340b4",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d0d6f5a6-6f7a-3c1f-a2e2-1b0bf8c340b4.jpg",
                                                "width": 50,
                                                "height": 41,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "dickssportinggoods_25ptgwwlssyctpcktapb",
                                "name": "Patagonia Women's Long Sleeve Cut Pocket T-Shirt",
                                "description": [],
                                "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                                "brand": "Patagonia",
                                "displayBrand": "Patagonia",
                                "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                                "category": "women's|womenspantstightscapris-129846|shirts & tops|shirts|Women's",
                                "categoryIds": [
                                    "78d",
                                    "823"
                                ],
                                "priceTag": "$16.60",
                                "priceTagCN": "¥122",
                                "originalPriceTag": "$60.90",
                                "officialURL": "https://www.dickssportinggoods.com/p/patagonia-womens-long-sleeve-cut-pocket-t-shirt-25ptgwwlssyctpcktapb/25ptgwwlssyctpcktapb",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.7折起",
                            "activityOffs": [],
                            "merchantName": "Dick's Sporting Goods",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.7折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "1e1f7f66-6711-3500-92dd-e7eb75404dcc",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/19PTGMMCPCLDLYSSTAPT_Pumice_Dyno_White_X_Dye?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1e1f7f66-6711-3500-92dd-e7eb75404dcc.jpg",
                                            "width": 623,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1e1f7f66-6711-3500-92dd-e7eb75404dcc.jpg",
                                            "width": 213,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d11a1ada-844b-3040-9110-c3d91e360eea",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/45215Z_PumiceDynoWhiteXDye_MODBCK?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d11a1ada-844b-3040-9110-c3d91e360eea.jpg",
                                            "width": 617,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d11a1ada-844b-3040-9110-c3d91e360eea.jpg",
                                            "width": 211,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "76e8dfe3-5a97-38a0-bcd9-0ae3f5f42170",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/45215Z_PumiceDynoWhiteXDye_MODSDE?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/76e8dfe3-5a97-38a0-bcd9-0ae3f5f42170.jpg",
                                            "width": 410,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/76e8dfe3-5a97-38a0-bcd9-0ae3f5f42170.jpg",
                                            "width": 140,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "048703b0-b31b-30e3-b48f-af917d9a2911",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/45215Z_PumiceDynoWhiteXDye_FRT?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/048703b0-b31b-30e3-b48f-af917d9a2911.jpg",
                                            "width": 800,
                                            "height": 973,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/048703b0-b31b-30e3-b48f-af917d9a2911.jpg",
                                            "width": 288,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8133b28c-4cab-3283-9a9a-a152877c1e7a",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/45215Z_PumiceDynoWhiteXDye_DET-alt3?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8133b28c-4cab-3283-9a9a-a152877c1e7a.jpg",
                                            "width": 800,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8133b28c-4cab-3283-9a9a-a152877c1e7a.jpg",
                                            "width": 280,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ef18e379-51ce-3be6-9e3f-ded3987016ae",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/45215Z_PumiceDynoWhiteXDye_DET-alt4?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ef18e379-51ce-3be6-9e3f-ded3987016ae.jpg",
                                            "width": 800,
                                            "height": 594,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ef18e379-51ce-3be6-9e3f-ded3987016ae.jpg",
                                            "width": 350,
                                            "height": 260,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "3b4802d8-f661-3c10-a9ac-15bc6b0e7a36",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/45215Z_BhrnGrnLtBhrnGrnXdye_DET?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3b4802d8-f661-3c10-a9ac-15bc6b0e7a36.jpg",
                                            "width": 800,
                                            "height": 859,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3b4802d8-f661-3c10-a9ac-15bc6b0e7a36.jpg",
                                            "width": 326,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "59515071-1b33-3184-9ac1-1961563c4cbb",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/45215Z_MGLX-MangoLightMangoX-Dye_DET?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/59515071-1b33-3184-9ac1-1961563c4cbb.jpg",
                                            "width": 800,
                                            "height": 400,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/59515071-1b33-3184-9ac1-1961563c4cbb.jpg",
                                            "width": 350,
                                            "height": 175,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "05e10544-7251-300d-af1b-928d7c40c561",
                                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/45215Z_MGLX-MangoLightMangoX-Dye_DET-alt1?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/05e10544-7251-300d-af1b-928d7c40c561.jpg",
                                            "width": 800,
                                            "height": 400,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/05e10544-7251-300d-af1b-928d7c40c561.jpg",
                                            "width": 350,
                                            "height": 175,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Rnsd Grn/Drk Rnsd Grn Xdy",
                                        "image": {
                                            "id": "bee25a04-0985-3e19-8346-a7cec52b2154",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bee25a04-0985-3e19-8346-a7cec52b2154.jpg",
                                                "width": 38,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Feather Grey",
                                        "image": {
                                            "id": "2e46a5e0-0781-35da-83a2-2282df11a716",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2e46a5e0-0781-35da-83a2-2282df11a716.jpg",
                                                "width": 50,
                                                "height": 31,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Pumice/Dyno White X-Dye",
                                        "image": {
                                            "id": "90fdf172-5bd2-3c73-8b97-cc1a16326e0a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/90fdf172-5bd2-3c73-8b97-cc1a16326e0a.jpg",
                                                "width": 30,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Wtld Blu/Lgt Wtld Blu Xdy",
                                        "image": {
                                            "id": "50d68785-828c-3711-8747-29fc4dbfc645",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/50d68785-828c-3711-8747-29fc4dbfc645.jpg",
                                                "width": 40,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "dickssportinggoods_19ptgmmcpcldlysstapt",
                                "name": "Patagonia Men's Capilene Cool Daily Shirt",
                                "nameCN": "男士Capilene速干T恤",
                                "description": [],
                                "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                                "brand": "Patagonia",
                                "displayBrand": "Patagonia",
                                "brandId": "79aed056-90c8-3a69-bb28-92ef539c9357",
                                "category": "mensshirtstops-129825|shirts & tops|men's|shirts|Men's",
                                "categoryIds": [
                                    "78d",
                                    "922",
                                    "920"
                                ],
                                "priceTag": "$20.20",
                                "priceTagCN": "¥148",
                                "originalPriceTag": "$49.95",
                                "officialURL": "https://www.dickssportinggoods.com/p/patagonia-mens-capilene-cool-daily-shirt-19ptgmmcpcldlysstapt/19ptgmmcpcldlysstapt",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XXL",
                                        "displayName": "XXL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4折起",
                            "activityOffs": [],
                            "merchantName": "Dick's Sporting Goods",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    }
                ]
            },
            {
                "id": "perfume",
                "title": "香水榜",
                "categoryIds": [
                    "b0m"
                ],
                "sections": [],
                "sort": 12,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "639cc6aa-bf16-3ea7-be49-17d33e327abc",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/34005145_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/639cc6aa-bf16-3ea7-be49-17d33e327abc.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/639cc6aa-bf16-3ea7-be49-17d33e327abc.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c13ba857-9b91-3f33-a30a-811a20b622f9",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/34005139_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c13ba857-9b91-3f33-a30a-811a20b622f9.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c13ba857-9b91-3f33-a30a-811a20b622f9.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a740488c-4907-397d-9bc5-2e745fcb93c3",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/34401505_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a740488c-4907-397d-9bc5-2e745fcb93c3.jpg",
                                            "width": 839,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a740488c-4907-397d-9bc5-2e745fcb93c3.jpg",
                                            "width": 287,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b22840ee-0987-3edf-a06d-4b09baaef770",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/34401507_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b22840ee-0987-3edf-a06d-4b09baaef770.jpg",
                                            "width": 839,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b22840ee-0987-3edf-a06d-4b09baaef770.jpg",
                                            "width": 287,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a3d5e5b8-1339-3bfa-a72f-8f31fc3e9cf5",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/27354139_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a3d5e5b8-1339-3bfa-a72f-8f31fc3e9cf5.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a3d5e5b8-1339-3bfa-a72f-8f31fc3e9cf5.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "85c0c7bf-a6c8-3727-9b2b-6389955da501",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/27354138_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/85c0c7bf-a6c8-3727-9b2b-6389955da501.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/85c0c7bf-a6c8-3727-9b2b-6389955da501.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "macys_22999035",
                                "name": "3-Pc. Good Girl Mini Fragrance Set",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Carolina Herrera",
                                "displayBrand": "Carolina Herrera",
                                "brandId": "638ca6b5-adca-377f-a7f5-c6cd0bce90b2",
                                "category": "fragrance|beauty|perfume",
                                "categoryIds": [
                                    "b0m"
                                ],
                                "priceTag": "$47.20",
                                "priceTagCN": "¥346",
                                "originalPriceTag": "$55.55",
                                "officialURL": "https://www.macys.com/shop/product/carolina-herrera-3-pc.-good-girl-mini-fragrance-set?ID=22999035",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "0.24 oz",
                                        "displayName": "0.24 oz (约7ml)",
                                        "label": "7 ml"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8.4折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8.4折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "316b03c7-18b6-4cfa-aa1c-07b0a95c5317",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/316b03c7-18b6-4cfa-aa1c-07b0a95c5317.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/316b03c7-18b6-4cfa-aa1c-07b0a95c5317.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "4437310c-b06d-47fa-b9b4-9b86946890a3",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4437310c-b06d-47fa-b9b4-9b86946890a3.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4437310c-b06d-47fa-b9b4-9b86946890a3.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "47e9354b-e525-44ae-ae10-b7d79d07c5c9",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/47e9354b-e525-44ae-ae10-b7d79d07c5c9.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/47e9354b-e525-44ae-ae10-b7d79d07c5c9.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "blankspace_10579",
                                "name": "Hermes爱马仕尼罗河花园女士香水30ml/ 50ml /100ml女士淡香【香港直邮】",
                                "description": [],
                                "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                                "brand": "Hermes",
                                "displayBrand": "Hermes",
                                "brandId": "9cee9469-4096-3d44-94fb-240c61ade29b",
                                "categoryIds": [
                                    "b0m"
                                ],
                                "priceTag": "$28.30",
                                "priceTagCN": "¥208",
                                "originalPriceTag": "$50",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "30ml",
                                        "displayName": "30ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "50ml",
                                        "displayName": "50ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ml",
                                        "displayName": "100ml"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.8折起",
                            "activityOffs": [],
                            "merchantName": "BLANKSPACE",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.8折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "25a364ce-fa10-4800-9668-d1328a15dc97",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/25a364ce-fa10-4800-9668-d1328a15dc97.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/25a364ce-fa10-4800-9668-d1328a15dc97.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "18d9706b-d506-4dc9-93d7-a1b3d1351fa9",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/18d9706b-d506-4dc9-93d7-a1b3d1351fa9.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/18d9706b-d506-4dc9-93d7-a1b3d1351fa9.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "a23635c5-dd14-4baf-b554-771b231e69dd",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a23635c5-dd14-4baf-b554-771b231e69dd.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a23635c5-dd14-4baf-b554-771b231e69dd.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "71e48e63-591c-4eb3-a812-adeccf1d69c6",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/71e48e63-591c-4eb3-a812-adeccf1d69c6.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/71e48e63-591c-4eb3-a812-adeccf1d69c6.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "blankspace_10856",
                                "name": "迪奥Dior迪奥小姐花漾甜心女士淡香水 30ml/50ml/100ml 新旧版随机发 香港直邮",
                                "description": [],
                                "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                                "brand": "Dior",
                                "displayBrand": "Dior",
                                "brandId": "8f8355bb-d29b-3699-9723-f0d1835f06a5",
                                "categoryIds": [
                                    "b0m"
                                ],
                                "priceTag": "$54",
                                "priceTagCN": "¥396",
                                "originalPriceTag": "$100",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "30ml",
                                        "displayName": "30ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "50ml",
                                        "displayName": "50ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ml",
                                        "displayName": "100ml"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5.4折起",
                            "activityOffs": [],
                            "merchantName": "BLANKSPACE",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5.4折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "d58adc7c-0c62-46c6-8036-f0ab2019eaba",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d58adc7c-0c62-46c6-8036-f0ab2019eaba.jpg",
                                            "width": 500,
                                            "height": 500,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d58adc7c-0c62-46c6-8036-f0ab2019eaba.jpg",
                                            "width": 500,
                                            "height": 500,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "e37cabd2-3aaa-4c8e-8a45-3e8a78ae1c97",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e37cabd2-3aaa-4c8e-8a45-3e8a78ae1c97.jpg",
                                            "width": 500,
                                            "height": 500,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e37cabd2-3aaa-4c8e-8a45-3e8a78ae1c97.jpg",
                                            "width": 500,
                                            "height": 500,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "257380bf-3577-45c4-b13a-12b8c346b179",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/257380bf-3577-45c4-b13a-12b8c346b179.jpg",
                                            "width": 500,
                                            "height": 500,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/257380bf-3577-45c4-b13a-12b8c346b179.jpg",
                                            "width": 500,
                                            "height": 500,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "blankspace_10582",
                                "name": "爱马仕Hermes大地男士中性香水淡香水30ml/50ml/100ml【香港直邮】",
                                "description": [],
                                "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                                "brand": "Hermes",
                                "displayBrand": "Hermes",
                                "brandId": "9cee9469-4096-3d44-94fb-240c61ade29b",
                                "categoryIds": [
                                    "b0m"
                                ],
                                "priceTag": "$43",
                                "priceTagCN": "¥315",
                                "originalPriceTag": "$100",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "50ml",
                                        "displayName": "50ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ml",
                                        "displayName": "100ml"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "3.6折起",
                            "activityOffs": [],
                            "merchantName": "BLANKSPACE",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "3.6折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "04b9ab28-86db-4afa-a1ac-99dcc8a4d3ab",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/04b9ab28-86db-4afa-a1ac-99dcc8a4d3ab.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/04b9ab28-86db-4afa-a1ac-99dcc8a4d3ab.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "7571bfb1-87c1-48e3-a837-f7df5d4ce0df",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7571bfb1-87c1-48e3-a837-f7df5d4ce0df.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7571bfb1-87c1-48e3-a837-f7df5d4ce0df.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "9a33f920-3ac8-44bb-8493-b4a7463802ab",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9a33f920-3ac8-44bb-8493-b4a7463802ab.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9a33f920-3ac8-44bb-8493-b4a7463802ab.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "c08b5df4-6eac-43f1-a630-6a4a67c77596",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c08b5df4-6eac-43f1-a630-6a4a67c77596.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c08b5df4-6eac-43f1-a630-6a4a67c77596.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "1df8cb81-9662-41b5-9e0e-7ad315cf1b5e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1df8cb81-9662-41b5-9e0e-7ad315cf1b5e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1df8cb81-9662-41b5-9e0e-7ad315cf1b5e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "94b29870-b6e3-44d2-9c83-5755518f51fb",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/94b29870-b6e3-44d2-9c83-5755518f51fb.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/94b29870-b6e3-44d2-9c83-5755518f51fb.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "e6584bec-6928-4277-9eaa-c3b873696936",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e6584bec-6928-4277-9eaa-c3b873696936.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e6584bec-6928-4277-9eaa-c3b873696936.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "vpfrance_12640",
                                "name": "Byredo百瑞德无人区玫瑰浓香水50ml-100ml ",
                                "description": [],
                                "merchantId": "a7dbaa3e-55a8-3190-a04c-ee838af8c328",
                                "brand": "BYREDO",
                                "displayBrand": "BYREDO",
                                "brandId": "d768d0cf-9487-37c4-ac9c-fb7c0fab04a2",
                                "categoryIds": [
                                    "b0m"
                                ],
                                "priceTag": "$118.66",
                                "priceTagCN": "¥869",
                                "originalPriceTag": "$162",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "100ML",
                                        "displayName": "100ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "50ML",
                                        "displayName": "50ML"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8.8折",
                            "activityOffs": [
                                "满折",
                                "限时价",
                                "额外九八折"
                            ],
                            "merchantName": "VP FRANCE",
                            "origin": "[法国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8.8折×额外9.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件9.9折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "法国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "8e938f01-3963-40e0-8d06-e13af7e7825e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8e938f01-3963-40e0-8d06-e13af7e7825e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8e938f01-3963-40e0-8d06-e13af7e7825e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "327d16e0-9095-4b13-86f3-435681b6eecf",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/327d16e0-9095-4b13-86f3-435681b6eecf.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/327d16e0-9095-4b13-86f3-435681b6eecf.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "e8f5addd-ea4f-4fb4-8843-858f0b1dd9f7",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e8f5addd-ea4f-4fb4-8843-858f0b1dd9f7.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e8f5addd-ea4f-4fb4-8843-858f0b1dd9f7.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "0d79f129-1c30-4c70-8459-f00d923e504e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0d79f129-1c30-4c70-8459-f00d923e504e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0d79f129-1c30-4c70-8459-f00d923e504e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "98d0a72b-de5a-420f-b902-8efc8554528d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/98d0a72b-de5a-420f-b902-8efc8554528d.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/98d0a72b-de5a-420f-b902-8efc8554528d.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "a38716e4-da01-491b-8502-1eb79de7b30d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a38716e4-da01-491b-8502-1eb79de7b30d.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a38716e4-da01-491b-8502-1eb79de7b30d.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "0ce9c491-e25a-4934-b3e0-4f6550276438",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0ce9c491-e25a-4934-b3e0-4f6550276438.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0ce9c491-e25a-4934-b3e0-4f6550276438.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "b4a372a5-f403-4755-8cb6-7815d8e29bce",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b4a372a5-f403-4755-8cb6-7815d8e29bce.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b4a372a5-f403-4755-8cb6-7815d8e29bce.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "737c39fe-06ba-4d97-b7ad-09e5fef67cd8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/737c39fe-06ba-4d97-b7ad-09e5fef67cd8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/737c39fe-06ba-4d97-b7ad-09e5fef67cd8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "6436e0b3-9f20-4c29-a3fc-1e0a931d639b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6436e0b3-9f20-4c29-a3fc-1e0a931d639b.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6436e0b3-9f20-4c29-a3fc-1e0a931d639b.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "luxurybeauty_10642",
                                "name": "圣罗兰YSL LIBRE自由之水馥奇花香 30/50/90ml 浓香型EDP 持久留香",
                                "description": [],
                                "merchantId": "eb66d114-c281-3762-ac98-b204b3352dd4",
                                "brand": "Yves Saint Laurent",
                                "displayBrand": "Yves Saint Laurent",
                                "brandId": "c260b086-eb36-3736-afbd-dfda6c669b08",
                                "categoryIds": [
                                    "b0m"
                                ],
                                "priceTag": "$59.98",
                                "priceTagCN": "¥440",
                                "originalPriceTag": "$74.20",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "经典版50ml",
                                        "displayName": "经典版50ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "经典版90ml",
                                        "displayName": "经典版90ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "清新版30ml",
                                        "displayName": "清新版30ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "清新版50ml",
                                        "displayName": "清新版50ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "清新版90ml",
                                        "displayName": "清新版90ml"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "9.9折",
                            "activityOffs": [
                                "满折",
                                "限时价"
                            ],
                            "merchantName": "LuxuryBeauty",
                            "origin": "[中国香港]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "9.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件8.5折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国香港"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "1786a90a-a437-467f-806d-eedfc8203dbd",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1786a90a-a437-467f-806d-eedfc8203dbd.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1786a90a-a437-467f-806d-eedfc8203dbd.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "e66cf8de-523d-433f-bd9a-20a7ff54f84e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e66cf8de-523d-433f-bd9a-20a7ff54f84e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e66cf8de-523d-433f-bd9a-20a7ff54f84e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "c5b069e4-4ccb-4bd3-aa26-6bac133c27ea",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c5b069e4-4ccb-4bd3-aa26-6bac133c27ea.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c5b069e4-4ccb-4bd3-aa26-6bac133c27ea.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "0006a3d2-0eb5-4065-b326-4f460719c293",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0006a3d2-0eb5-4065-b326-4f460719c293.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0006a3d2-0eb5-4065-b326-4f460719c293.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "e789ee5d-4f79-49b3-bfa5-39efb06e10f4",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e789ee5d-4f79-49b3-bfa5-39efb06e10f4.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e789ee5d-4f79-49b3-bfa5-39efb06e10f4.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "3aaf0b50-1537-43dc-8be0-cd6320d5a5e3",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3aaf0b50-1537-43dc-8be0-cd6320d5a5e3.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3aaf0b50-1537-43dc-8be0-cd6320d5a5e3.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "9e583b67-ba4a-4fc7-85a7-092ea2a3cede",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9e583b67-ba4a-4fc7-85a7-092ea2a3cede.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9e583b67-ba4a-4fc7-85a7-092ea2a3cede.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "137443cd-0675-4733-8a87-8c5547537314",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/137443cd-0675-4733-8a87-8c5547537314.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/137443cd-0675-4733-8a87-8c5547537314.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "fae77de2-488a-4321-9506-370ea5025498",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fae77de2-488a-4321-9506-370ea5025498.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fae77de2-488a-4321-9506-370ea5025498.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "35f287fb-fc5b-4b45-b48d-298634c386d8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/35f287fb-fc5b-4b45-b48d-298634c386d8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/35f287fb-fc5b-4b45-b48d-298634c386d8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "vpfrance_12917",
                                "name": "Maison Margiela马丁马吉拉全香水30-100ml",
                                "description": [],
                                "merchantId": "a7dbaa3e-55a8-3190-a04c-ee838af8c328",
                                "brand": "MAISON MARGIELA",
                                "displayBrand": "MAISON MARGIELA",
                                "brandId": "279dde94-7560-3e3f-8282-868fe5ba3565",
                                "categoryIds": [
                                    "b0m"
                                ],
                                "priceTag": "$61.99",
                                "priceTagCN": "¥454",
                                "originalPriceTag": "$126",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "BEACH-WALK漫步沙滩 100ML",
                                        "displayName": "BEACH-WALK漫步沙滩 100ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "BEACH-WALK漫步沙滩 30ML",
                                        "displayName": "BEACH-WALK漫步沙滩 30ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "BUBBLE-BATH泡泡浴 100ML",
                                        "displayName": "BUBBLE-BATH泡泡浴 100ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "BUBBLE-BATH泡泡浴 30ML",
                                        "displayName": "BUBBLE-BATH泡泡浴 30ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "COFFEE-BREAK咖啡小憩 100ML",
                                        "displayName": "COFFEE-BREAK咖啡小憩 100ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "SAILING-DAY航海日 100ML",
                                        "displayName": "SAILING-DAY航海日 100ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "SAILING-DAY航海日 30ML",
                                        "displayName": "SAILING-DAY航海日 30ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "SPRINGTIME-IN-A-PARK春日公园 100ML",
                                        "displayName": "SPRINGTIME-IN-A-PARK春日公园 100ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "UNDER-THE-LEMON-TREES柠檬树 100ML",
                                        "displayName": "UNDER-THE-LEMON-TREES柠檬树 100ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "30ML温暖壁炉",
                                        "displayName": "30ML温暖壁炉"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ML温暖壁炉",
                                        "displayName": "100ML温暖壁炉"
                                    },
                                    {
                                        "ids": [],
                                        "name": "30ML慵懒的周日早晨",
                                        "displayName": "30ML慵懒的周日早晨"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ML慵懒的周日早晨",
                                        "displayName": "100ML慵懒的周日早晨"
                                    },
                                    {
                                        "ids": [],
                                        "name": "30ML爵士酒吧",
                                        "displayName": "30ML爵士酒吧"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ML爵士酒吧",
                                        "displayName": "100ML爵士酒吧"
                                    },
                                    {
                                        "ids": [],
                                        "name": "30ML雨后初晴",
                                        "displayName": "30ML雨后初晴"
                                    },
                                    {
                                        "ids": [],
                                        "name": "30ML微醺后",
                                        "displayName": "30ML微醺后"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ML微醺后",
                                        "displayName": "100ML微醺后"
                                    },
                                    {
                                        "ids": [],
                                        "name": "30ml乌木星尘",
                                        "displayName": "30ml乌木星尘"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ml乌木星尘",
                                        "displayName": "100ml乌木星尘"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ML温暖壁炉补充装",
                                        "displayName": "100ML温暖壁炉补充装"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ML慵懒的周日早晨补充装",
                                        "displayName": "100ML慵懒的周日早晨补充装"
                                    },
                                    {
                                        "ids": [],
                                        "name": "30MLGARDEN",
                                        "displayName": "30MLGARDEN"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100MLGARDEN",
                                        "displayName": "100MLGARDEN"
                                    },
                                    {
                                        "ids": [],
                                        "name": "闲情午后30ML",
                                        "displayName": "闲情午后30ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "闲情午后100ML",
                                        "displayName": "闲情午后100ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "无尽夏日30ML",
                                        "displayName": "无尽夏日30ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "无尽夏日100ML",
                                        "displayName": "无尽夏日100ML"
                                    },
                                    {
                                        "ids": [],
                                        "name": "100ML爵士酒吧补充装",
                                        "displayName": "100ML爵士酒吧补充装"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8.5折起",
                            "activityOffs": [
                                "满折",
                                "限时价",
                                "额外九八折"
                            ],
                            "merchantName": "VP FRANCE",
                            "origin": "[法国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8.5折起×额外9.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件9.9折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "法国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "839754a4-5e91-474d-8040-8c72ad337add",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/839754a4-5e91-474d-8040-8c72ad337add.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/839754a4-5e91-474d-8040-8c72ad337add.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "382fb6b5-fd7e-4ab3-b131-a822d580df37",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/382fb6b5-fd7e-4ab3-b131-a822d580df37.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/382fb6b5-fd7e-4ab3-b131-a822d580df37.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "f42d045d-8079-422c-a09e-7dcbcd7cef9b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f42d045d-8079-422c-a09e-7dcbcd7cef9b.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f42d045d-8079-422c-a09e-7dcbcd7cef9b.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "ca4f030b-aec7-49ba-88ea-490098ede83a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ca4f030b-aec7-49ba-88ea-490098ede83a.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ca4f030b-aec7-49ba-88ea-490098ede83a.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "4c37544b-d8bd-4965-b599-b027d12c57df",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4c37544b-d8bd-4965-b599-b027d12c57df.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4c37544b-d8bd-4965-b599-b027d12c57df.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "5a670a1f-ea75-4892-9d3b-e7c3e38dd58c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5a670a1f-ea75-4892-9d3b-e7c3e38dd58c.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5a670a1f-ea75-4892-9d3b-e7c3e38dd58c.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "1d609de8-1306-4742-a1f9-4de225446e13",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1d609de8-1306-4742-a1f9-4de225446e13.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1d609de8-1306-4742-a1f9-4de225446e13.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "luxurybeauty_10669",
                                "name": "范思哲 晶钻女士香恋粉钻香水 30/50/90ml 淡香水清新花果香",
                                "description": [],
                                "merchantId": "eb66d114-c281-3762-ac98-b204b3352dd4",
                                "brand": "Versace",
                                "displayBrand": "Versace",
                                "brandId": "930df4b2-b7fb-3ee4-bc23-45289e5f9a46",
                                "categoryIds": [
                                    "b0m"
                                ],
                                "priceTag": "$33.79",
                                "priceTagCN": "¥248",
                                "originalPriceTag": "$63",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "30ml",
                                        "displayName": "30ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "50ml",
                                        "displayName": "50ml"
                                    },
                                    {
                                        "ids": [],
                                        "name": "90ml",
                                        "displayName": "90ml"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8.3折",
                            "activityOffs": [
                                "满折",
                                "限时价"
                            ],
                            "merchantName": "LuxuryBeauty",
                            "origin": "[中国香港]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8.3折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件8.5折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国香港"
                        }
                    }
                ]
            },
            {
                "id": "luxury_bag",
                "title": "奢包榜",
                "categoryIds": [
                    "e"
                ],
                "sections": [],
                "sort": 13,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "ab2c516b-db5a-46a6-a8ca-d1218676a34c",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ab2c516b-db5a-46a6-a8ca-d1218676a34c.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ab2c516b-db5a-46a6-a8ca-d1218676a34c.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "2c68758b-5c78-454c-9162-14379f7913cb",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2c68758b-5c78-454c-9162-14379f7913cb.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2c68758b-5c78-454c-9162-14379f7913cb.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "fc6d0030-aeca-4916-90a2-a34d7dc956a2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fc6d0030-aeca-4916-90a2-a34d7dc956a2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fc6d0030-aeca-4916-90a2-a34d7dc956a2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "06aa207f-91e4-4546-85cd-a527e8c78e22",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/06aa207f-91e4-4546-85cd-a527e8c78e22.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/06aa207f-91e4-4546-85cd-a527e8c78e22.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "c804e056-dff4-4460-a132-6ebf82ba6402",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c804e056-dff4-4460-a132-6ebf82ba6402.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c804e056-dff4-4460-a132-6ebf82ba6402.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "de7d69e4-cd7d-4f36-a62f-867ed873f5f2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/de7d69e4-cd7d-4f36-a62f-867ed873f5f2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/de7d69e4-cd7d-4f36-a62f-867ed873f5f2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "vpf_33595",
                                "name": "Burberry/博柏利 女士米色棉布网格条纹通勤轻行单肩包",
                                "description": [],
                                "merchantId": "b9b5cb38-ef6a-3705-b8a7-18fa18b8d36f",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "categoryIds": [
                                    "e05"
                                ],
                                "priceTag": "$407.19",
                                "priceTagCN": "¥2982",
                                "originalPriceTag": "$619",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.7折",
                            "activityOffs": [
                                "满折",
                                "限时价",
                                "额外九八折"
                            ],
                            "merchantName": "VPF",
                            "origin": "[法国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.7折×额外9.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件9.9折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "法国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "dda79780-8fc7-4765-8485-1c487bda9a5e",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dda79780-8fc7-4765-8485-1c487bda9a5e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dda79780-8fc7-4765-8485-1c487bda9a5e.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "e92b178a-bb2a-4ecb-8b01-6ca57d99b400",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e92b178a-bb2a-4ecb-8b01-6ca57d99b400.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e92b178a-bb2a-4ecb-8b01-6ca57d99b400.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "ed7f7926-d96d-4d59-92c7-279d1f160476",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ed7f7926-d96d-4d59-92c7-279d1f160476.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ed7f7926-d96d-4d59-92c7-279d1f160476.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "161de313-7fd5-4d5b-91ec-f3d491eec074",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/161de313-7fd5-4d5b-91ec-f3d491eec074.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/161de313-7fd5-4d5b-91ec-f3d491eec074.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "灰褐色",
                                        "image": {
                                            "id": "5387bf7c-da84-3911-99ad-fc729dbb4707",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/5387bf7c-da84-3911-99ad-fc729dbb4707.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "vpfrance_31379",
                                "name": "【现货】博柏利 灰褐色纺织格纹装饰拉链配口袋双肩包80845501",
                                "description": [],
                                "merchantId": "a7dbaa3e-55a8-3190-a04c-ee838af8c328",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "categoryIds": [
                                    "e21"
                                ],
                                "priceTag": "$515.18",
                                "priceTagCN": "¥3772",
                                "originalPriceTag": "$774",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7.9折",
                            "activityOffs": [
                                "满折",
                                "限时价",
                                "额外九八折"
                            ],
                            "merchantName": "VP FRANCE",
                            "origin": "[法国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7.9折×额外9.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件9.9折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "法国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "fc51181b-2e53-3a89-96c7-0efc394f2ac7",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0667/2098/9336/files/45a38dee-70c1-432e-b434-9d122c1bc59c-upscale_15k-1500x1500-70.jpg?v=1753912087",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fc51181b-2e53-3a89-96c7-0efc394f2ac7.jpg",
                                            "width": 768,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fc51181b-2e53-3a89-96c7-0efc394f2ac7.jpg",
                                            "width": 262,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "1158b542-103e-3ec7-af36-b03e59314b26",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0667/2098/9336/files/6da8e547-e690-4816-8ef4-fd0e56877f16-upscale_15k-1500x1500-70.jpg?v=1753912087",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1158b542-103e-3ec7-af36-b03e59314b26.jpg",
                                            "width": 768,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1158b542-103e-3ec7-af36-b03e59314b26.jpg",
                                            "width": 262,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Light Blue",
                                        "image": {
                                            "id": "cf6e52d6-5062-3a32-9b0c-c569be2c88f9",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/cf6e52d6-5062-3a32-9b0c-c569be2c88f9.jpg",
                                                "width": 37,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "elitefinds_8790216736920",
                                "name": "Balenciaga - Men's Le Cagole Leather Card Holder",
                                "description": [],
                                "merchantId": "006fe186-e172-3d9f-8922-a6dbfc2a7098",
                                "brand": "BALENCIAGA",
                                "displayBrand": "Balenciaga",
                                "brandId": "304e45ca-de1b-31ff-bb44-a8719001b276",
                                "category": "men > accessories > key & card holders|3261841018|accessories|blue|card-holders|key|keychains|leather|men|wallet-accessories",
                                "categoryIds": [
                                    "e12"
                                ],
                                "priceTag": "$175.33",
                                "priceTagCN": "¥1284",
                                "originalPriceTag": "$352.65",
                                "officialURL": "https://snaggedandbagged-elite-finds.myshopify.com/products/3261841018",
                                "labels": [
                                    "final_sale",
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "os",
                                        "displayName": "os"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.4折",
                            "activityOffs": [
                                "额外七七折"
                            ],
                            "merchantName": "ELITE FINDS",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外七七折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.4折×额外7.7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "982cf268-8767-3a06-8f85-0121efb59d1e",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-check-pattern-roll-backpack-8077774.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/982cf268-8767-3a06-8f85-0121efb59d1e.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/982cf268-8767-3a06-8f85-0121efb59d1e.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4f215c16-07e7-39b7-8302-4b388e01e631",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-check-pattern-roll-backpack-8077774_2.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4f215c16-07e7-39b7-8302-4b388e01e631.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4f215c16-07e7-39b7-8302-4b388e01e631.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fa430682-c208-3ecc-9e17-f621bec9350d",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-check-pattern-roll-backpack-8077774_3.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fa430682-c208-3ecc-9e17-f621bec9350d.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fa430682-c208-3ecc-9e17-f621bec9350d.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "jomashop_8077774",
                                "name": "Check Pattern Roll Backpack",
                                "description": [],
                                "merchantId": "dfcf41b9-6034-05cd-ba41-158f21d80888",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "category": "men|male",
                                "categoryIds": [
                                    "e15"
                                ],
                                "priceTag": "$488.00",
                                "priceTagCN": "¥3573",
                                "originalPriceTag": "$1790",
                                "officialURL": "https://www.jomashop.com/burberry-check-pattern-roll-backpack-8077774.html",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.7折",
                            "activityOffs": [
                                "满减"
                            ],
                            "merchantName": "Jomashop",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.7折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$300减$10",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "3b2763f4-4069-4b40-acd5-ef611b5210db",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3b2763f4-4069-4b40-acd5-ef611b5210db.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3b2763f4-4069-4b40-acd5-ef611b5210db.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "5f750c85-86ee-46ee-82ad-a15173b5cda1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5f750c85-86ee-46ee-82ad-a15173b5cda1.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5f750c85-86ee-46ee-82ad-a15173b5cda1.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "63c9fa89-71fc-410c-88a7-f2d8024509f6",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/63c9fa89-71fc-410c-88a7-f2d8024509f6.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/63c9fa89-71fc-410c-88a7-f2d8024509f6.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "vpf_23352",
                                "name": "Burberry/博柏丽 女士棕色棉麻牛皮饰边可调节水桶单肩包",
                                "description": [],
                                "merchantId": "b9b5cb38-ef6a-3705-b8a7-18fa18b8d36f",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "categoryIds": [
                                    "e05"
                                ],
                                "priceTag": "$384.97",
                                "priceTagCN": "¥2819",
                                "originalPriceTag": "$536",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7.4折",
                            "activityOffs": [
                                "满折",
                                "限时价",
                                "额外九八折"
                            ],
                            "merchantName": "VPF",
                            "origin": "[法国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7.4折×额外9.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件9.9折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "法国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "c1405fc2-e63f-3dba-aae8-7f3a0a9bddd5",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/8100486__20638__1.jpg?v=1743717475",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c1405fc2-e63f-3dba-aae8-7f3a0a9bddd5.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c1405fc2-e63f-3dba-aae8-7f3a0a9bddd5.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5c5b2ce6-62e4-3108-9bbe-fa15a4562137",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/8100486__20638__2.jpg?v=1743717475",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5c5b2ce6-62e4-3108-9bbe-fa15a4562137.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5c5b2ce6-62e4-3108-9bbe-fa15a4562137.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ad148b5c-e662-3c57-afa3-3c2269618526",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/8100486__20638__3.jpg?v=1743717475",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ad148b5c-e662-3c57-afa3-3c2269618526.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ad148b5c-e662-3c57-afa3-3c2269618526.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d705da77-0303-39be-bdb7-937d581d5b69",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/8100486__20638__4.jpg?v=1743717475",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d705da77-0303-39be-bdb7-937d581d5b69.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d705da77-0303-39be-bdb7-937d581d5b69.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c689fcba-6b8d-3163-91de-930613650929",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/8100486__20638__5.jpg?v=1743717475",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c689fcba-6b8d-3163-91de-930613650929.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c689fcba-6b8d-3163-91de-930613650929.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "6cf7acb6-e298-3f15-8967-80bc776da321",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/8100486__20638__6.jpg?v=1743717475",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6cf7acb6-e298-3f15-8967-80bc776da321.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6cf7acb6-e298-3f15-8967-80bc776da321.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "VNTG CHK BRIAR BROWN",
                                        "image": {
                                            "id": "2c818900-e50e-3061-a08a-16ed96aedd18",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2c818900-e50e-3061-a08a-16ed96aedd18.jpg",
                                                "width": 40,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "madaluxevault_8378512507030",
                                "name": "Mini TB Bucket Bag",
                                "description": [],
                                "merchantId": "915f7e36-9962-1888-3f00-149431e51ec6",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "category": "handbags|burberry-mini-tb-bucket-bag-8100486-p|black|brown|bucket bag|burberry|crossbody bags|employee 40|handbags|handbags and slgs|multi|plaid print|red|shoulder bags|vntg chk briar brown--#bda478--#72302f--#7f7f7f|women|womens",
                                "categoryIds": [
                                    "e08"
                                ],
                                "priceTag": "$1062.63",
                                "priceTagCN": "¥7780",
                                "originalPriceTag": "$1464.50",
                                "officialURL": "https://madaluxe-vault-beyond.myshopify.com/products/burberry-mini-tb-bucket-bag-8100486-p",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8折",
                            "activityOffs": [
                                "额外九折"
                            ],
                            "merchantName": "Maison Beyond",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外九折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8折×额外9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "45875646-67bc-4ee0-ad59-78ee6df88dd2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/45875646-67bc-4ee0-ad59-78ee6df88dd2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/45875646-67bc-4ee0-ad59-78ee6df88dd2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "c5321f76-24c9-4c9b-9cff-ea30367d2881",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c5321f76-24c9-4c9b-9cff-ea30367d2881.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c5321f76-24c9-4c9b-9cff-ea30367d2881.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "14cf7314-76e4-4202-8a51-5a5088d677c2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/14cf7314-76e4-4202-8a51-5a5088d677c2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/14cf7314-76e4-4202-8a51-5a5088d677c2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "棕色",
                                        "image": {
                                            "id": "6b9c985b-5685-3c9a-b4b3-038d68b9eb24",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6b9c985b-5685-3c9a-b4b3-038d68b9eb24.jpg",
                                                "width": 800,
                                                "height": 800,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "vpfrance_37491",
                                "name": "【现货】博柏利 女士棕色皮革字母徽标拼色设计单肩包 81072701",
                                "description": [],
                                "merchantId": "a7dbaa3e-55a8-3190-a04c-ee838af8c328",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "categoryIds": [
                                    "e05"
                                ],
                                "priceTag": "$434.65",
                                "priceTagCN": "¥3183",
                                "originalPriceTag": "$551",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8.7折",
                            "activityOffs": [
                                "满折",
                                "限时价",
                                "额外九八折"
                            ],
                            "merchantName": "VP FRANCE",
                            "origin": "[法国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8.7折×额外9.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件9.9折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "法国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "d6ade7bd-5745-499e-865a-ce5e84a2956f",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d6ade7bd-5745-499e-865a-ce5e84a2956f.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d6ade7bd-5745-499e-865a-ce5e84a2956f.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "48c8e58a-4957-4a84-9015-0f56a7486f1a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/48c8e58a-4957-4a84-9015-0f56a7486f1a.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/48c8e58a-4957-4a84-9015-0f56a7486f1a.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "94772b41-31c8-4e7f-b628-92a6dcc4feb8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/94772b41-31c8-4e7f-b628-92a6dcc4feb8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/94772b41-31c8-4e7f-b628-92a6dcc4feb8.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "d58294af-f555-4110-960a-91c28a492ae5",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d58294af-f555-4110-960a-91c28a492ae5.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d58294af-f555-4110-960a-91c28a492ae5.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "vpfrance_26873",
                                "name": "【现货】路易威登女士老花涂层帆布牛皮边路易威登标志手提包M46234",
                                "nameCN": " 【现货】路易威登Speedy女士老花涂层帆布牛皮边路易威登标志手提包M46234",
                                "description": [],
                                "merchantId": "a7dbaa3e-55a8-3190-a04c-ee838af8c328",
                                "brand": "Louis Vuitton",
                                "displayBrand": "Louis Vuitton",
                                "brandId": "4ccf66c9-2105-33d0-943a-a2d178a28c51",
                                "categoryIds": [
                                    "e05"
                                ],
                                "priceTag": "$2224.40",
                                "priceTagCN": "¥16285",
                                "originalPriceTag": "$2664",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8.7折",
                            "activityOffs": [
                                "额外九七折",
                                "额外九八折"
                            ],
                            "merchantName": "VP FRANCE",
                            "origin": "[法国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外九七折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8.7折×额外9.7折x额外9.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "法国",
                            "allowExpressBuy": true
                        }
                    }
                ]
            },
            {
                "id": "luxury_cloth",
                "title": "奢服榜",
                "categoryIds": [
                    "k",
                    "8",
                    "9"
                ],
                "sections": [],
                "sort": 14,
                "subTab": [],
                "excludeCategoryIds": [
                    "86",
                    "95"
                ],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "68706e06-4780-300b-9ade-ac0fb0e66f7c",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/8036292__10002__1.jpg?v=1733842651",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/68706e06-4780-300b-9ade-ac0fb0e66f7c.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/68706e06-4780-300b-9ade-ac0fb0e66f7c.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0eaaa010-5345-3f53-b83c-12754dbf0d6c",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/8036292__10002__2.jpg?v=1733842651",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0eaaa010-5345-3f53-b83c-12754dbf0d6c.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0eaaa010-5345-3f53-b83c-12754dbf0d6c.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "506a4f33-85c0-3a9f-a5cf-e353c34c92fb",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/8036292__10002__3.jpg?v=1733842651",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/506a4f33-85c0-3a9f-a5cf-e353c34c92fb.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/506a4f33-85c0-3a9f-a5cf-e353c34c92fb.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "White",
                                        "image": {
                                            "id": "dd0d752d-fdd0-345e-a392-1f99ff3e20d8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/dd0d752d-fdd0-345e-a392-1f99ff3e20d8.jpg",
                                                "width": 40,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "madaluxevault_8315074609302",
                                "name": "Stretch Cotton Poplin Shirt",
                                "description": [],
                                "merchantId": "915f7e36-9962-1888-3f00-149431e51ec6",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "category": "clothing|burberry-stretch-cotton-poplin-shirt-8036292-p|black|burberry|clothing|employee 40|men|mens|multi|rtw|shirts|solid|tailored|white|white--#000000--#ffffff",
                                "categoryIds": [
                                    "920"
                                ],
                                "priceTag": "$118.17",
                                "priceTagCN": "¥866",
                                "originalPriceTag": "$414.10",
                                "officialURL": "https://madaluxe-vault-beyond.myshopify.com/products/burberry-stretch-cotton-poplin-shirt-8036292-p",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XXL",
                                        "displayName": "XXL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "3.1折",
                            "activityOffs": [
                                "额外九折"
                            ],
                            "merchantName": "Maison Beyond",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外九折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "3.1折×额外9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "bb68fd30-33e0-348c-b08c-6dc972406547",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-checked-reversible-bomber-jacket-with-zipper-8078899.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/bb68fd30-33e0-348c-b08c-6dc972406547.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/bb68fd30-33e0-348c-b08c-6dc972406547.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9fbe301b-3b6e-3b43-8593-3814f8ca7890",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-checked-reversible-bomber-jacket-with-zipper-8078899_2.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9fbe301b-3b6e-3b43-8593-3814f8ca7890.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9fbe301b-3b6e-3b43-8593-3814f8ca7890.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4f7294b2-4836-3c53-a892-2572f3a184f4",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-checked-reversible-bomber-jacket-with-zipper-8078899_3.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4f7294b2-4836-3c53-a892-2572f3a184f4.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4f7294b2-4836-3c53-a892-2572f3a184f4.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "jomashop_8078899",
                                "name": "Checked Reversible Bomber Jacket With Zipper",
                                "nameCN": "男士格纹双面拉链飞行员夹克",
                                "description": [],
                                "merchantId": "dfcf41b9-6034-05cd-ba41-158f21d80888",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "category": "male|men",
                                "categoryIds": [
                                    "911"
                                ],
                                "priceTag": "$438.00",
                                "priceTagCN": "¥3207",
                                "originalPriceTag": "$2890",
                                "officialURL": "https://www.jomashop.com/burberry-checked-reversible-bomber-jacket-with-zipper-8078899.html?product_id=1530729",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "Medium",
                                        "displayName": "Medium"
                                    },
                                    {
                                        "ids": [],
                                        "name": "X-Small",
                                        "displayName": "X-Small"
                                    },
                                    {
                                        "ids": [],
                                        "name": "Small",
                                        "displayName": "Small"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XX-Small",
                                        "displayName": "XX-Small"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "1.5折",
                            "activityOffs": [
                                "满减"
                            ],
                            "merchantName": "Jomashop",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "1.5折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$300减$10",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "68a7b867-37fd-39c8-88e7-92a94e52ec8b",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-mens-ripple-reversible-checkprint-bomber-jacket-8078906.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/68a7b867-37fd-39c8-88e7-92a94e52ec8b.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/68a7b867-37fd-39c8-88e7-92a94e52ec8b.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "34683e54-c30e-3030-ae09-f77dbaa559a0",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-mens-ripple-reversible-checkprint-bomber-jacket-8078906_2.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/34683e54-c30e-3030-ae09-f77dbaa559a0.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/34683e54-c30e-3030-ae09-f77dbaa559a0.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9ef83c9c-8a6e-346e-b392-9bb0aadee09d",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-mens-ripple-reversible-checkprint-bomber-jacket-8078906_3.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9ef83c9c-8a6e-346e-b392-9bb0aadee09d.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9ef83c9c-8a6e-346e-b392-9bb0aadee09d.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "jomashop_8078906",
                                "name": "Men's Ripple Reversible Check-Print Bomber Jacket",
                                "nameCN": "男士 Ripple 双面格纹印花飞行员夹克",
                                "description": [],
                                "merchantId": "dfcf41b9-6034-05cd-ba41-158f21d80888",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "category": "male|men",
                                "categoryIds": [
                                    "911"
                                ],
                                "priceTag": "$347.99",
                                "priceTagCN": "¥2548",
                                "originalPriceTag": "$1790",
                                "officialURL": "https://www.jomashop.com/burberry-mens-ripple-reversible-check-print-bomber-jacket-8078906.html?product_id=1522153",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XX-Small",
                                        "displayName": "XX-Small"
                                    },
                                    {
                                        "ids": [],
                                        "name": "X-Small",
                                        "displayName": "X-Small"
                                    },
                                    {
                                        "ids": [],
                                        "name": "Medium",
                                        "displayName": "Medium"
                                    },
                                    {
                                        "ids": [],
                                        "name": "Small",
                                        "displayName": "Small"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "1.9折起",
                            "activityOffs": [
                                "满减"
                            ],
                            "merchantName": "Jomashop",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "1.9折起",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$300减$10",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "7fb6a05a-6764-35e0-a263-024ab3f5ccb8",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-creeper-leather-chelsea-boots-8077690.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7fb6a05a-6764-35e0-a263-024ab3f5ccb8.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7fb6a05a-6764-35e0-a263-024ab3f5ccb8.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "92488b11-828c-35a1-a5a1-295fa5045795",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-creeper-leather-chelsea-boots-8077690_2.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/92488b11-828c-35a1-a5a1-295fa5045795.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/92488b11-828c-35a1-a5a1-295fa5045795.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c2b2c065-fb09-3737-8629-655a4fb17532",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-creeper-leather-chelsea-boots-8077690_3.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c2b2c065-fb09-3737-8629-655a4fb17532.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c2b2c065-fb09-3737-8629-655a4fb17532.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "jomashop_8077690",
                                "name": "Creeper Leather Chelsea Boots",
                                "nameCN": "女款Creeper 真皮切尔西靴 8077690",
                                "description": [],
                                "merchantId": "dfcf41b9-6034-05cd-ba41-158f21d80888",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "category": "women|female",
                                "categoryIds": [
                                    "k10"
                                ],
                                "priceTag": "$249.99",
                                "priceTagCN": "¥1831",
                                "originalPriceTag": "$1290",
                                "officialURL": "https://www.jomashop.com/burberry-creeper-leather-chelsea-boots-8077690.html?product_id=1387129",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "eu_35"
                                        ],
                                        "name": "35 ( US Size 5 )",
                                        "displayName": "欧码35",
                                        "type": "eu",
                                        "label": "35"
                                    },
                                    {
                                        "ids": [
                                            "eu_35.5"
                                        ],
                                        "name": "35.5 ( US Size 5.5 )",
                                        "displayName": "欧码35.5",
                                        "type": "eu",
                                        "label": "35.5"
                                    },
                                    {
                                        "ids": [
                                            "eu_36.5"
                                        ],
                                        "name": "36.5 ( US Size 6.5 )",
                                        "displayName": "欧码36.5",
                                        "type": "eu",
                                        "label": "36.5"
                                    },
                                    {
                                        "ids": [
                                            "eu_37"
                                        ],
                                        "name": "37 ( US Size 7 )",
                                        "displayName": "欧码37",
                                        "type": "eu",
                                        "label": "37"
                                    },
                                    {
                                        "ids": [
                                            "eu_38"
                                        ],
                                        "name": "38 ( US Size 8 )",
                                        "displayName": "欧码38",
                                        "type": "eu",
                                        "label": "38"
                                    },
                                    {
                                        "ids": [
                                            "eu_38.5"
                                        ],
                                        "name": "38.5 ( US Size 8.5 )",
                                        "displayName": "欧码38.5",
                                        "type": "eu",
                                        "label": "38.5"
                                    },
                                    {
                                        "ids": [
                                            "eu_39"
                                        ],
                                        "name": "39 ( US Size 9 )",
                                        "displayName": "欧码39",
                                        "type": "eu",
                                        "label": "39"
                                    },
                                    {
                                        "ids": [
                                            "eu_39.5"
                                        ],
                                        "name": "39.5 ( US Size 9.5 )",
                                        "displayName": "欧码39.5",
                                        "type": "eu",
                                        "label": "39.5"
                                    },
                                    {
                                        "ids": [
                                            "eu_40"
                                        ],
                                        "name": "40 ( US Size 10 )",
                                        "displayName": "欧码40",
                                        "type": "eu",
                                        "label": "40"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "1.9折",
                            "activityOffs": [
                                "满减"
                            ],
                            "merchantName": "Jomashop",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "1.9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$300减$10",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "618ee4a1-61a5-368a-91cc-997eeb3f69a7",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-francis-reversible-vintage-check-overshirt-8049139.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/618ee4a1-61a5-368a-91cc-997eeb3f69a7.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/618ee4a1-61a5-368a-91cc-997eeb3f69a7.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "71f13610-df3d-3af4-baa3-09fa1ae5fcf0",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-francis-reversible-vintage-check-overshirt-8049139_2.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/71f13610-df3d-3af4-baa3-09fa1ae5fcf0.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/71f13610-df3d-3af4-baa3-09fa1ae5fcf0.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "09afcd67-3d69-398f-bf22-d4ddcbdf6a79",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-francis-reversible-vintage-check-overshirt-8049139_3.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/09afcd67-3d69-398f-bf22-d4ddcbdf6a79.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/09afcd67-3d69-398f-bf22-d4ddcbdf6a79.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "f8f84ea9-7df9-3a21-9315-9db3fc54fde4",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f8f84ea9-7df9-3a21-9315-9db3fc54fde4.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "jomashop_8049139",
                                "name": "Francis Reversible Vintage Check Overshirt",
                                "nameCN": "男士双面复古格纹外套",
                                "description": [],
                                "merchantId": "dfcf41b9-6034-05cd-ba41-158f21d80888",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "category": "male|men",
                                "categoryIds": [
                                    "911"
                                ],
                                "priceTag": "$769.99",
                                "priceTagCN": "¥5638",
                                "originalPriceTag": "$1550",
                                "officialURL": "https://www.jomashop.com/burberry-francis-reversible-vintage-check-overshirt-8049139.html?product_id=1591601",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "X-Large",
                                        "displayName": "X-Large"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "5折",
                            "activityOffs": [
                                "满减"
                            ],
                            "merchantName": "Jomashop",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "5折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$300减$10",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "ce4358a8-772b-3d03-aa2a-b3c35ba4269c",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-check-pillow-drawstring-boots-8074738.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ce4358a8-772b-3d03-aa2a-b3c35ba4269c.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ce4358a8-772b-3d03-aa2a-b3c35ba4269c.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "31e67584-57cb-300c-b22a-44974c160adc",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-check-pillow-drawstring-boots-8074738_2.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/31e67584-57cb-300c-b22a-44974c160adc.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/31e67584-57cb-300c-b22a-44974c160adc.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ad9b52ad-f613-3f36-a271-66cc5a4d23a4",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/b/u/burberry-check-pillow-drawstring-boots-8074738_3.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ad9b52ad-f613-3f36-a271-66cc5a4d23a4.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ad9b52ad-f613-3f36-a271-66cc5a4d23a4.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "jomashop_8074738",
                                "name": "Check Pillow Drawstring Boots",
                                "description": [],
                                "merchantId": "dfcf41b9-6034-05cd-ba41-158f21d80888",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "category": "male|men",
                                "categoryIds": [
                                    "k05"
                                ],
                                "priceTag": "$198",
                                "priceTagCN": "¥1450",
                                "originalPriceTag": "$1050",
                                "officialURL": "https://www.jomashop.com/burberry-check-pillow-drawstring-boots-8074738.html?product_id=1386485",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "eu_43"
                                        ],
                                        "name": "43 ( US Size 10 )",
                                        "displayName": "欧码43",
                                        "type": "eu",
                                        "label": "43"
                                    },
                                    {
                                        "ids": [
                                            "eu_44"
                                        ],
                                        "name": "44 ( US Size 11 )",
                                        "displayName": "欧码44",
                                        "type": "eu",
                                        "label": "44"
                                    },
                                    {
                                        "ids": [
                                            "eu_46"
                                        ],
                                        "name": "46 ( US Size 13 )",
                                        "displayName": "欧码46",
                                        "type": "eu",
                                        "label": "46"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "1.8折",
                            "activityOffs": [
                                "满减"
                            ],
                            "merchantName": "Jomashop",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "1.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$300减$10",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "7eefc601-00c6-37e7-a96f-6efa73764d02",
                                        "originalURL": "https://www.yoox.com/images/items/17/17713144WA_14_f.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7eefc601-00c6-37e7-a96f-6efa73764d02.jpg",
                                            "width": 804,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7eefc601-00c6-37e7-a96f-6efa73764d02.jpg",
                                            "width": 275,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "90c7b33c-3ac7-3db8-9012-3e200103949a",
                                        "originalURL": "https://www.yoox.com/images/items/17/17713144WA_14_r.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/90c7b33c-3ac7-3db8-9012-3e200103949a.jpg",
                                            "width": 804,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/90c7b33c-3ac7-3db8-9012-3e200103949a.jpg",
                                            "width": 275,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7b91d254-1710-31e3-9245-62a348b35afb",
                                        "originalURL": "https://www.yoox.com/images/items/17/17713144WA_14_d.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7b91d254-1710-31e3-9245-62a348b35afb.jpg",
                                            "width": 804,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7b91d254-1710-31e3-9245-62a348b35afb.jpg",
                                            "width": 275,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "99719304-c8d0-3d64-ae6e-63bcf8c604a6",
                                        "originalURL": "https://www.yoox.com/images/items/17/17713144WA_14_e.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/99719304-c8d0-3d64-ae6e-63bcf8c604a6.jpg",
                                            "width": 804,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/99719304-c8d0-3d64-ae6e-63bcf8c604a6.jpg",
                                            "width": 275,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0a1934ed-797e-370e-a9bf-f851800ee52f",
                                        "originalURL": "https://www.yoox.com/images/items/17/17713144WA_14_a.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0a1934ed-797e-370e-a9bf-f851800ee52f.jpg",
                                            "width": 804,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0a1934ed-797e-370e-a9bf-f851800ee52f.jpg",
                                            "width": 275,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "3e9c4580-c4b3-36e0-a045-e9dea6fafe40",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3e9c4580-c4b3-36e0-a045-e9dea6fafe40.jpg",
                                                "width": 39,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Blue",
                                        "image": {
                                            "id": "35f1cffb-3d27-3367-a286-b48875c4ad39",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/35f1cffb-3d27-3367-a286-b48875c4ad39.jpg",
                                                "width": 39,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Light brown",
                                        "image": {
                                            "id": "9eeb7df5-a46a-36d0-9b21-89e988979a17",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9eeb7df5-a46a-36d0-9b21-89e988979a17.jpg",
                                                "width": 39,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "yooxhk_17713144",
                                "name": "Sneakers",
                                "description": [],
                                "merchantId": "1909da89-b21b-38c3-b449-378e79039eae",
                                "brand": "MAISON MARGIELA",
                                "displayBrand": "MAISON MARGIELA",
                                "brandId": "279dde94-7560-3e3f-8282-868fe5ba3565",
                                "category": "sneakers|women",
                                "categoryIds": [
                                    "k1b"
                                ],
                                "priceTag": "$170.16",
                                "priceTagCN": "¥1246",
                                "originalPriceTag": "$902.65",
                                "officialURL": "https://www.yoox.com/hk/17713144PC/item",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [
                                            "eu_35"
                                        ],
                                        "name": "35(EU)",
                                        "displayName": "欧码35",
                                        "type": "eu",
                                        "label": "35"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "2.3折",
                            "activityOffs": [
                                "额外八折"
                            ],
                            "merchantName": "Yoox HK",
                            "origin": "[意大利]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "2.3折×额外8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "意大利",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "3290fc73-790e-4ffd-a7b9-11ecdb5790c1",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3290fc73-790e-4ffd-a7b9-11ecdb5790c1.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3290fc73-790e-4ffd-a7b9-11ecdb5790c1.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "ad37a65a-7241-46dc-b757-27559fea5ce7",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ad37a65a-7241-46dc-b757-27559fea5ce7.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ad37a65a-7241-46dc-b757-27559fea5ce7.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "60055817-327e-4f37-871c-3648b448232b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/60055817-327e-4f37-871c-3648b448232b.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/60055817-327e-4f37-871c-3648b448232b.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "196ca4a6-93db-431c-89e4-d6d591fad11b",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/196ca4a6-93db-431c-89e4-d6d591fad11b.jpg",
                                            "width": 917,
                                            "height": 1071,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/196ca4a6-93db-431c-89e4-d6d591fad11b.jpg",
                                            "width": 917,
                                            "height": 1071,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "e4798977-7b73-4130-8548-166cd622ff46",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e4798977-7b73-4130-8548-166cd622ff46.jpg",
                                            "width": 1078,
                                            "height": 1548,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e4798977-7b73-4130-8548-166cd622ff46.jpg",
                                            "width": 1078,
                                            "height": 1548,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "5d4c5439-a9f0-4bf3-a191-67392546abb2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5d4c5439-a9f0-4bf3-a191-67392546abb2.jpg",
                                            "width": 1148,
                                            "height": 1276,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5d4c5439-a9f0-4bf3-a191-67392546abb2.jpg",
                                            "width": 1148,
                                            "height": 1276,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "d04df290-ce68-4a79-8055-bbcbbb29ef73",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d04df290-ce68-4a79-8055-bbcbbb29ef73.jpg",
                                            "width": 1076,
                                            "height": 1532,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d04df290-ce68-4a79-8055-bbcbbb29ef73.jpg",
                                            "width": 1076,
                                            "height": 1532,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "vpf_22215",
                                "name": "现货 BURBERRY/博柏利女士米色聚酰胺贴袋按扣开襟棉服 80841951/80914441",
                                "description": [],
                                "merchantId": "b9b5cb38-ef6a-3705-b8a7-18fa18b8d36f",
                                "brand": "Burberry",
                                "displayBrand": "Burberry",
                                "brandId": "a050bb83-f33f-3f9b-9882-29ded0ceaea2",
                                "categoryIds": [
                                    "819"
                                ],
                                "priceTag": "$367.61",
                                "priceTagCN": "¥2692",
                                "originalPriceTag": "$618",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.2折",
                            "activityOffs": [
                                "满折",
                                "限时价",
                                "额外九八折"
                            ],
                            "merchantName": "VPF",
                            "origin": "[法国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.2折×额外9.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件9.9折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "法国",
                            "allowExpressBuy": true
                        }
                    }
                ]
            },
            {
                "id": "luxury_accessory",
                "title": "奢配榜",
                "categoryIds": [
                    "f",
                    "954",
                    "955",
                    "956",
                    "864",
                    "865",
                    "866"
                ],
                "sections": [],
                "sort": 15,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "490aa7ab-09aa-36f9-af10-bc70ffdfd5f6",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/645570-J8410-1064__SLVER__1.jpg?v=1727196913",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/490aa7ab-09aa-36f9-af10-bc70ffdfd5f6.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/490aa7ab-09aa-36f9-af10-bc70ffdfd5f6.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "127ffcec-6cd1-3d9a-a7a7-f9d978a4b9a7",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/645570-J8410-1064__SLVER__2.jpg?v=1727196913",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/127ffcec-6cd1-3d9a-a7a7-f9d978a4b9a7.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/127ffcec-6cd1-3d9a-a7a7-f9d978a4b9a7.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "51043f02-c54b-3169-965a-d3f4680c1f50",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/0511/4098/4982/files/524892-J7648-8131__SLVER__5.jpg?v=1749733247",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/51043f02-c54b-3169-965a-d3f4680c1f50.jpg",
                                            "width": 827,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/51043f02-c54b-3169-965a-d3f4680c1f50.jpg",
                                            "width": 283,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Silver Black",
                                        "image": {
                                            "id": "1fa612c5-c5cd-3212-b3ee-92f6f6a7cc83",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1fa612c5-c5cd-3212-b3ee-92f6f6a7cc83.jpg",
                                                "width": 40,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "madaluxevault_8280066031766",
                                "name": "Sterling Silver Interlocking G Bracelet",
                                "nameCN": "纯银互扣式 G手链",
                                "description": [],
                                "merchantId": "915f7e36-9962-1888-3f00-149431e51ec6",
                                "brand": "Gucci",
                                "displayBrand": "Gucci",
                                "brandId": "24b4b388-e8fb-334a-b95e-c5c3d0ad258c",
                                "category": "accessories|gucci-sterling-silver-interlocking-g-bracelet-645570-j8410-1064-p|accessories|black|bracelets|colorblock pattern|flash35|gucci|jewelry|limited time|multi|silver|silver black--#dbd8d3--#222224|spring30|unisex|women|womens",
                                "categoryIds": [
                                    "f11"
                                ],
                                "priceTag": "$281.79",
                                "priceTagCN": "¥2063",
                                "originalPriceTag": "$666.60",
                                "officialURL": "https://madaluxe-vault-beyond.myshopify.com/products/gucci-sterling-silver-interlocking-g-bracelet-645570-j8410-1064-p",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "18",
                                        "displayName": "18"
                                    },
                                    {
                                        "ids": [],
                                        "name": "19",
                                        "displayName": "19"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "4.6折",
                            "activityOffs": [
                                "额外九折"
                            ],
                            "merchantName": "Maison Beyond",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外九折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "4.6折×额外9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "1b4bb9aa-c27c-3e5f-9157-a6b2944bdc14",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/l/o/longines-prima-luna-quartz-diamond-white-dial-unisex-watch-l81154876-l81154876_1.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1b4bb9aa-c27c-3e5f-9157-a6b2944bdc14.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1b4bb9aa-c27c-3e5f-9157-a6b2944bdc14.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "66cec00c-ce8d-38db-92e1-db07f434c1c1",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/l/o/longines-prima-luna-quartz-diamond-white-dial-unisex-watch-l81154876-l81154876_2.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/66cec00c-ce8d-38db-92e1-db07f434c1c1.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/66cec00c-ce8d-38db-92e1-db07f434c1c1.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5a150dbf-250e-3b67-8125-d238764856d4",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/l/o/longines-prima-luna-quartz-diamond-white-dial-unisex-watch-l81154876-l81154876_3.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5a150dbf-250e-3b67-8125-d238764856d4.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5a150dbf-250e-3b67-8125-d238764856d4.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Mother Of Pearl/White/Silver Tone",
                                        "image": {
                                            "id": "f033c932-2b2d-357f-b63a-5381e4b61957",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f033c932-2b2d-357f-b63a-5381e4b61957.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "jomashop_LNG81154876",
                                "name": "Prima Luna Quartz Diamond White Dial Unisex Watch L8.115.4.87.6",
                                "nameCN": "心月系列贝母钻石女士腕表 L8.115.4.87.6",
                                "description": [],
                                "merchantId": "dfcf41b9-6034-05cd-ba41-158f21d80888",
                                "brand": "Longines",
                                "displayBrand": "Longines",
                                "brandId": "7bf710e4-7b15-3a9e-acb8-f4c306960eab",
                                "category": "men|unisex|quartz movement|women",
                                "categoryIds": [
                                    "954"
                                ],
                                "priceTag": "$1134.98",
                                "priceTagCN": "¥8310",
                                "originalPriceTag": "$1800",
                                "officialURL": "https://www.jomashop.com/longines-prima-luna-watch-l81154876.html",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "6.4折",
                            "activityOffs": [
                                "满减"
                            ],
                            "merchantName": "Jomashop",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "6.4折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$300减$10",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "059dd033-401d-333a-8ec8-8768072f0196",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/l/o/longines-primaluna-quartz-silver-dial-ladies-watch-l81224716-l81224716.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/059dd033-401d-333a-8ec8-8768072f0196.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/059dd033-401d-333a-8ec8-8768072f0196.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "274c7f6a-9969-344a-8e58-3dd071d6d910",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/l/o/longines-primaluna-quartz-silver-dial-ladies-watch-l81224716-l81224716_2.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/274c7f6a-9969-344a-8e58-3dd071d6d910.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/274c7f6a-9969-344a-8e58-3dd071d6d910.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a4ef011c-134b-3c73-92f6-2ba7f698325c",
                                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/l/o/longines-primaluna-quartz-silver-dial-ladies-watch-l81224716-l81224716_3.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a4ef011c-134b-3c73-92f6-2ba7f698325c.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a4ef011c-134b-3c73-92f6-2ba7f698325c.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Silver Tone",
                                        "image": {
                                            "id": "6d45c49b-c401-3a27-aa0a-14879c95427c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6d45c49b-c401-3a27-aa0a-14879c95427c.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "jomashop_LNG81224716",
                                "name": "Primaluna Quartz Silver Dial Ladies Watch L8.122.4.71.6",
                                "nameCN": "浪琴 迪丽热巴同款  Primaluna月相女士石英手表  L8.122.4.71.6",
                                "description": [],
                                "merchantId": "dfcf41b9-6034-05cd-ba41-158f21d80888",
                                "brand": "Longines",
                                "displayBrand": "Longines",
                                "brandId": "7bf710e4-7b15-3a9e-acb8-f4c306960eab",
                                "category": "female|quartz movement|women",
                                "categoryIds": [
                                    "865"
                                ],
                                "priceTag": "$938.50",
                                "priceTagCN": "¥6871",
                                "originalPriceTag": "$1350",
                                "officialURL": "https://www.jomashop.com/longines-primaluna-silver-tone-dial-unisex-watch-l81224716.html",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7.1折",
                            "activityOffs": [
                                "满减"
                            ],
                            "merchantName": "Jomashop",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7.1折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$300减$10",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "fb87b82b-dee5-4048-8cef-574d86a595b2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fb87b82b-dee5-4048-8cef-574d86a595b2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fb87b82b-dee5-4048-8cef-574d86a595b2.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "3aa5a964-e847-428b-b31e-4622165f4fc3",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3aa5a964-e847-428b-b31e-4622165f4fc3.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3aa5a964-e847-428b-b31e-4622165f4fc3.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "vpf_21894",
                                "name": "GUCCI/古驰 925银镂空方G图案边缘纹理饰面戒指576993J84000811",
                                "description": [],
                                "merchantId": "b9b5cb38-ef6a-3705-b8a7-18fa18b8d36f",
                                "brand": "Gucci",
                                "displayBrand": "Gucci",
                                "brandId": "24b4b388-e8fb-334a-b95e-c5c3d0ad258c",
                                "categoryIds": [
                                    "f63"
                                ],
                                "priceTag": "$124.96",
                                "priceTagCN": "¥915",
                                "originalPriceTag": "$333",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "14",
                                        "displayName": "14"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "3.8折",
                            "activityOffs": [
                                "满折",
                                "限时价",
                                "额外九八折"
                            ],
                            "merchantName": "VPF",
                            "origin": "[法国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "限时价",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "3.8折×额外9.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "限时价",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件9.9折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "法国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "10c893fe-1607-3c79-9f21-d851ba805f0d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/10c893fe-1607-3c79-9f21-d851ba805f0d.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/10c893fe-1607-3c79-9f21-d851ba805f0d.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "56e4e104-04af-3515-9b6b-dad7f092c496",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/56e4e104-04af-3515-9b6b-dad7f092c496.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/56e4e104-04af-3515-9b6b-dad7f092c496.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "10c893fe-1607-3c79-9f21-d851ba805f0d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/10c893fe-1607-3c79-9f21-d851ba805f0d.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/10c893fe-1607-3c79-9f21-d851ba805f0d.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "56e4e104-04af-3515-9b6b-dad7f092c496",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/56e4e104-04af-3515-9b6b-dad7f092c496.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/56e4e104-04af-3515-9b6b-dad7f092c496.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "iwcoco_100080383",
                                "name": "【预售3-7天】HERMES/爱马仕 经典款Clic H系列 奶油色珐琅镀玫瑰金饰面H标识手镯 H700001FO85",
                                "description": [],
                                "merchantId": "bf9c7de2-8f2d-32eb-afe4-db20f6e95180",
                                "displayBrand": "Hermes",
                                "brandId": "9cee9469-4096-3d44-94fb-240c61ade29b",
                                "categoryIds": [
                                    "f51"
                                ],
                                "priceTag": "$712.13",
                                "priceTagCN": "¥5214",
                                "originalPriceTag": "$900",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "奶油色 GM",
                                        "displayName": "奶油色 GM"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8.1折",
                            "activityOffs": [
                                "满折",
                                "额外九八折"
                            ],
                            "merchantName": "IWCOCO",
                            "origin": "[法国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满折",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8.1折×额外9.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "1件9.9折",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "法国",
                            "allowExpressBuy": true
                        }
                    }
                ]
            },
            {
                "id": "art_toys",
                "title": "潮玩榜",
                "categoryIds": [
                    "a"
                ],
                "sections": [],
                "sort": 16,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "93e3bf57-73d3-3742-b09a-63270262211a",
                                        "originalURL": "https://images2.ray-ban.com/cdn-record-files-pi/94dccfdb-e47c-4ad5-8395-b2ea00e0227b/bfa237d8-6125-4b90-959c-b2ea00e02531/0RW4012__601SSB__P21__shad__qt.png?impolicy=RB_Product&width=1024&bgc=%23f2f2f2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/93e3bf57-73d3-3742-b09a-63270262211a.jpg",
                                            "width": 1024,
                                            "height": 601,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/93e3bf57-73d3-3742-b09a-63270262211a.jpg",
                                            "width": 350,
                                            "height": 205,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0e99a630-b955-3143-9b5f-738805f22853",
                                        "originalURL": "https://images2.ray-ban.com/cdn-record-files-pi/94dccfdb-e47c-4ad5-8395-b2ea00e0227b/faad7233-4989-47ec-bef3-b2ea00e028b1/0RW4012__601SSB__P21__shad__fr.png?impolicy=RB_Product&width=1024&bgc=%23f2f2f2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0e99a630-b955-3143-9b5f-738805f22853.jpg",
                                            "width": 1024,
                                            "height": 601,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0e99a630-b955-3143-9b5f-738805f22853.jpg",
                                            "width": 350,
                                            "height": 205,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "364bf585-8264-3619-87f4-267b07699daf",
                                        "originalURL": "https://images2.ray-ban.com/cdn-record-files/dressedon/a5f8fc68-2f1a-4eb6-85c3-b355010f5dfe/0RW4012__SHOOT__om2.png?impolicy=RB_Product&width=1024&bgc=%23f2f2f2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/364bf585-8264-3619-87f4-267b07699daf.jpg",
                                            "width": 1024,
                                            "height": 601,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/364bf585-8264-3619-87f4-267b07699daf.jpg",
                                            "width": 350,
                                            "height": 205,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "16add020-4643-34b5-b93a-0568445844cf",
                                        "originalURL": "https://images2.ray-ban.com/cdn-record-files-pi/94dccfdb-e47c-4ad5-8395-b2ea00e0227b/fd3a6c18-a875-4675-8bab-b2ea00e02a6b/0RW4012__601SSB__P21__shad__lt.png?impolicy=RB_Product&width=1024&bgc=%23f2f2f2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/16add020-4643-34b5-b93a-0568445844cf.jpg",
                                            "width": 1024,
                                            "height": 601,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/16add020-4643-34b5-b93a-0568445844cf.jpg",
                                            "width": 350,
                                            "height": 205,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "dd96c7b5-2b9c-3ad1-ab07-69b03ee949ef",
                                        "originalURL": "https://images2.ray-ban.com/cdn-record-files-pi/94dccfdb-e47c-4ad5-8395-b2ea00e0227b/b03b5acc-bbeb-4190-995f-b2ea00e02bfa/0RW4012__601SSB__P21__shad__bk.png?impolicy=RB_Product&width=1024&bgc=%23f2f2f2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dd96c7b5-2b9c-3ad1-ab07-69b03ee949ef.jpg",
                                            "width": 1024,
                                            "height": 601,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dd96c7b5-2b9c-3ad1-ab07-69b03ee949ef.jpg",
                                            "width": 350,
                                            "height": 205,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "90132733-e3fb-3bbf-9461-26f1a65bb1b9",
                                        "originalURL": "https://images2.ray-ban.com/cdn-record-files-pi/94dccfdb-e47c-4ad5-8395-b2ea00e0227b/2d987791-d290-432e-9725-b2ea00e02daa/0RW4012__601SSB__P21__shad__cfr.png?impolicy=RB_Product&width=1024&bgc=%23f2f2f2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/90132733-e3fb-3bbf-9461-26f1a65bb1b9.jpg",
                                            "width": 1024,
                                            "height": 601,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/90132733-e3fb-3bbf-9461-26f1a65bb1b9.jpg",
                                            "width": 350,
                                            "height": 205,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "eab1b1e5-9869-3d1a-ac34-9ff3c2a46594",
                                        "originalURL": "https://images2.ray-ban.com/cdn-record-files-pi/94dccfdb-e47c-4ad5-8395-b2ea00e0227b/051aff9e-ffd8-4688-972d-b2ea00e02fcd/0RW4012__601SSB__P21__shad__al2.png?impolicy=RB_Product&width=1024&bgc=%23f2f2f2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/eab1b1e5-9869-3d1a-ac34-9ff3c2a46594.jpg",
                                            "width": 1024,
                                            "height": 601,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/eab1b1e5-9869-3d1a-ac34-9ff3c2a46594.jpg",
                                            "width": 350,
                                            "height": 205,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "16b1a88f-9988-3efa-bc6d-8f5fc49271d4",
                                        "originalURL": "https://images2.ray-ban.com/cdn-record-files/packaging/6a782909-c838-4a16-9bd9-b35400a898e6/PACK__RB__JupiterWayfarer.png?impolicy=RB_Product&width=1024&bgc=%23f2f2f2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/16b1a88f-9988-3efa-bc6d-8f5fc49271d4.jpg",
                                            "width": 1024,
                                            "height": 601,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/16b1a88f-9988-3efa-bc6d-8f5fc49271d4.jpg",
                                            "width": 350,
                                            "height": 205,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Matte Black/Clear",
                                        "image": {
                                            "id": "4cd74772-2bb5-3302-833f-a9c1d4f6317b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4cd74772-2bb5-3302-833f-a9c1d4f6317b.jpg",
                                                "width": 50,
                                                "height": 29,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Matte Black/Graphite",
                                        "image": {
                                            "id": "47804df0-8741-3442-9f30-64a580be6c8c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/47804df0-8741-3442-9f30-64a580be6c8c.jpg",
                                                "width": 50,
                                                "height": 29,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Shiny Cosmic Blue/Clear/Sapphire",
                                        "image": {
                                            "id": "3132bc7d-c563-3d34-a65d-dc8c3e46520d",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3132bc7d-c563-3d34-a65d-dc8c3e46520d.jpg",
                                                "width": 50,
                                                "height": 29,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Shiny Black/Clear/Graphite Green",
                                        "image": {
                                            "id": "6b6589bf-f45c-3e16-bb61-6216bb7ce783",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6b6589bf-f45c-3e16-bb61-6216bb7ce783.jpg",
                                                "width": 50,
                                                "height": 29,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Matte Black/Clear/Grey",
                                        "image": {
                                            "id": "af2406a2-c7a0-3c49-a56d-d1f95082ef11",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/af2406a2-c7a0-3c49-a56d-d1f95082ef11.jpg",
                                                "width": 50,
                                                "height": 29,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Shiny Black/G-15 Green",
                                        "image": {
                                            "id": "497c06f8-44df-3333-ba3e-c29901b59e04",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/497c06f8-44df-3333-ba3e-c29901b59e04.jpg",
                                                "width": 50,
                                                "height": 29,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "rayban_RW4012",
                                "name": "RAY-BAN | META WAYFARER",
                                "nameCN": "雷朋 Meta Wayfarer 智能太阳镜 GEN 2代",
                                "description": [],
                                "merchantId": "8083a2ad-6ba3-cbe1-c850-dc50c0162720",
                                "brand": "Ray-Ban",
                                "displayBrand": "Ray-Ban",
                                "brandId": "2091d438-dc6e-3d12-83e9-d08d16582644",
                                "category": "ray-ban|2)|glasses|meta|battery|(gen",
                                "categoryIds": [
                                    "a3a"
                                ],
                                "priceTag": "$401.95",
                                "priceTagCN": "¥2943",
                                "officialURL": "https://www.ray-ban.com/usa/electronics/RW4012ray-ban%20%7C%20meta%20wayfarer-black/8056262721414",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "M 50-22",
                                        "displayName": "M 50-22"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L 53-22",
                                        "displayName": "L 53-22"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Ray-Ban",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "8e33971f-9fed-363b-90f9-d715760f665b",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/34075787_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8e33971f-9fed-363b-90f9-d715760f665b.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8e33971f-9fed-363b-90f9-d715760f665b.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ae99fc71-dd1d-38c5-b425-38305bfb34ab",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/34075782_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ae99fc71-dd1d-38c5-b425-38305bfb34ab.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ae99fc71-dd1d-38c5-b425-38305bfb34ab.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "1f767623-6fa6-355d-96d8-c90565f00fec",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/34075783_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1f767623-6fa6-355d-96d8-c90565f00fec.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1f767623-6fa6-355d-96d8-c90565f00fec.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d0329e36-cc0b-34ed-87b9-60d2278297cb",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/34075784_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d0329e36-cc0b-34ed-87b9-60d2278297cb.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d0329e36-cc0b-34ed-87b9-60d2278297cb.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "897222fe-f6ec-36a7-beff-edd12c64b298",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/34075785_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/897222fe-f6ec-36a7-beff-edd12c64b298.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/897222fe-f6ec-36a7-beff-edd12c64b298.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "46f763c6-b30f-3e52-b1d6-843a75248ef0",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/34075786_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/46f763c6-b30f-3e52-b1d6-843a75248ef0.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/46f763c6-b30f-3e52-b1d6-843a75248ef0.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "84d4a6ab-1995-3d14-aedb-c71af06a09da",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/23949093_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/84d4a6ab-1995-3d14-aedb-c71af06a09da.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/84d4a6ab-1995-3d14-aedb-c71af06a09da.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e8b8383c-5f5e-399e-9d69-be1b0ff35b6e",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/34656879_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e8b8383c-5f5e-399e-9d69-be1b0ff35b6e.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e8b8383c-5f5e-399e-9d69-be1b0ff35b6e.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0cef5da1-8690-3df8-bb0a-8b7cd8782e32",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/34656880_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0cef5da1-8690-3df8-bb0a-8b7cd8782e32.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0cef5da1-8690-3df8-bb0a-8b7cd8782e32.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c0b65835-d0da-34dd-81a5-6ce1c95ce4da",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/34656874_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c0b65835-d0da-34dd-81a5-6ce1c95ce4da.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c0b65835-d0da-34dd-81a5-6ce1c95ce4da.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5c177d6f-3070-3782-927a-d5b854c2bef3",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/34656867_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5c177d6f-3070-3782-927a-d5b854c2bef3.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5c177d6f-3070-3782-927a-d5b854c2bef3.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "e515badc-cf9f-345f-9820-057e6d9e1a66",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e515badc-cf9f-345f-9820-057e6d9e1a66.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_24156423",
                                "name": "Unisex AI Glasses, Meta Low Bridge Fit Headliner RW4013F - GEN 2",
                                "nameCN": "【Gen2代】 雷朋 Meta  Headliner 智能太阳镜 RW4013F",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Ray-Ban",
                                "displayBrand": "Ray-Ban",
                                "brandId": "2091d438-dc6e-3d12-83e9-d08d16582644",
                                "category": "sunglasses|women's fashion|sunglasses",
                                "categoryIds": [
                                    "a3a"
                                ],
                                "priceTag": "$382.80",
                                "priceTagCN": "¥2803",
                                "officialURL": "https://www.macys.com/shop/product/ray-ban-unisex-ai-meta-gen2-low-bridge-fit-headliner-sunglasses-rw4013f?ID=24156423",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "51mm",
                                        "displayName": "51mm"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "5deea556-1090-3353-a8c7-6ea3f25130e0",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/33599749_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5deea556-1090-3353-a8c7-6ea3f25130e0.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5deea556-1090-3353-a8c7-6ea3f25130e0.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "f594b2e2-9160-3ab1-b311-ba4fcc84f78a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/33599745_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f594b2e2-9160-3ab1-b311-ba4fcc84f78a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f594b2e2-9160-3ab1-b311-ba4fcc84f78a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "1a575c99-6ef8-35e2-9db7-d72132b40c32",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/33599746_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1a575c99-6ef8-35e2-9db7-d72132b40c32.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1a575c99-6ef8-35e2-9db7-d72132b40c32.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b46e4815-e5b9-3328-937c-6a314065fad4",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/33599747_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b46e4815-e5b9-3328-937c-6a314065fad4.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b46e4815-e5b9-3328-937c-6a314065fad4.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "3a9b5b4d-fda8-36a6-85e7-1dc3716a60bf",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/33599748_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3a9b5b4d-fda8-36a6-85e7-1dc3716a60bf.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3a9b5b4d-fda8-36a6-85e7-1dc3716a60bf.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d1a5ad54-1f57-30f0-8263-fa6a72e20402",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/33599744_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d1a5ad54-1f57-30f0-8263-fa6a72e20402.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d1a5ad54-1f57-30f0-8263-fa6a72e20402.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Multicolor",
                                        "image": {
                                            "id": "5febb974-8c91-3388-94ec-10eeea6ceb65",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/5febb974-8c91-3388-94ec-10eeea6ceb65.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_23269080",
                                "name": "LEGO Speed Champions Lamborghini Revuelto Huracán STO 77238, 607 Pieces",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "LEGO®",
                                "displayBrand": "LEGO",
                                "brandId": "3a22c9ea-9a30-39d1-80e0-a514a5a3b619",
                                "category": "all|and|toys|games",
                                "categoryIds": [
                                    "a34"
                                ],
                                "priceTag": "$50.50",
                                "priceTagCN": "¥370",
                                "officialURL": "https://www.macys.com/shop/product/lego-speed-champions-lamborghini-revuelto-huracan-sto-77238-607-pieces?ID=23269080",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "524b90db-b4f5-3649-9676-fd8722ed1c21",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/30328486_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/524b90db-b4f5-3649-9676-fd8722ed1c21.jpg",
                                            "width": 839,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/524b90db-b4f5-3649-9676-fd8722ed1c21.jpg",
                                            "width": 287,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "3f8e1624-50b7-380e-ac97-6326aad4a655",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/30328481_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3f8e1624-50b7-380e-ac97-6326aad4a655.jpg",
                                            "width": 839,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3f8e1624-50b7-380e-ac97-6326aad4a655.jpg",
                                            "width": 287,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "771fb05a-4bd7-3992-a177-7a4206df6262",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/30328479_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/771fb05a-4bd7-3992-a177-7a4206df6262.jpg",
                                            "width": 839,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/771fb05a-4bd7-3992-a177-7a4206df6262.jpg",
                                            "width": 287,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e89589e5-f953-35e1-b49a-199262ef6ee2",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/30328487_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e89589e5-f953-35e1-b49a-199262ef6ee2.jpg",
                                            "width": 839,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e89589e5-f953-35e1-b49a-199262ef6ee2.jpg",
                                            "width": 287,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "da80eac9-bac1-37ce-b235-726dac374224",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/30328495_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/da80eac9-bac1-37ce-b235-726dac374224.jpg",
                                            "width": 839,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/da80eac9-bac1-37ce-b235-726dac374224.jpg",
                                            "width": 287,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Multicolor",
                                        "image": {
                                            "id": "f79cc5d8-a9a6-3f31-b1ca-af7e627fa978",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f79cc5d8-a9a6-3f31-b1ca-af7e627fa978.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_19261255",
                                "name": "The Hedgehog 3 Action Figure",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Sonic",
                                "displayBrand": "Sonic",
                                "category": "games|and|toys|all",
                                "categoryIds": [
                                    "a38",
                                    "ga2"
                                ],
                                "priceTag": "$36.35",
                                "priceTagCN": "¥267",
                                "originalPriceTag": "$50.50",
                                "officialURL": "https://www.macys.com/shop/product/sonic-the-hedgehog-3-action-figure?ID=19261255",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7.1折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7.1折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "a7a7830d-d1ee-31a4-ae01-9bed9f1a06ef",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/33599592_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a7a7830d-d1ee-31a4-ae01-9bed9f1a06ef.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a7a7830d-d1ee-31a4-ae01-9bed9f1a06ef.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "94583b14-f680-31d7-8ac9-f9ce6541cdde",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/33599586_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/94583b14-f680-31d7-8ac9-f9ce6541cdde.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/94583b14-f680-31d7-8ac9-f9ce6541cdde.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0e14772a-0c63-3812-b381-5fbe1a02a239",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/33599587_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0e14772a-0c63-3812-b381-5fbe1a02a239.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0e14772a-0c63-3812-b381-5fbe1a02a239.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b087144a-2cdb-38f7-93a1-8609a93c094d",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/33599588_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b087144a-2cdb-38f7-93a1-8609a93c094d.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b087144a-2cdb-38f7-93a1-8609a93c094d.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "2e39503c-d3df-3c26-9b7f-9ebbdd241930",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/33599589_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2e39503c-d3df-3c26-9b7f-9ebbdd241930.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2e39503c-d3df-3c26-9b7f-9ebbdd241930.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7556f9a8-79e0-3ab8-8b41-7213899fc1de",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/33599590_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7556f9a8-79e0-3ab8-8b41-7213899fc1de.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7556f9a8-79e0-3ab8-8b41-7213899fc1de.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a1609249-caff-3b8c-abcb-298f86ea1add",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/33599591_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a1609249-caff-3b8c-abcb-298f86ea1add.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a1609249-caff-3b8c-abcb-298f86ea1add.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Multicolor",
                                        "image": {
                                            "id": "f765e68f-5e87-31c3-903f-5aed480dd539",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f765e68f-5e87-31c3-903f-5aed480dd539.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_23269094",
                                "name": "LEGO Marvel Spider-Man vs. Doc Ock Subway Train Scene 76321, 393 Pieces",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "LEGO®",
                                "displayBrand": "LEGO",
                                "brandId": "3a22c9ea-9a30-39d1-80e0-a514a5a3b619",
                                "category": "games|and|all|toys",
                                "categoryIds": [
                                    "a34"
                                ],
                                "priceTag": "$55.25",
                                "priceTagCN": "¥405",
                                "officialURL": "https://www.macys.com/shop/product/lego-marvel-spider-man-vs.-doc-ock-subway-train-scene-76321-393-pieces?ID=23269094",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "d74da313-1c5c-3feb-bc23-ee8bc94b7293",
                                        "originalURL": "https://m.media-amazon.com/images/I/71mTfSKhhTL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d74da313-1c5c-3feb-bc23-ee8bc94b7293.jpg",
                                            "width": 1024,
                                            "height": 768,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d74da313-1c5c-3feb-bc23-ee8bc94b7293.jpg",
                                            "width": 350,
                                            "height": 263,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "966f4e98-3a41-36b8-b589-6dd98f4e0d7b",
                                        "originalURL": "https://m.media-amazon.com/images/I/81QrVvqopBL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/966f4e98-3a41-36b8-b589-6dd98f4e0d7b.jpg",
                                            "width": 1024,
                                            "height": 823,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/966f4e98-3a41-36b8-b589-6dd98f4e0d7b.jpg",
                                            "width": 350,
                                            "height": 281,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ca535962-0af9-3d2b-847d-0b4f5aa60625",
                                        "originalURL": "https://m.media-amazon.com/images/I/91crcb7AooL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ca535962-0af9-3d2b-847d-0b4f5aa60625.jpg",
                                            "width": 1024,
                                            "height": 668,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ca535962-0af9-3d2b-847d-0b4f5aa60625.jpg",
                                            "width": 350,
                                            "height": 228,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7246866c-9ee2-3c83-9aba-88805e8770d6",
                                        "originalURL": "https://m.media-amazon.com/images/I/81vMw-QLpYL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7246866c-9ee2-3c83-9aba-88805e8770d6.jpg",
                                            "width": 1024,
                                            "height": 671,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7246866c-9ee2-3c83-9aba-88805e8770d6.jpg",
                                            "width": 350,
                                            "height": 229,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "fa25da25-4cf0-3d6e-973c-9b37f2e78d15",
                                        "originalURL": "https://m.media-amazon.com/images/I/81O14QSsMXL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fa25da25-4cf0-3d6e-973c-9b37f2e78d15.jpg",
                                            "width": 1024,
                                            "height": 774,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fa25da25-4cf0-3d6e-973c-9b37f2e78d15.jpg",
                                            "width": 350,
                                            "height": 264,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "dc005e80-58ba-3f48-a3b7-14a3c965137b",
                                        "originalURL": "https://m.media-amazon.com/images/I/71QuEK+XuML.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dc005e80-58ba-3f48-a3b7-14a3c965137b.jpg",
                                            "width": 1024,
                                            "height": 768,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dc005e80-58ba-3f48-a3b7-14a3c965137b.jpg",
                                            "width": 350,
                                            "height": 263,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "caaccf3c-d06c-3632-ad9c-ce65b14769e0",
                                        "originalURL": "https://m.media-amazon.com/images/I/71kTbjPQO3L.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/caaccf3c-d06c-3632-ad9c-ce65b14769e0.jpg",
                                            "width": 1024,
                                            "height": 768,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/caaccf3c-d06c-3632-ad9c-ce65b14769e0.jpg",
                                            "width": 350,
                                            "height": 263,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "dae54fae-fd1f-3702-9b61-cfd34deb8472",
                                        "originalURL": "https://m.media-amazon.com/images/I/71NFV42DkVL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dae54fae-fd1f-3702-9b61-cfd34deb8472.jpg",
                                            "width": 1024,
                                            "height": 768,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dae54fae-fd1f-3702-9b61-cfd34deb8472.jpg",
                                            "width": 350,
                                            "height": 263,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8c0b122b-ea76-3509-bd29-2b791d8c3eec",
                                        "originalURL": "https://m.media-amazon.com/images/I/81DgDEr4A7L.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8c0b122b-ea76-3509-bd29-2b791d8c3eec.jpg",
                                            "width": 1024,
                                            "height": 768,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8c0b122b-ea76-3509-bd29-2b791d8c3eec.jpg",
                                            "width": 350,
                                            "height": 263,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "025b0499-483a-3ba8-adc2-5d7fdb6d936b",
                                        "originalURL": "https://m.media-amazon.com/images/I/71pUhtNCw0L.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/025b0499-483a-3ba8-adc2-5d7fdb6d936b.jpg",
                                            "width": 1024,
                                            "height": 768,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/025b0499-483a-3ba8-adc2-5d7fdb6d936b.jpg",
                                            "width": 350,
                                            "height": 263,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "dd315c5e-b190-3861-8dc3-1b9d045543ca",
                                        "originalURL": "https://m.media-amazon.com/images/I/71KyVUIm4pL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dd315c5e-b190-3861-8dc3-1b9d045543ca.jpg",
                                            "width": 1024,
                                            "height": 768,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dd315c5e-b190-3861-8dc3-1b9d045543ca.jpg",
                                            "width": 350,
                                            "height": 263,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "07fb37c9-f0cc-3622-94b5-65e410b204d2",
                                        "originalURL": "https://m.media-amazon.com/images/I/71TJ0btVDJL.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/07fb37c9-f0cc-3622-94b5-65e410b204d2.jpg",
                                            "width": 1024,
                                            "height": 768,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/07fb37c9-f0cc-3622-94b5-65e410b204d2.jpg",
                                            "width": 350,
                                            "height": 263,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "e445ea82-4bc1-3589-bb56-a0d2298a2c0b",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e445ea82-4bc1-3589-bb56-a0d2298a2c0b.jpg",
                                                "width": 50,
                                                "height": 38,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Brown",
                                        "image": {
                                            "id": "c420ee3b-ce28-3199-ad8f-df6379d49e8e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c420ee3b-ce28-3199-ad8f-df6379d49e8e.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "amazon_B09M85WPFM",
                                "name": "Marshall Major IV On-Ear Bluetooth Headphone, Black",
                                "nameCN": "马歇尔四代Major IV 头戴式耳机🎧",
                                "description": [],
                                "merchantId": "e8493d47-7121-b17a-888a-2bd40a18bdb5",
                                "brand": "Marshall",
                                "displayBrand": "Marshall",
                                "brandId": "701fb907-16e1-3ecc-ba43-852e0eae27f1",
                                "category": "accessories|charging|on-ear|headphones|earbuds|electronics",
                                "categoryIds": [
                                    "a10"
                                ],
                                "priceTag": "$113",
                                "priceTagCN": "¥828",
                                "officialURL": "https://www.amazon.com/Marshall-Major-Bluetooth-Headphone-Black/dp/B08KHT2HDT/",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "Standard",
                                        "displayName": "Standard"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "1.6折",
                            "activityOffs": [],
                            "merchantName": "Amazon US selection",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "1.6折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "2d646dee-6446-3dbd-9027-debc1cc2e577",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/34075836_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2d646dee-6446-3dbd-9027-debc1cc2e577.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2d646dee-6446-3dbd-9027-debc1cc2e577.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "f5e8b1b6-71f5-35a1-a02c-4862589162df",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/34075777_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f5e8b1b6-71f5-35a1-a02c-4862589162df.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f5e8b1b6-71f5-35a1-a02c-4862589162df.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c9b354dc-28a3-3d10-960f-a5e0fc8cbfaf",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/34075778_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c9b354dc-28a3-3d10-960f-a5e0fc8cbfaf.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c9b354dc-28a3-3d10-960f-a5e0fc8cbfaf.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a1cc5f9e-a995-306f-a954-8ee00a5f1b27",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/34075779_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a1cc5f9e-a995-306f-a954-8ee00a5f1b27.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a1cc5f9e-a995-306f-a954-8ee00a5f1b27.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "74bc5381-7c66-3010-a5c8-6d05e4f51055",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/34075780_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/74bc5381-7c66-3010-a5c8-6d05e4f51055.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/74bc5381-7c66-3010-a5c8-6d05e4f51055.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "84d4a6ab-1995-3d14-aedb-c71af06a09da",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/23949093_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/84d4a6ab-1995-3d14-aedb-c71af06a09da.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/84d4a6ab-1995-3d14-aedb-c71af06a09da.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "6ca5ff8c-1926-30dc-9d31-f30348aca06d",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/34656864_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6ca5ff8c-1926-30dc-9d31-f30348aca06d.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6ca5ff8c-1926-30dc-9d31-f30348aca06d.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "594a5a9f-accb-39df-8275-e66ee01735f5",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/34656865_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/594a5a9f-accb-39df-8275-e66ee01735f5.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/594a5a9f-accb-39df-8275-e66ee01735f5.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "10c91f49-c880-3875-8500-42ea53d7db3c",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/34656866_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/10c91f49-c880-3875-8500-42ea53d7db3c.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/10c91f49-c880-3875-8500-42ea53d7db3c.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5c177d6f-3070-3782-927a-d5b854c2bef3",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/34656867_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5c177d6f-3070-3782-927a-d5b854c2bef3.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5c177d6f-3070-3782-927a-d5b854c2bef3.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "bae59114-f395-3b83-9ab8-cab16f2d68f2",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bae59114-f395-3b83-9ab8-cab16f2d68f2.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Warm Grey",
                                        "image": {
                                            "id": "0a8f1b06-1612-3008-92c6-ae3fb0131c6e",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0a8f1b06-1612-3008-92c6-ae3fb0131c6e.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_24156412",
                                "name": "Unisex Meta HSTN AI Glasses, OW8002",
                                "nameCN": "Oakley✖️Meta HSTN 智能太阳镜 男女同款  OW8002 ",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Oakley",
                                "displayBrand": "Oakley",
                                "brandId": "327be2e8-021d-393a-8446-fcdad6491a55",
                                "category": "sunglasses|women's fashion|sunglasses",
                                "categoryIds": [
                                    "a3a"
                                ],
                                "priceTag": "$403",
                                "priceTagCN": "¥2951",
                                "officialURL": "https://www.macys.com/shop/product/oakley-unisex-ai-meta-hstn-sunglasses-ow8002?ID=24156412",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "51mm",
                                        "displayName": "51mm"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "597add07-5800-373d-8776-93ade843dc2b",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/34125880_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/597add07-5800-373d-8776-93ade843dc2b.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/597add07-5800-373d-8776-93ade843dc2b.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a367c903-6f73-3b16-b786-5b8773fca62f",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/34239358_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a367c903-6f73-3b16-b786-5b8773fca62f.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a367c903-6f73-3b16-b786-5b8773fca62f.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a1e8e660-580b-320e-9a26-ff9eaa5833b6",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/34239359_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a1e8e660-580b-320e-9a26-ff9eaa5833b6.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a1e8e660-580b-320e-9a26-ff9eaa5833b6.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "027bb28c-dbbd-3049-b8bb-685f5bce0c3e",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/34239360_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/027bb28c-dbbd-3049-b8bb-685f5bce0c3e.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/027bb28c-dbbd-3049-b8bb-685f5bce0c3e.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e079f9a2-139e-3feb-937f-dc60d6b98fb9",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/34239361_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e079f9a2-139e-3feb-937f-dc60d6b98fb9.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e079f9a2-139e-3feb-937f-dc60d6b98fb9.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "84d4a6ab-1995-3d14-aedb-c71af06a09da",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/23949093_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/84d4a6ab-1995-3d14-aedb-c71af06a09da.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/84d4a6ab-1995-3d14-aedb-c71af06a09da.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "aeebffb0-5cc7-3564-95c1-8fbd7c00227f",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/34418525_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/aeebffb0-5cc7-3564-95c1-8fbd7c00227f.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/aeebffb0-5cc7-3564-95c1-8fbd7c00227f.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e8b8383c-5f5e-399e-9d69-be1b0ff35b6e",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/34656879_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e8b8383c-5f5e-399e-9d69-be1b0ff35b6e.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e8b8383c-5f5e-399e-9d69-be1b0ff35b6e.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c0b65835-d0da-34dd-81a5-6ce1c95ce4da",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/34656874_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c0b65835-d0da-34dd-81a5-6ce1c95ce4da.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c0b65835-d0da-34dd-81a5-6ce1c95ce4da.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5c177d6f-3070-3782-927a-d5b854c2bef3",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/34656867_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5c177d6f-3070-3782-927a-d5b854c2bef3.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5c177d6f-3070-3782-927a-d5b854c2bef3.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0cef5da1-8690-3df8-bb0a-8b7cd8782e32",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/34656880_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0cef5da1-8690-3df8-bb0a-8b7cd8782e32.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0cef5da1-8690-3df8-bb0a-8b7cd8782e32.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "ba9e325d-a536-30f7-a445-903d01520433",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ba9e325d-a536-30f7-a445-903d01520433.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_24156419",
                                "name": "Unisex AI Glasses, Meta Wayfarer RW4012 - GEN 2",
                                "nameCN": "【Gen2代】 雷朋 Meta  Wayfarer智能太阳镜 RW4012",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Ray-Ban",
                                "displayBrand": "Ray-Ban",
                                "brandId": "2091d438-dc6e-3d12-83e9-d08d16582644",
                                "category": "sunglasses|women's fashion|sunglasses",
                                "categoryIds": [
                                    "a3a"
                                ],
                                "priceTag": "$382.80",
                                "priceTagCN": "¥2803",
                                "officialURL": "https://www.macys.com/shop/product/ray-ban-unisex-ai-meta-gen2-wayfarer-sunglasses-rw4012?ID=24156419",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "50mm",
                                        "displayName": "50mm"
                                    },
                                    {
                                        "ids": [],
                                        "name": "53mm",
                                        "displayName": "53mm"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    }
                ]
            },
            {
                "id": "household_appliances",
                "title": "家电榜",
                "categoryIds": [
                    "j"
                ],
                "sections": [],
                "sort": 17,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "c8add255-e391-36bd-b410-c748a4551b8a",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/13367405_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c8add255-e391-36bd-b410-c748a4551b8a.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c8add255-e391-36bd-b410-c748a4551b8a.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c9a1d950-34af-3499-98c6-7e22790071f0",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/13340686_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c9a1d950-34af-3499-98c6-7e22790071f0.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c9a1d950-34af-3499-98c6-7e22790071f0.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ed5193d5-97a8-334c-b695-c8193dfa9e70",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/13340687_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ed5193d5-97a8-334c-b695-c8193dfa9e70.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ed5193d5-97a8-334c-b695-c8193dfa9e70.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "5726af72-0133-3af7-b593-3b051862ed2c",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/13340688_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5726af72-0133-3af7-b593-3b051862ed2c.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5726af72-0133-3af7-b593-3b051862ed2c.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "macys_1961022",
                                "name": "BL610 Professional 72-oz 1000W Blender",
                                "nameCN": "多功能搅拌机料理机 72盎司 1000w 需变压  BL610",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Ninja",
                                "displayBrand": "Ninja",
                                "brandId": "3899dcba-b79f-32af-b27c-2190bbd8abc5",
                                "category": "appliances|small|home|blender",
                                "categoryIds": [
                                    "j1l"
                                ],
                                "priceTag": "$90.90",
                                "priceTagCN": "¥666",
                                "originalPriceTag": "$111.10",
                                "officialURL": "https://www.macys.com/shop/product/ninja-bl610-professional-72-oz-1000w-blender?ID=1961022",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8.1折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8.1折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "7e6ebea8-03c6-3afc-957f-7bf688764879",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/21372682_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7e6ebea8-03c6-3afc-957f-7bf688764879.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7e6ebea8-03c6-3afc-957f-7bf688764879.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "621e9344-3fdc-3c09-b5e5-306fb06cbaeb",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/21372685_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/621e9344-3fdc-3c09-b5e5-306fb06cbaeb.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/621e9344-3fdc-3c09-b5e5-306fb06cbaeb.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9a4c1d29-93f7-3be7-8771-a0f5d9ebf1c0",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/21372686_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9a4c1d29-93f7-3be7-8771-a0f5d9ebf1c0.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9a4c1d29-93f7-3be7-8771-a0f5d9ebf1c0.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "085db37f-8b49-38a7-92e1-73c1113e22bf",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/21372687_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/085db37f-8b49-38a7-92e1-73c1113e22bf.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/085db37f-8b49-38a7-92e1-73c1113e22bf.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8648d726-00bf-3cf8-bc75-1b6403bc5bea",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/21372688_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8648d726-00bf-3cf8-bc75-1b6403bc5bea.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8648d726-00bf-3cf8-bc75-1b6403bc5bea.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "372d5d63-be7a-34a4-a330-6ddcda978fa1",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/21372691_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/372d5d63-be7a-34a4-a330-6ddcda978fa1.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/372d5d63-be7a-34a4-a330-6ddcda978fa1.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b601419a-e5f2-33c4-a310-683c4ec5bb56",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/21372692_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b601419a-e5f2-33c4-a310-683c4ec5bb56.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b601419a-e5f2-33c4-a310-683c4ec5bb56.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "450543c5-e205-3b76-a87b-2125ce9ebe0e",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/21372693_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/450543c5-e205-3b76-a87b-2125ce9ebe0e.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/450543c5-e205-3b76-a87b-2125ce9ebe0e.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a4e5a17a-b4c4-3243-94a1-d622860c9805",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/21372694_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a4e5a17a-b4c4-3243-94a1-d622860c9805.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a4e5a17a-b4c4-3243-94a1-d622860c9805.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "1b3915e8-d2de-35ee-8319-3fae6f12ec37",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/21372695_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1b3915e8-d2de-35ee-8319-3fae6f12ec37.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1b3915e8-d2de-35ee-8319-3fae6f12ec37.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Platinum",
                                        "image": {
                                            "id": "8069eeda-178c-3b13-8370-a203595b3de5",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8069eeda-178c-3b13-8370-a203595b3de5.jpg",
                                                "width": 41,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_14030516",
                                "name": "TWISTi™ HIGH-SPEED Blender DUO",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Ninja",
                                "displayBrand": "Ninja",
                                "brandId": "3899dcba-b79f-32af-b27c-2190bbd8abc5",
                                "category": "appliances|small|blender|home",
                                "categoryIds": [
                                    "j1l"
                                ],
                                "priceTag": "$111.10",
                                "priceTagCN": "¥814",
                                "originalPriceTag": "$141.40",
                                "officialURL": "https://www.macys.com/shop/product/ninja-twisti-high-speed-blender-duo?ID=14030516",
                                "labels": [
                                    "on_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "7.8折",
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "7.8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "c93f9e56-daa7-3e3e-bb9a-8bc5801d1c1d",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/30482785_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c93f9e56-daa7-3e3e-bb9a-8bc5801d1c1d.jpg",
                                            "width": 1000,
                                            "height": 1000,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c93f9e56-daa7-3e3e-bb9a-8bc5801d1c1d.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "aa1d1624-3a09-3674-a3bb-59111b4c1302",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/25853555_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/aa1d1624-3a09-3674-a3bb-59111b4c1302.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/aa1d1624-3a09-3674-a3bb-59111b4c1302.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "7c44a1e9-1b92-3d4a-8736-9a0e30c99cbb",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/25853556_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7c44a1e9-1b92-3d4a-8736-9a0e30c99cbb.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7c44a1e9-1b92-3d4a-8736-9a0e30c99cbb.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d976bb0d-60e8-3a08-955e-f03c9323d921",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/25853557_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d976bb0d-60e8-3a08-955e-f03c9323d921.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d976bb0d-60e8-3a08-955e-f03c9323d921.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e65ed65c-afe2-3373-a581-79ea994eb445",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/25853558_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e65ed65c-afe2-3373-a581-79ea994eb445.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e65ed65c-afe2-3373-a581-79ea994eb445.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a9db52a4-888e-383c-a469-c59134dba861",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/25853559_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a9db52a4-888e-383c-a469-c59134dba861.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a9db52a4-888e-383c-a469-c59134dba861.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4b934a41-a4b3-303c-ab44-234ea3fb024c",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/25853560_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4b934a41-a4b3-303c-ab44-234ea3fb024c.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4b934a41-a4b3-303c-ab44-234ea3fb024c.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e38f442c-c947-3a5f-8cf2-cff30b2f04db",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/25853561_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e38f442c-c947-3a5f-8cf2-cff30b2f04db.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e38f442c-c947-3a5f-8cf2-cff30b2f04db.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "759ab4e1-ecee-3aac-902e-76b94e3d5e01",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/25853562_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/759ab4e1-ecee-3aac-902e-76b94e3d5e01.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/759ab4e1-ecee-3aac-902e-76b94e3d5e01.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "3f3f6117-4550-3636-a772-6b041715b57f",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/25853563_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3f3f6117-4550-3636-a772-6b041715b57f.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3f3f6117-4550-3636-a772-6b041715b57f.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "b9e8a6cc-516e-3106-8f46-f6a74b55625c",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/4/optimized/25853564_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b9e8a6cc-516e-3106-8f46-f6a74b55625c.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b9e8a6cc-516e-3106-8f46-f6a74b55625c.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "8d2080a5-a47c-38fd-9f65-c358c08bdbe9",
                                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/25853565_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8d2080a5-a47c-38fd-9f65-c358c08bdbe9.jpg",
                                            "width": 838,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8d2080a5-a47c-38fd-9f65-c358c08bdbe9.jpg",
                                            "width": 286,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "945c8ea7-9d2d-3eae-9a87-4d9314570121",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/945c8ea7-9d2d-3eae-9a87-4d9314570121.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "macys_16701560",
                                "name": "Detect Power Blender Pro with BlendSense, TB201",
                                "description": [],
                                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                                "brand": "Ninja",
                                "displayBrand": "Ninja",
                                "brandId": "3899dcba-b79f-32af-b27c-2190bbd8abc5",
                                "category": "small|home|blender|appliances|automatic",
                                "categoryIds": [
                                    "j1l"
                                ],
                                "priceTag": "$151.50",
                                "priceTagCN": "¥1110",
                                "officialURL": "https://www.macys.com/shop/product/ninja-detect-power-blender-pro-with-blendsense-tb201?ID=16701560",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Macy's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "c79a3d20-8a84-35bb-a26d-3f595083f538",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/0/optimized/9140860_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c79a3d20-8a84-35bb-a26d-3f595083f538.jpg",
                                            "width": 700,
                                            "height": 700,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c79a3d20-8a84-35bb-a26d-3f595083f538.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "f19939b1-0f36-344e-98fd-fd2ba140a9bd",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/1/optimized/9140861_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f19939b1-0f36-344e-98fd-fd2ba140a9bd.jpg",
                                            "width": 700,
                                            "height": 700,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f19939b1-0f36-344e-98fd-fd2ba140a9bd.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "558b14ee-3998-3bd7-a57c-2fa8cf9db104",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/8/optimized/9140858_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/558b14ee-3998-3bd7-a57c-2fa8cf9db104.jpg",
                                            "width": 700,
                                            "height": 700,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/558b14ee-3998-3bd7-a57c-2fa8cf9db104.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "206ad2d0-4f6a-3ded-9afe-e9eab971d449",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/3/optimized/9140863_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/206ad2d0-4f6a-3ded-9afe-e9eab971d449.jpg",
                                            "width": 700,
                                            "height": 700,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/206ad2d0-4f6a-3ded-9afe-e9eab971d449.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e46e2a63-9c50-3fe0-b442-72e67ce11c1d",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/2/optimized/9140862_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e46e2a63-9c50-3fe0-b442-72e67ce11c1d.jpg",
                                            "width": 700,
                                            "height": 700,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e46e2a63-9c50-3fe0-b442-72e67ce11c1d.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "6008ebce-879a-36d7-83a9-fd50aee3b1bb",
                                        "originalURL": "https://images.bloomingdales.com/is/image/BLM/products/0/optimized/9163190_fpx.tif?op_sharpen=1&wid=700",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6008ebce-879a-36d7-83a9-fd50aee3b1bb.jpg",
                                            "width": 700,
                                            "height": 700,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6008ebce-879a-36d7-83a9-fd50aee3b1bb.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Silver",
                                        "image": {
                                            "id": "cd59a8c3-0086-3570-a04e-56cb01063ccd",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/cd59a8c3-0086-3570-a04e-56cb01063ccd.jpg",
                                                "width": 50,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "bloomingdales_1735541",
                                "name": "Shark Mega Kitchen System",
                                "description": [],
                                "merchantId": "34b7c946-2aec-d75b-66f0-81fcea0ce875",
                                "brand": "Ninja",
                                "displayBrand": "Ninja",
                                "brandId": "3899dcba-b79f-32af-b27c-2190bbd8abc5",
                                "category": "electric",
                                "categoryIds": [
                                    "j1l"
                                ],
                                "priceTag": "$222.20",
                                "priceTagCN": "¥1627",
                                "officialURL": "https://www.bloomingdales.com/shop/product/shark-ninja-mega-kitchen-system?ID=1735541",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Bloomingdale's",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "96bb16ed-18c7-40e9-8abc-e7a442bb7a91",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/96bb16ed-18c7-40e9-8abc-e7a442bb7a91.jpg",
                                            "width": 800,
                                            "height": 926,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/96bb16ed-18c7-40e9-8abc-e7a442bb7a91.jpg",
                                            "width": 800,
                                            "height": 926,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "f8f76527-60b7-4a09-b4b7-e0e0232d41f2",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f8f76527-60b7-4a09-b4b7-e0e0232d41f2.jpg",
                                            "width": 750,
                                            "height": 1000,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f8f76527-60b7-4a09-b4b7-e0e0232d41f2.jpg",
                                            "width": 750,
                                            "height": 1000,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "dc21ec9a-2352-4918-8004-ba03e47eb193",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dc21ec9a-2352-4918-8004-ba03e47eb193.jpg",
                                            "width": 750,
                                            "height": 1000,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dc21ec9a-2352-4918-8004-ba03e47eb193.jpg",
                                            "width": 750,
                                            "height": 1000,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "59fff0e7-83bd-4b59-9b74-78d91d44b341",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/59fff0e7-83bd-4b59-9b74-78d91d44b341.jpg",
                                            "width": 750,
                                            "height": 1000,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/59fff0e7-83bd-4b59-9b74-78d91d44b341.jpg",
                                            "width": 750,
                                            "height": 1000,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "c045f2eb-0067-4a61-83bb-ad6b57005fd3",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c045f2eb-0067-4a61-83bb-ad6b57005fd3.jpg",
                                            "width": 750,
                                            "height": 1000,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c045f2eb-0067-4a61-83bb-ad6b57005fd3.jpg",
                                            "width": 750,
                                            "height": 1000,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "74742646-525d-4d38-8a99-57c441109565",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/74742646-525d-4d38-8a99-57c441109565.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/74742646-525d-4d38-8a99-57c441109565.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "ca47e6fc-8b7f-4c52-8d04-1f241c1a170f",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ca47e6fc-8b7f-4c52-8d04-1f241c1a170f.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ca47e6fc-8b7f-4c52-8d04-1f241c1a170f.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "b968d922-c208-4211-8cb8-dc5986018a45",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b968d922-c208-4211-8cb8-dc5986018a45.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b968d922-c208-4211-8cb8-dc5986018a45.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "1da1c8ee-ec55-46bf-8cee-cd223189d9cc",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1da1c8ee-ec55-46bf-8cee-cd223189d9cc.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1da1c8ee-ec55-46bf-8cee-cd223189d9cc.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "清新绿",
                                        "image": {
                                            "id": "aaecf222-4edb-31f6-a29e-3bfc9ee8e5e6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/aaecf222-4edb-31f6-a29e-3bfc9ee8e5e6.jpg",
                                                "width": 800,
                                                "height": 926,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "轻奢蓝",
                                        "image": {
                                            "id": "aaecf222-4edb-31f6-a29e-3bfc9ee8e5e6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/aaecf222-4edb-31f6-a29e-3bfc9ee8e5e6.jpg",
                                                "width": 800,
                                                "height": 926,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "落樱粉",
                                        "image": {
                                            "id": "aaecf222-4edb-31f6-a29e-3bfc9ee8e5e6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/aaecf222-4edb-31f6-a29e-3bfc9ee8e5e6.jpg",
                                                "width": 800,
                                                "height": 926,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "椰奶白",
                                        "image": {
                                            "id": "aaecf222-4edb-31f6-a29e-3bfc9ee8e5e6",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/aaecf222-4edb-31f6-a29e-3bfc9ee8e5e6.jpg",
                                                "width": 800,
                                                "height": 926,
                                                "format": "jpg"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "yixing_10352",
                                "name": "烧水杯便携式烧水壶旅行热水壶办公室加热杯小型电炖杯保温杯MR6061",
                                "description": [],
                                "merchantId": "f55ae92d-49a0-328f-ba73-2178a1f35eae",
                                "brand": "Morphy Richards",
                                "displayBrand": "Morphy Richards",
                                "brandId": "e4069225-62b3-3311-add2-0f77e2c362f7",
                                "categoryIds": [
                                    "j15"
                                ],
                                "priceTag": "$43.20",
                                "priceTagCN": "¥317",
                                "originalPriceTag": "$60",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "off": "8折",
                            "activityOffs": [
                                "额外九折"
                            ],
                            "merchantName": "Yixing",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "额外九折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "8折×额外9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "def4acd3-37a9-320a-86e8-ffb36baede17",
                                        "originalURL": "https://pics.walgreens.com/prodimg/669970/900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/def4acd3-37a9-320a-86e8-ffb36baede17.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/def4acd3-37a9-320a-86e8-ffb36baede17.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "6f770795-6b9a-3aac-afbd-b410f724573c",
                                        "originalURL": "https://pics.walgreens.com/prodimg/669970/2_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6f770795-6b9a-3aac-afbd-b410f724573c.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6f770795-6b9a-3aac-afbd-b410f724573c.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "db7eeb13-8e23-338a-adcb-2694a8a20105",
                                        "originalURL": "https://pics.walgreens.com/prodimg/669970/3_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/db7eeb13-8e23-338a-adcb-2694a8a20105.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/db7eeb13-8e23-338a-adcb-2694a8a20105.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0457dca4-7ed0-33af-a894-e8a24593b20d",
                                        "originalURL": "https://pics.walgreens.com/prodimg/669970/4_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0457dca4-7ed0-33af-a894-e8a24593b20d.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0457dca4-7ed0-33af-a894-e8a24593b20d.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "9af9a3c3-0788-3a22-bc14-3cd2f9d0416a",
                                        "originalURL": "https://pics.walgreens.com/prodimg/669970/5_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9af9a3c3-0788-3a22-bc14-3cd2f9d0416a.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9af9a3c3-0788-3a22-bc14-3cd2f9d0416a.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "18fe5129-816d-3413-9e49-8114dc496f73",
                                        "originalURL": "https://pics.walgreens.com/prodimg/669970/6_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/18fe5129-816d-3413-9e49-8114dc496f73.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/18fe5129-816d-3413-9e49-8114dc496f73.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "588d3c5c-1886-3a03-8cc5-c9417399c3b2",
                                        "originalURL": "https://pics.drugstore.com/prodimg/669970/7_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/588d3c5c-1886-3a03-8cc5-c9417399c3b2.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/588d3c5c-1886-3a03-8cc5-c9417399c3b2.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "535b2fd5-cae7-3c3d-b94d-08b35e304b63",
                                        "originalURL": "https://pics.drugstore.com/prodimg/669970/8_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/535b2fd5-cae7-3c3d-b94d-08b35e304b63.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/535b2fd5-cae7-3c3d-b94d-08b35e304b63.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "walgreens_300448219",
                                "name": "Electric Shaver for Men, Series 5 5118s, Wet & Dry Shave, Turbo Shaving Mode",
                                "description": [],
                                "merchantId": "63ea689e-3888-7d2a-25b1-f57a6f86748f",
                                "brand": "Braun",
                                "displayBrand": "Braun",
                                "brandId": "33b1929f-4a9a-34b0-8c02-74860e07096a",
                                "category": "Personal Care|Shaving & Grooming|Electric Shave for Men",
                                "categoryIds": [
                                    "j2d"
                                ],
                                "priceTag": "$105.20",
                                "priceTagCN": "¥771",
                                "officialURL": "https://www.walgreens.com/store/c/braun-electric-shaver-for-men,-series-5-5118s,-wet-%26-dry-shave,-turbo-shaving-mode/ID=300448219-product",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Walgreens",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "2d95050c-ff04-30dd-8de3-8e82ef6a21b8",
                                        "originalURL": "https://pics.walgreens.com/prodimg/666790/900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2d95050c-ff04-30dd-8de3-8e82ef6a21b8.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2d95050c-ff04-30dd-8de3-8e82ef6a21b8.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "d7dbe66b-2371-352a-b80f-24ea41ae62b3",
                                        "originalURL": "https://pics.walgreens.com/prodimg/666790/2_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d7dbe66b-2371-352a-b80f-24ea41ae62b3.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d7dbe66b-2371-352a-b80f-24ea41ae62b3.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "a3605683-8ff7-3ed1-948d-891c84586f83",
                                        "originalURL": "https://pics.walgreens.com/prodimg/666790/7_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a3605683-8ff7-3ed1-948d-891c84586f83.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a3605683-8ff7-3ed1-948d-891c84586f83.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c3b0197c-6d2f-31dd-b899-7cd60c1b0a15",
                                        "originalURL": "https://pics.walgreens.com/prodimg/666790/6_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c3b0197c-6d2f-31dd-b899-7cd60c1b0a15.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c3b0197c-6d2f-31dd-b899-7cd60c1b0a15.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "218e3f77-9cfd-3396-a071-eded9fe7df49",
                                        "originalURL": "https://pics.walgreens.com/prodimg/666790/2_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/218e3f77-9cfd-3396-a071-eded9fe7df49.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/218e3f77-9cfd-3396-a071-eded9fe7df49.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "28bfe819-3026-332b-bc3a-35b9cecee9af",
                                        "originalURL": "https://pics.walgreens.com/prodimg/666790/7_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/28bfe819-3026-332b-bc3a-35b9cecee9af.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/28bfe819-3026-332b-bc3a-35b9cecee9af.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "28bfe819-3026-332b-bc3a-35b9cecee9af",
                                        "originalURL": "https://pics.walgreens.com/prodimg/666790/7_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/28bfe819-3026-332b-bc3a-35b9cecee9af.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/28bfe819-3026-332b-bc3a-35b9cecee9af.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "walgreens_300445037",
                                "name": "Marvel's Spiderman Battery Toothbrush Soft Bristles",
                                "description": [],
                                "merchantId": "63ea689e-3888-7d2a-25b1-f57a6f86748f",
                                "brand": "Oral-B",
                                "displayBrand": "Oral-B",
                                "brandId": "dba4aaab-4511-3105-828c-e68411226f56",
                                "category": "personal|oral|electric|care|toothbrushes",
                                "categoryIds": [
                                    "j2f"
                                ],
                                "priceTag": "$9.95",
                                "priceTagCN": "¥73",
                                "officialURL": "https://www.walgreens.com/store/c/oral-b-marvel's-spiderman-battery-toothbrush-soft-bristles/ID=300445037-product",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Walgreens",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    }
                ]
            },
            {
                "id": "food",
                "title": "酒水食品榜",
                "categoryIds": [
                    "c"
                ],
                "sections": [],
                "sort": 18,
                "subTab": [],
                "excludeCategoryIds": [],
                "products": [
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "d1fb32d7-9ca8-343c-93ee-612cbf64c7f1",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/W3781R_01_b1_s1_a1_1_m91_750x.jpg?v=1731610124",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d1fb32d7-9ca8-343c-93ee-612cbf64c7f1.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d1fb32d7-9ca8-343c-93ee-612cbf64c7f1.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "4cf676c3-e0f7-348c-a198-6b252c352fb7",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/W3781R_01_b1_s1_a2_1_m91_750x.jpg?v=1731610220",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4cf676c3-e0f7-348c-a198-6b252c352fb7.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4cf676c3-e0f7-348c-a198-6b252c352fb7.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "462aa875-f360-386a-8424-d15adbf9f95e",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/W3781R_01_b1_s1_a3_1_m91_750x.jpg?v=1731610224",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/462aa875-f360-386a-8424-d15adbf9f95e.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/462aa875-f360-386a-8424-d15adbf9f95e.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "0811be9b-97db-34a7-92ae-5c6ed496f8fd",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/W3781R_01_b1_s1_a4_1_m91_750x.jpg?v=1731610230",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0811be9b-97db-34a7-92ae-5c6ed496f8fd.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0811be9b-97db-34a7-92ae-5c6ed496f8fd.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "11b42049-5781-342f-9ef5-c2d4b4be4131",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/11b42049-5781-342f-9ef5-c2d4b4be4131.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Ivory",
                                        "image": {
                                            "id": "0576cfcb-eb54-3da5-9733-27219056702c",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0576cfcb-eb54-3da5-9733-27219056702c.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "aloyoga_W3781R",
                                "name": "Ribbed Sea Coast Long Sleeve - Ivory",
                                "nameCN": "女士 罗纹海岸长袖 - 黑色",
                                "description": [],
                                "merchantId": "ad4a17c1-7ed8-e5d2-acee-a6d9711d1ef0",
                                "brand": "Alo Yoga",
                                "displayBrand": "Alo",
                                "brandId": "1b2ccf52-b54e-32c9-868c-a24fbe164919",
                                "category": "yoga|alo",
                                "categoryIds": [
                                    "c24"
                                ],
                                "priceTag": "$76.95",
                                "priceTagCN": "¥564",
                                "officialURL": "https://www.aloyoga.com/products/w3781r-ribbed-sea-coast-long-sleeve-ivory",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XXS",
                                        "displayName": "XXS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Alo yoga",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_1.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "4a846849-b087-4af8-ab9e-9243e4a7722d",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4a846849-b087-4af8-ab9e-9243e4a7722d.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4a846849-b087-4af8-ab9e-9243e4a7722d.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "f6fbfdd4-b5fe-486b-a548-083ebd62bd72",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f6fbfdd4-b5fe-486b-a548-083ebd62bd72.jpg",
                                            "width": 2866,
                                            "height": 4055,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f6fbfdd4-b5fe-486b-a548-083ebd62bd72.jpg",
                                            "width": 2866,
                                            "height": 4055,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "9b32bf7c-4212-44b7-a265-a161aeb169a8",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9b32bf7c-4212-44b7-a265-a161aeb169a8.jpg",
                                            "width": 850,
                                            "height": 542,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9b32bf7c-4212-44b7-a265-a161aeb169a8.jpg",
                                            "width": 850,
                                            "height": 542,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "winestory_10017",
                                "name": "蔷薇之恋马尔维萨甜白起泡酒",
                                "description": [],
                                "merchantId": "50a6d34f-1ed4-38fb-8eb5-3eb34a9bbaad",
                                "brand": "Gladstone",
                                "displayBrand": "Gladstone",
                                "brandId": "b02f774f-224e-381e-b0f9-28d98bd11f0a",
                                "categoryIds": [
                                    "c43"
                                ],
                                "priceTag": "$11.25",
                                "priceTagCN": "¥83",
                                "originalPriceTag": "$12.50",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "750ml",
                                        "displayName": "750ml"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [
                                "满减",
                                "满赠",
                                "额外九折"
                            ],
                            "merchantName": "Wine Story",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "满赠",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_2.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "额外9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$100减$5",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$160送赠品",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$260送赠品",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "60e4073d-3bdd-3558-a209-ca213b099432",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/A0783U_03299_b1_s1_a2_f96c126d-f289-48fa-9091-1cd612528183_750x.jpg?v=1758661549",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/60e4073d-3bdd-3558-a209-ca213b099432.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/60e4073d-3bdd-3558-a209-ca213b099432.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "6d824331-aee6-3b1a-a347-42b2444564a0",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/A0783U_03299_b1_s1_a1_df1083d4-ac37-4e4e-b8ed-fa9f502e7018_750x.jpg?v=1758661549",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/6d824331-aee6-3b1a-a347-42b2444564a0.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/6d824331-aee6-3b1a-a347-42b2444564a0.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Ivory",
                                        "image": {
                                            "id": "d42bb141-432a-3363-829d-d7ca83e39cd8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d42bb141-432a-3363-829d-d7ca83e39cd8.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "891f0e4f-29de-38e3-9813-553fc9f1c929",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/891f0e4f-29de-38e3-9813-553fc9f1c929.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Light Cocoa",
                                        "image": {
                                            "id": "de4b9f13-6c13-3663-8b7a-022f3dceceaf",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/de4b9f13-6c13-3663-8b7a-022f3dceceaf.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "aloyoga_A0783U",
                                "name": "Polar Fleece Ear Warmer - Light Cocoa",
                                "description": [],
                                "merchantId": "ad4a17c1-7ed8-e5d2-acee-a6d9711d1ef0",
                                "brand": "Alo Yoga",
                                "displayBrand": "Alo",
                                "brandId": "1b2ccf52-b54e-32c9-868c-a24fbe164919",
                                "category": "yoga|alo",
                                "categoryIds": [
                                    "c24"
                                ],
                                "priceTag": "$49.80",
                                "priceTagCN": "¥365",
                                "officialURL": "https://www.aloyoga.com/products/a0783u-polar-fleece-ear-warmer-light-cocoa",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "One Size",
                                        "displayName": "One Size"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Alo yoga",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_3.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "535a2a29-c05f-32c9-83fe-d292fb7d4bec",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/M5171R_04064_b1_s1_a2_m191_jpg_0f70744f-4954-4b01-93ba-7d942d66e85c_750x.jpg?v=1760468997",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/535a2a29-c05f-32c9-83fe-d292fb7d4bec.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/535a2a29-c05f-32c9-83fe-d292fb7d4bec.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "f8ec0a02-b072-39d4-b1e6-c379425c7610",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/M5171R_04064_b1_s1_ai_m191_98e51366-7ca5-4a10-93ed-8cb5ccade980_750x.jpg?v=1760468997",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f8ec0a02-b072-39d4-b1e6-c379425c7610.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f8ec0a02-b072-39d4-b1e6-c379425c7610.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "ed3891dc-7aaf-3b90-bee3-f7bfa68ddff1",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/M5171R_04064_b1_s1_a4_m191_jpg_116f086b-a5ab-4579-a03b-84e807f1026e_750x.jpg?v=1760468997",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ed3891dc-7aaf-3b90-bee3-f7bfa68ddff1.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ed3891dc-7aaf-3b90-bee3-f7bfa68ddff1.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "f12cde27-7b1f-3907-aa8e-3eaadc952ccc",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/M5171R_04064_b1_s1_a1_m191_40ac3ddc-5337-40ae-8de0-50d75de4b560_750x.jpg?v=1760468997",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f12cde27-7b1f-3907-aa8e-3eaadc952ccc.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f12cde27-7b1f-3907-aa8e-3eaadc952ccc.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "f58762af-4043-3475-a3f2-c2e6664827d6",
                                        "originalURL": "https://cdn.shopify.com/s/files/1/2185/2813/files/M5171R_04064_b1_s1_a5_m191_jpg_5364df90-bddb-4367-a48b-e02abee1924a_750x.jpg?v=1760468964",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f58762af-4043-3475-a3f2-c2e6664827d6.jpg",
                                            "width": 683,
                                            "height": 1024,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f58762af-4043-3475-a3f2-c2e6664827d6.jpg",
                                            "width": 233,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [
                                    {
                                        "name": "Espresso",
                                        "image": {
                                            "id": "2b4f122e-8a11-3689-8d88-0a0d1d07689a",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2b4f122e-8a11-3689-8d88-0a0d1d07689a.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Black",
                                        "image": {
                                            "id": "e14147a7-610c-3701-9507-089d6a05a5b0",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e14147a7-610c-3701-9507-089d6a05a5b0.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Ivory",
                                        "image": {
                                            "id": "f3adbee0-420c-3da0-871f-455bc70da6d3",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f3adbee0-420c-3da0-871f-455bc70da6d3.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Celestial Blue Heather",
                                        "image": {
                                            "id": "b200b36a-7595-3c26-bf3d-e2f5e7cb67be",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b200b36a-7595-3c26-bf3d-e2f5e7cb67be.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    },
                                    {
                                        "name": "Light Cocoa",
                                        "image": {
                                            "id": "c46ca450-e7fc-3c5b-865c-e04893f2dee8",
                                            "full": {
                                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c46ca450-e7fc-3c5b-865c-e04893f2dee8.jpg",
                                                "width": 33,
                                                "height": 50,
                                                "format": "JPG"
                                            },
                                            "thumbnail": {}
                                        }
                                    }
                                ],
                                "id": "aloyoga_WomensM5171R",
                                "name": "Scholar Straight Leg Sweatpant - Light Cocoa",
                                "description": [],
                                "merchantId": "ad4a17c1-7ed8-e5d2-acee-a6d9711d1ef0",
                                "brand": "Alo Yoga",
                                "displayBrand": "Alo",
                                "brandId": "1b2ccf52-b54e-32c9-868c-a24fbe164919",
                                "category": "yoga|alo",
                                "categoryIds": [
                                    "c24"
                                ],
                                "priceTag": "$195.50",
                                "priceTagCN": "¥1432",
                                "officialURL": "https://www.aloyoga.com/products/m5171r-scholar-straight-leg-sweatpant-light-cocoa-womens",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "XS",
                                        "displayName": "XS"
                                    },
                                    {
                                        "ids": [],
                                        "name": "S",
                                        "displayName": "S"
                                    },
                                    {
                                        "ids": [],
                                        "name": "M",
                                        "displayName": "M"
                                    },
                                    {
                                        "ids": [],
                                        "name": "L",
                                        "displayName": "L"
                                    },
                                    {
                                        "ids": [],
                                        "name": "XL",
                                        "displayName": "XL"
                                    },
                                    {
                                        "ids": [],
                                        "name": "2XL",
                                        "displayName": "2XL"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Alo yoga",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "4",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国",
                            "allowExpressBuy": true
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "1a8d56a7-aa84-3370-8f3d-1dccb7e4eaa8",
                                        "originalURL": "https://pics.drugstore.com/prodimg/553953/900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/1a8d56a7-aa84-3370-8f3d-1dccb7e4eaa8.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/1a8d56a7-aa84-3370-8f3d-1dccb7e4eaa8.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "dca1b86f-b741-361f-8b9e-35b0d48cc275",
                                        "originalURL": "https://pics.drugstore.com/prodimg/553953/2_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dca1b86f-b741-361f-8b9e-35b0d48cc275.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dca1b86f-b741-361f-8b9e-35b0d48cc275.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "c3ca116c-702b-37af-84a4-246a2037f520",
                                        "originalURL": "https://pics.drugstore.com/prodimg/553953/3_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c3ca116c-702b-37af-84a4-246a2037f520.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c3ca116c-702b-37af-84a4-246a2037f520.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    },
                                    {
                                        "id": "e8520326-5629-3864-9327-67c641011c9d",
                                        "originalURL": "https://pics.drugstore.com/prodimg/553953/4_900.jpg",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e8520326-5629-3864-9327-67c641011c9d.jpg",
                                            "width": 900,
                                            "height": 900,
                                            "format": "JPG"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e8520326-5629-3864-9327-67c641011c9d.jpg",
                                            "width": 350,
                                            "height": 350,
                                            "format": "JPG"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "walgreens_prod6278044",
                                "name": "Pistachios No Shell Roasted Salted",
                                "description": [],
                                "merchantId": "63ea689e-3888-7d2a-25b1-f57a6f86748f",
                                "brand": "Wonderful",
                                "displayBrand": "Wonderful",
                                "brandId": "9f608aae-d334-3e3b-bc0c-c481b86458ad",
                                "category": "grocery|seeds|nuts|snacks",
                                "categoryIds": [
                                    "c05"
                                ],
                                "priceTag": "$4.20",
                                "priceTagCN": "¥31",
                                "officialURL": "https://www.walgreens.com/store/c/wonderful-roasted-%26-salted-pistachios-shelled-roasted-%26-salted/ID=prod6278044-product",
                                "labels": [],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [],
                            "merchantName": "Walgreens",
                            "origin": "[美国]",
                            "promotion": {
                                "promotionLabels": [],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "5",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "美国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "d188a37e-093f-4016-8a64-1dda96ab07b0",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d188a37e-093f-4016-8a64-1dda96ab07b0.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d188a37e-093f-4016-8a64-1dda96ab07b0.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "d73b9171-52eb-46ff-91b9-1220b608f79a",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d73b9171-52eb-46ff-91b9-1220b608f79a.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d73b9171-52eb-46ff-91b9-1220b608f79a.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "713bac18-d1e5-4aa2-984b-9aea2e0e48ba",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/713bac18-d1e5-4aa2-984b-9aea2e0e48ba.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/713bac18-d1e5-4aa2-984b-9aea2e0e48ba.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "winestory_10238",
                                "name": "帝罗干红葡萄酒 知名餐厅Anan Saigon的首选",
                                "description": [],
                                "merchantId": "50a6d34f-1ed4-38fb-8eb5-3eb34a9bbaad",
                                "brand": "Gladstone",
                                "displayBrand": "Gladstone",
                                "brandId": "b02f774f-224e-381e-b0f9-28d98bd11f0a",
                                "categoryIds": [
                                    "c43"
                                ],
                                "priceTag": "$21.25",
                                "priceTagCN": "¥156",
                                "originalPriceTag": "$25",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "750ML",
                                        "displayName": "750ML"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [
                                "满减",
                                "满赠",
                                "额外八五折"
                            ],
                            "merchantName": "Wine Story",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "满赠",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外八五折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "6",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "额外8.5折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$100减$5",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$160送赠品",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$260送赠品",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "b68c8694-d873-4419-a400-73253f915841",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b68c8694-d873-4419-a400-73253f915841.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b68c8694-d873-4419-a400-73253f915841.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "d83200b7-a29b-4764-8087-d1a7c9413f56",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/d83200b7-a29b-4764-8087-d1a7c9413f56.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/d83200b7-a29b-4764-8087-d1a7c9413f56.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "66c87fcd-63b2-4e15-b12a-1e1ae9ce08eb",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/66c87fcd-63b2-4e15-b12a-1e1ae9ce08eb.jpg",
                                            "width": 947,
                                            "height": 949,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/66c87fcd-63b2-4e15-b12a-1e1ae9ce08eb.jpg",
                                            "width": 947,
                                            "height": 949,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "winestory_10246",
                                "name": "法岚茜小酒馆黑皮诺",
                                "description": [],
                                "merchantId": "50a6d34f-1ed4-38fb-8eb5-3eb34a9bbaad",
                                "brand": "Gladstone",
                                "displayBrand": "Gladstone",
                                "brandId": "b02f774f-224e-381e-b0f9-28d98bd11f0a",
                                "categoryIds": [
                                    "c43"
                                ],
                                "priceTag": "$17.55",
                                "priceTagCN": "¥129",
                                "originalPriceTag": "$19.50",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "750ml",
                                        "displayName": "750ml"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [
                                "满减",
                                "满赠",
                                "额外九折"
                            ],
                            "merchantName": "Wine Story",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "满赠",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外九折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "7",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "额外9折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$100减$5",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$160送赠品",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$260送赠品",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    },
                    {
                        "searchProduct": {
                            "product": {
                                "images": [
                                    {
                                        "id": "4c7315d2-4603-4a23-b3d6-10d40e1c0dcc",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4c7315d2-4603-4a23-b3d6-10d40e1c0dcc.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4c7315d2-4603-4a23-b3d6-10d40e1c0dcc.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "e70ec600-f757-455c-b6d6-857da330d304",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e70ec600-f757-455c-b6d6-857da330d304.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e70ec600-f757-455c-b6d6-857da330d304.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    },
                                    {
                                        "id": "fecc5833-4800-46b2-afff-f64e7a87b168",
                                        "full": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fecc5833-4800-46b2-afff-f64e7a87b168.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        },
                                        "thumbnail": {
                                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fecc5833-4800-46b2-afff-f64e7a87b168.jpg",
                                            "width": 800,
                                            "height": 800,
                                            "format": "jpg"
                                        }
                                    }
                                ],
                                "colors": [],
                                "id": "winestory_10034",
                                "name": "红山老藤歌海娜干红葡萄酒",
                                "description": [],
                                "merchantId": "50a6d34f-1ed4-38fb-8eb5-3eb34a9bbaad",
                                "brand": "Gladstone",
                                "displayBrand": "Gladstone",
                                "brandId": "b02f774f-224e-381e-b0f9-28d98bd11f0a",
                                "categoryIds": [
                                    "c43"
                                ],
                                "priceTag": "$16",
                                "priceTagCN": "¥118",
                                "originalPriceTag": "$20",
                                "labels": [
                                    "final_sale"
                                ],
                                "badges": [],
                                "keyDetails": [],
                                "inventoryStatus": "AVAILABLE",
                                "sizes": [
                                    {
                                        "ids": [],
                                        "name": "750ml",
                                        "displayName": "750ml"
                                    }
                                ],
                                "availableSkus": [],
                                "marks": [],
                                "badgeList": [],
                                "type": "REGULAR",
                                "videos": [],
                                "unAvailableSkus": []
                            },
                            "activityOffs": [
                                "满减",
                                "满赠",
                                "额外八折"
                            ],
                            "merchantName": "Wine Story",
                            "origin": "[中国]",
                            "promotion": {
                                "promotionLabels": [
                                    {
                                        "text": "满减",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "满赠",
                                        "color": "D27D3F"
                                    },
                                    {
                                        "text": "额外八折",
                                        "color": "D27D3F"
                                    }
                                ],
                                "type": "LABEL"
                            },
                            "insignia": {
                                "text": "8",
                                "image": {
                                    "url": "http://5thave-img-cdn-g.bybieyang.com/img/app/board/board_top_common.png"
                                }
                            },
                            "labelView": {
                                "shortLabels": [
                                    {
                                        "labels": [
                                            {
                                                "text": "额外8折",
                                                "color": "FFFFFF",
                                                "backgroundColor": "222222",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ],
                                        "kind": "DISCOUNT_LABEL"
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$100减$5",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$160送赠品",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "满$260送赠品",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": []
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "包邮包税",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER",
                                            "PRODUCT_LIST_LAYER"
                                        ]
                                    },
                                    {
                                        "labels": [
                                            {
                                                "text": "独家减免邮费",
                                                "color": "E1660C",
                                                "backgroundColor": "FAF2EB",
                                                "fontSize": 18,
                                                "fontWeight": "REGULAR"
                                            }
                                        ],
                                        "layers": [
                                            "PRODUCT_DETAIL_LAYER"
                                        ],
                                        "kind": "SHIPPING_LABEL"
                                    }
                                ],
                                "viewLabelType": "V2_LIST_VIEW"
                            },
                            "numberViews": [],
                            "merchantOrigin": "中国"
                        }
                    }
                ]
            }
        ]
    },
    "giftInfo": {
        "amount": "688元",
        "backgroundImg": "https://baleen-cdn-g.bybieyang.com/static/images/profile/newcomer_v1.png"
    }
}

export const pymlProducts = [
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "c067c13d-5b04-3b3c-86a1-e10cdf594a5e",
                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IG8188_1l.jpg?v=1729219603",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c067c13d-5b04-3b3c-86a1-e10cdf594a5e.jpg",
                            "width": 1000,
                            "height": 1000,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c067c13d-5b04-3b3c-86a1-e10cdf594a5e.jpg",
                            "width": 350,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [],
                "id": "shoebacca_9635520184602",
                "name": "adidas Yeezy 950 Round Toe Lace Up Boots",
                "nameCN": "Yeezy 950 Boots 男款 短筒 户外靴 舒适百搭  IG8188",
                "description": [
                    "The adidas Yeezy 950 Boot ‘Pirate’ brings back a monochrome colorway of the hybrid silhouette that blends design notes from a duck boot and military boot. Crafted from black rubber and ballistic nylon mesh, the high-cut upper is lined in leather and canvas for improved durability and support. Branding is limited to mismatched tongue tags marked with debossed adidas and Yeezy logos. Anchoring the boot is a bulky midsole, fitted with an interior foam wedge and supported by a lugged rubber outsole.",
                    "Hybrid Design: Combines military and duck boot aesthetics for a rugged, fashion-forward silhouette.",
                    "Durable Upper: Made from ballistic nylon mesh and leather for a tough, textured appearance.",
                    "Chunky Rubber Sole: Thick, ridged sole provides excellent traction and a stable platform.",
                    "Functional Closure: Rope laces and a heel pull-tab allow for secure fit and easy wear.",
                    "Subtle and unique branding, with the Yeezy logo on one tongue and the Adidas logo on the other.",
                    "Season 1 Release: Debuted in Yeezy Season 1, known for earth-toned colorways and utilitarian style.",
                    "SKU: \nIG8188",
                    "Color: \nBlack",
                    "Material: \nMesh, Rubber",
                    "Style: \nLace Up",
                    "Heel Height: \nLow Heel 1in-2in",
                    "Shaft Height: \nAnkle"
                ],
                "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                "brand": "adidas",
                "displayBrand": "Adidas",
                "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                "category": "casual|sapg::adi08277 ~ color::black|adult|shoes|men|boots|mens|adidas|clearance",
                "categoryIds": [
                    "k05"
                ],
                "priceTag": "$249.95",
                "priceTagCN": "¥1830",
                "officialURL": "https://www.shoebacca.com/products/adidas-yeezy-950-lace-up-boots-ig8188",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [
                            "cm_23",
                            "eu_37 1/3",
                            "uk_4.5",
                            "us_5"
                        ],
                        "name": "5",
                        "displayName": "欧码37 1/3(适合脚长23cm)",
                        "type": "eu",
                        "label": "37 1/3"
                    },
                    {
                        "ids": [
                            "cm_23.5",
                            "eu_38",
                            "uk_5",
                            "us_5.5"
                        ],
                        "name": "5.5",
                        "displayName": "欧码38(适合脚长23.5cm)",
                        "type": "eu",
                        "label": "38"
                    },
                    {
                        "ids": [
                            "cm_24",
                            "eu_38 2/3",
                            "uk_5.5",
                            "us_6"
                        ],
                        "name": "6",
                        "displayName": "欧码38 2/3(适合脚长24cm)",
                        "type": "eu",
                        "label": "38 2/3"
                    },
                    {
                        "ids": [
                            "cm_24.5",
                            "eu_39 1/3",
                            "uk_6",
                            "us_6.5"
                        ],
                        "name": "6.5",
                        "displayName": "欧码39 1/3(适合脚长24.5cm)",
                        "type": "eu",
                        "label": "39 1/3"
                    },
                    {
                        "ids": [
                            "cm_25",
                            "eu_40",
                            "uk_6.5",
                            "us_7"
                        ],
                        "name": "7",
                        "displayName": "欧码40(适合脚长25cm)",
                        "type": "eu",
                        "label": "40"
                    },
                    {
                        "ids": [
                            "cm_25.5",
                            "eu_40 2/3",
                            "uk_7",
                            "us_7.5"
                        ],
                        "name": "7.5",
                        "displayName": "欧码40 2/3(适合脚长25.5cm)",
                        "type": "eu",
                        "label": "40 2/3"
                    },
                    {
                        "ids": [
                            "cm_26",
                            "eu_41 1/3",
                            "uk_7.5",
                            "us_8"
                        ],
                        "name": "8",
                        "displayName": "欧码41 1/3(适合脚长26cm)",
                        "type": "eu",
                        "label": "41 1/3"
                    },
                    {
                        "ids": [
                            "us_17.0",
                            "eu_53  1/3",
                            "cm_35.0"
                        ],
                        "name": "17",
                        "displayName": "欧码53  1/3(适合脚长35.0cm)",
                        "type": "eu",
                        "label": "53  1/3"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "4.1折",
            "activityOffs": [
                "新人补贴价"
            ],
            "merchantName": "SHOEBACCA",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "4.1折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$5",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 913,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "48b38a8f-c5ff-3417-8467-3791850ab320",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/33177901_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/48b38a8f-c5ff-3417-8467-3791850ab320.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/48b38a8f-c5ff-3417-8467-3791850ab320.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Chocolate Brown",
                        "image": {
                            "id": "3ab85c5a-07f7-3409-ad88-d77bca75f1a4",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3ab85c5a-07f7-3409-ad88-d77bca75f1a4.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_22284350",
                "name": "Men's Heritage Aera Suede Sneakers",
                "nameCN": "男士 Heritage Aera 麂皮运动鞋",
                "description": [
                    "The Heritage Aera updates Polo's classic sneaker with a vintage-inspired silhouette realized in suede. Featuring a rubber cup-sole construction with integrated heel support and a dual-compound EVA midsole, it is finished with tonal tumbled leather accents and Ralph Lauren's signature Pony.",
                    "Round toe",
                    "Lace-up style; comes with two sets of laces",
                    "Padded insole; EVA midsole; textured rubber outsole",
                    "Reinforced heel",
                    "Tumbled leather tongue, heel tab, and side stripes",
                    "Signature Pony embossed at the tongue and the side; \"Polo\" embossed at the heel",
                    "Faux-suede lining",
                    "Upper: 100% leather; lining: 80% polyester, 20% leather; outsole: 100% rubber",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Polo Ralph Lauren",
                "displayBrand": "Ralph Lauren",
                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                "category": "shoe|men's shoes",
                "categoryIds": [
                    "k09"
                ],
                "priceTag": "$90.50",
                "priceTagCN": "¥663",
                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-mens-heritage-aera-suede-sneakers?ID=22284350",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [
                            "us_7.5"
                        ],
                        "name": "7.5",
                        "displayName": "美码7.5",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_8"
                        ],
                        "name": "8",
                        "displayName": "美码8",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_8.5"
                        ],
                        "name": "8.5",
                        "displayName": "美码8.5",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_9"
                        ],
                        "name": "9",
                        "displayName": "美码9",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_9.5"
                        ],
                        "name": "9.5",
                        "displayName": "美码9.5",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_10"
                        ],
                        "name": "10",
                        "displayName": "美码10",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_10.5"
                        ],
                        "name": "10.5",
                        "displayName": "美码10.5",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_11"
                        ],
                        "name": "11",
                        "displayName": "美码11",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_11.5"
                        ],
                        "name": "11.5",
                        "displayName": "美码11.5",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_12"
                        ],
                        "name": "12",
                        "displayName": "美码12",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_13"
                        ],
                        "name": "13",
                        "displayName": "美码13",
                        "type": "us"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "6.9折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "6.9折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 6,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "508ab921-aec3-3aa1-9881-9a9e0cf69c95",
                        "originalURL": "https://www.steepandcheap.com/images/items/900/LOW/LOWZ13U/STO.jpg",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/508ab921-aec3-3aa1-9881-9a9e0cf69c95.jpg",
                            "width": 900,
                            "height": 900,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/508ab921-aec3-3aa1-9881-9a9e0cf69c95.jpg",
                            "width": 350,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Stone",
                        "image": {
                            "id": "c6201099-8d5e-3023-a76d-e9e50c92f955",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c6201099-8d5e-3023-a76d-e9e50c92f955.jpg",
                                "width": 50,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "steepcheap_LOWZ13U",
                "name": "Renegade GTX Wide Mid Boot - Women's",
                "nameCN": "女款Renegade GTX 皮革越野鞋 户外登山鞋",
                "description": [
                    "For reliable performance on the trail, we lace up Lowa's best-selling model, the Renegade GTX Wide Mid Boot. The dense cushioning gives us reliable shock absorption and forward propulsion mile after mile. When navigating muddy sections and traveling over scree, we step confidently with the full-length stabilizer protecting us from rotational forces.",
                    "Upper Material: Heinen Terracare nubuck leather;",
                    "Waterproofing: GORE-TEX;",
                    "Lining: GORE-TEX;",
                    "Closure: lace;",
                    "Last: woman;",
                    "Footbed: ATC (polyurethane foam);",
                    "Midsole: Double Injection DuraPU (polyurethane), hard stabilizer (nylon joint-stabilizing element), Monowrap frame technology;",
                    "Sole: Vibram Evo;",
                    "Claimed Weight: [single] 15.5oz;",
                    "Manufacturer Warranty: 1 year;",
                    "storecredits: 0.0;"
                ],
                "merchantId": "797b723d-c156-3d8c-b8a9-d9f45c236ec1",
                "brand": "Lowa",
                "displayBrand": "Lowa",
                "brandId": "1a2ffe36-502b-3610-a6c5-71867b7f458c",
                "category": "womens hiking, backpacking &amp; mountaineering boots|womens|womens clothing|womens hiking boots|womens shoes &amp; footwear",
                "categoryIds": [
                    "k10",
                    "789"
                ],
                "priceTag": "$97.05",
                "priceTagCN": "¥711",
                "officialURL": "https://www.steepandcheap.com/lowa-renegade-gtx-mid-boot-wide-womens",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [
                            "us_7"
                        ],
                        "name": "7.0",
                        "displayName": "美码7",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_7.5"
                        ],
                        "name": "7.5",
                        "displayName": "美码7.5",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_8"
                        ],
                        "name": "8.0",
                        "displayName": "美码8",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_8.5"
                        ],
                        "name": "8.5",
                        "displayName": "美码8.5",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_9"
                        ],
                        "name": "9.0",
                        "displayName": "美码9",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_9.5"
                        ],
                        "name": "9.5",
                        "displayName": "美码9.5",
                        "type": "us"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "3.5折",
            "activityOffs": [],
            "merchantName": "Steep&Cheap",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "3.5折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 46,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "8446a29d-9db2-3535-852f-667bafe9edf4",
                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S1GTTC7L-1241_1?dpr=on%2C2",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/8446a29d-9db2-3535-852f-667bafe9edf4.jpg",
                            "width": 595,
                            "height": 800,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/8446a29d-9db2-3535-852f-667bafe9edf4.jpg",
                            "width": 260,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "HONEY",
                        "image": {
                            "id": "d214f3df-2bfe-36be-9dde-407e54393290",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d214f3df-2bfe-36be-9dde-407e54393290.jpg",
                                "width": 50,
                                "height": 31,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "CHERRY",
                        "image": {
                            "id": "06ee3e7c-f91a-3766-b162-8b7969187e53",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/06ee3e7c-f91a-3766-b162-8b7969187e53.jpg",
                                "width": 50,
                                "height": 31,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "BLACK",
                        "image": {
                            "id": "bd611f40-8384-318a-855d-d4affaa26fd8",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bd611f40-8384-318a-855d-d4affaa26fd8.jpg",
                                "width": 50,
                                "height": 31,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "michaelkors_35S1GTTC7L",
                "name": "Jet Set Large Saffiano Leather Crossbody Bag",
                "nameCN": "Saffiano大号相机包",
                "description": [
                    "Crafted from Saffiano leather for luxe appeal, our Jet Set crossbody bag is designed in a sleek, compact silhouette. A polished chain-link zipper pull delivers standout style, while the pocketed interior is perfectly sized for a day’s worth of essentials. Wear it while commuting, running errands or taking a weekend getaway.",
                    "• Crossbody bag",
                    "• Saffiano leather",
                    "• 100% leather from tanneries meeting the highest standards of environmental performance from tanneries meeting the highest standards of environmental performance",
                    "• Gold-tone hardware",
                    "• 9.5”W X 6.5”H X 2”D",
                    "• Exterior details: detachable crossbody strap, back slip pocket, front slip and zip pockets",
                    "• Interior details: back and front slip pockets",
                    "• Lining: 100% polyester",
                    "• Zip fastening",
                    "• Dust bag not included",
                    "• Imported",
                    "• Crossbody bag",
                    "• Saffiano leather",
                    "• 100% leather from tanneries meeting the highest standards of environmental performance from tanneries meeting the highest standards of environmental performance",
                    "• Gold-tone hardware",
                    "• 9.5”W X 6.5”H X 2”D",
                    "• Exterior details: detachable crossbody strap, back slip pocket, front slip and zip pockets",
                    "• Interior details: back and front slip pockets",
                    "• Lining: 100% polyester",
                    "• Zip fastening",
                    "• Dust bag not included",
                    "• Imported"
                ],
                "merchantId": "89896b29-9191-a09f-8ffd-e872a296da04",
                "brand": "Michael Kors",
                "displayBrand": "Michael Kors",
                "brandId": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                "category": "?sz=72&start=294|women",
                "categoryIds": [
                    "e08"
                ],
                "priceTag": "$43.29",
                "priceTagCN": "¥317",
                "officialURL": "https://www.michaelkors.com/jet-set-large-saffiano-leather-crossbody-bag/35S1GTTC7L.html?astc=true&dwvar_35S1GTTC7L_color=0001",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "1.9折起",
            "activityOffs": [
                "额外八五折",
                "新人补贴价"
            ],
            "merchantName": "Michael Kors",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "额外八五折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "1.9折起×额外8.5折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$1",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 159,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "da706dad-ea30-42f0-946e-5326aee56790",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/da706dad-ea30-42f0-946e-5326aee56790.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/da706dad-ea30-42f0-946e-5326aee56790.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        }
                    }
                ],
                "colors": [],
                "id": "vpfrance_15929",
                "name": "MAISON FRANCIS KURKDJIAN 弗朗西斯·库尔吉安中性香水 EDP香精35-70ml 东方花香调 35ML",
                "description": [],
                "merchantId": "a7dbaa3e-55a8-3190-a04c-ee838af8c328",
                "brand": "Maison Francis Kurkdjian",
                "displayBrand": "Maison Francis Kurkdjian",
                "brandId": "62a966ad-fa05-338e-9ff6-9a62e1c79b1a",
                "categoryIds": [
                    "b0m"
                ],
                "priceTag": "$323.99",
                "priceTagCN": "¥2372",
                "labels": [
                    "final_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "70ML",
                        "displayName": "70ML"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "8.9折",
            "activityOffs": [
                "满折",
                "新人补贴价",
                "额外九八折"
            ],
            "merchantName": "VP FRANCE",
            "origin": "[法国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "满折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    },
                    {
                        "text": "额外九八折",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "8.9折×额外9.8折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$7",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "1件9.9折",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "包邮包税",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ]
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 86,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "法国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "0883bd41-ffbb-4982-80af-4cb6a1ee0bb6",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/0883bd41-ffbb-4982-80af-4cb6a1ee0bb6.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/0883bd41-ffbb-4982-80af-4cb6a1ee0bb6.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "60ml滋润",
                        "image": {
                            "id": "e80b5d81-2a2a-3ef9-8a0e-1d13ee9fb4f7",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e80b5d81-2a2a-3ef9-8a0e-1d13ee9fb4f7.jpg",
                                "width": 800,
                                "height": 800,
                                "format": "jpg"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "60ml清爽",
                        "image": {
                            "id": "fd0321ad-d775-3c3f-8e61-3453c900a392",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fd0321ad-d775-3c3f-8e61-3453c900a392.jpg",
                                "width": 800,
                                "height": 800,
                                "format": "jpg"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "15ml*2中样体验装（滋润款）",
                        "image": {
                            "id": "4475d74b-a24e-31e2-b56e-e7bef730c1c5",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4475d74b-a24e-31e2-b56e-e7bef730c1c5.jpg",
                                "width": 800,
                                "height": 800,
                                "format": "jpg"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "15ml*2中样体验装（清爽款）",
                        "image": {
                            "id": "4475d74b-a24e-31e2-b56e-e7bef730c1c5",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4475d74b-a24e-31e2-b56e-e7bef730c1c5.jpg",
                                "width": 800,
                                "height": 800,
                                "format": "jpg"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "流云霜60ml",
                        "image": {
                            "id": "9951cf2f-3337-3b73-be29-6fc8880ad2ac",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9951cf2f-3337-3b73-be29-6fc8880ad2ac.jpg",
                                "width": 800,
                                "height": 800,
                                "format": "jpg"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "luxurybeauty_10071",
                "name": "兰蔻 菁纯面霜滋润版 抗老紧致面霜 饱满弹润光泽 60ml",
                "description": [],
                "merchantId": "eb66d114-c281-3762-ac98-b204b3352dd4",
                "brand": "Lancôme",
                "displayBrand": "Lancôme",
                "brandId": "8c3ccaca-ed0e-37bb-8e39-9baeca9e3d26",
                "categoryIds": [
                    "b28"
                ],
                "priceTag": "$49.50",
                "priceTagCN": "¥363",
                "labels": [
                    "final_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "6.5折",
            "activityOffs": [
                "满折",
                "限时价",
                "新人补贴价"
            ],
            "merchantName": "LuxuryBeauty",
            "origin": "[中国香港]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "满折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "限时价",
                        "color": "D27D3F"
                    },
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "6.5折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$1",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "限时价",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "1件8.5折",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "包邮包税",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ]
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 1821,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "中国香港",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "ce2c96d9-6822-41e7-bb30-c04ce143eb45",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ce2c96d9-6822-41e7-bb30-c04ce143eb45.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ce2c96d9-6822-41e7-bb30-c04ce143eb45.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "20ml",
                        "image": {
                            "id": "98bb615e-d567-3f9a-aee0-f792e5f248a2",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/98bb615e-d567-3f9a-aee0-f792e5f248a2.jpg",
                                "width": 800,
                                "height": 800,
                                "format": "jpg"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "5ml*3 3瓶体验装",
                        "image": {
                            "id": "4a8f4825-7995-3d5e-afb1-7a1e46089753",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/4a8f4825-7995-3d5e-afb1-7a1e46089753.jpg",
                                "width": 800,
                                "height": 800,
                                "format": "jpg"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "5ml体验装",
                        "image": {
                            "id": "0836b63b-4b92-3558-b044-381439e7cffd",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0836b63b-4b92-3558-b044-381439e7cffd.jpg",
                                "width": 800,
                                "height": 800,
                                "format": "jpg"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "luxurybeauty_10070",
                "name": "兰蔻 菁纯眼霜 滋润焕亮淡化细纹紧致眼周抗老眼霜 20ml",
                "description": [],
                "merchantId": "eb66d114-c281-3762-ac98-b204b3352dd4",
                "brand": "Lancôme",
                "displayBrand": "Lancôme",
                "brandId": "8c3ccaca-ed0e-37bb-8e39-9baeca9e3d26",
                "categoryIds": [
                    "b24"
                ],
                "priceTag": "$14.20",
                "priceTagCN": "¥104",
                "labels": [
                    "final_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "5.4折",
            "activityOffs": [
                "满折",
                "限时价"
            ],
            "merchantName": "LuxuryBeauty",
            "origin": "[中国香港]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "满折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "限时价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "5.4折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "限时价",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "1件8.5折",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "包邮包税",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ]
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 2326,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "中国香港",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "24b23af9-3c6a-4398-a503-b6c1bea88261",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/24b23af9-3c6a-4398-a503-b6c1bea88261.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/24b23af9-3c6a-4398-a503-b6c1bea88261.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        }
                    }
                ],
                "colors": [],
                "id": "vpf_16997",
                "name": "Filorga菲洛嘉 调皮洁面啫喱150ml洁面乳泡沫洗面奶",
                "description": [],
                "merchantId": "b9b5cb38-ef6a-3705-b8a7-18fa18b8d36f",
                "brand": "Filorga",
                "displayBrand": "Filorga",
                "brandId": "475541ea-81c1-34d3-8e0e-ea443a6e787f",
                "categoryIds": [
                    "b20"
                ],
                "priceTag": "$28.62",
                "priceTagCN": "¥210",
                "labels": [
                    "final_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "150ml",
                        "displayName": "150ml"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "8.8折",
            "activityOffs": [
                "满折",
                "额外九八折"
            ],
            "merchantName": "VPF",
            "origin": "[法国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "满折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "额外九八折",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "8.8折×额外9.8折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "1件9.9折",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 1,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "法国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "af24b49d-1a17-3793-8629-b3067dcc3269",
                        "originalURL": "https://cdn2.jomashop.com/media/catalog/product/n/i/nike-blue-mirror-shield-mens-sunglasses-nike-show-x1-dx6520-065-58.jpg",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/af24b49d-1a17-3793-8629-b3067dcc3269.jpg",
                            "width": 900,
                            "height": 900,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/af24b49d-1a17-3793-8629-b3067dcc3269.jpg",
                            "width": 350,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [],
                "id": "jomashop_NIKE_SHOW_X1_DX6520_065_58",
                "name": "Blue Mirror Shield Men's Sunglasses NIKE SHOW X1 DX6520 065 58",
                "description": [
                    "Nike Sunglasses. Series number: NIKE SHOW X1 DX6520. Color code: 065. Shape: Shield. Lens Width: 58 mm. Lens Height: 45 mm. Lens Bridge: 18 mm. Arm Length: 136 mm. 100% UV protection. Non-Polarized. Frame Material: Plastic. Frame Color: Shiny Wolf Grey. Lenses Type: Blue Mirror. Rim Style: Semi-Rimless. UPC/EAN code: 196149796871. Nike Blue Mirror Shield Mens Sunglasses NIKE SHOW X1 DX6520 065 58. Manufacturers Packaging Included. Packaging Size And Color May Vary."
                ],
                "merchantId": "dfcf41b9-6034-05cd-ba41-158f21d80888",
                "brand": "Nike",
                "displayBrand": "NIKE",
                "brandId": "41fd220f-05ed-3d8c-96e3-b83af87d45d7",
                "category": "men|male",
                "categoryIds": [
                    "953"
                ],
                "priceTag": "$43.99",
                "priceTagCN": "¥323",
                "officialURL": "https://www.jomashop.com/nike-blue-mirror-shield-mens-sunglasses-nike-show-x1-dx6520-065-58.html",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "5折",
            "activityOffs": [
                "满减",
                "新人补贴价"
            ],
            "merchantName": "Jomashop",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "满减",
                        "color": "D27D3F"
                    },
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "5折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$1",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "满$300减$10",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 1,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "3ea38168-956b-4add-9392-c404c8a5bd02",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/3ea38168-956b-4add-9392-c404c8a5bd02.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/3ea38168-956b-4add-9392-c404c8a5bd02.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "紫檀玫瑰-ROSA",
                        "image": {
                            "id": "e5c33299-d246-3deb-842c-2a27eeaabd5a",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e5c33299-d246-3deb-842c-2a27eeaabd5a.jpg",
                                "width": 800,
                                "height": 800,
                                "format": "jpg"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "清柚乌木-YUZU",
                        "image": {
                            "id": "6c015864-928b-329c-8da1-4305d1f2beec",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6c015864-928b-329c-8da1-4305d1f2beec.jpg",
                                "width": 800,
                                "height": 800,
                                "format": "jpg"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "浮木香草-VANILLA",
                        "image": {
                            "id": "58e42f42-37ea-3335-b631-f07afb6814e0",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/58e42f42-37ea-3335-b631-f07afb6814e0.jpg",
                                "width": 800,
                                "height": 800,
                                "format": "jpg"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "vpfrance_25730",
                "name": "娇兰花草水语全新木质香调女士淡香精 75-125-200ml 花香调",
                "description": [],
                "merchantId": "a7dbaa3e-55a8-3190-a04c-ee838af8c328",
                "brand": "Guerlain",
                "displayBrand": "Guerlain",
                "brandId": "1726d017-a62c-3eab-afa6-25db794102a1",
                "categoryIds": [
                    "b0m"
                ],
                "priceTag": "$83.79",
                "priceTagCN": "¥614",
                "labels": [
                    "final_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "75ML",
                        "displayName": "75ML"
                    },
                    {
                        "ids": [],
                        "name": "125ML",
                        "displayName": "125ML"
                    },
                    {
                        "ids": [],
                        "name": "补充装200ML",
                        "displayName": "补充装200ML"
                    },
                    {
                        "ids": [],
                        "name": "替换装200ML",
                        "displayName": "替换装200ML"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "8.7折起",
            "activityOffs": [
                "满折",
                "限时价",
                "额外九八折"
            ],
            "merchantName": "VP FRANCE",
            "origin": "[法国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "满折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "限时价",
                        "color": "D27D3F"
                    },
                    {
                        "text": "额外九八折",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "8.7折起×额外9.8折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "限时价",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "1件9.9折",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "包邮包税",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ]
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 5,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "法国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "bd20ea55-2393-3fef-bfd5-3a214496a650",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/25561147_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/bd20ea55-2393-3fef-bfd5-3a214496a650.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/bd20ea55-2393-3fef-bfd5-3a214496a650.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Black",
                        "image": {
                            "id": "3e9a35f3-f916-3d55-af7f-5a9f2c72e632",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3e9a35f3-f916-3d55-af7f-5a9f2c72e632.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Cognac",
                        "image": {
                            "id": "e991a528-1558-3f20-a73a-db64eff9b1ce",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e991a528-1558-3f20-a73a-db64eff9b1ce.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Red",
                        "image": {
                            "id": "207d9dc1-2da6-364f-8594-7327a76cba8a",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/207d9dc1-2da6-364f-8594-7327a76cba8a.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Blush",
                        "image": {
                            "id": "f143392b-fe0a-31ca-987e-74b5bf4f1e73",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f143392b-fe0a-31ca-987e-74b5bf4f1e73.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Light Natural",
                        "image": {
                            "id": "fe984e1f-2ab0-3268-a614-d87d64bc0e19",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/fe984e1f-2ab0-3268-a614-d87d64bc0e19.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Leopard",
                        "image": {
                            "id": "65bc321a-cc0f-392c-adaf-2005256470b8",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/65bc321a-cc0f-392c-adaf-2005256470b8.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Slate Blue",
                        "image": {
                            "id": "86414e35-5184-3e3f-89cb-e8d7e184c385",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/86414e35-5184-3e3f-89cb-e8d7e184c385.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_16504300",
                "name": "Women's King Cozy Cold Weather Booties",
                "nameCN": "女士 舒适冬靴",
                "description": [
                    "This lightweight, ankle winter boot with plush texture on the ankle and subtle Juicy Couture logo on the back ribbon will be your new favorite boot. Faux suede material with memory foam padding on insole makes it great for everyday wear.",
                    "Heel height - 0.75 flat",
                    "Shoe width - medium",
                    "Shaft height - 3.5\", circumference - 14\"",
                    "Pull-on",
                    "Memory foam comfort in insole",
                    "Round toe",
                    "Upper: man-made, faux suede, lining and sole: man-made",
                    "Spot clean",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Juicy Couture",
                "displayBrand": "Juicy Couture",
                "brandId": "5cb502e0-ff52-341b-a304-54307164573c",
                "category": "shoe|women's fashion|boots",
                "categoryIds": [
                    "k10"
                ],
                "priceTag": "$45.10",
                "priceTagCN": "¥331",
                "officialURL": "https://www.macys.com/shop/product/juicy-couture-womens-king-cozy-cold-weather-booties?ID=16504300",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [
                            "us_5.0",
                            "eu_35.0"
                        ],
                        "name": "5M",
                        "displayName": "欧码35.0",
                        "type": "eu",
                        "label": "35"
                    },
                    {
                        "ids": [
                            "us_6.0",
                            "eu_36.0"
                        ],
                        "name": "6M",
                        "displayName": "欧码36.0",
                        "type": "eu",
                        "label": "36"
                    },
                    {
                        "ids": [
                            "us_7.0",
                            "eu_37.0"
                        ],
                        "name": "7M",
                        "displayName": "欧码37.0",
                        "type": "eu",
                        "label": "37"
                    },
                    {
                        "ids": [
                            "us_8.0",
                            "eu_38.0"
                        ],
                        "name": "8M",
                        "displayName": "欧码38.0",
                        "type": "eu",
                        "label": "38"
                    },
                    {
                        "ids": [
                            "us_9.0",
                            "eu_39.0"
                        ],
                        "name": "9M",
                        "displayName": "欧码39.0",
                        "type": "eu",
                        "label": "39"
                    },
                    {
                        "ids": [
                            "us_10.0",
                            "eu_40.0"
                        ],
                        "name": "10M",
                        "displayName": "欧码40.0",
                        "type": "eu",
                        "label": "40"
                    },
                    {
                        "ids": [
                            "us_11.0",
                            "eu_41.0"
                        ],
                        "name": "11M",
                        "displayName": "欧码41.0",
                        "type": "eu",
                        "label": "41"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "5.5折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "5.5折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 309,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "602adb7f-650d-3ffb-8273-10d18f07b98b",
                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IB2518-A_1l.jpg?v=1737486054",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/602adb7f-650d-3ffb-8273-10d18f07b98b.jpg",
                            "width": 1000,
                            "height": 1000,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/602adb7f-650d-3ffb-8273-10d18f07b98b.jpg",
                            "width": 350,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [],
                "id": "shoebacca_9759759761690",
                "name": "Training Travel Tapered Aeroready Joggers",
                "description": [
                    "Unbeatable comfort and performance. Made with fleece for a cozy feel, these adidas pants have a tapered cut for a streamlined look. AEROREADY manages moisture, so you stay dry as you get into your training groove. Ankle zips let you create more of a laid-back look once your workout is over. Made with 100% recycled materials, this product represents just one of our solutions to help end plastic waste.",
                    "Regular fit",
                    "Drawcord on elastic waist",
                    "100% polyester (recycled)",
                    "AEROREADY",
                    "Side pockets",
                    "Ankle zips",
                    "SKU: \nIB2518-A",
                    "Color: \nBlue",
                    "Feature: \nDrawstring, Moisture Wicking, Sustainable",
                    "Material: \nPolyester",
                    "Style: \nJoggers"
                ],
                "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                "brand": "adidas",
                "displayBrand": "Adidas",
                "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                "category": "clothes|mens|men|adidas-puma-diadora|adidas|sapg::adi10407 ~ color::blue|casual|adult|clearance|pants",
                "categoryIds": [
                    "932",
                    "931"
                ],
                "priceTag": "$20.35",
                "priceTagCN": "¥149",
                "officialURL": "https://www.shoebacca.com/products/training-travel-tapered-aeroready-joggers-ib2518-a",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "XS",
                        "displayName": "XS"
                    },
                    {
                        "ids": [],
                        "name": "S",
                        "displayName": "S"
                    },
                    {
                        "ids": [],
                        "name": "M",
                        "displayName": "M"
                    },
                    {
                        "ids": [],
                        "name": "L",
                        "displayName": "L"
                    },
                    {
                        "ids": [],
                        "name": "XL",
                        "displayName": "XL"
                    },
                    {
                        "ids": [],
                        "name": "XXL",
                        "displayName": "XXL"
                    },
                    {
                        "ids": [],
                        "name": "XXXL",
                        "displayName": "XXXL"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "2.8折",
            "activityOffs": [],
            "merchantName": "SHOEBACCA",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "2.8折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 7,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "5a5fdedd-1135-35c5-b1c5-ac2fff05e8f0",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/34062267_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5a5fdedd-1135-35c5-b1c5-ac2fff05e8f0.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5a5fdedd-1135-35c5-b1c5-ac2fff05e8f0.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Inviting Grey",
                        "image": {
                            "id": "49f7e20f-4d2c-370b-897b-c1fdc354b1aa",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/49f7e20f-4d2c-370b-897b-c1fdc354b1aa.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_11203251",
                "name": "Gabbie Medium Crossbody Bag",
                "description": [
                    "Take this versatile bag out for the day and right into the night. You can rely on Gabbie to keep everything secure with the multiple zip pockets. The hardest part is deciding what to put in each compartment.",
                    "Medium bag",
                    "Approx. Dimensions: 14\" L X 11.75\" H X 7.25\" D (width is measured across bottom of handbag)",
                    "Interior zip pocket, two slip pockets, Pen loop, key clasp",
                    "26.5\" Adjustable crossbody strap",
                    "Zipper closure",
                    "Two front zip pockets, Two side zip pockets, One back zip pocket",
                    "Approx. Weight: 0.9 lbs.",
                    "Nylon",
                    "Spot clean",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Kipling",
                "displayBrand": "Kipling",
                "brandId": "a03ef079-efb3-3f8e-bbae-1b2c75bd020f",
                "category": "handbag|women's fashion|handbags, wallets & accessories",
                "categoryIds": [
                    "e08"
                ],
                "priceTag": "$50.50",
                "priceTagCN": "¥370",
                "officialURL": "https://www.macys.com/shop/product/kipling-gabbie-medium-crossbody-bag?ID=11203251",
                "labels": [
                    "final_sale",
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "4.2折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "4.2折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 4,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "2b2f91f1-760f-3b30-8195-d48812cacdcb",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/6/optimized/16025306_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/2b2f91f1-760f-3b30-8195-d48812cacdcb.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/2b2f91f1-760f-3b30-8195-d48812cacdcb.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Silver",
                        "image": {
                            "id": "9a5e9fd5-c5d5-3330-a0e3-1c026e73e5ed",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9a5e9fd5-c5d5-3330-a0e3-1c026e73e5ed.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Rose Gold",
                        "image": {
                            "id": "3f4f6b4f-87ae-3497-9365-b5f545bf23e1",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/3f4f6b4f-87ae-3497-9365-b5f545bf23e1.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Gold",
                        "image": {
                            "id": "6ba73b0f-7358-3861-be87-4a2a665fa3d6",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6ba73b0f-7358-3861-be87-4a2a665fa3d6.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_669033",
                "name": "Crystal Pendant Necklace, 16\" + 2\" Extender",
                "nameCN": "（手链扣）手链扣 纪梵希 圆形吊坠水晶项链",
                "description": [
                    "Simple sparkle, Givenchy's small pendant necklace features the prettiest element at the center.",
                    "Set in gold-tone mixed metal, rose gold-tone, or silver-tone mixed metal",
                    "Approx. length: 16\" + 2\" extender; approx. drop: 3/8\"",
                    "Lobster clasp closure",
                    "Photo may have been enlarged and/or enhanced.",
                    "This item cannot be shipped to American Samoa, Guam, Marshall Islands, U.S. Virgin Islands, Puerto Rico, Palau, or the Pacific Islands"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Givenchy",
                "displayBrand": "Givenchy",
                "brandId": "7278c89a-d217-3de4-ac96-33d46843fb5b",
                "category": "necklace|necklaces",
                "categoryIds": [
                    "f65"
                ],
                "priceTag": "$22.60",
                "priceTagCN": "¥166",
                "officialURL": "https://www.macys.com/shop/product/givenchy-crystal-pendant-necklace-16-2-extender?ID=669033",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "6.9折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "6.9折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 16083,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "def11435-8f38-3d74-a186-267f1f4e1275",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/7/optimized/8902047_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/def11435-8f38-3d74-a186-267f1f4e1275.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/def11435-8f38-3d74-a186-267f1f4e1275.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Acacia Pink",
                        "image": {
                            "id": "f12d2e8e-f241-3057-aa4f-7ccab3687bc3",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f12d2e8e-f241-3057-aa4f-7ccab3687bc3.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Hunter Navy",
                        "image": {
                            "id": "b98d1b2c-0a3b-3440-9fb0-b3e61136b3fb",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/b98d1b2c-0a3b-3440-9fb0-b3e61136b3fb.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Warm White",
                        "image": {
                            "id": "90605d30-566f-3c5c-95c3-d8a404d3b085",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/90605d30-566f-3c5c-95c3-d8a404d3b085.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Red",
                        "image": {
                            "id": "e0787a1e-8b16-3475-af39-cfac3564b72b",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e0787a1e-8b16-3475-af39-cfac3564b72b.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Preppy Pink",
                        "image": {
                            "id": "e9f60998-d8b0-3263-ab8a-40b89d57491d",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e9f60998-d8b0-3263-ab8a-40b89d57491d.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_2184526",
                "name": "Baby Girls Cable-Knit Cotton Cardigan",
                "nameCN": "Ralph Lauren 女童 开襟衫",
                "description": [
                    "Essential long-sleeved cardigan in Ralph Lauren's signature cabled cotton.",
                    "Six-button placket",
                    "Ribbed neck, placket, cuffs and hem",
                    "Ralph Lauren's embroidered pony accents the chest",
                    "All cotton",
                    "Machine washable",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Polo Ralph Lauren",
                "displayBrand": "Ralph Lauren",
                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                "category": "sweater|kids|sweaters",
                "categoryIds": [
                    "gbf"
                ],
                "priceTag": "$35",
                "priceTagCN": "¥257",
                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-baby-girls-cable-knit-cotton-cardigan?ID=2184526",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "3 months",
                        "displayName": "3 months"
                    },
                    {
                        "ids": [],
                        "name": "6 months",
                        "displayName": "6 months"
                    },
                    {
                        "ids": [],
                        "name": "9 months",
                        "displayName": "9 months"
                    },
                    {
                        "ids": [],
                        "name": "12 months",
                        "displayName": "12 months"
                    },
                    {
                        "ids": [],
                        "name": "18 months",
                        "displayName": "18 months"
                    },
                    {
                        "ids": [],
                        "name": "24 months",
                        "displayName": "24 months"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "7折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "7折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 897,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "7bc1c188-5b0d-31c8-a014-e23674144116",
                        "originalURL": "https://dks.scene7.com/is/image/GolfGalaxy/24TNOMMTRBLNDSSTXAPT_New_Taupe_Green_Wht_Hthr?qlt=70&wid=800&fmt=webp&op_sharpen=1",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7bc1c188-5b0d-31c8-a014-e23674144116.jpg",
                            "width": 610,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7bc1c188-5b0d-31c8-a014-e23674144116.jpg",
                            "width": 208,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Tnf Light Grey Heather",
                        "image": {
                            "id": "53a0e860-4c68-35bb-964a-baaadfe4d09e",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/53a0e860-4c68-35bb-964a-baaadfe4d09e.jpg",
                                "width": 33,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Shady Blue White Heather",
                        "image": {
                            "id": "c98960a8-b46b-3d5f-a780-6539007d7855",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c98960a8-b46b-3d5f-a780-6539007d7855.jpg",
                                "width": 35,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "TNF Dark Grey Heather",
                        "image": {
                            "id": "0946daf1-ec9f-3efb-adcc-c6b01be97216",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0946daf1-ec9f-3efb-adcc-c6b01be97216.jpg",
                                "width": 31,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Super Sonic Blue Wht Hthr",
                        "image": {
                            "id": "0d509844-be2b-30d3-b271-2a2436c34109",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0d509844-be2b-30d3-b271-2a2436c34109.jpg",
                                "width": 47,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "dickssportinggoods_24tnommtrblndsstxapt",
                "name": "The North Face Men's Triblend Short Sleeve T-Shirt",
                "description": [
                    "Highlights",
                    "Regular fit t-shirt for a comfortable, just-right feel",
                    "Classic crew neck feels comfortable on your body",
                    "The tri-blend fabric combines the best of three materials for all-around performance",
                    "Fit & Design",
                    "Regular fit men’s t-shirt",
                    "Classic crew neckline",
                    "Short sleeves",
                    "Tri-blend fabric combines the durability of polyester, the softness of cotton, and the adaptability of TENCEL™ Lyocell",
                    "Screen-printed logo on left chest",
                    "Even classics can be thoughtfully elevated. This shirt is made from a mixture of fibers that provide softness, durability, and adaptability all at once.",
                    "Fit & Design",
                    "Regular fit men’s t-shirt",
                    "Classic crew neckline",
                    "Short sleeves",
                    "Tri-blend fabric combines the durability of polyester, the softness of cotton, and the adaptability of TENCEL™ Lyocell",
                    "Screen-printed logo on left chest",
                    "Brand :",
                    "The North Face",
                    "Country of Origin : Imported",
                    "Fabric : 50% polyester / 37% cotton / 13% TENCEL™ Lyocell",
                    "Web ID:",
                    "24TNOMMTRBLNDSSTXAPT"
                ],
                "merchantId": "f51beea7-2e93-c6af-1c61-200e29c63b4f",
                "brand": "The North Face",
                "displayBrand": "The North Face",
                "brandId": "9ed285dc-8718-3b9e-9881-910b3bfb8a15",
                "category": "shirts|Men's|men's|shirts & tops|mensshirtstops-129825",
                "categoryIds": [
                    "922"
                ],
                "priceTag": "$13.65",
                "priceTagCN": "¥100",
                "officialURL": "https://www.dickssportinggoods.com/p/the-north-face-mens-triblend-short-sleeve-t-shirt-24tnommtrblndsstxapt/24tnommtrblndsstxapt",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "S",
                        "displayName": "S"
                    },
                    {
                        "ids": [],
                        "name": "M",
                        "displayName": "M"
                    },
                    {
                        "ids": [],
                        "name": "L",
                        "displayName": "L"
                    },
                    {
                        "ids": [],
                        "name": "XL",
                        "displayName": "XL"
                    },
                    {
                        "ids": [],
                        "name": "XXL",
                        "displayName": "XXL"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "3.5折起",
            "activityOffs": [
                "硬核补贴"
            ],
            "merchantName": "Dick's Sporting Goods",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "硬核补贴",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "3.5折起",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "硬核补贴",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 66,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "cca695be-2bce-305f-82fd-55a78d95861e",
                        "originalURL": "https://cdn.shopify.com/s/files/1/0291/4536/6588/files/526d60ab420a4d259f8064ae2981aea2.jpg?v=1761606349",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/cca695be-2bce-305f-82fd-55a78d95861e.jpg",
                            "width": 819,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/cca695be-2bce-305f-82fd-55a78d95861e.jpg",
                            "width": 280,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "black",
                        "image": {
                            "id": "6c37d7a8-891a-3450-b5d1-a8451fae6fe5",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6c37d7a8-891a-3450-b5d1-a8451fae6fe5.jpg",
                                "width": 40,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "shoppremiumoutlets_8703463882812",
                "name": "Soleil Jacket",
                "description": [
                    "Introducing the Spyder Soleil Jacket, the perfect addition to your active wardrobe. This innovative ski wear brand is known for elevating performance, and this black jacket is no exception. Featuring front zip pockets, a drawcord hood, and zipper cuffs, this jacket is both stylish and practical. The zipper front and 100% recycled polyester material make it easy to care for and environmentally friendly. Stay warm and stylish on the slopes or the streets with the Spyder Soleil Jacket. Available now in women's sizes, so you can find the perfect fit for your next adventure."
                ],
                "merchantId": "9f93ee10-3f3f-3b95-beae-7a177d0f53e4",
                "brand": "Spyder",
                "displayBrand": "Spyder",
                "brandId": "e5fb0cda-12f9-3dc4-b412-47ddab54d1da",
                "category": "women|clothing|activewear|jackets",
                "categoryIds": [
                    "812"
                ],
                "priceTag": "$202.80",
                "priceTagCN": "¥1485",
                "officialURL": "https://www.shoppremiumoutlets.com/products/spyder-soleil-jacket",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "US 2 (XS)",
                        "displayName": "US 2 (XS)"
                    },
                    {
                        "ids": [],
                        "name": "US 4 (S)",
                        "displayName": "US 4 (S)"
                    },
                    {
                        "ids": [],
                        "name": "US 6 (S)",
                        "displayName": "US 6 (S)"
                    },
                    {
                        "ids": [],
                        "name": "US 8 (M)",
                        "displayName": "US 8 (M)"
                    },
                    {
                        "ids": [],
                        "name": "US 10 (M)",
                        "displayName": "US 10 (M)"
                    },
                    {
                        "ids": [],
                        "name": "US 12 (L)",
                        "displayName": "US 12 (L)"
                    },
                    {
                        "ids": [],
                        "name": "US 14 (L)",
                        "displayName": "US 14 (L)"
                    },
                    {
                        "ids": [],
                        "name": "US 16 (XL)",
                        "displayName": "US 16 (XL)"
                    },
                    {
                        "ids": [],
                        "name": "US 18 (XL)",
                        "displayName": "US 18 (XL)"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "3.4折",
            "activityOffs": [],
            "merchantName": "Premium Outlets",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "3.4折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 1,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "a7151daa-a76d-3f93-8cbf-59aeddf1a7e1",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/34561032_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a7151daa-a76d-3f93-8cbf-59aeddf1a7e1.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a7151daa-a76d-3f93-8cbf-59aeddf1a7e1.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Gray Marl",
                        "image": {
                            "id": "c5009d87-0b32-3bb8-bdc2-a059e0eef8f8",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c5009d87-0b32-3bb8-bdc2-a059e0eef8f8.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_21382253",
                "name": "Men's Donegal Mock Neck Cardigan",
                "nameCN": "男士针织开衫",
                "description": [
                    "Featuring a chunky neck knit, this cardigan from Polo Ralph Lauren is finished with custom-developed signature buttons. The saddle sleeves and front pockets add classic, refined details.",
                    "Approx. model height is 6'1\" and he is wearing a size medium",
                    "Regular fit",
                    "Rib-knit mock neck; buttoned placket",
                    "Long saddle sleeves with rib-knit cuffs",
                    "Two front waist welt pockets; rib-knit hem",
                    "Signature embroidered Pony at the left chest",
                    "60% wool, 20% viscose, 20% nylon",
                    "Hand wash",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Polo Ralph Lauren",
                "displayBrand": "Ralph Lauren",
                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                "category": "sweater|sweaters|Men|men's fashion",
                "categoryIds": [
                    "923"
                ],
                "priceTag": "$161.20",
                "priceTagCN": "¥1181",
                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-mens-donegal-mock-neck-cardigan?ID=21382253",
                "labels": [
                    "new_arrivals",
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "2XL",
                        "displayName": "2XL"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "6.9折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "6.9折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 165,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {
                "remainingSizes": "剩2XL码",
                "buoyId": "REMAINING_SIZES"
            }
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "664aa490-4295-3740-af51-fe856f687639",
                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/IH5152_1l.jpg?v=1732414082",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/664aa490-4295-3740-af51-fe856f687639.jpg",
                            "width": 1000,
                            "height": 1000,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/664aa490-4295-3740-af51-fe856f687639.jpg",
                            "width": 350,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [],
                "id": "shoebacca_9695499878682",
                "name": "Fear of God x Athletics Los Angeles Lace Up Sneakers",
                "nameCN": "男款 FOG联名 休闲运动鞋",
                "description": [
                    "Fear of God Athletics reimagines the iconic L.A. Trainer in full premium suede with durable ripstop fabric framed in a wavy rubber sole. The shoe features a padded tongue, a molded cupsole for comfort, and a lace toggle for adjustability. Branding details are realized in the signature Adidas 3-Stripes on the midfoot, Adidas logo embossed on the sole, and the Fear of God embossed logo on the black bar on the heel.",
                    "Full premium suede uppers with durable ripstop fabric",
                    "Molded cupsole",
                    "Wavy rubber outsole",
                    "Padded tongue",
                    "Lace toggle and additional off white laces",
                    "SKU: \nIH5152",
                    "Color: \nBeige",
                    "Material: \nSuede",
                    "Style: \nLace Up"
                ],
                "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                "brand": "adidas",
                "displayBrand": "Adidas",
                "brandId": "28a34010-e84b-381f-b087-359c7e280a08",
                "category": "mens|sneakers|men|clearance|adidas|adult|casual|shoes|sapg::adi08832 ~ color::beige",
                "categoryIds": [
                    "751"
                ],
                "priceTag": "$55.05",
                "priceTagCN": "¥404",
                "officialURL": "https://www.shoebacca.com/products/fear-of-god-x-athletics-los-angeles-lace-up-sneakers-ih5152",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [
                            "cm_22",
                            "eu_36",
                            "uk_3.5",
                            "us_4"
                        ],
                        "name": "4",
                        "displayName": "欧码36(适合脚长22cm)",
                        "type": "eu",
                        "label": "36"
                    },
                    {
                        "ids": [
                            "cm_22.5",
                            "eu_36 2/3",
                            "uk_4",
                            "us_4.5"
                        ],
                        "name": "4.5",
                        "displayName": "欧码36 2/3(适合脚长22.5cm)",
                        "type": "eu",
                        "label": "36 2/3"
                    },
                    {
                        "ids": [
                            "cm_23",
                            "eu_37 1/3",
                            "uk_4.5",
                            "us_5"
                        ],
                        "name": "5",
                        "displayName": "欧码37 1/3(适合脚长23cm)",
                        "type": "eu",
                        "label": "37 1/3"
                    },
                    {
                        "ids": [
                            "cm_23.5",
                            "eu_38",
                            "uk_5",
                            "us_5.5"
                        ],
                        "name": "5.5",
                        "displayName": "欧码38(适合脚长23.5cm)",
                        "type": "eu",
                        "label": "38"
                    },
                    {
                        "ids": [
                            "cm_24",
                            "eu_38 2/3",
                            "uk_5.5",
                            "us_6"
                        ],
                        "name": "6",
                        "displayName": "欧码38 2/3(适合脚长24cm)",
                        "type": "eu",
                        "label": "38 2/3"
                    },
                    {
                        "ids": [
                            "cm_24.5",
                            "eu_39 1/3",
                            "uk_6",
                            "us_6.5"
                        ],
                        "name": "6.5",
                        "displayName": "欧码39 1/3(适合脚长24.5cm)",
                        "type": "eu",
                        "label": "39 1/3"
                    },
                    {
                        "ids": [
                            "cm_25",
                            "eu_40",
                            "uk_6.5",
                            "us_7"
                        ],
                        "name": "7",
                        "displayName": "欧码40(适合脚长25cm)",
                        "type": "eu",
                        "label": "40"
                    },
                    {
                        "ids": [
                            "cm_25.5",
                            "eu_40 2/3",
                            "uk_7",
                            "us_7.5"
                        ],
                        "name": "7.5",
                        "displayName": "欧码40 2/3(适合脚长25.5cm)",
                        "type": "eu",
                        "label": "40 2/3"
                    },
                    {
                        "ids": [
                            "cm_26",
                            "eu_41 1/3",
                            "uk_7.5",
                            "us_8"
                        ],
                        "name": "8",
                        "displayName": "欧码41 1/3(适合脚长26cm)",
                        "type": "eu",
                        "label": "41 1/3"
                    },
                    {
                        "ids": [
                            "cm_26.5",
                            "eu_42",
                            "uk_8",
                            "us_8.5"
                        ],
                        "name": "8.5",
                        "displayName": "欧码42(适合脚长26.5cm)",
                        "type": "eu",
                        "label": "42"
                    },
                    {
                        "ids": [
                            "cm_27",
                            "eu_42 2/3",
                            "uk_8.5",
                            "us_9"
                        ],
                        "name": "9",
                        "displayName": "欧码42 2/3(适合脚长27cm)",
                        "type": "eu",
                        "label": "42 2/3"
                    },
                    {
                        "ids": [
                            "cm_27.5",
                            "eu_43 1/3",
                            "uk_9",
                            "us_9.5"
                        ],
                        "name": "9.5",
                        "displayName": "欧码43 1/3(适合脚长27.5cm)",
                        "type": "eu",
                        "label": "43 1/3"
                    },
                    {
                        "ids": [
                            "cm_28",
                            "eu_44",
                            "uk_9.5",
                            "us_10"
                        ],
                        "name": "10",
                        "displayName": "欧码44(适合脚长28cm)",
                        "type": "eu",
                        "label": "44"
                    },
                    {
                        "ids": [
                            "cm_28.5",
                            "eu_44 2/3",
                            "uk_10",
                            "us_10.5"
                        ],
                        "name": "10.5",
                        "displayName": "欧码44 2/3(适合脚长28.5cm)",
                        "type": "eu",
                        "label": "44 2/3"
                    },
                    {
                        "ids": [
                            "cm_29",
                            "eu_45 1/3",
                            "uk_10.5",
                            "us_11"
                        ],
                        "name": "11",
                        "displayName": "欧码45 1/3(适合脚长29cm)",
                        "type": "eu",
                        "label": "45 1/3"
                    },
                    {
                        "ids": [
                            "cm_29.5",
                            "eu_46",
                            "uk_11",
                            "us_11.5"
                        ],
                        "name": "11.5",
                        "displayName": "欧码46(适合脚长29.5cm)",
                        "type": "eu",
                        "label": "46"
                    },
                    {
                        "ids": [
                            "cm_30",
                            "eu_46 2/3",
                            "uk_11.5",
                            "us_12"
                        ],
                        "name": "12",
                        "displayName": "欧码46 2/3(适合脚长30cm)",
                        "type": "eu",
                        "label": "46 2/3"
                    },
                    {
                        "ids": [
                            "cm_30.5",
                            "eu_47 1/3",
                            "uk_12",
                            "us_12.5"
                        ],
                        "name": "12.5",
                        "displayName": "欧码47 1/3(适合脚长30.5cm)",
                        "type": "eu",
                        "label": "47 1/3"
                    },
                    {
                        "ids": [
                            "cm_31",
                            "eu_48",
                            "uk_12.5",
                            "us_13"
                        ],
                        "name": "13",
                        "displayName": "欧码48(适合脚长31cm)",
                        "type": "eu",
                        "label": "48"
                    },
                    {
                        "ids": [
                            "cm_31.5",
                            "eu_48 2/3",
                            "uk_13",
                            "us_13.5"
                        ],
                        "name": "13.5",
                        "displayName": "欧码48 2/3(适合脚长31.5cm)",
                        "type": "eu",
                        "label": "48 2/3"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "3.2折",
            "activityOffs": [
                "新人补贴价"
            ],
            "merchantName": "SHOEBACCA",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "tideShoes": true,
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "3.2折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$1",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 777,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "dbff2ca5-dc03-40d2-90ea-4c48117567a9",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/dbff2ca5-dc03-40d2-90ea-4c48117567a9.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/dbff2ca5-dc03-40d2-90ea-4c48117567a9.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        }
                    }
                ],
                "colors": [],
                "id": "luxurybeauty_10000",
                "name": "【新款第5代】雅诗兰黛 小棕瓶熬夜眼霜特润修护精华眼霜 15ml 淡化细纹黑眼圈眼袋 紧致补水抗衰老",
                "description": [],
                "merchantId": "eb66d114-c281-3762-ac98-b204b3352dd4",
                "brand": "Estée Lauder",
                "displayBrand": "Estée Lauder",
                "brandId": "31324581-2dcc-3c7d-a1fc-70541e5e2ba4",
                "categoryIds": [
                    "b24"
                ],
                "priceTag": "$9.39",
                "priceTagCN": "¥69",
                "labels": [
                    "final_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "5ml",
                        "displayName": "5ml"
                    },
                    {
                        "ids": [],
                        "name": "15ml",
                        "displayName": "15ml"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "7.4折",
            "activityOffs": [
                "满折",
                "限时价"
            ],
            "merchantName": "LuxuryBeauty",
            "origin": "[中国香港]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "满折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "限时价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "7.4折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "限时价",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "1件8.5折",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "包邮包税",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ]
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 1569,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "中国香港",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "ff3af843-28d3-329b-9d82-dfc9886cda2d",
                        "originalURL": "https://cdn.shopify.com/s/files/1/0753/7914/7034/files/179103-C6103_1l.jpg?v=1737267829",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ff3af843-28d3-329b-9d82-dfc9886cda2d.jpg",
                            "width": 1000,
                            "height": 1000,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ff3af843-28d3-329b-9d82-dfc9886cda2d.jpg",
                            "width": 350,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [],
                "id": "shoebacca_9758044389658",
                "name": "B.Icon 2 AG Tennis Shoes",
                "description": [
                    "B.Icon 2 W AG is the women's tennis shoe designed for all levels players, for an use on hard surfaces or clay courts. Upper made of SuprellTech, air mesh and d skin, plus outer hook for excellent stability. Anatomic insole of shock proof EVA; midsole dd anima C.C.B. Outsole made of rubber, with wear resistant Duratech 5000 compound.",
                    "Suprelltech, Air mesh and D Skin with Thermoplastic Polyurethane transfer",
                    "Lace up closure",
                    "Removable anatomical insole",
                    "Rubber with special wear resistant Duratech 5000 compound. Sole for hard terrains and and or clay court",
                    "Removable, insole in shock absorbing expanded EVA",
                    "SKU: \n179103-C6103",
                    "Color: \nWhite",
                    "Feature: \nComfort Technology, E.V.A., Removable Insole",
                    "Material: \nMesh, Synthetic",
                    "Sport: \nTennis",
                    "Style: \nLace Up"
                ],
                "merchantId": "c8e61a83-521a-1878-82af-c4463441498c",
                "brand": "diadora",
                "displayBrand": "Diadora",
                "brandId": "793a9a91-1ab2-3c0e-8750-776de574f2f4",
                "category": "tennis|new arrival|women|athletic|casual|adult|shoes|womens|sapg::didora01105 ~ color::silver/white",
                "categoryIds": [
                    "121"
                ],
                "priceTag": "$45.75",
                "priceTagCN": "¥335",
                "officialURL": "https://www.shoebacca.com/products/b-icon-2-ag-tennis-shoes-179103-c6103",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [
                            "cm_22.5",
                            "eu_36.5",
                            "uk_4",
                            "us_6"
                        ],
                        "name": "6",
                        "displayName": "欧码36.5(适合脚长22.5cm)",
                        "type": "eu",
                        "label": "36.5"
                    },
                    {
                        "ids": [
                            "cm_23",
                            "eu_37",
                            "uk_4.5",
                            "us_6.5"
                        ],
                        "name": "6.5",
                        "displayName": "欧码37(适合脚长23cm)",
                        "type": "eu",
                        "label": "37"
                    },
                    {
                        "ids": [
                            "cm_23.5",
                            "eu_38",
                            "uk_5",
                            "us_7"
                        ],
                        "name": "7",
                        "displayName": "欧码38(适合脚长23.5cm)",
                        "type": "eu",
                        "label": "38"
                    },
                    {
                        "ids": [
                            "cm_24",
                            "eu_38.5",
                            "uk_5.5",
                            "us_7.5"
                        ],
                        "name": "7.5",
                        "displayName": "欧码38.5(适合脚长24cm)",
                        "type": "eu",
                        "label": "38.5"
                    },
                    {
                        "ids": [
                            "cm_24.5",
                            "eu_39",
                            "uk_6",
                            "us_8"
                        ],
                        "name": "8",
                        "displayName": "欧码39(适合脚长24.5cm)",
                        "type": "eu",
                        "label": "39"
                    },
                    {
                        "ids": [
                            "cm_25",
                            "eu_40",
                            "uk_6.5",
                            "us_8.5"
                        ],
                        "name": "8.5",
                        "displayName": "欧码40(适合脚长25cm)",
                        "type": "eu",
                        "label": "40"
                    },
                    {
                        "ids": [
                            "cm_25.5",
                            "eu_40.5",
                            "uk_7",
                            "us_9"
                        ],
                        "name": "9",
                        "displayName": "欧码40.5(适合脚长25.5cm)",
                        "type": "eu",
                        "label": "40.5"
                    },
                    {
                        "ids": [
                            "cm_26",
                            "eu_41",
                            "uk_7.5",
                            "us_9.5"
                        ],
                        "name": "9.5",
                        "displayName": "欧码41(适合脚长26cm)",
                        "type": "eu",
                        "label": "41"
                    },
                    {
                        "ids": [
                            "cm_26.5",
                            "eu_42",
                            "uk_8",
                            "us_10"
                        ],
                        "name": "10",
                        "displayName": "欧码42(适合脚长26.5cm)",
                        "type": "eu",
                        "label": "42"
                    },
                    {
                        "ids": [
                            "cm_27",
                            "eu_42.5",
                            "uk_8.5",
                            "us_10.5"
                        ],
                        "name": "10.5",
                        "displayName": "欧码42.5(适合脚长27cm)",
                        "type": "eu",
                        "label": "42.5"
                    },
                    {
                        "ids": [
                            "cm_27.5",
                            "eu_43",
                            "uk_9",
                            "us_11"
                        ],
                        "name": "11",
                        "displayName": "欧码43(适合脚长27.5cm)",
                        "type": "eu",
                        "label": "43"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "2.8折",
            "activityOffs": [],
            "merchantName": "SHOEBACCA",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "2.8折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 9,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "123d734d-da4f-3a19-ba13-2cd62a7bc768",
                        "originalURL": "https://cdn.shopify.com/s/files/1/0291/4536/6588/files/400d4dbb788e476aa0961f4f6e4b0f49.jpg?v=1748397959",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/123d734d-da4f-3a19-ba13-2cd62a7bc768.jpg",
                            "width": 777,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/123d734d-da4f-3a19-ba13-2cd62a7bc768.jpg",
                            "width": 266,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Ivory",
                        "image": {
                            "id": "0da4c8c9-06ec-3a3a-aa26-acb0367f262a",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0da4c8c9-06ec-3a3a-aa26-acb0367f262a.jpg",
                                "width": 38,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "elitefinds_8825575833752",
                "name": "Free People - Darcy Mini Dress",
                "description": [
                    "The kind of easy and flattering dress you'll be reaching for all season long.\nElevate your spring wardrobe with the Darcy Mini Dress by Free People, a chic choice in versatile ivory. This A-line mini dress features short sleeves and a flattering V-neck, perfect for boho chic occasions like Valentine's Day or a baby shower. Made from high-quality cotton for a blend of style and durability."
                ],
                "merchantId": "006fe186-e172-3d9f-8922-a6dbfc2a7098",
                "brand": "Free People",
                "displayBrand": "Free People",
                "brandId": "0e42f86f-7098-3292-99dc-2cd5171579c2",
                "category": "women > dresses > mini|2868984970|clothing|cotton|dresses|mini|solid|white|women",
                "categoryIds": [
                    "832"
                ],
                "priceTag": "$51.75",
                "priceTagCN": "¥379",
                "officialURL": "https://snaggedandbagged-elite-finds.myshopify.com/products/2868984970",
                "labels": [
                    "final_sale",
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "S",
                        "displayName": "S"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "8.7折",
            "activityOffs": [
                "额外七七折",
                "新人补贴价"
            ],
            "merchantName": "ELITE FINDS",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "额外七七折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "8.7折×额外7.7折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$1",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 1,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {
                "remainingSizes": "剩S码",
                "buoyId": "REMAINING_SIZES"
            }
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "e050a0e8-cc3a-3014-b232-af226e8bfa42",
                        "originalURL": "https://michaelkors.scene7.com/is/image/MichaelKors/35S1GTTC9B-0200_1?dpr=on%2C2",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e050a0e8-cc3a-3014-b232-af226e8bfa42.jpg",
                            "width": 595,
                            "height": 800,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e050a0e8-cc3a-3014-b232-af226e8bfa42.jpg",
                            "width": 260,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "BROWN",
                        "image": {
                            "id": "0cc15dcb-7766-3658-809b-40180d468862",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0cc15dcb-7766-3658-809b-40180d468862.jpg",
                                "width": 50,
                                "height": 31,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "PWD BLSH MLT",
                        "image": {
                            "id": "32f193b3-1dff-3a03-afbd-65d8c82e6846",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/32f193b3-1dff-3a03-afbd-65d8c82e6846.jpg",
                                "width": 50,
                                "height": 31,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "VANILLA",
                        "image": {
                            "id": "e9672619-cfa3-38f4-bd96-32172fcf1625",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e9672619-cfa3-38f4-bd96-32172fcf1625.jpg",
                                "width": 50,
                                "height": 31,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "michaelkors_35S1GTTC9B",
                "name": "Jet Set Large Logo Crossbody Bag",
                "nameCN": "女式 Jet Set 大号徽标斜挎包",
                "description": [
                    "Crafted from our Signature-print canvas for novelty appeal, the Jet Set crossbody bag is designed in a sleek, compact silhouette. A polished chain-link zipper pull delivers standout style, while the pocketed interior is perfectly sized for a day’s worth of essentials. Wear it while commuting, running errands or taking a weekend getaway.",
                    "• Crossbody bag",
                    "• Logo-print canvas",
                    "• 89.4% coated canvas/9.6% polyester/1% polyurethane",
                    "• Gold-tone hardware",
                    "• 9.5”W X 6.5”H X 2”D",
                    "• Exterior details: detachable crossbody strap, back slip pocket, front slip and zip pockets",
                    "• Interior details: back and front slip pockets",
                    "• Lining: 100% polyester",
                    "• Zip fastening",
                    "• Dust bag not included",
                    "• Imported",
                    "• Crossbody bag",
                    "• Logo-print canvas",
                    "• 89.4% coated canvas/9.6% polyester/1% polyurethane",
                    "• Gold-tone hardware",
                    "• 9.5”W X 6.5”H X 2”D",
                    "• Exterior details: detachable crossbody strap, back slip pocket, front slip and zip pockets",
                    "• Interior details: back and front slip pockets",
                    "• Lining: 100% polyester",
                    "• Zip fastening",
                    "• Dust bag not included",
                    "• Imported"
                ],
                "merchantId": "89896b29-9191-a09f-8ffd-e872a296da04",
                "brand": "Michael Kors",
                "displayBrand": "Michael Kors",
                "brandId": "24d65c47-66a9-35a5-892e-5bb75b056f0d",
                "category": "?sz=72&start=294|women",
                "categoryIds": [
                    "e08"
                ],
                "priceTag": "$49.66",
                "priceTagCN": "¥364",
                "officialURL": "https://www.michaelkors.com/jet-set-large-logo-crossbody-bag/35S1GTTC9B.html?astc=true&dwvar_35S1GTTC9B_color=0200&priceStatusType=md",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "2.2折",
            "activityOffs": [
                "额外八五折",
                "新人补贴价"
            ],
            "merchantName": "Michael Kors",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "额外八五折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "2.2折×额外8.5折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$1",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 1567,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "a4615fca-ba9d-355b-90ad-99925e96d182",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/1/optimized/29482691_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a4615fca-ba9d-355b-90ad-99925e96d182.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a4615fca-ba9d-355b-90ad-99925e96d182.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Black",
                        "image": {
                            "id": "bf84de79-00d2-30e8-891a-383d07f162a2",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bf84de79-00d2-30e8-891a-383d07f162a2.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Tan",
                        "image": {
                            "id": "85478c15-97b7-335b-a883-f51a1f002770",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/85478c15-97b7-335b-a883-f51a1f002770.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_19436782",
                "name": "Men’s Manti Oxford Dress Shoe",
                "description": [
                    "Elevate your look with our stylish Aston Marc footwear collection, designed to complement any outfit. From sleek dress shoes perfect for formal occasions to comfortable casuals for everyday wear, we have something for every style and occasion. Crafted with quality materials and attention to detail, Aston Marc offers both durability and a fashion-forward flair. Step out with confidence and sophistication in footwear that's as unique as you are.",
                    "Fashion",
                    "Comfort",
                    "All Year Purpose",
                    "Trendy",
                    "Round Toe",
                    "Lace Up Closure",
                    "Artificial Leather Upper, Rubber Sole",
                    "Spot clean",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Aston Marc",
                "displayBrand": "Aston Marc",
                "category": "shoe|men's shoes",
                "categoryIds": [
                    "k08"
                ],
                "priceTag": "$31.65",
                "priceTagCN": "¥232",
                "officialURL": "https://www.macys.com/shop/product/aston-marc-mens-manti-oxford-dress-shoe?ID=19436782",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [
                            "us_8"
                        ],
                        "name": "8M",
                        "displayName": "美码8",
                        "type": "us"
                    },
                    {
                        "ids": [
                            "us_8.5"
                        ],
                        "name": "8.5M",
                        "displayName": "美码8.5",
                        "type": "us"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "6.2折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "6.2折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 1,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {
                "remainingSizes": "剩8M/8.5M码",
                "buoyId": "REMAINING_SIZES"
            }
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "c24e2077-5742-37f5-bc16-4386013c4e8c",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/3/optimized/33300803_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c24e2077-5742-37f5-bc16-4386013c4e8c.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c24e2077-5742-37f5-bc16-4386013c4e8c.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "College Purple",
                        "image": {
                            "id": "f049b30f-39b1-344c-bcc7-c3384b1e9744",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/f049b30f-39b1-344c-bcc7-c3384b1e9744.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Preppy Pink",
                        "image": {
                            "id": "0d1b5297-90c7-34bc-b8df-311ebf9253af",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0d1b5297-90c7-34bc-b8df-311ebf9253af.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "White",
                        "image": {
                            "id": "cb60e063-7bfe-33f2-946d-042a65726af5",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/cb60e063-7bfe-33f2-946d-042a65726af5.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_22843748",
                "name": "Girls 7-16 Mini-Cable Full-Zip Hoodie",
                "nameCN": "大童款全拉链连帽衫",
                "description": [
                    "This Full-Zip Hoodie is reimagined with medium-weight combed cotton in a mini-cable pattern.",
                    "Signature embroidered Pony at the left chest",
                    "Hood. Full-zip front",
                    "Long sleeves with rib-knit cuffs",
                    "Split kangaroo pocket",
                    "Rib-knit hem",
                    "100% cotton",
                    "Machine wash",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Polo Ralph Lauren",
                "displayBrand": "Ralph Lauren",
                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                "category": "sweatshirt|kids|sweatshirts & hoodies",
                "categoryIds": [
                    "g84"
                ],
                "priceTag": "$49.15",
                "priceTagCN": "¥360",
                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-big-girls-mini-cable-full-zip-hoodie?ID=22843748",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "S (7)",
                        "displayName": "S (7)"
                    },
                    {
                        "ids": [],
                        "name": "M (8/10)",
                        "displayName": "M (8/10)"
                    },
                    {
                        "ids": [],
                        "name": "L (12/14)",
                        "displayName": "L (12/14)"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "7折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "7折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 168,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "f8228acd-d22a-3ee2-bd84-ac25f7519e06",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/9/optimized/31066309_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/f8228acd-d22a-3ee2-bd84-ac25f7519e06.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/f8228acd-d22a-3ee2-bd84-ac25f7519e06.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Black",
                        "image": {
                            "id": "0b6d9190-7f8b-3587-a01e-7907ef7b5c29",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0b6d9190-7f8b-3587-a01e-7907ef7b5c29.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "White",
                        "image": {
                            "id": "67ca9537-c73b-3ea6-b43a-313810af38da",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/67ca9537-c73b-3ea6-b43a-313810af38da.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Pearl Grey Heather",
                        "image": {
                            "id": "a7283faf-b657-3572-825b-5310859a0524",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/a7283faf-b657-3572-825b-5310859a0524.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Buttercream",
                        "image": {
                            "id": "29d2c375-2f97-3715-be7a-9ef3e4686c2b",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/29d2c375-2f97-3715-be7a-9ef3e4686c2b.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Porcini",
                        "image": {
                            "id": "e05f6707-0eab-3327-aa38-9c32ee1e57dd",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/e05f6707-0eab-3327-aa38-9c32ee1e57dd.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Celadon Tint",
                        "image": {
                            "id": "129cda8f-e27d-360c-932d-04f39a87c4fc",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/129cda8f-e27d-360c-932d-04f39a87c4fc.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Blue Twilight",
                        "image": {
                            "id": "d131e939-ad80-3ea5-9ae2-af99a7fb7488",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d131e939-ad80-3ea5-9ae2-af99a7fb7488.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Cool Blue",
                        "image": {
                            "id": "bd3512ef-3b5d-3ba9-98be-5a2d73e57b9d",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/bd3512ef-3b5d-3ba9-98be-5a2d73e57b9d.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Persian Violet",
                        "image": {
                            "id": "78a086a9-5e1e-3861-97d4-84a97b82a6cb",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/78a086a9-5e1e-3861-97d4-84a97b82a6cb.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Peach Nectar",
                        "image": {
                            "id": "2e2e4c30-2163-3439-a555-eaa117f8d160",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2e2e4c30-2163-3439-a555-eaa117f8d160.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_5707740",
                "name": "Ruched-Sleeve Zip Hoodie",
                "description": [
                    "Ruched sleeves and textured fabric freshen this hoodie from Calvin Klein Performance. Lightweight, breathable fabric makes the look a great layer for the gym or the streets.",
                    "Approx. model height is 5'9\" and she is wearing a size M",
                    "Approx. model height is 5'10\" and she is wearing a size 2X",
                    "Hits at hip",
                    "Breathable, lightweight fabric",
                    "Attached hood with braided drawstring; front-zip closure; kangaroo pockets; long ruched raglan sleeves",
                    "Available in regular and plus sizes",
                    "Cotton/polyester",
                    "Machine washable",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Calvin Klein",
                "displayBrand": "Calvin Klein",
                "brandId": "04005cf7-5278-3d59-a187-ef0b416c10a2",
                "category": "jacket|women's fashion|activewear & workout",
                "categoryIds": [
                    "822",
                    "812"
                ],
                "priceTag": "$20.75",
                "priceTagCN": "¥152",
                "officialURL": "https://www.macys.com/shop/product/calvin-klein-performance-ruched-sleeve-zip-hoodie?ID=5707740",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "XS",
                        "displayName": "XS"
                    },
                    {
                        "ids": [],
                        "name": "S",
                        "displayName": "S"
                    },
                    {
                        "ids": [],
                        "name": "M",
                        "displayName": "M"
                    },
                    {
                        "ids": [],
                        "name": "L",
                        "displayName": "L"
                    },
                    {
                        "ids": [],
                        "name": "XL",
                        "displayName": "XL"
                    },
                    {
                        "ids": [],
                        "name": "XXL",
                        "displayName": "XXL"
                    },
                    {
                        "ids": [],
                        "name": "2XL",
                        "displayName": "2XL"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "3.4折起",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "3.4折起",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 1,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "ea6ef55c-2f0e-3511-81f0-131708b7e276",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/ea6ef55c-2f0e-3511-81f0-131708b7e276.png",
                            "width": 720,
                            "height": 638,
                            "format": "png"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/ea6ef55c-2f0e-3511-81f0-131708b7e276.png",
                            "width": 350,
                            "height": 310,
                            "format": "png"
                        }
                    }
                ],
                "colors": [],
                "id": "febee_R2024120500196",
                "name": "Estee Lauder 雅诗兰黛 白金级蕴能黑钻光璨面霜 7ml 中小样",
                "description": [],
                "merchantId": "5c0ae2c5-b2a1-3aab-afa1-8796e0512966",
                "displayBrand": "Estée Lauder",
                "brandId": "31324581-2dcc-3c7d-a1fc-70541e5e2ba4",
                "categoryIds": [
                    "b28"
                ],
                "priceTag": "$15.45",
                "priceTagCN": "¥114",
                "labels": [
                    "final_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "7ml",
                        "displayName": "7ml"
                    },
                    {
                        "ids": [],
                        "name": "7ml*2",
                        "displayName": "7ml*2"
                    },
                    {
                        "ids": [],
                        "name": "7ml*3",
                        "displayName": "7ml*3"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "2折起",
            "activityOffs": [
                "满折"
            ],
            "merchantName": "Febee",
            "origin": "[中国香港]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "满折",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "2折起",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "1件7.6折",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "包邮包税",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ]
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 25,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "中国香港",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "5d50f39b-3d8f-3242-8409-600705fa3d9a",
                        "originalURL": "https://s3.amazonaws.com/syncpigeon/alti_prod/images/hhn-53311_navy.jpg",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/5d50f39b-3d8f-3242-8409-600705fa3d9a.jpg",
                            "width": 688,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/5d50f39b-3d8f-3242-8409-600705fa3d9a.jpg",
                            "width": 235,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Navy",
                        "image": {
                            "id": "ba627f3c-ca6c-359d-8b27-e9377478824e",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/ba627f3c-ca6c-359d-8b27-e9377478824e.jpg",
                                "width": 34,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "thelasthunt_HHN-53311",
                "name": "Patrol Transition Jacket - Men's",
                "description": [
                    "The Patrol Transition Jacket is constructed with waterproof breathable Helly Tech™ Protection fabric and fully taped for wet and windy days in the city or outdoors. It’s finished with a PFC-free water-repellent treatment – a win for you and the environment. The Arctic Patrol product series has been designed and developed with the insights and knowledge of professional scientists working in harsh Arctic areas.Features:• HELLY TECH® Protection• PFC-free• Chest and Sleeve Pockets with Zippers• Adjustable Hood• Adjustable Cuffs• Elastic Cuffs• Reflective Cuff Details• Fully TapedFabric:• Shell: 100% Polyamide. Lining 2: 100% Polyester. Lining: 100% Polyester"
                ],
                "merchantId": "6a15c73e-6317-3c8f-9644-1e9a8c581857",
                "brand": "Helly Hansen",
                "displayBrand": "Helly Hansen",
                "brandId": "efc3bf19-8f47-39c3-aeb4-0c94aa26e19d",
                "category": "parkas and winter jackets|e|n|m|clothing|jackets and vests",
                "categoryIds": [
                    "214",
                    "211"
                ],
                "priceTag": "$147.80",
                "priceTagCN": "¥1083",
                "officialURL": "https://www.thelasthunt.com/p/helly-hansen-patrol-transition-jacket-mens-hhn-53311",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "S",
                        "displayName": "S"
                    },
                    {
                        "ids": [],
                        "name": "M",
                        "displayName": "M"
                    },
                    {
                        "ids": [],
                        "name": "L",
                        "displayName": "L"
                    },
                    {
                        "ids": [],
                        "name": "XL",
                        "displayName": "XL"
                    },
                    {
                        "ids": [],
                        "name": "XXL",
                        "displayName": "XXL"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "6.1折",
            "activityOffs": [
                "满折",
                "新人补贴价"
            ],
            "merchantName": "The Last Hunt",
            "origin": "[加拿大]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "满折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "6.1折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$2",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "满$165享8折",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 7,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "加拿大",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "fdf34e09-80e2-3f24-b10c-494ffae18c59",
                        "originalURL": "https://www.yoox.com/images/items/13/13191168XN_14_f.jpg",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fdf34e09-80e2-3f24-b10c-494ffae18c59.jpg",
                            "width": 804,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fdf34e09-80e2-3f24-b10c-494ffae18c59.jpg",
                            "width": 275,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Khaki",
                        "image": {
                            "id": "6472d819-c87a-38d7-b29a-22293fcd5820",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/6472d819-c87a-38d7-b29a-22293fcd5820.jpg",
                                "width": 39,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "yooxhk_13191168",
                "name": "Casual pants",
                "description": [
                    "98% Cotton, 2% Elastane",
                    "Velvet",
                    "Logo",
                    "Solid color",
                    "Mid Rise",
                    "Regular fit",
                    "Tapered leg",
                    "Button, zip",
                    "Multipockets",
                    "Stretch",
                    "5 pocket",
                    "Outside leg 98 cm, Inside leg 75 cm, Width at end 14 cm",
                    "ALL Fit: Regular fit",
                    "Appliqué: Logo detail",
                    "Clothes closures: Button, zip",
                    "Clothes Waist: Mid Rise",
                    "ColoreFoto_ID: 20",
                    "Composition: 98% Cotton, 2% Elastane",
                    "CustomsInvoiceDescr: Woven",
                    "Design: Solid color",
                    "HSCode: 62046239",
                    "ItemDescription: VelvetLogoSolid colorMid RiseRegular fitTapered legButton, zipMultipocketsStretch5 pocket",
                    "KeywordDescription: Velvet Logo Solid color Mid Rise Regular fit Tapered leg Button, zip Multipockets Stretch 5 pocket not made of fur Zip Woven",
                    "Kind of fabric: Woven",
                    "MacroDetails_Pants Leg: Tapered leg",
                    "MacroDetails_Seasonability: Wintry",
                    "MainMaterial: Cotton",
                    "Material Description: Velvet",
                    "MicroModel: 5 pocket",
                    "PANTS: Casual pants",
                    "Pants Model: 5 pocket",
                    "Pockets: Multipockets",
                    "Stretch: Stretch",
                    "Zip closure: Zip",
                    "MacroCategory: BOTTOMWEAR",
                    "MicroCategory: Pants",
                    "MicroCategoryPlural: Pants",
                    "Product Code: 13191168XN",
                    "Outside leg: 98.0",
                    "Inside leg: 75.0",
                    "Width at end: 14.0"
                ],
                "merchantId": "1909da89-b21b-38c3-b449-378e79039eae",
                "brand": "TRUSSARDI JEANS",
                "displayBrand": "TRUSSARDI JEANS",
                "brandId": "bb2a0f24-8c09-3fb9-843d-6ace5af600db",
                "category": "women|clothing|pants",
                "categoryIds": [
                    "843"
                ],
                "priceTag": "$54.60",
                "priceTagCN": "¥400",
                "officialURL": "https://www.yoox.com/hk/13191168XN/item",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "30(jeans)",
                        "displayName": "30(jeans)"
                    },
                    {
                        "ids": [],
                        "name": "32(jeans)",
                        "displayName": "32(jeans)"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "2.5折",
            "activityOffs": [
                "额外八折",
                "新人补贴价"
            ],
            "merchantName": "Yoox HK",
            "origin": "[意大利]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "额外八折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "2.5折×额外8折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$1",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 2,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "意大利",
            "buoy": {
                "remainingSizes": "剩30(jeans)/32(jeans)码",
                "buoyId": "REMAINING_SIZES"
            }
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "24a9ed22-c89a-3cf0-bb95-2ea7fc7c3637",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/2/optimized/34639472_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/24a9ed22-c89a-3cf0-bb95-2ea7fc7c3637.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/24a9ed22-c89a-3cf0-bb95-2ea7fc7c3637.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Hint Of Pink",
                        "image": {
                            "id": "8a26a76f-1045-3413-aaa7-3241d0abf934",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8a26a76f-1045-3413-aaa7-3241d0abf934.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Andover Heather",
                        "image": {
                            "id": "9ca8f53d-1c82-3c2d-ad4b-9ef75910989d",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/9ca8f53d-1c82-3c2d-ad4b-9ef75910989d.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Navy",
                        "image": {
                            "id": "615c6e7c-29a7-31d7-a298-36c2f767599e",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/615c6e7c-29a7-31d7-a298-36c2f767599e.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Nevis",
                        "image": {
                            "id": "8b674122-abc5-3598-8eb9-78fe57a0f7d1",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/8b674122-abc5-3598-8eb9-78fe57a0f7d1.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Preppy Pink",
                        "image": {
                            "id": "cdef1e5f-e475-302d-9999-880d2a5efc93",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/cdef1e5f-e475-302d-9999-880d2a5efc93.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "White",
                        "image": {
                            "id": "d4632ad7-5175-3d38-8d5b-cf0b706ce1ad",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/d4632ad7-5175-3d38-8d5b-cf0b706ce1ad.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_22843745",
                "name": "Girls 7-16 Fleece Full-Zip Hoodie",
                "nameCN": "大童款 连帽卫衣",
                "description": [
                    "A staple for casual days, this hoodie is made with comfortable cotton-blend fleece and finished with our signature embroidered Pony.",
                    "Full-zip front closure",
                    "Size medium has a 20.25\" body length (front and back) and a 26\" sleeve length. Sleeve length is taken from the center back of the neck",
                    "Signature embroidered Pony at the left chest.",
                    "Hood",
                    "Long sleeves with ribbed cuffs",
                    "Split kangaroo pocket",
                    "Ribbed hem",
                    "60% cotton, 40% polyester",
                    "Machine wash",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Polo Ralph Lauren",
                "displayBrand": "Ralph Lauren",
                "brandId": "fb35adb5-fa93-3307-ab74-a644b26facee",
                "category": "sweatshirt|kids|sweatshirts & hoodies",
                "categoryIds": [
                    "g84"
                ],
                "priceTag": "$42.05",
                "priceTagCN": "¥308",
                "officialURL": "https://www.macys.com/shop/product/polo-ralph-lauren-girls-7-16-fleece-full-zip-hoodie?ID=22843745",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "S (7)",
                        "displayName": "S (7)"
                    },
                    {
                        "ids": [],
                        "name": "M (8/10)",
                        "displayName": "M (8/10)"
                    },
                    {
                        "ids": [],
                        "name": "L (12/14)",
                        "displayName": "L (12/14)"
                    },
                    {
                        "ids": [],
                        "name": "XL (16)",
                        "displayName": "XL (16)"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "6.9折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "6.9折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 20,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "14f836ea-1147-3a38-948a-ff19c3df9376",
                        "originalURL": "https://cdn.shopify.com/s/files/1/0291/4536/6588/products/ae061a9004c3415199fe0048e1e774dc_b056ff23-d095-47d7-9a6b-210543dee07f.jpg?v=1701483512",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/14f836ea-1147-3a38-948a-ff19c3df9376.jpg",
                            "width": 819,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/14f836ea-1147-3a38-948a-ff19c3df9376.jpg",
                            "width": 280,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "multi",
                        "image": {
                            "id": "270289e7-ad25-3e7a-b312-adc6f6f88e49",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/270289e7-ad25-3e7a-b312-adc6f6f88e49.jpg",
                                "width": 40,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "shoppremiumoutlets_7215893643324",
                "name": "Cashmere Scarf",
                "description": [
                    "Introducing the Portolano Cashmere Scarf, a luxurious accessory crafted for women who appreciate timeless elegance and unparalleled comfort. With its exquisite design and superior quality, this scarf exemplifies the essence of the Portolano brand.Wrap yourself in pure indulgence with the Portolano Cashmere Scarf in the beautiful shade of Cammello Chiaro. Made with 100% cashmere, this scarf offers a supremely soft and cozy feel, ensuring optimal warmth even on the coldest days. Measuring 64 inches long and 8 inches wide, this scarf provides ample coverage to keep you perfectly snug. Whether you're venturing out on a winter stroll or curling up by the fireplace, this accessory will not only keep you warm but also elevate your style.With attention to detail and an unwavering commitment to quality, Portolano ensures that this cashmere scarf meets the highest standards. To maintain its luxurious texture, it is recommended to dry clean only. As an imported product, the Portolano Cashmere Scarf showcases the brand's dedication to sourcing the finest materials from around the world. However, please note that all measurements were taken by hand and are approximate; slight variations may occur, adding a unique touch to each scarf.Embrace the art of layering and accentuate your outfit with the Portolano Cashmere Scarf. Whether you're dressing up for a special occasion or looking for an everyday accessory, this scarf is a must-have addition to every woman's wardrobe. Experience warmth, style, and unmatched sophistication with Portolano."
                ],
                "merchantId": "9f93ee10-3f3f-3b95-beae-7a177d0f53e4",
                "brand": "Portolano",
                "displayBrand": "Portolano",
                "brandId": "f013f27d-2959-31ad-8aae-2475e36144a8",
                "category": "accessories|women|scarves-wraps",
                "categoryIds": [
                    "860"
                ],
                "priceTag": "$36.30",
                "priceTagCN": "¥266",
                "officialURL": "https://www.shoppremiumoutlets.com/products/portolano-cashmere-scarf-25",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "One Size",
                        "displayName": "One Size"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "1.7折",
            "activityOffs": [],
            "merchantName": "Premium Outlets",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "1.7折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 2,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "c49e0ed2-b30a-3760-af88-39e7b1c78346",
                        "originalURL": "https://i.stpost.com/icebreaker-queens-high-neck-bodysuit-merino-wool-long-sleeve-in-black~p~7updj_01~1500.2.jpg",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/c49e0ed2-b30a-3760-af88-39e7b1c78346.jpg",
                            "width": 1024,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/c49e0ed2-b30a-3760-af88-39e7b1c78346.jpg",
                            "width": 350,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Black",
                        "image": {
                            "id": "1b3e69d8-54c4-3fcc-a3ca-de9b7f45044c",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1b3e69d8-54c4-3fcc-a3ca-de9b7f45044c.jpg",
                                "width": 50,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "sierra_7UPDJ",
                "name": "Icebreaker Queens High Neck Bodysuit - Merino Wool, Long Sleeve",
                "description": [
                    "Icebreaker harvests merino wool exclusively from sheep grown in the Southern Alps of New Zealand, where conditions are extreme and the wool responds accordingly",
                    "Itch-free merino wool is temperature regulating, moisture wicking and odor resistant",
                    "High collar",
                    "Offset shoulder seams",
                    "Thumb loops",
                    "Snap-close gusset",
                    "Made in Bangladesh",
                    "Specs about Icebreaker Queens High Neck Bodysuit - Merino Wool, Long Sleeve",
                    "Long sleeves",
                    "Fabric: 100% merino wool",
                    "Care: Machine wash cold, dry flat in shade",
                    "Made in Bangladesh"
                ],
                "merchantId": "e1b81220-0153-3367-a080-0c37490a19a1",
                "brand": "Icebreaker",
                "displayBrand": "Icebreaker",
                "brandId": "7b4e2d31-ea0b-3bb9-ab13-3eecaf313bc9",
                "category": "Women's Long Sleeve/Women's Long Sleeve Tops",
                "categoryIds": [
                    "825",
                    "78d"
                ],
                "priceTag": "$42.20",
                "priceTagCN": "¥309",
                "officialURL": "https://www.sierra.com/icebreaker-queens-high-neck-bodysuit-merino-wool-long-sleeve~p~7updj/?filterString=s~icebreaker%2F",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "XS",
                        "displayName": "XS (2)",
                        "label": "XS"
                    },
                    {
                        "ids": [],
                        "name": "S",
                        "displayName": "S (4-6)",
                        "label": "S"
                    },
                    {
                        "ids": [],
                        "name": "M",
                        "displayName": "M (8-10)",
                        "label": "M"
                    },
                    {
                        "ids": [],
                        "name": "L",
                        "displayName": "L (12-14)",
                        "label": "L"
                    },
                    {
                        "ids": [],
                        "name": "XL",
                        "displayName": "XL (16-18)",
                        "label": "XL"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "3折",
            "activityOffs": [
                "新人补贴价"
            ],
            "merchantName": "SIERRA",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "3折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$1",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 21,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "e955bbf2-6583-482f-ba3a-056837acb10b",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/e955bbf2-6583-482f-ba3a-056837acb10b.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/e955bbf2-6583-482f-ba3a-056837acb10b.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        }
                    }
                ],
                "colors": [],
                "id": "oraclebeautyglbalshop_10024",
                "name": "KIEHL'S 科颜氏高保湿面霜125ml补水提亮滋润修复屏障神经酰胺【香港直邮】",
                "description": [],
                "merchantId": "51f855e4-7b23-3c07-994d-30bbd7030f09",
                "brand": "Kiehl's",
                "displayBrand": "Kiehl's",
                "brandId": "8cca16b7-687c-3924-a7a4-0df624cd1296",
                "categoryIds": [
                    "b28"
                ],
                "priceTag": "$29",
                "priceTagCN": "¥213",
                "labels": [
                    "final_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "125ML",
                        "displayName": "125ML"
                    },
                    {
                        "ids": [],
                        "name": "125ml-赠送【小棕瓶15ml*1】",
                        "displayName": "125ml-赠送【小棕瓶15ml*1】"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "3.5折起",
            "activityOffs": [],
            "merchantName": "ORACLE BEAUTY GLBAL SHOP",
            "origin": "[中国香港]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "3.5折起",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "包邮包税",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ]
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 271,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "中国香港",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "b94f9bc4-171a-32fd-b839-919fce099841",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/0/optimized/26847360_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/b94f9bc4-171a-32fd-b839-919fce099841.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/b94f9bc4-171a-32fd-b839-919fce099841.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Black",
                        "image": {
                            "id": "2b59d053-75b4-3dd4-b9a6-9d0d424da2c5",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/2b59d053-75b4-3dd4-b9a6-9d0d424da2c5.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Black/Gray Sky/Pomeian Red",
                        "image": {
                            "id": "89cee9c2-1bc3-3af4-b50b-6fb15603b31d",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/89cee9c2-1bc3-3af4-b50b-6fb15603b31d.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Black/Gray Sky/White",
                        "image": {
                            "id": "711674a4-17ec-3ae2-95c6-732ef677aecc",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/711674a4-17ec-3ae2-95c6-732ef677aecc.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Black/Royalty/Turbulence",
                        "image": {
                            "id": "787d7235-2c1e-332a-8120-bfb92fb39522",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/787d7235-2c1e-332a-8120-bfb92fb39522.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Black/Teal Breeze/Forest Freeze",
                        "image": {
                            "id": "1c1330d1-3afa-3bc1-8128-88040ce78910",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1c1330d1-3afa-3bc1-8128-88040ce78910.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_17506320",
                "name": "Men's 3-Pack Intense Power Micro Low Rise Trunks",
                "description": [
                    "Offering maximum comfort and enhanced movement, these Calvin Klein low rise trunks feature a wide supportive waistband, a sleek pouch with contoured seaming at the sides and an unmistakable, modern look.",
                    "3-pack",
                    "Elastic logo waistband",
                    "Contoured pouch",
                    "88% polyester, 12% elastane",
                    "Machine wash",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Calvin Klein",
                "displayBrand": "Calvin Klein",
                "brandId": "04005cf7-5278-3d59-a187-ef0b416c10a2",
                "category": "underwear|men's fashion|underwear & socks|Men",
                "categoryIds": [
                    "943"
                ],
                "priceTag": "$45.60",
                "priceTagCN": "¥334",
                "officialURL": "https://www.macys.com/shop/product/calvin-klein-mens-3-pack-intense-power-micro-low-rise-trunks?ID=17506320",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "S",
                        "displayName": "S"
                    },
                    {
                        "ids": [],
                        "name": "M",
                        "displayName": "M"
                    },
                    {
                        "ids": [],
                        "name": "L",
                        "displayName": "L"
                    },
                    {
                        "ids": [],
                        "name": "XL",
                        "displayName": "XL"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "6.9折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "6.9折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 24,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "a705911b-e140-341f-a5ef-174ec90965ba",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/34033235_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/a705911b-e140-341f-a5ef-174ec90965ba.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/a705911b-e140-341f-a5ef-174ec90965ba.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Island Fossil",
                        "image": {
                            "id": "c56fe0e8-2fc7-3084-bd56-c71cc3071a53",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c56fe0e8-2fc7-3084-bd56-c71cc3071a53.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Hemisphere Blue",
                        "image": {
                            "id": "1dd696e1-c693-334f-aa79-d4327ae20405",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/1dd696e1-c693-334f-aa79-d4327ae20405.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Racing Red",
                        "image": {
                            "id": "c722365d-74d2-368e-b385-2d3291bb64ae",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c722365d-74d2-368e-b385-2d3291bb64ae.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Black, Racing Red",
                        "image": {
                            "id": "0baccc75-7395-3305-a19e-80d2f65b3826",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/0baccc75-7395-3305-a19e-80d2f65b3826.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Light gray heather",
                        "image": {
                            "id": "117a079e-2f45-3344-9ce8-e77646401fbb",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/117a079e-2f45-3344-9ce8-e77646401fbb.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "White",
                        "image": {
                            "id": "c73e3342-d4df-38da-8793-048101d2c2e0",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c73e3342-d4df-38da-8793-048101d2c2e0.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_23011551",
                "name": "Boys 8-20 Old School Logo Pullover Hoodie",
                "nameCN": "大童款连帽衫",
                "description": [
                    "This hoodie from Calvin Klein is a cozy everyday layer for boys, featuring a crossover hood, long sleeves, and a kangaroo pocket for convenience. Ribbed cuffs and hem ensure a snug fit, while printed logo graphics add a stylish finish.",
                    "Hood with crossover construction",
                    "Long sleeves",
                    "Printed logo graphics; ribbed cuffs and hem",
                    "Kangaroo pocket",
                    "60% cotton, 40% polyester",
                    "Machine wash",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Calvin Klein",
                "displayBrand": "Calvin Klein",
                "brandId": "04005cf7-5278-3d59-a187-ef0b416c10a2",
                "category": "sweatshirt|kids|sweatshirts & hoodies",
                "categoryIds": [
                    "g84"
                ],
                "priceTag": "$26.15",
                "priceTagCN": "¥192",
                "officialURL": "https://www.macys.com/shop/product/calvin-klein-boys-8-20-old-school-logo-pullover-hoodie?ID=23011551",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "S (8)",
                        "displayName": "S (8)"
                    },
                    {
                        "ids": [],
                        "name": "M (10/12)",
                        "displayName": "M (10/12)"
                    },
                    {
                        "ids": [],
                        "name": "L (14/16)",
                        "displayName": "L (14/16)"
                    },
                    {
                        "ids": [],
                        "name": "XL (18/20)",
                        "displayName": "XL (18/20)"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "5.2折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "5.2折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 408,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "272d1a95-6c59-415c-8b78-bfd6ed4e1bc7",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/272d1a95-6c59-415c-8b78-bfd6ed4e1bc7.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/272d1a95-6c59-415c-8b78-bfd6ed4e1bc7.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        }
                    }
                ],
                "colors": [],
                "id": "blankspace_10712",
                "name": "SK-II氨基酸洗面奶舒透洁面乳120g 水润滋养泡沫细腻温和清洁多版本随机发【香港直邮】",
                "description": [],
                "merchantId": "1d415ac9-c2b7-3c63-858c-448db062a156",
                "brand": "SK-II",
                "displayBrand": "SK-II",
                "brandId": "e4fc21fd-3082-3814-b482-80fe8b93b08f",
                "categoryIds": [
                    "b20"
                ],
                "priceTag": "$31",
                "priceTagCN": "¥227",
                "labels": [
                    "final_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "120g",
                        "displayName": "120g"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "4折",
            "activityOffs": [
                "新人补贴价"
            ],
            "merchantName": "BLANKSPACE",
            "origin": "[中国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "4折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$1",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "包邮包税",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ]
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 42,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "中国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "9a2969f5-b5c9-31ff-b9a7-85005b029c29",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/9a2969f5-b5c9-31ff-b9a7-85005b029c29.png",
                            "width": 543,
                            "height": 717,
                            "format": "png"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/9a2969f5-b5c9-31ff-b9a7-85005b029c29.png",
                            "width": 265,
                            "height": 350,
                            "format": "png"
                        }
                    }
                ],
                "colors": [],
                "id": "xiangbeiguoji_goodsId_14178",
                "name": "【享贝家】ZY-FILA 斐乐 复古机能风休闲运动鞋 1XM02347",
                "description": [],
                "merchantId": "1941c66c-af1b-3532-9d8e-6b7019af351c",
                "displayBrand": "Fila",
                "brandId": "f71b8edc-b242-3bd8-b6a0-474e90ab0010",
                "categoryIds": [
                    "7e0"
                ],
                "priceTag": "$39.54",
                "priceTagCN": "¥290",
                "labels": [],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "240",
                        "displayName": "240"
                    },
                    {
                        "ids": [],
                        "name": "245",
                        "displayName": "245"
                    },
                    {
                        "ids": [],
                        "name": "250",
                        "displayName": "250"
                    },
                    {
                        "ids": [],
                        "name": "255",
                        "displayName": "255"
                    },
                    {
                        "ids": [],
                        "name": "260",
                        "displayName": "260"
                    },
                    {
                        "ids": [],
                        "name": "270",
                        "displayName": "270"
                    },
                    {
                        "ids": [],
                        "name": "280",
                        "displayName": "280"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "activityOffs": [],
            "merchantName": "xiangbeiguoji",
            "origin": "[韩国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "tideShoes": true,
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "包邮包税",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ]
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 17,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "韩国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "7da035f9-6812-389f-9d11-6e73f49f4e4c",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/8/optimized/8240468_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/7da035f9-6812-389f-9d11-6e73f49f4e4c.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/7da035f9-6812-389f-9d11-6e73f49f4e4c.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Black",
                        "image": {
                            "id": "c5b8a66f-c0f4-3b10-ad62-c74e941bac52",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/c5b8a66f-c0f4-3b10-ad62-c74e941bac52.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "White",
                        "image": {
                            "id": "214a5fab-fb6b-31e7-8fb6-79c94fffb3f8",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/214a5fab-fb6b-31e7-8fb6-79c94fffb3f8.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    },
                    {
                        "name": "Navy",
                        "image": {
                            "id": "05cfc311-f83a-3e81-a941-d5ccaf8ca1b9",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/05cfc311-f83a-3e81-a941-d5ccaf8ca1b9.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_4402467",
                "name": "Men's Cotton Crew Neck Undershirt",
                "nameCN": "男士纯棉半袖T恤",
                "description": [
                    "Relax in classic style and comfort in this Tommy Hilfiger undershirt, crafted from cotton for a great feel.",
                    "Ribbed crew neck with contrast tape",
                    "Embroidered logo at chest",
                    "Cotton jersey fabric",
                    "Cotton",
                    "Machine washable",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Tommy Hilfiger",
                "displayBrand": "Tommy Hilfiger",
                "brandId": "00e3d77f-2be8-3ccc-b1a0-27f3ee32e81c",
                "category": "underwear & socks|Men|undershirt|men's fashion",
                "categoryIds": [
                    "922"
                ],
                "priceTag": "$18.40",
                "priceTagCN": "¥135",
                "officialURL": "https://www.macys.com/shop/product/tommy-hilfiger-mens-cotton-crew-neck-undershirt?ID=4402467",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "S",
                        "displayName": "S"
                    },
                    {
                        "ids": [],
                        "name": "M",
                        "displayName": "M"
                    },
                    {
                        "ids": [],
                        "name": "L",
                        "displayName": "L"
                    },
                    {
                        "ids": [],
                        "name": "XL",
                        "displayName": "XL"
                    },
                    {
                        "ids": [],
                        "name": "XXL",
                        "displayName": "XXL"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "7折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "7折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 829,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "fbda320f-bb8e-3600-8e77-667083faef5e",
                        "originalURL": "http://slimages.macysassets.com/is/image/MCY/products/5/optimized/33499525_fpx.tif?fmt=webp&qlt=55,0&resMode=sharp2&op_usm=1.75,0.3,2,0&wid=1000",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/fbda320f-bb8e-3600-8e77-667083faef5e.jpg",
                            "width": 838,
                            "height": 1024,
                            "format": "JPG"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/fbda320f-bb8e-3600-8e77-667083faef5e.jpg",
                            "width": 286,
                            "height": 350,
                            "format": "JPG"
                        }
                    }
                ],
                "colors": [
                    {
                        "name": "Sky Captain Multi",
                        "image": {
                            "id": "278d3867-bd50-3b7f-a081-157c5ada5c79",
                            "full": {
                                "url": "https://5thave-img-cdn-g.bybieyang.com/plf/278d3867-bd50-3b7f-a081-157c5ada5c79.jpg",
                                "width": 41,
                                "height": 50,
                                "format": "JPG"
                            },
                            "thumbnail": {}
                        }
                    }
                ],
                "id": "macys_22074308",
                "name": "Women's Plaid Open-Front Jacket",
                "description": [
                    "The perfect polish for any look, with Tommy Hilfiger jacket features a versatile open front and allover plaid that keeps things classic.",
                    "Approx. 23-3/4\" long",
                    "Crewneck; open front with decorative buttons",
                    "Welt pockets at front",
                    "Allover plaid",
                    "Long sleeves with shoulder pads",
                    "99% polyester, 1% spandex",
                    "Machine wash",
                    "Imported"
                ],
                "merchantId": "cb1be947-49c8-dfdb-bb6e-d56648ddded8",
                "brand": "Tommy Hilfiger",
                "displayBrand": "Tommy Hilfiger",
                "brandId": "00e3d77f-2be8-3ccc-b1a0-27f3ee32e81c",
                "category": "jacket|women's fashion|coats & jackets",
                "categoryIds": [
                    "812"
                ],
                "priceTag": "$57.75",
                "priceTagCN": "¥423",
                "officialURL": "https://www.macys.com/shop/product/tommy-hilfiger-womens-plaid-open-front-jacket?ID=22074308",
                "labels": [
                    "on_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "XS",
                        "displayName": "XS"
                    },
                    {
                        "ids": [],
                        "name": "S",
                        "displayName": "S"
                    },
                    {
                        "ids": [],
                        "name": "M",
                        "displayName": "M"
                    },
                    {
                        "ids": [],
                        "name": "L",
                        "displayName": "L"
                    },
                    {
                        "ids": [],
                        "name": "XL",
                        "displayName": "XL"
                    },
                    {
                        "ids": [],
                        "name": "XXL",
                        "displayName": "XXL"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "5.2折",
            "activityOffs": [],
            "merchantName": "Macy's",
            "origin": "[美国]",
            "promotion": {
                "promotionLabels": [],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "5.2折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 1,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "美国",
            "buoy": {}
        }
    },
    {
        "searchProduct": {
            "product": {
                "images": [
                    {
                        "id": "4e8dd609-8c67-4b8e-94ea-b7e7ce09a8a5",
                        "full": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pf/4e8dd609-8c67-4b8e-94ea-b7e7ce09a8a5.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        },
                        "thumbnail": {
                            "url": "https://5thave-img-cdn-g.bybieyang.com/pt/4e8dd609-8c67-4b8e-94ea-b7e7ce09a8a5.jpg",
                            "width": 800,
                            "height": 800,
                            "format": "jpg"
                        }
                    }
                ],
                "colors": [],
                "id": "vpfrance_10014",
                "name": "TOM FORD 乌木沉香男女士浓香水 中性EDP香水",
                "description": [],
                "merchantId": "a7dbaa3e-55a8-3190-a04c-ee838af8c328",
                "brand": "Tom Ford",
                "displayBrand": "Tom Ford",
                "brandId": "ee6d6a48-2195-3239-a9fe-63aab4f0f73d",
                "categoryIds": [
                    "b0m"
                ],
                "priceTag": "$182.67",
                "priceTagCN": "¥1338",
                "labels": [
                    "final_sale"
                ],
                "badges": [],
                "keyDetails": [],
                "inventoryStatus": "AVAILABLE",
                "sizes": [
                    {
                        "ids": [],
                        "name": "50mL",
                        "displayName": "50mL"
                    },
                    {
                        "ids": [],
                        "name": "250mL",
                        "displayName": "250mL"
                    },
                    {
                        "ids": [],
                        "name": "100mL",
                        "displayName": "100mL"
                    }
                ],
                "availableSkus": [],
                "marks": [],
                "badgeList": [],
                "type": "REGULAR",
                "videos": [],
                "unAvailableSkus": [],
                "descriptionCN": []
            },
            "off": "7.9折起",
            "activityOffs": [
                "满折",
                "限时价",
                "新人补贴价",
                "额外九八折"
            ],
            "merchantName": "VP FRANCE",
            "origin": "[法国]",
            "promotion": {
                "promotionLabels": [
                    {
                        "text": "满折",
                        "color": "D27D3F"
                    },
                    {
                        "text": "限时价",
                        "color": "D27D3F"
                    },
                    {
                        "text": "新人补贴价",
                        "color": "D27D3F"
                    },
                    {
                        "text": "额外九八折",
                        "color": "D27D3F"
                    }
                ],
                "type": "LABEL"
            },
            "labelView": {
                "shortLabels": [
                    {
                        "labels": [
                            {
                                "text": "7.9折起×额外9.8折",
                                "color": "FFFFFF",
                                "backgroundColor": "222222",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ],
                        "kind": "DISCOUNT_LABEL"
                    },
                    {
                        "labels": [
                            {
                                "text": "新人补贴减$4",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "限时价",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "1件9.9折",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": []
                    },
                    {
                        "labels": [
                            {
                                "text": "包邮包税",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER",
                            "PRODUCT_LIST_LAYER"
                        ]
                    },
                    {
                        "labels": [
                            {
                                "text": "独家减免邮费",
                                "color": "E1660C",
                                "backgroundColor": "FAF2EB",
                                "fontSize": 18,
                                "fontWeight": "REGULAR"
                            }
                        ],
                        "layers": [
                            "PRODUCT_DETAIL_LAYER"
                        ],
                        "kind": "SHIPPING_LABEL"
                    }
                ],
                "viewLabelType": "V2_LIST_VIEW"
            },
            "numberViews": [
                {
                    "value": 589,
                    "view": "SALE_VIEW"
                }
            ],
            "merchantOrigin": "法国",
            "buoy": {}
        }
    }
]